<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class=""
      right
      no-header
      backdrop
      shadow
      :width="createSidebarWidth"
      @hidden="sideBarHidden()"
    >
      <div class="salary-create-header">
        <div class="salary-create-header__bar">
          <div class="salary-create-header__lead">
            <span
              class="salary-create-header__icon"
              :class="{ 'is-update': salaryIsUpdate }"
            >
              <feather-icon :icon="salaryModeIcon" size="18" />
            </span>
            <div class="salary-create-header__headline">
              <h5 class="salary-create-header__title">
                {{ salaryModeLabel }}
              </h5>
              <p class="salary-create-header__subtitle">
                {{ salaryModeHint }}
              </p>
            </div>
          </div>

          <div class="salary-create-header__bar-actions">
            <div class="salary-create-header__decimal">
              <span class="salary-create-header__label">
                Decimal
                <feather-icon
                  class="cursor-pointer"
                  icon="InfoIcon"
                  size="12"
                  v-b-tooltip.hover.bottom
                  title="Used for salary allowances & deductions"
                />
              </span>
              <div class="salary-create-header__decimal-group">
                <button
                  v-for="item in decimalData"
                  :key="item"
                  type="button"
                  class="salary-create-header__decimal-btn"
                  :class="{
                    'is-active': $store.state.decimal == item,
                  }"
                  @click="$store.commit('setDecimal', item)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
            <button
              type="button"
              class="salary-create-header__close"
              aria-label="Close"
              @click="hideSideBar()"
            >
              <feather-icon icon="XIcon" size="18" />
            </button>
          </div>
        </div>

        <div
          v-if="sidebarStaffName || salaryHeaderPeriodLabel"
          class="salary-create-header__context"
        >
          <div
            v-if="sidebarStaffName"
            class="salary-create-header__identity"
          >
            <span class="salary-create-header__staff-name">{{
              sidebarStaffName
            }}</span>
            <span
              v-if="sidebarStaffDesignation"
              class="salary-create-header__staff-role"
              >{{ sidebarStaffDesignation }}</span
            >
          </div>
          <div class="salary-create-header__chips">
            <span
              v-if="sidebarStaffAppointedOn"
              class="salary-create-header__chip"
            >
              <feather-icon icon="UserIcon" size="12" />
              Joined {{ sidebarStaffAppointedOn }}
            </span>
            <span
              v-if="salaryHeaderPeriodLabel"
              class="salary-create-header__chip is-period"
            >
              <feather-icon icon="CalendarIcon" size="12" />
              {{ salaryHeaderPeriodLabel }}
            </span>
          </div>
        </div>
      </div>

      <div class="p-1 salary-create-body" v-if="!showSettings && !showDetails">
        <b-row
          class="salary-top-fields mx-0"
          :class="{
            'is-date-range': usesSalaryDateRange,
            'is-standard-row': !usesSalaryDateRange,
          }"
        >
          <b-col
            cols="12"
            class="salary-top-field salary-top-field--month"
            v-if="!usesSalaryDateRange"
          >
            <b-form-group
              label="Salary Month"
              invalid-feedback="Salary Month is required."
              ref="month"
              label-class="salary-top-field__label"
            >
              <v-select
                v-model="sal.month"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="months"
                label="text"
                :reduce="(month) => month.value"
                :clearable="false"
                ref="month"
                placeholder="Select a month"
                @input="LoadSalary()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            class="salary-top-field salary-top-field--year"
            v-if="!usesSalaryDateRange"
          >
            <b-form-group
              label="Year"
              invalid-feedback="Year is required."
              ref="year"
              label-class="salary-top-field__label"
            >
              <v-select
                v-model="sal.year"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="years"
                :clearable="false"
                ref="year"
                placeholder="Select salary year"
                @input="LoadSalary()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="usesSalaryDateRange ? null : 5"
            :lg="usesSalaryDateRange ? null : 5"
            v-else
            :class="{ 'salary-top-field salary-top-field--period': usesSalaryDateRange }"
          >
            <b-form-group
              label="Salary Period"
              invalid-feedback="Date range is required."
              ref="month"
              label-class="salary-top-field__label"
            >
              <flat-pickr
                :config="config2"
                v-model="salaryRange"
                class="form-control salary-top-field__control"
                placeholder="Select salary date range"
                @on-change="onRangeChange"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :md="usesSalaryDateRange ? null : 3"
            :lg="usesSalaryDateRange ? null : 3"
            v-if="usesSalaryDateRange"
            class="salary-top-field"
          >
            <b-form-group
              label="Month"
              invalid-feedback="Salary Month is required."
              ref="month_myskooliuss"
              label-class="salary-top-field__label"
            >
              <v-select
                v-model="sal.month"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="months"
                label="text"
                :reduce="(month) => month.value"
                :clearable="false"
                placeholder="Select a month"
                @input="LoadSalary()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :class="{
              'salary-top-field': true,
              'salary-top-field--date': !usesSalaryDateRange,
            }"
          >
            <b-form-group
              :label="usesSalaryDateRange ? 'Date' : 'Payment Date'"
              invalid-feedback="Payment date is required."
              ref="date"
              label-class="salary-top-field__label"
            >
              <flat-pickr
                ref="date"
                :config="config"
                v-model="currentDate"
                class="form-control salary-top-field__control"
                :placeholder="$t('Select Date')"
                @on-change="saveDate()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            :class="{
              'salary-top-field': true,
              'salary-top-field--department': !usesSalaryDateRange,
            }"
          >
            <b-form-group
              label="Department"
              invalid-feedback="Department is required."
              label-class="salary-top-field__label"
            >
              <v-select
                v-model="mSalary.salary.departmentID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departments"
                :reduce="(opt) => opt.id"
                label="name"
                :clearable="false"
                placeholder="Select department"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-card class="mt-1" v-if="false">
          <div class="d-flex justify-content-between">
            <h4 class="">Custom Payroll Policy</h4>
            <b-form-checkbox v-model="customObj.show" switch />
          </div>

          <hr />
          <b-row
            v-if="customObj.show"
            v-for="(item, index) in policyObj"
            :key="index"
            class="align-items-center"
          >
            <b-col md="3" class="pr-0">
              <b-form-group
                label="Leaves By"
                invalid-feedback="Leaves By is required."
                ref="leave_type"
              >
                <v-select
                  v-model="item.type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="leaveTypes"
                  :reduce="(op) => op.value"
                  :clearable="false"
                  label="text"
                />

                <!-- @input="changeAllow()" -->
              </b-form-group>
            </b-col>
            <b-col md="4" class="pr-0" v-if="item.type == 'monthly'">
              <b-form-group
                label="Month"
                invalid-feedback="Month is required."
                ref="pmonth"
              >
                <v-select
                  v-model="item.month"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  :clearable="false"
                  ref="pmonth"
                  placeholder="Select"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="pr-0" v-if="item.type == 'yearly'">
              <b-form-group
                label="From"
                invalid-feedback="From Date is required."
                ref="dtFrom"
              >
                <flat-pickr
                  ref="dtFrom"
                  :config="config"
                  v-model="item.dateFrom"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  @on-change="setTillDate(item)"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="pr-0" v-if="item.type == 'yearly'">
              <b-form-group
                label="Till"
                invalid-feedback="Till Date is required."
                ref="dtTo"
              >
                <flat-pickr
                  disabled
                  ref="dtFrom"
                  :config="config"
                  v-model="item.dateTo"
                  class="form-control"
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <!--
            <b-col md="5" class="pr-0" v-if="item.type == 'yearly'">
              <b-form-group
                label="Date"
                invalid-feedback="Date is required"
                ref="dtFrom"
              >
                <flat-pickr
                  ref="dtFrom"
                  :config="config2"
                  v-model="item.range"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            -->
            <b-col :md="item.type == 'monthly' ? '3' : '2'" class="pr-0">
              <b-form-group
                label="Leaves"
                invalid-feedback="Leaves is required."
                ref="leave_days"
              >
                <b-form-input
                  ref="leave_days"
                  type="number"
                  placeholder="Enter days"
                  v-model="item.days"
                />
              </b-form-group>
            </b-col>
            <b-col md="1" class="pr-0 pl-50">
              <b-button
                v-if="index == policyObj.length - 1"
                variant="primary"
                class="btn-icon rounded-circle"
                @click="AddPolicy(item)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
              <b-button
                v-else
                variant="outline-danger"
                class="btn-icon rounded-circle"
                @click="removePolicy(item, index)"
              >
                <feather-icon size="16" icon="Trash2Icon" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mt-1 salary-panel">
          <div class="salary-panel__head">
            <div class="salary-panel__title-row">
              <span class="salary-panel__icon">
                <feather-icon icon="CalendarIcon" size="16" />
              </span>
              <h4 class="salary-panel__title mb-0">Attendance</h4>
              <button
                type="button"
                class="salary-panel__refresh"
                v-b-tooltip.hover.top
                title="Refresh attendance"
                @click="LoadSalary()"
              >
                <feather-icon icon="RefreshCwIcon" size="15" />
              </button>
            </div>
            <div class="salary-panel__tools">
              <b-form-checkbox
                v-if="sunObj && sunmonDepID != 9"
                v-model="sunmonValue"
                switch
                v-b-tooltip.hover.top
                title="Friday / Monday Policy"
                class="mr-3 salary-panel__switch"
              >
                <span class="salary-panel__switch-label">Fri / Mon Policy</span>
              </b-form-checkbox>
              <div class="salary-panel__deduction-toggle">
                <span class="salary-panel__switch-label"
                  >Enable deduction from salary</span
                >
                <b-form-checkbox
                  v-model="enableDeductionFromSalary"
                  switch
                  class="leave-deduction-toggle"
                  v-b-tooltip.hover.top
                  title="When off, unused casual/sick pool is not applied and salary may be deducted (skipUtilizeableLeaves). When on, leave balance covers eligible casual/sick days first."
                />
                <feather-icon
                  icon="InfoIcon"
                  size="15"
                  class="salary-panel__info"
                  v-b-tooltip.hover.top
                  title="If you enable this option, any remaining unused leaves will not be carried forward or deducted from your leave balance. Instead, the equivalent amount will be deducted directly from your salary."
                />
              </div>
            </div>
          </div>
          <div class="salary-panel__body">
          <!-- Loading skeleton while the salary is being calculated -->
          <div v-if="requestCalculate" class="salary-calc-skeleton">
            <div class="salary-calc-skeleton__grid">
              <div
                v-for="n in 12"
                :key="`calc-skel-${n}`"
                class="salary-calc-skeleton__field"
              >
                <div class="salary-calc-skeleton__label"></div>
                <div class="salary-calc-skeleton__input"></div>
              </div>
            </div>
          </div>
          <b-row v-else class="mt-1">
            <b-col md="4">
              <b-form-group
                label="Working Days"
                invalid-feedback="Working Days is required."
                ref="wDays"
              >
                <b-form-input
                  placeholder="Enter working days"
                  ref="wDays"
                  type="number"
                  v-model="mSalary.salary.workingDays"
                  @input="setP()"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Present"
                invalid-feedback="Invalid value entered"
                ref="present"
              >
                <b-form-input
                  placeholder="Present no. of days"
                  ref="present"
                  type="number"
                  v-model="mSalary.salary.present"
                  @input="setAbsent()"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                invalid-feedback="Invalid value entered"
                ref="absent"
              >
                <label class="bv-no-focus-ring col-form-label pt-0"
                  >Absent (<strong
                    >{{
                      mSalary.salary.absentDeductionCount
                    }}
                    deductible</strong
                  >)</label
                >
                <b-form-input
                  placeholder="Absent no. of days"
                  ref="absent"
                  type="number"
                  v-model="mSalary.salary.absent"
                  @input="setP()"
                />
                <small
                  v-if="showAbsentLeaveBalanceHint"
                  class="text-muted d-block mt-25"
                >
                  {{ absentLeaveBalanceHintText }}
                </small>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                invalid-feedback="Invalid value entered"
                ref="leave"
              >
                <div class="d-flex justify-content-between">
                  <label class="bv-no-focus-ring col-form-label pt-0"
                    >{{ primaryLeaveFieldLabel }} (<strong
                      >{{ primaryLeaveRemainingLabel }} remaining</strong
                    >)</label
                  >
                  <feather-icon
                    class="cursor-pointer"
                    icon="InfoIcon"
                    size="18"
                    v-b-tooltip.html.hover.top
                    :title="primaryLeaveTooltipHtml"
                  />
                </div>

                <b-form-input
                  :placeholder="primaryLeaveInputPlaceholder"
                  ref="leave"
                  type="number"
                  v-model="mSalary.salary.leave"
                  @input="onPrimaryLeaveInput()"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                invalid-feedback="Invalid value entered"
                ref="sickLeave"
              >
                <div class="d-flex justify-content-between">
                  <label class="bv-no-focus-ring col-form-label pt-0"
                    >{{ sickLeaveFieldLabel }} (<strong
                      >{{ sickLeaveRemainingLabel }} remaining</strong
                    >)</label
                  >
                  <feather-icon
                    class="cursor-pointer"
                    icon="InfoIcon"
                    size="18"
                    v-b-tooltip.html.hover.top
                    :title="sickLeaveTooltipHtml"
                  />
                </div>

                <b-form-input
                  :placeholder="sickLeaveInputPlaceholder"
                  ref="sickLeave"
                  type="number"
                  v-model="mSalary.salary.sickLeaves"
                  @input="onSickLeaveInput()"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              v-for="(leaveBal, lbIndex) in salaryOtherLeaveBalances"
              :key="'salary-lb-' + (leaveBal.leaveTypeID || leaveBal.code || lbIndex)"
            >
              <b-form-group invalid-feedback="Invalid value entered">
                <div class="d-flex justify-content-between">
                  <label class="bv-no-focus-ring col-form-label pt-0"
                    >{{ leaveBalanceDisplayName(leaveBal) }} (<strong
                      >{{ formatLeaveBalanceCount(leaveBal.remaining) }}
                      remaining</strong
                    >)</label
                  >
                  <feather-icon
                    class="cursor-pointer"
                    icon="InfoIcon"
                    size="18"
                    v-b-tooltip.html.hover.top
                    :title="leaveBalanceTooltipHtml(leaveBal)"
                  />
                </div>
                <b-form-input
                  :placeholder="leaveBalanceDisplayName(leaveBal) + ' no. of days'"
                  type="number"
                  :value="otherLeavePeriodDayCount(leaveBal)"
                  @input="onOtherLeavePeriodInput(leaveBal, $event)"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group invalid-feedback="Invalid value entered" ref="late">
                <label class="bv-no-focus-ring col-form-label pt-0"
                  >Late Coming (<strong
                    >{{ mSalary.salary.lateDeductionCount }} deductible</strong
                  >)</label
                >
                <b-form-input
                  placeholder="Late Coming no. of days"
                  ref="late"
                  type="number"
                  v-model="mSalary.salary.late"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group invalid-feedback="Invalid value entered" ref="half">
                <label class="bv-no-focus-ring col-form-label pt-0"
                  >Half Leave (<strong
                    >{{
                      mSalary.salary.shortLeaveDeductionCount
                    }}
                    deductible</strong
                  >)</label
                >
                <b-form-input
                  placeholder="Half Leave no. of days"
                  ref="half"
                  type="number"
                  v-model="mSalary.salary.shortLeave"
                />
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="['myskoolhpgs'].includes(reportDomain)">
              <b-form-group
                label="Early Departure"
                invalid-feedback="Invalid value entered"
                ref="earlyDep"
              >
                <b-form-input
                  placeholder="Enter early departure days"
                  type="number"
                  v-model="mSalary.salary.earlyDeparture"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Bonus Working Days"
                invalid-feedback="Bonus Working Days is required."
                ref="bDays"
              >
                <b-form-input
                  placeholder="Enter bonus working days"
                  ref="bDays"
                  type="number"
                  v-model="mSalary.salary.bonusDays"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Leave Encashment Days"
                invalid-feedback="Leave Encashment Days is required."
                ref="enDays"
              >
                <b-form-input
                  placeholder="Enter leave encashment days"
                  ref="enDays"
                  type="number"
                  v-model="mSalary.salary.leavesEncashed"
                />
              </b-form-group>
            </b-col>

            <template
              v-if="
                isIussDomain &&
                (!holidaySalaryObj || !holidaySalaryObj.valueBool)
              "
            >
              <b-col md="3">
                <b-form-group
                  label="Off Days"
                  invalid-feedback="Off days is required."
                >
                  <b-form-input
                    type="number"
                    placeholder="Enter off days"
                    v-model.number="extraDays.offdays"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Holidays"
                  invalid-feedback="Holidays count is required."
                >
                  <b-form-input
                    type="number"
                    placeholder="Enter holidays"
                    v-model.number="extraDays.holidays"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Deduction Days">
                  <b-form-input
                    type="number"
                    :value="extraDays.deductionDays"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Salary Days">
                  <b-form-input
                    type="number"
                    :value="extraDays.salaryDays"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </template>

            <template v-if="holidaySalaryObj && holidaySalaryObj.valueBool">
              <b-col md="3">
                <b-form-group
                  label="Off Days"
                  invalid-feedback="Off days is required."
                >
                  <b-form-input
                    type="number"
                    placeholder="Enter off days"
                    v-model.number="extraDays.offdays"
                    @input="setAbsent()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Holidays"
                  invalid-feedback="Holidays count is required."
                >
                  <b-form-input
                    type="number"
                    placeholder="Enter holidays"
                    v-model.number="extraDays.holidays"
                    @input="setAbsent()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Total Days"
                  v-b-tooltip.hover.top
                  title="Present + Off Days + Holidays + Late"
                >
                  <b-form-input
                    type="number"
                    :value="totalDaysCalculated"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col
              v-if="['myskoolhpgs'].includes(reportDomain)"
              md="12"
              class="pt-1 pb-50 mb-1 border-top border-bottom"
            >
              <b-form-checkbox v-model="isTaxes" switch inline class="mb-50">
                <span class="font-small-4">Calculate Taxes</span>
              </b-form-checkbox>
              <b-form-checkbox v-model="exludeSD" switch inline class="mb-50">
                <span class="font-small-4">Exlude Deposit</span>
              </b-form-checkbox>
              <b-form-checkbox v-model="holdSalary" switch inline class="mb-50">
                <span class="font-small-4">Hold Salary</span>
              </b-form-checkbox>
              <b-form-checkbox v-model="excludeCL" switch inline class="mb-50">
                <span class="font-small-4">Exclude Casual Leave</span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <div class="salary-calc-actions">
            <button
              type="button"
              class="salary-calc-btn"
              :class="{ 'is-loading': requestCalculate }"
              :disabled="requestCalculate"
              @click="CalculateSalary()"
            >
              <b-spinner
                v-if="requestCalculate"
                small
                type="grow"
                class="mr-50"
              />
              <template v-else>
                <feather-icon icon="ZapIcon" size="16" class="mr-50" />
                <span>Calculate Salary</span>
              </template>
              <span v-if="requestCalculate">Calculating…</span>
            </button>
          </div>
          </div>
        </b-card>

        <b-card class="mt-1 salary-panel">
          <div class="salary-panel__head">
            <div class="salary-panel__title-row">
              <span class="salary-panel__icon salary-panel__icon--allow">
                <feather-icon icon="TrendingUpIcon" size="16" />
              </span>
              <h4 class="salary-panel__title mb-0">Allowances</h4>
              <span
                v-if="mSalary.allowances.length"
                class="salary-panel__count"
              >
                {{ mSalary.allowances.length }}
              </span>
            </div>
            <div class="salary-panel__tools">
              <span v-if="mSalary.salary.totalAllownaces" class="salary-panel__total">
                Rs. {{ formatSheetMoney(mSalary.salary.totalAllownaces) }}
              </span>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="salary-panel__action-btn"
                @click="openReturns()"
                :disabled="returnLoading"
              >
                <b-spinner
                  v-if="returnLoading"
                  small
                  class="mr-50"
                />
                <feather-icon
                  v-else
                  icon="RotateCcwIcon"
                  size="14"
                  class="mr-50"
                />
                <span>Return Deposits</span>
              </b-button>
            </div>
          </div>
          <div class="salary-panel__body">
          <div v-if="requestCalculate" class="salary-row-skeleton">
            <div
              v-for="n in 2"
              :key="`allow-skel-${n}`"
              class="salary-row-skeleton__row"
            >
              <div class="salary-row-skeleton__field is-main"></div>
              <div class="salary-row-skeleton__field is-amount"></div>
            </div>
          </div>
          <div v-else class="salary-row-list">
            <div
              v-for="(item, index) in mSalary.allowances"
              :key="`allow-${index}`"
              class="salary-row"
            >
              <div
                class="salary-row__fields"
                :class="{ 'has-days': isMyskoolStJacobDomain }"
              >
                <div class="salary-row__field">
                  <label class="salary-row__label">Allowance</label>
                  <v-select
                    v-model="item.staffAllowanceID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allowances"
                    :reduce="(op) => op.id"
                    :selectable="(opt) => !allowIDs.includes(opt.id)"
                    :clearable="false"
                    label="title"
                    placeholder="Select allowance"
                    @input="changeAllow()"
                  />
                </div>
                <div
                  v-if="isMyskoolStJacobDomain"
                  class="salary-row__field"
                >
                  <label class="salary-row__label">Days</label>
                  <v-select
                    v-model="item.allowanceDays"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="stjacobAllowanceDaySelectOptions"
                    :reduce="(opt) => opt.value"
                    :clearable="false"
                    :searchable="false"
                    label="label"
                    placeholder="0"
                    class="stjacob-days-select"
                    @input="applyStjacobAllowanceAmountFromDays(item)"
                  />
                </div>
                <div class="salary-row__field">
                  <label class="salary-row__label">Amount</label>
                  <b-input-group class="salary-row__money">
                    <b-input-group-prepend is-text>
                      <span class="salary-row__currency">Rs.</span>
                    </b-input-group-prepend>
                    <b-form-input
                      type="number"
                      placeholder="0"
                      v-model="item.amount"
                    />
                  </b-input-group>
                </div>
              </div>
              <div class="salary-row__actions">
                <button
                  v-if="mSalary.allowances.length > 1"
                  type="button"
                  class="salary-row__icon-btn is-remove"
                  v-b-tooltip.hover.top
                  title="Remove allowance"
                  @click="removeDetail(item, index)"
                >
                  <feather-icon size="15" icon="Trash2Icon" />
                </button>
                <button
                  v-if="index == mSalary.allowances.length - 1"
                  type="button"
                  class="salary-row__icon-btn is-add"
                  v-b-tooltip.hover.top
                  title="Add allowance"
                  @click="AddDetail(item)"
                >
                  <feather-icon size="15" icon="PlusIcon" />
                </button>
              </div>
            </div>
          </div>
          </div>
        </b-card>

        <b-card class="mt-1 salary-panel">
          <div class="salary-panel__head">
            <div class="salary-panel__title-row">
              <span class="salary-panel__icon salary-panel__icon--deduct">
                <feather-icon icon="TrendingDownIcon" size="16" />
              </span>
              <h4 class="salary-panel__title mb-0">Salary Deductions</h4>
              <span
                v-if="mSalary.deductions.length"
                class="salary-panel__count"
              >
                {{ mSalary.deductions.length }}
              </span>
            </div>
            <div class="salary-panel__tools">
              <span v-if="mSalary.salary.totalDedcutions" class="salary-panel__total is-deduct">
                Rs. {{ formatSheetMoney(mSalary.salary.totalDedcutions) }}
              </span>
            </div>
          </div>
          <div class="salary-panel__body">
          <div v-if="requestCalculate" class="salary-row-skeleton">
            <div
              v-for="n in 2"
              :key="`ded-skel-${n}`"
              class="salary-row-skeleton__row"
            >
              <div class="salary-row-skeleton__field is-main"></div>
              <div class="salary-row-skeleton__field is-amount"></div>
            </div>
          </div>
          <div v-else class="salary-row-list">
            <div
              v-for="(item, ind) in mSalary.deductions"
              :key="`ded-${ind}`"
              class="salary-row"
              :class="{ 'is-skipped': item.skipped }"
            >
              <div class="salary-row__fields">
                <div class="salary-row__field">
                  <label class="salary-row__label">Deduction</label>
                  <v-select
                    v-model="item.staffDeductionID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="deductions"
                    :reduce="(op) => op.id"
                    :selectable="(opt) => !dedIDs.includes(opt.id)"
                    :clearable="false"
                    :disabled="item.skipped"
                    label="title"
                    placeholder="Select deduction"
                    @input="changeDed()"
                  />
                </div>
                <div class="salary-row__field">
                  <label class="salary-row__label">Amount</label>
                  <b-input-group class="salary-row__money">
                    <b-input-group-prepend is-text>
                      <span class="salary-row__currency">Rs.</span>
                    </b-input-group-prepend>
                    <b-form-input
                      type="number"
                      placeholder="0"
                      v-model="item.amount"
                      :disabled="item.skipped"
                    />
                  </b-input-group>
                </div>
              </div>
              <div class="salary-row__actions">
                <span v-if="item.skipped" class="salary-row__badge">Skipped</span>
                <button
                  v-if="mSalary.deductions.length > 1"
                  type="button"
                  class="salary-row__icon-btn is-remove"
                  v-b-tooltip.hover.top
                  title="Remove deduction"
                  @click="removeDeduct(item, ind)"
                >
                  <feather-icon size="15" icon="Trash2Icon" />
                </button>
                <button
                  v-if="
                    isLoanOrAdvanceDeduction(item.staffDeductionID) &&
                    ind == mSalary.deductions.length - 1 &&
                    !item.skipped
                  "
                  type="button"
                  class="salary-row__icon-btn is-skip"
                  v-b-tooltip.hover.top
                  title="Skip this deduction"
                  @click="skipDeduction(item, ind)"
                >
                  <feather-icon size="15" icon="SkipForwardIcon" />
                </button>
                <button
                  v-if="ind == mSalary.deductions.length - 1"
                  type="button"
                  class="salary-row__icon-btn is-add"
                  v-b-tooltip.hover.top
                  title="Add deduction"
                  @click="AddDeduct(item)"
                >
                  <feather-icon size="15" icon="PlusIcon" />
                </button>
              </div>
            </div>
          </div>
          </div>
        </b-card>

        <b-card
          v-if="
            reportDomain === 'myskooliuss' &&
            mSalary.contributions &&
            mSalary.contributions.length > 0
          "
          class="mt-1 salary-panel"
        >
          <div class="salary-panel__head">
            <div class="salary-panel__title-row">
              <span class="salary-panel__icon">
                <feather-icon icon="BriefcaseIcon" size="16" />
              </span>
              <h4 class="salary-panel__title mb-0">Contributions</h4>
            </div>
          </div>
          <div class="salary-panel__body">
            <div class="salary-row-list">
              <!-- PF Contribution -->
              <template v-for="(item, ind) in mSalary.contributions">
                <div
                  v-if="
                    item.contributionPFAmount != null &&
                    item.contributionPFAmount !== undefined
                  "
                  :key="'pf-contribution-' + ind"
                  class="contribution-row"
                >
                  <span class="contribution-row__name">
                    <feather-icon icon="PercentIcon" size="14" class="mr-50" />
                    PF Contribution
                  </span>
                  <span class="contribution-row__amount">
                    Rs. {{ formatSheetMoney(item.contributionPFAmount) }}
                  </span>
                </div>
              </template>

              <!-- EOBI Contribution -->
              <template v-for="(item, ind) in mSalary.contributions">
                <div
                  v-if="
                    item.contributionEOBIAmount != null &&
                    item.contributionEOBIAmount !== undefined
                  "
                  :key="'eobi-contribution-' + ind"
                  class="contribution-row"
                >
                  <span class="contribution-row__name">
                    <feather-icon icon="PercentIcon" size="14" class="mr-50" />
                    EOBI Contribution
                  </span>
                  <span class="contribution-row__amount">
                    Rs. {{ formatSheetMoney(item.contributionEOBIAmount) }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </b-card>

        <b-card class="mt-1 salary-panel">
          <div class="salary-panel__head">
            <div class="salary-panel__title-row">
              <span class="salary-panel__icon salary-panel__icon--summary">
                <feather-icon icon="BarChart2Icon" size="16" />
              </span>
              <h4 class="salary-panel__title mb-0">Summary</h4>
            </div>
            <div class="salary-panel__tools">
              <span class="salary-summary-net">
                <span class="salary-summary-net__label">Net Salary</span>
                <span class="salary-summary-net__value">
                  Rs. {{ formatSheetMoney(mSalary.salary.netSalary) }}
                </span>
              </span>
            </div>
          </div>
          <div class="salary-panel__body">
            <div v-if="requestCalculate" class="salary-summary-skeleton">
              <div
                v-for="n in 6"
                :key="`sum-skel-${n}`"
                class="salary-summary-skeleton__tile"
              >
                <div class="salary-summary-skeleton__label"></div>
                <div class="salary-summary-skeleton__value"></div>
              </div>
            </div>
            <div v-else class="salary-summary-grid">
              <div class="salary-summary-tile">
                <span class="salary-summary-tile__label">Basic Salary</span>
                <span class="salary-summary-tile__value">
                  Rs. {{ formatSheetMoney(mSalary.salary.basicSalary) }}
                </span>
              </div>
              <div class="salary-summary-tile">
                <span class="salary-summary-tile__label">Total Allowance</span>
                <span class="salary-summary-tile__value is-allow">
                  Rs. {{ formatSheetMoney(mSalary.salary.totalAllownaces) }}
                </span>
              </div>
              <div class="salary-summary-tile">
                <span class="salary-summary-tile__label">Gross Salary</span>
                <span class="salary-summary-tile__value">
                  Rs. {{ formatSheetMoney(mSalary.salary.grossSalary) }}
                </span>
              </div>
              <div class="salary-summary-tile">
                <span class="salary-summary-tile__label">Total Deduction</span>
                <span class="salary-summary-tile__value is-deduct">
                  Rs. {{ formatSheetMoney(mSalary.salary.totalDedcutions) }}
                </span>
              </div>
              <div class="salary-summary-tile">
                <span class="salary-summary-tile__label">Gross Payable</span>
                <span class="salary-summary-tile__value">
                  Rs. {{ formatSheetMoney(mSalary.salary.grossPayable) }}
                </span>
              </div>
              <div class="salary-summary-tile is-net">
                <span class="salary-summary-tile__label">Net Salary</span>
                <span class="salary-summary-tile__value">
                  Rs. {{ formatSheetMoney(mSalary.salary.netSalary) }}
                </span>
              </div>
            </div>

            <div class="salary-summary-fields">
              <div v-if="showSalaryPaymentDate" class="salary-summary-field">
                <label class="salary-summary-field__label">
                  Salary Payment Date
                </label>
                <flat-pickr
                  :config="config"
                  v-model="mSalary.salary.salaryPaymentDate"
                  class="form-control"
                  placeholder="Select salary payment date"
                />
              </div>

              <div class="salary-summary-field">
                <div class="salary-summary-field__head">
                  <label class="salary-summary-field__label">Salary From</label>
                  <feather-icon
                    class="cursor-pointer"
                    icon="BriefcaseIcon"
                    size="16"
                    v-b-tooltip.hover.top
                    title="Accounts"
                    @click="openAccount()"
                  />
                </div>
                <v-select
                  v-model="mSalary.salary.accountID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="accTypes"
                  :reduce="(opt) => opt.id"
                  label="account"
                  :clearable="false"
                  ref="acc"
                  placeholder="Select account type"
                  @input="reportDomain == 'myskoolhpgs' && LoadBranches()"
                />
              </div>

              <div v-if="isKentSchoolDomain" class="salary-summary-field">
                <label class="salary-summary-field__label">Paid</label>
                <v-select
                  v-model="mSalary.salary.paid"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="paidOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="true"
                  placeholder="Select paid status"
                />
              </div>

              <div v-if="reportDomain == 'myskoolhpgs'" class="salary-summary-field">
                <label class="salary-summary-field__label">Branch</label>
                <v-select
                  v-model="mSalary.salary.branchID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="branchOptions"
                  :reduce="(opt) => opt.id"
                  label="branch"
                  :clearable="false"
                  :disabled="branchLoading || disBranch"
                  placeholder="Select branch"
                />
              </div>
            </div>
          </div>
        </b-card>

        <b-form-group
          label="Note"
          invalid-feedback="Note is required"
          ref="note"
        >
          <b-form-textarea
            ref="note"
            placeholder="Enter note"
            v-model="mSalary.salary.note"
            rows="2"
          ></b-form-textarea>
        </b-form-group>

        <b-row class="mb-5 salary-create-actions">
          <b-col cols="4" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="salary-create-save"
              @click="SaveSalary(false)"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" class="mr-50" />
              <template v-else>
                <feather-icon :icon="salaryModeIcon" size="16" class="mr-50" />
                <span>{{ salaryModeActionLabel }}</span>
              </template>
            </b-button>
          </b-col>
          <b-col cols="4" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="salary-create-save-print"
              @click="SaveSalary(true)"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" class="mr-50" />
              <template v-else>
                <feather-icon icon="PrinterIcon" size="16" class="mr-50" />
                <span>Save &amp; Print</span>
              </template>
            </b-button>
          </b-col>
          <b-col cols="4">
            <b-form-group
              label="Add to Expense"
              invalid-feedback="Expense is required."
            >
              <v-select
                v-model="toExpense"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="expOptions"
                :reduce="(opt) => opt.value"
                label="text"
                :clearable="false"
                placeholder="Select"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div v-if="showDetails" class="p-1">
        <b-button
          @click="showDetails = false"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-secondary"
          class="mb-1"
        >
          <feather-icon icon="ChevronLeftIcon" class="mr-50" />
          <span class="align-middle">Back</span>
        </b-button>
        <b-card class="">
          <h4 class="">Allowances</h4>
          <hr />
          <b-row class="">
            <div
              v-for="(item, index) in AddingInfo"
              :key="index"
              style="display: flex; align-items: center; width: 100%"
            >
              <b-col md="7" class="pr-0">
                <b-form-group
                  label="Allowance"
                  invalid-feedback="Allowance is required."
                  ref="details"
                >
                  <v-select
                    v-model="item.staffAllowanceID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allowances"
                    :reduce="(op) => op.id"
                    :selectable="(opt) => !allowIDs.includes(opt.id)"
                    :clearable="false"
                    label="title"
                    @input="changeAllow()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3" class="pr-0">
                <b-form-group
                  label="Amount"
                  invalid-feedback="Amount is required."
                  ref="sal_amount"
                >
                  <b-form-input
                    ref="sal_amount"
                    type="number"
                    placeholder="Enter amount"
                    v-model="item.amount"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-button
                  v-if="index == AddingInfo.length - 1"
                  @click="AddDetail(item)"
                  variant="primary"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon size="16" icon="PlusIcon" />
                </b-button>
                <b-button
                  v-else
                  @click="removeDetail(item, index)"
                  variant="outline-danger"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon size="16" icon="Trash2Icon" />
                </b-button>
              </b-col>
            </div>
          </b-row>
        </b-card>
        <b-card class="mb-50">
          <h4 class="">Salary Deductions</h4>
          <hr />
          <b-row class="">
            <div
              v-for="(item, ind) in mSalary.deductions"
              :key="ind"
              style="display: flex; align-items: center; width: 100%"
            >
              <b-col md="7" class="pr-0">
                <b-form-group
                  label="Deduction"
                  invalid-feedback="detail is required."
                  ref="ded_details"
                >
                  <v-select
                    v-model="item.staffDeductionID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="deductions"
                    :reduce="(op) => op.id"
                    :selectable="(opt) => !dedIDs.includes(opt.id)"
                    :clearable="false"
                    label="title"
                    @input="changeDed()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3" class="pr-0">
                <b-form-group
                  label="Amount"
                  invalid-feedback="Amount is required."
                  ref="ded_amount"
                >
                  <b-form-input
                    ref="ded_amount"
                    type="number"
                    placeholder="Enter amount"
                    v-model="item.amount"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-button
                  v-if="ind == mSalary.deductions - 1"
                  @click="AddDeduct(item)"
                  variant="primary"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon size="16" icon="PlusIcon" />
                </b-button>
                <b-button
                  v-else
                  @click="removeDeduct(item, ind)"
                  variant="outline-danger"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon size="16" icon="Trash2Icon" />
                </b-button>
              </b-col>
            </div>
          </b-row>
        </b-card>
      </div>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="accountbar"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Collection Account</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="accountbar = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <!-- <b-row class="mt-1" v-if="!addingAcc">
            <b-col md="12">
              <b-button variant="primary" @click="addingAcc = true">
                Add Account
              </b-button>
            </b-col>
          </b-row> -->
        <b-row class="d-flex align-items-center">
          <b-col md="12">
            <b-form-group
              label="Account Name"
              invalid-feedback="Account name is required."
            >
              <b-form-input
                ref="accname"
                v-model="accountObj.account"
                placeholder="Enter collection account name"
                @focusout="checkAccount()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <!--  v-if="entryObj && entryObj.valueBool" -->
          <b-col md="12">
            <b-form-group
              label="Link with"
              invalid-feedback="Account is required."
            >
              <v-select
                ref="coa"
                v-model="accountObj.accountID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="coAccounts"
                :reduce="(opt) => opt.id"
                :clearable="true"
                label="title"
                placeholder="Select account"
                @input="setCOA"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="saveAcc()"
              :disabled="savingacc"
              block
            >
              <b-spinner v-if="savingacc" small type="grow" />
              <!-- <feather-icon v-else :icon="accIcon" /> -->
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-2"
          show-empty
          :items="accTypes"
          :fields="accFields"
          responsive
          hover
          small
        >
          <template #head(actions)="data">
            <div class="text-right">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="text-right">
              <b-button
                v-if="
                  reportDomain === 'myskoolhpgs' &&
                  !['cash', 'cheque', 'paypro', 'online'].some((word) =>
                    data.item.account.toLowerCase().includes(word)
                  )
                "
                variant="outline-primary"
                class="btn-icon mr-75"
                @click="showAccBranch(data.item)"
              >
                <feather-icon icon="HomeIcon" />
              </b-button>
              <b-button
                variant="primary"
                class="btn-icon mr-50"
                @click="editAcc(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <!-- <b-button
                variant="outline-danger"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="deleteAcc(data.item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button> -->
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="showSettings"
      :sidebar-class="settingsSidebarClasses"
      right
      no-header
      backdrop
      shadow
      :width="settingsSidebarWidth"
    >
      <div class="settings-shell">
      <div class="settings-header">
        <div class="settings-header__text">
          <h5 class="settings-header__title">Salary Settings</h5>
          <small class="settings-header__subtitle">
            Leave, deduction &amp; allowance policies
          </small>
        </div>
        <button
          type="button"
          class="settings-close"
          aria-label="Close settings"
          @click="showSettings = false"
        >
          <feather-icon icon="XIcon" size="18" />
        </button>
      </div>

      <div class="settings-scroll">
        <div v-if="settLoading" class="settings-skeleton">
          <div v-for="n in 5" :key="`settings-skel-${n}`" class="policy-card skeleton-card">
            <div class="policy-head">
              <span class="skeleton-icon"></span>
              <div class="policy-heading">
                <div class="skeleton-title-line"></div>
                <div class="skeleton-desc-line"></div>
              </div>
              <span class="skeleton-switch"></span>
            </div>
          </div>
        </div>

        <template v-else>
        <section class="policy-card" :class="{ 'is-on': leavesObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="CalendarIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Allow Leaves</h6>
              <p class="policy-desc">
                Casual &amp; sick leave allowance per department
              </p>
            </div>
            <b-form-checkbox
              v-model="leavesObj.enabled"
              switch
              class="policy-switch"
              @change="onAllowLeavesToggle"
            />
          </div>
          <div v-if="leavesObj.enabled" class="policy-body">
            <div
              v-for="(row, rIndex) in leavePolicyRows"
              :key="row.uid"
            >
              <div class="leave-policy-row">
                <div
                  class="leave-policy-grid"
                  :class="{ 'leave-policy-grid--stjacob': isMyskoolStJacobDomain }"
                >
                  <div class="leave-policy-field leave-policy-dept">
                    <label class="leave-policy-label">Department</label>
                    <v-select
                      v-model="row.departmentID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="leaveDeptOptions(row)"
                      :reduce="(opt) => opt.id"
                      label="name"
                      :clearable="false"
                      placeholder="Select department"
                      @input="(val) => onLeaveDeptChange(row, val)"
                    />
                  </div>
                  <div class="leave-policy-field leave-policy-cat">
                    <label class="leave-policy-label">Category</label>
                    <v-select
                      v-model="row.leavesObj.option"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="bonusOptions"
                      :reduce="(opt) => opt.text"
                      label="text"
                      :clearable="false"
                      placeholder="Select"
                      @input="onLeaveCategoryChange(row)"
                    />
                  </div>
                  <div class="leave-policy-field leave-policy-num">
                    <label class="leave-policy-label">
                      <span
                        v-b-tooltip.hover.top
                        title="Casual Leave - Leave for personal reasons, vacations, or short absences"
                        class="cursor-pointer"
                      >
                        C.L Allowed
                      </span>
                    </label>
                    <b-form-input
                      placeholder="0"
                      type="number"
                      :state="leaveRequiredState(row.leavesObj.number)"
                      v-model="row.leavesObj.number"
                    />
                  </div>
                  <div class="leave-policy-field leave-policy-num">
                    <label class="leave-policy-label">
                      <span
                        v-b-tooltip.hover.top
                        title="Sick Leave - Leave specifically for health-related absences and medical appointments"
                        class="cursor-pointer"
                      >
                        S.L Allowed
                      </span>
                    </label>
                    <b-form-input
                      placeholder="0"
                      type="number"
                      :state="leaveRequiredState(row.sickLeaveObj.number)"
                      v-model="row.sickLeaveObj.number"
                    />
                  </div>
                  <div
                    v-if="row.leavesObj.option === 'Yearly'"
                    class="leave-policy-field leave-policy-num"
                  >
                    <label class="leave-policy-label">
                      <span
                        v-b-tooltip.hover.top
                        title="Maximum number of leaves allowed per month"
                        class="cursor-pointer"
                      >
                        M.L per Month
                      </span>
                    </label>
                    <b-form-input
                      placeholder="0"
                      type="number"
                      :state="leaveMaxState(row)"
                      v-model="row.maxObj.number"
                    />
                  </div>
                  <div
                    v-if="isMyskoolStJacobDomain"
                    class="leave-policy-field leave-policy-months"
                  >
                    <label class="leave-policy-label">
                      <span
                        v-b-tooltip.hover.top
                        title="Months when this casual/sick allowance applies (salary month)"
                        class="cursor-pointer"
                      >
                        Include months
                      </span>
                    </label>
                    <b-form-checkbox-group
                      v-model="row.includeMonths"
                      :options="stJacobLeaveMonthCheckboxOptions"
                      buttons
                      button-variant="outline-primary"
                      size="sm"
                      class="stjacob-months-btn-group"
                    />
                  </div>
                </div>
                <div class="leave-policy-actions">
                  <b-button
                    v-if="rIndex === leavePolicyRows.length - 1"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon rounded-circle"
                    v-b-tooltip.hover.top
                    title="Add another department"
                    @click="addLeavePolicyRow()"
                  >
                    <feather-icon size="16" icon="PlusIcon" />
                  </b-button>
                  <b-button
                    v-if="leavePolicyRows.length > 1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                    v-b-tooltip.hover.top
                    title="Remove this department"
                    @click="removeLeavePolicyRow(rIndex)"
                  >
                    <feather-icon size="16" icon="Trash2Icon" />
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': lateObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="ClockIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Late Coming Deduction</h6>
              <p class="policy-desc">Convert late arrivals into absent days</p>
            </div>
            <b-form-checkbox
              v-model="lateObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="lateObj.enabled" class="policy-body">
            <div class="policy-grid">
              <div class="policy-field">
                <label class="policy-label">Late Coming Scale</label>
                <b-form-input
                  placeholder="Enter late coming scale"
                  ref="lateScale"
                  type="number"
                  v-model="lateObj.number"
                  @input="setLateHint()"
                />
                <p v-if="showLateHint" class="policy-hint">
                  ({{ lateObj.number ? lateObj.number : "n" }}) late comings
                  equal to 1 absent
                </p>
              </div>
              <div class="policy-field policy-field--switch">
                <label class="policy-label">Deduct For Every Late</label>
                <b-form-checkbox
                  v-model="lateObj.option"
                  switch
                  value="Yes"
                  unchecked-value="No"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': minuteObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="WatchIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Late Coming Deduction (minutes)</h6>
              <p class="policy-desc">Charge a fixed amount per late minute</p>
            </div>
            <b-form-checkbox
              v-model="minuteObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="minuteObj.enabled" class="policy-body">
            <div class="policy-grid">
              <div class="policy-field">
                <label class="policy-label">Rupees per minute</label>
                <b-form-input
                  placeholder="Enter rupees per minute"
                  ref="lateAmount"
                  type="number"
                  v-model="minuteObj.number"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': shortObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="ScissorsIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Short Leave Deduction</h6>
              <p class="policy-desc">Convert short leaves into absent days</p>
            </div>
            <b-form-checkbox
              v-model="shortObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="shortObj.enabled" class="policy-body">
            <div class="policy-grid">
              <div class="policy-field">
                <label class="policy-label">Short Leave Scale</label>
                <b-form-input
                  placeholder="Enter short leave scale"
                  ref="shortScale"
                  type="number"
                  v-model="shortObj.number"
                  @input="setHalfHint()"
                />
                <p v-if="showHalfHint" class="policy-hint">
                  ({{ shortObj.number ? shortObj.number : "n" }}) short leaves
                  equal to 1 absent
                </p>
              </div>
              <div class="policy-field policy-field--switch">
                <label class="policy-label">Deduct For Every Short Leave</label>
                <b-form-checkbox
                  v-model="shortObj.option"
                  switch
                  value="Yes"
                  unchecked-value="No"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': earlyObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="LogOutIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Early Departure</h6>
              <p class="policy-desc">
                Convert early departures into absent days
              </p>
            </div>
            <b-form-checkbox
              v-model="earlyObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="earlyObj.enabled" class="policy-body">
            <div class="policy-grid">
              <div class="policy-field">
                <label class="policy-label">Early Departure Scale</label>
                <b-form-input
                  placeholder="Enter early departure scale"
                  ref="earlyScale"
                  type="number"
                  v-model="earlyObj.number"
                  @input="setEarlyHint()"
                />
                <p v-if="showEarly" class="policy-hint">
                  ({{ earlyObj.number ? earlyObj.number : "n" }}) early
                  departures equal to 1 absent
                </p>
              </div>
              <div class="policy-field policy-field--switch">
                <label class="policy-label">
                  Deduct For Every Early Departure
                </label>
                <b-form-checkbox
                  v-model="earlyObj.option"
                  switch
                  value="Yes"
                  unchecked-value="No"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': attObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="AwardIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">100% Attendance Allowance</h6>
              <p class="policy-desc">
                Reward staff with perfect monthly attendance
              </p>
            </div>
            <b-form-checkbox
              v-model="attObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="attObj.enabled" class="policy-body">
            <div class="policy-field">
              <label class="policy-label">Departments</label>
              <v-select
                v-model="attDeptSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="attDeptOptions"
                :reduce="(opt) => opt.id"
                label="name"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                placeholder="Select departments"
                @input="setAttDept()"
              />
              <p class="policy-hint">
                {{
                  attDeptIsAll
                    ? "Allowance applies to all departments."
                    : "Allowance applies only to the selected department(s)."
                }}
              </p>
            </div>
            <div class="policy-grid">
              <div class="policy-field">
                <label class="policy-label">Based On</label>
                <v-select
                  ref="att_allow"
                  v-model="attObj.option"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="attTypes"
                  :reduce="(opt) => opt.text"
                  label="text"
                  :clearable="false"
                  placeholder="Select"
                  @input="checkFields()"
                />
              </div>
              <div class="policy-field">
                <label
                  v-if="attObj.option == 'Fixed amount'"
                  class="policy-label"
                >
                  Amount
                </label>
                <label
                  v-else-if="attObj.option == 'Percentage'"
                  class="policy-label"
                >
                  Percentage
                </label>
                <b-form-input
                  v-if="attObj.option == 'Fixed amount'"
                  placeholder="Enter amount"
                  type="number"
                  ref="amount"
                  v-model="attObj.number"
                />
                <b-form-input
                  v-else-if="attObj.option == 'Percentage'"
                  placeholder="Enter percentage"
                  type="number"
                  ref="percentage"
                  v-model="attObj.number"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': encashObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="DollarSignIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Leave Encashment</h6>
              <p class="policy-desc">Encash remaining leaves into salary</p>
            </div>
            <b-form-checkbox
              v-model="encashObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="encashObj.enabled" class="policy-body">
            <div class="policy-grid">
              <div class="policy-field">
                <label class="policy-label">Maximum Encashment Leaves</label>
                <b-form-input
                  placeholder="Enter max no.of leaves"
                  type="number"
                  ref="maxEn"
                  v-model="encashObj.number"
                  @input="checkMax()"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="policy-card" :class="{ 'is-on': sandwichObj.enabled }">
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="LayersIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Sandwich Policy</h6>
              <p class="policy-desc">
                Count the gap between two absences as absent
              </p>
            </div>
            <b-form-checkbox
              v-model="sandwichObj.enabled"
              switch
              class="policy-switch"
            />
          </div>
          <div v-if="sandwichObj.enabled" class="policy-body">
            <div class="policy-field">
              <label class="policy-label">Departments</label>
              <v-select
                ref="sandwich_dept"
                v-model="sandwichDeptSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { name: 'All Departments', id: 0 },
                  ...departments,
                ]"
                :reduce="(opt) => opt.id"
                label="name"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                placeholder="Select departments"
                @input="setSandwichDep()"
              />
            </div>
          </div>
        </section>

        <section
          v-if="showLeavesAllowedDepartment"
          class="policy-card"
          :class="{ 'is-on': leavesAllowedDeptObj.enabled }"
        >
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="UsersIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Leaves Allowed Department</h6>
              <p class="policy-desc">
                Only the selected departments receive paid leaves
              </p>
            </div>
            <b-form-checkbox
              v-model="leavesAllowedDeptObj.enabled"
              switch
              class="policy-switch"
              @change="onLeavesAllowedDeptToggle"
            />
          </div>
          <div v-if="leavesAllowedDeptObj.enabled" class="policy-body">
            <div class="policy-field">
              <label class="policy-label">Departments</label>
              <v-select
                ref="leaves_allowed_dept"
                v-model="leavesAllowedDeptSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departments"
                :reduce="(opt) => opt.id"
                label="name"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                placeholder="Select departments"
              />
            </div>
          </div>
        </section>

        <section
          v-if="
            (salaryLedgerObj && salaryLedgerObj.valueBool) ||
            (showLeavesSessionSettings &&
              (leavesSessionObj ||
                leavesStartMonthObj ||
                leavesEndMonthObj))
          "
          class="policy-card is-on"
        >
          <div class="policy-head">
            <span class="policy-icon">
              <feather-icon icon="SettingsIcon" size="18" />
            </span>
            <div class="policy-heading">
              <h6 class="policy-title">Accounts &amp; Session</h6>
              <p class="policy-desc">
                Ledger accounts and leave session window
              </p>
            </div>
          </div>
          <div class="policy-body">
            <template v-if="salaryLedgerObj && salaryLedgerObj.valueBool">
              <div v-if="salaryExpenseObj" class="policy-field">
                <label class="policy-label">Salary Expense Account</label>
                <v-select
                  v-model="salaryExpenseObj.valueNumber"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="coAccounts"
                  :reduce="(opt) => opt.id"
                  :clearable="true"
                  label="title"
                  placeholder="Select account"
                  @input="(e) => !e && (salaryExpenseObj.valueNumber = 0)"
                />
              </div>
              <div v-if="salaryPayableObj" class="policy-field">
                <label class="policy-label">Salary Payable Account</label>
                <v-select
                  v-model="salaryPayableObj.valueNumber"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="coAccounts"
                  :reduce="(opt) => opt.id"
                  :clearable="true"
                  label="title"
                  placeholder="Select account"
                  @input="(e) => !e && (salaryPayableObj.valueNumber = 0)"
                />
              </div>
            </template>

            <div
              v-if="showLeavesSessionSettings && leavesSessionObj"
              class="policy-field"
            >
              <label class="policy-label">Leaves Session</label>
              <v-select
                v-model="leavesSessionObj.valueNumber"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sessions"
                :reduce="(opt) => opt.id"
                :clearable="true"
                label="session"
                placeholder="Select session"
                @input="(e) => !e && (leavesSessionObj.valueNumber = 0)"
              />
            </div>

            <div v-if="showLeavesSessionSettings" class="policy-grid">
              <div v-if="leavesStartMonthObj" class="policy-field">
                <label class="policy-label">Leaves Start Month</label>
                <v-select
                  v-model="leavesStartMonthObj.valueNumber"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  label="text"
                  :reduce="(month) => month.value"
                  :clearable="true"
                  placeholder="Select month"
                  @input="(e) => !e && (leavesStartMonthObj.valueNumber = 0)"
                />
              </div>
              <div v-if="leavesEndMonthObj" class="policy-field">
                <label class="policy-label">Leaves End Month</label>
                <v-select
                  v-model="leavesEndMonthObj.valueNumber"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  label="text"
                  :reduce="(month) => month.value"
                  :clearable="true"
                  placeholder="Select month"
                  @input="(e) => !e && (leavesEndMonthObj.valueNumber = 0)"
                />
              </div>
            </div>
          </div>
        </section>
        </template>
      </div>

      <div class="settings-footer">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="settings-save"
          @click="saveSettings()"
          :disabled="saving || settLoading"
          block
        >
          <b-spinner v-if="saving" small type="grow" class="mr-50" />
          <feather-icon v-else icon="SaveIcon" size="16" class="mr-50" />
          <span>{{ saving ? "Saving..." : $t("Save Settings") }}</span>
        </b-button>
      </div>
      </div>
    </b-sidebar>

    <b-modal
      id="modal-history"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      title="History"
    >
      <b-form>
        <b-form-group
          label="Salary Month"
          invalid-feedback="Salary Month is required."
          ref="his_month"
        >
          <v-select
            v-model="history.month"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="months"
            label="text"
            :reduce="(month) => month.value"
            :clearable="false"
            ref="month"
            placeholder="Select a month"
          />
        </b-form-group>

        <b-form-group
          label="Year"
          invalid-feedback="Year is required."
          ref="his_year"
        >
          <v-select
            v-model="history.year"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="years"
            :clearable="false"
            ref="his_year"
            placeholder="Select year"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="showHistory()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">Show</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-payroll"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="showMsg ? 'WhatsApp Pay Slip' : 'Payroll Report'"
    >
      <b-form>
        <b-form-group
          v-if="!showMsg"
          label="Report"
          invalid-feedback="Report is required."
          ref="pay_report"
        >
          <v-select
            v-model="payroll.report"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="reportOptions"
            label="text"
            :reduce="(opt) => opt.value"
            :clearable="false"
            ref="pay_report"
            placeholder="Select report"
          />
        </b-form-group>

        <b-form-group
          v-if="['myskoolhpgs'].includes(reportDomain) && !showMsg"
          label="Campus"
          invalid-feedback="Campus is required."
          ref="camp"
        >
          <v-select
            multiple
            :closeOnSelect="false"
            v-model="payroll.cIDs"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ branch: 'All Campuses', id: 0 }, ...campuses]"
            :clearable="false"
            :reduce="(val) => val.id"
            label="branch"
            placeholder="Select campus"
            @input="setCampus()"
          />
        </b-form-group>

        <b-form-group
          label="Departments"
          invalid-feedback="Department is required."
          ref="pay_depart"
        >
          <!-- multiple
        :closeOnSelect="false" -->
          <v-select
            v-model="payroll.depIDs"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ name: 'All Departments', id: 0 }, ...departments]"
            :reduce="(opt) => opt.id"
            label="name"
            :clearable="false"
            placeholder="Select department"
          />
          <!-- @input="setDeps()" -->
        </b-form-group>

        <b-form-group
          label="Salary Month"
          invalid-feedback="Salary Month is required."
          ref="pay_month"
        >
          <v-select
            v-model="payroll.month"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="months"
            label="text"
            :reduce="(month) => month.value"
            :clearable="false"
            ref="pay_month"
            placeholder="Select a month"
          />
        </b-form-group>

        <b-form-group
          label="Year"
          invalid-feedback="Year is required."
          ref="pay_year"
        >
          <v-select
            v-model="payroll.year"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="years"
            :clearable="false"
            ref="pay_year"
            placeholder="Select year"
          />
        </b-form-group>

        <b-form-group v-if="isKentSchoolDomain && !payroll.report" label="Paid">
          <v-select
            v-model="payrollPaidFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="payrollPaidOptions"
            :reduce="(opt) => opt.value"
            label="text"
            :clearable="false"
            placeholder="Paid"
          />
        </b-form-group>

        <template v-if="!showMsg && payroll.report == 'bank'">
          <b-form-group
            label="Date"
            invalid-feedback="Date is required"
            ref="pay_date"
          >
            <flat-pickr
              ref="pay_date"
              :config="config"
              v-model="payroll.date"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>

          <b-form-group
            label="Cheque Number"
            invalid-feedback="Cheque Number is required"
            ref="pay_cheq"
          >
            <b-form-input
              ref="pay_cheq"
              placeholder="Enter cheque number"
              v-model.trim="payroll.cheque"
            />
          </b-form-group>

          <template v-if="['myskoolhpgs'].includes(reportDomain)">
            <b-form-group
              label="Account"
              invalid-feedback="Account is required."
              ref="pay_acc"
            >
              <v-select
                v-model="payroll.accountID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ account: 'All Accounts', id: 0 }, ...accTypes]"
                :reduce="(opt) => opt.id"
                label="account"
                :clearable="false"
                placeholder="Select account type"
                @input="LoadAccBranch()"
              />
            </b-form-group>

            <b-form-group
              label="Branch"
              invalid-feedback="Branch is required."
              ref="pay_branch"
            >
              <v-select
                v-model="payroll.branchID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ branch: 'All Branches', id: 0 }, ...accBranches]"
                :reduce="(opt) => opt.id"
                label="branch"
                :clearable="false"
                :disabled="accBranchLoading || disAccBranch"
                placeholder="Select branch"
              />
            </b-form-group>
          </template>
        </template>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex align-items-start justify-content-end flex-wrap">
          <b-button
            v-if="showMsg"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="success"
            :disabled="sending"
            class=""
            @click="send()"
          >
            <b-spinner v-if="sending" small type="grow" />
            <span v-else> Send </span>
          </b-button>

          <template v-else>
            <b-button
              v-if="salaryLedgerObj && salaryLedgerObj.valueBool"
              @click="createLedger()"
              :disabled="exporting || updating || creatingLedger"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="success"
              class="mb-50 mr-auto"
            >
              <b-spinner
                v-if="creatingLedger"
                small
                type="grow"
                class="mr-25"
              />
              <span class="align-middle">Create Ledger</span>
            </b-button>
            <b-button
              @click="showPayroll()"
              :disabled="exporting || updating"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              class="mb-50"
            >
              <span class="align-middle">Show</span>
            </b-button>
            <b-button
              @click="exportPayroll()"
              :disabled="exporting || updating"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              class="ml-50 mb-50"
            >
              <span class="align-middle">Export</span>
            </b-button>
          </template>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-encashment-report"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      title="Leave Encashment Report"
    >
      <b-form>
        <b-form-group label="Session" invalid-feedback="Session is required.">
          <v-select
            v-model="encashmentReportSessionID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sessions"
            :reduce="(opt) => opt.id"
            :clearable="false"
            label="session"
            placeholder="Select session"
          />
        </b-form-group>

        <b-form-group
          v-if="encashmentReportType !== 'summary'"
          label="Department"
        >
          <v-select
            v-model="encashmentReportDepID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ name: 'All Departments', id: 0 }, ...departments]"
            :reduce="(opt) => opt.id"
            label="name"
            :clearable="false"
            placeholder="Select department"
          />
        </b-form-group>

        <b-form-group label="Report Type">
          <v-select
            v-model="encashmentReportType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="encashmentReportTypeOptions"
            :reduce="(opt) => opt.value"
            label="label"
            :clearable="false"
            placeholder="Select report type"
          />
        </b-form-group>

        <b-form-group
          v-if="encashmentReportType === 'bank'"
          label="Bank No"
          invalid-feedback="Bank number is required."
        >
          <b-form-input
            v-model="encashmentReportBankNo"
            placeholder="Enter bank number"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex align-items-start justify-content-end flex-wrap">
          <b-button
            @click="exportLeaveEncashmentReport()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-primary"
            class="mb-50 mr-50"
            :disabled="encashmentReportExporting"
          >
            <b-spinner
              v-if="encashmentReportExporting"
              small
              variant="primary"
              class="mr-50"
            />
            <span class="align-middle">Export</span>
          </b-button>
          <b-button
            @click="openLeaveEncashmentReport()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-50"
          >
            <span class="align-middle">Generate Report</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-returns"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      title="Return Deposites"
    >
      <b-form>
        <b-form-group
          label="Deductions"
          invalid-feedback="Deductions is required."
          ref="ret_deds"
        >
          <v-select
            multiple
            :closeOnSelect="false"
            v-model="returnIDs"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="deductions"
            :reduce="(opt) => opt.id"
            label="title"
            :clearable="false"
            placeholder="Select deductions"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="saveReturns()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="returnLoading"
          >
            <span class="align-middle">Save</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Edit Amount Modal -->
    <b-modal
      id="deposit-amount-edit-modal"
      title="Edit Amount"
      centered
      hide-footer
    >
      <b-form @submit.prevent v-if="editAmountObj">
        <b-form-group
          label="Amount"
          invalid-feedback="Amount is required"
          ref="edit_amount"
        >
          <b-form-input
            type="number"
            v-model="editAmountObj.amount"
            placeholder="Enter amount"
          />
        </b-form-group>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="success"
            @click="saveEditAmount()"
            :disabled="isUpdatingAmount"
          >
            <b-spinner v-if="isUpdatingAmount" small type="grow" />
            <span v-else>{{ $t("Save") }}</span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-att"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="attendanceModalTitle"
    >
      <b-row class="mb-3">
        <b-col>
          <h6 class="mb-2">Status</h6>
          <div class="status-buttons-container">
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'P' ? 'success' : 'outline-success'"
              @click="currentObj.status = 'P'"
            >
              P
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'A' ? 'danger' : 'outline-danger'"
              @click="currentObj.status = 'A'"
            >
              A
            </b-button>
            <b-button
              v-if="doubleObj && doubleObj.valueBool == true"
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'AA' ? 'danger' : 'outline-danger'"
              @click="currentObj.status = 'AA'"
            >
              AA
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'L' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'L'"
            >
              L
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'SL' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'SL'"
            >
              SL
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status.toLowerCase() == 'late'
                  ? 'warning'
                  : 'outline-warning'
              "
              @click="currentObj.status = 'Late'"
            >
              Late
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'H' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'H'"
            >
              H
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'HL' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'HL'"
            >
              HL
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status == 'Off' ? 'secondary' : 'outline-secondary'
              "
              @click="currentObj.status = 'Off'"
            >
              Off
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status == 'Extra Day' ? 'primary' : 'outline-primary'
              "
              @click="currentObj.status = 'Extra Day'"
            >
              Extra Day
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'WFH' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'WFH'"
            >
              WFH
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="!['A', 'L', 'H', 'SL', 'Off'].includes(currentObj.status)"
        class="mb-3"
      >
        <b-col md="6">
          <b-form-group
            label="Time In"
            invalid-feedback="Time In is required"
            ref="edit_time_in"
          >
            <flat-pickr
              :config="timeConfig"
              v-model="currentObj.timeIn"
              class="form-control"
              placeholder="Select Time In"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Time Out"
            invalid-feedback="Time Out is required"
            ref="edit_time_out"
          >
            <flat-pickr
              :config="timeConfig"
              v-model="currentObj.timeOut"
              class="form-control"
              placeholder="Select Time Out"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="saveAtt()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="success"
            :disabled="savingAtt"
          >
            <b-spinner v-if="savingAtt" small type="grow" />
            <span v-else class="align-middle">Save</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-create"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      title="Generate Salary"
    >
      <b-form>
        <b-form-group
          v-if="
            reportDomain !== 'myskoolbrightfuture' &&
            (reportDomain !== 'myskooliuss' || $store.state.userData.cId == 1)
          "
          label="Campus"
          invalid-feedback="Campus is required."
          ref="sal_camp"
        >
          <v-select
            :key="'gen-sal-campus-' + campusSelectOptions.length + '-' + salObj.campusID"
            v-model="salObj.campusID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="campusSelectOptions"
            :clearable="false"
            :reduce="(val) => val.id"
            label="branch"
            append-to-body
            placeholder="Select campus"
          />
        </b-form-group>

        <template v-if="usesSalaryDateRange">
          <b-form-group
            label="Salary Period"
            invalid-feedback="Date range is required."
            ref="sal_range"
          >
            <flat-pickr
              :config="config2"
              v-model="salObj.dateRange"
              class="form-control"
              placeholder="Select salary date range"
              @on-change="onGenerateRangeChange"
            />
          </b-form-group>
          <b-form-group
            label="Month"
            invalid-feedback="Salary Month is required."
            ref="sal_month_myskooliuss"
          >
            <v-select
              v-model="salObj.month"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="months"
              label="text"
              :reduce="(month) => month.value"
              :clearable="false"
              placeholder="Select a month"
              @input="onGenerateMonthChange"
            />
          </b-form-group>
          <b-form-group
            label="Year"
            invalid-feedback="Year is required."
            ref="sal_year_myskooliuss"
          >
            <v-select
              v-model="salObj.year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="years"
              :clearable="false"
              placeholder="Select year"
              @input="onGenerateYearChange"
            />
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group
            label="Salary Month"
            invalid-feedback="Salary Month is required."
            ref="sal_month"
          >
            <v-select
              v-model="salObj.month"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="months"
              label="text"
              :reduce="(month) => month.value"
              :clearable="false"
              placeholder="Select a month"
            />
          </b-form-group>

          <b-form-group
            label="Year"
            invalid-feedback="Year is required."
            ref="sal_year"
          >
            <v-select
              v-model="salObj.year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="years"
              :clearable="false"
              placeholder="Select year"
            />
          </b-form-group>
        </template>
      </b-form>
      <div v-if="!salSaving" class="generate-modal-footer">
        <b-button
          block
          @click="createSalary()"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="primary"
          class="generate-create-btn"
          :disabled="salSaving"
        >
          <span class="align-middle">Create</span>
        </b-button>
      </div>

      <!-- Generating state: shimmer placeholders instead of a frozen button -->
      <div v-else class="generate-progress">
        <div class="generate-progress__head">
          <b-spinner small variant="primary" class="mr-50" />
          <span>Generating salary… this can take a moment.</span>
        </div>
        <div class="generate-progress__skeleton">
          <div
            v-for="n in 3"
            :key="`gen-skel-${n}`"
            class="generate-progress__tile"
          ></div>
        </div>
      </div>
    </b-modal>

    <!-- Generate Salary result -->
    <b-modal
      id="modal-generate-result"
      :size="generateResult && generateResult.mode === 'ledger' ? 'xl' : 'lg'"
      hide-footer
      centered
      no-close-on-backdrop
      :title="generateResultModalTitle"
      modal-class="salary-gen-result-modal"
      content-class="salary-gen-result-modal__content"
      body-class="salary-gen-result-modal__body"
    >
      <template v-if="generateResult">
        <div class="gen-modal__head">
          <span
            class="gen-modal__status-icon"
            :class="{ 'is-warn': generateResult.skippedCount > 0 }"
          >
            <feather-icon
              :icon="
                generateResult.skippedCount > 0
                  ? 'AlertTriangleIcon'
                  : 'CheckCircleIcon'
              "
              size="20"
            />
          </span>
          <div class="gen-modal__head-text">
            <h5 class="gen-modal__title">
              {{ generateResultHeadline }}
            </h5>
            <p v-if="generateResultShortText" class="gen-modal__subtitle">
              {{ generateResultShortText }}
            </p>
          </div>
        </div>

        <div class="gen-modal__stats">
          <div class="gen-stat">
            <span class="gen-stat__label">Attempted</span>
            <span class="gen-stat__value">{{ generateResult.attempted }}</span>
          </div>
          <div class="gen-stat is-created">
            <span class="gen-stat__label">Created</span>
            <span class="gen-stat__value">{{ generateResult.created }}</span>
          </div>
          <div class="gen-stat is-updated">
            <span class="gen-stat__label">Updated</span>
            <span class="gen-stat__value">{{ generateResult.updated }}</span>
          </div>
          <div class="gen-stat is-skipped">
            <span class="gen-stat__label">Skipped</span>
            <span class="gen-stat__value">{{ generateResult.skippedCount }}</span>
          </div>
        </div>

        <p
          v-if="generateResult.periodLabel"
          class="gen-modal__period-label"
        >
          {{ generateResult.periodLabel }}
        </p>

        <div
          v-if="generateResult.showCreatedList"
          class="gen-modal__staff-block is-created"
        >
          <h6 class="gen-modal__block-title">
            <feather-icon icon="CheckCircleIcon" size="14" class="mr-50" />
            Created ({{ generateResult.createdList.length }})
          </h6>
          <div
            class="gen-modal__staff-list"
            :class="{ 'is-ledger-scroll': generateResult.mode === 'ledger' }"
          >
            <div
              v-for="row in generateResult.createdList"
              :key="row.key"
              class="gen-staff-result-row is-created"
            >
              <div class="gen-staff-result-row__head">
                <span class="gen-staff-result-row__name">{{ row.staffName }}</span>
                <span class="gen-staff-result-row__id">ID {{ row.staffID }}</span>
              </div>
              <p class="gen-staff-result-row__meta">{{ row.metaLine }}</p>
            </div>
          </div>
        </div>

        <div
          v-if="generateResult.showUpdatedList"
          class="gen-modal__staff-block is-updated"
        >
          <h6 class="gen-modal__block-title">
            <feather-icon icon="RefreshCwIcon" size="14" class="mr-50" />
            Updated ({{ generateResult.updatedList.length }})
          </h6>
          <div
            class="gen-modal__staff-list"
            :class="{ 'is-ledger-scroll': generateResult.mode === 'ledger' }"
          >
            <div
              v-for="row in generateResult.updatedList"
              :key="row.key"
              class="gen-staff-result-row is-updated"
            >
              <div class="gen-staff-result-row__head">
                <span class="gen-staff-result-row__name">{{ row.staffName }}</span>
                <span class="gen-staff-result-row__id">ID {{ row.staffID }}</span>
              </div>
              <p class="gen-staff-result-row__meta">{{ row.metaLine }}</p>
              <p
                v-if="row.replacedLine"
                class="gen-staff-result-row__sub"
              >
                {{ row.replacedLine }}
              </p>
            </div>
          </div>
        </div>

        <p
          v-else-if="generateResult.updatedList.length && generateResult.updatedSummary"
          class="gen-modal__compact-summary is-updated"
        >
          {{ generateResult.updatedSummary }}
        </p>

        <p
          v-if="
            generateResult.skippedCount > 0 && !generateResult.showSkippedList
          "
          class="gen-modal__skipped-summary"
        >
          {{ generateResult.skippedSummary }}
        </p>

        <div
          v-if="generateResult.showSkippedList"
          class="gen-modal__skipped"
        >
          <h6 class="gen-modal__skipped-title">
            <feather-icon icon="AlertTriangleIcon" size="14" class="mr-50" />
            Skipped staff ({{ generateResult.skippedCount }})
          </h6>
          <p
            v-if="generateResult.skippedReasonSummary"
            class="gen-modal__skipped-reason-hint"
          >
            {{ generateResult.skippedReasonSummary }}
          </p>
          <div class="gen-modal__skipped-list">
            <div
              v-for="row in generateResult.skipped"
              :key="row.key"
              class="gen-skip-row"
            >
              <div class="gen-skip-row__staff">
                <span class="gen-skip-row__name">{{ row.staffName }}</span>
                <span class="gen-skip-row__id">ID {{ row.staffID }}</span>
              </div>
              <span class="gen-skip-row__reason">{{ row.reason }}</span>
            </div>
          </div>
        </div>
      </template>

      <div class="gen-modal__footer">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="gen-modal__done-btn"
          @click="closeGenerateResult()"
        >
          Done
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="modal-account"
      size="lg"
      :title="modalTitle"
      hide-footer
      centered
      no-close-on-backdrop
    >
      <AccountBranch
        :currentAccount="currentAccount"
        :campuses="campuses"
        :getCampus="getCampus"
      />
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      class="salary-form-sidebar salary-form-sidebar--loan"
      right
      no-header
      backdrop
      shadow
    >
      <div class="sidebar-header-modern">
        <div class="sidebar-header-content">
          <div class="sidebar-title-block">
            <div class="sidebar-title-wrapper">
              <feather-icon
                icon="DollarSignIcon"
                size="22"
                class="sidebar-title-icon"
              />
              <h5 class="mb-0 sidebar-title">Advance / Loan</h5>
            </div>
            <small class="sidebar-subtitle d-block"
              >Installments preview below</small
            >
          </div>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="sidebar-close-btn"
            @click="visibility2 = false"
          >
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
      </div>
      <div class="sidebar-body-modern">
      <b-form class="sidebar-form-modern" @submit.prevent>
        <b-row class="mt-0">
          <b-col md="12" class="mb-1">
            <div
              class="salary-type-segment"
              role="tablist"
              :class="{
                'salary-type-segment--loan': loanObj.loanType === 'loan',
              }"
            >
              <span class="salary-type-segment__glide" aria-hidden="true"></span>
              <button
                v-for="t in typeOptions"
                :key="t.value"
                type="button"
                class="salary-type-segment__btn"
                :class="{ 'is-active': t.value == loanObj.loanType }"
                :disabled="loanObj.id > 0"
                @click="loanObj.loanType = t.value"
              >
                {{ t.text }}
              </button>
            </div>
          </b-col>
          <b-col md="12" v-if="false">
            <b-form-group
              label="Date"
              invalid-feedback="Date is required"
              ref="loan_date"
            >
              <flat-pickr
                :disabled="loanObj.id > 0"
                ref="loan_date"
                :config="config"
                v-model="loanObj.date"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
              <!-- @on-change="checkLoanDate()" -->
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Amount"
              class="modern-form-group"
              invalid-feedback="Amount is required"
              ref="loan_amount"
            >
              <b-form-input
                :disabled="loanObj.id > 0"
                ref="loan_amount"
                type="number"
                id="mc-first-name"
                class="modern-input"
                placeholder="Enter amount"
                v-model="loanObj.amount"
                @input="checkLoanAmount()"
                @focusout="setInstallment()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Return in months"
              class="modern-form-group"
              invalid-feedback="Invalid Month"
              ref="loan_month"
            >
              <b-form-input
                :disabled="loanObj.id > 0"
                ref="loan_month"
                type="number"
                class="modern-input"
                placeholder="Enter no. of months"
                v-model="loanObj.months"
                @input="checkMonth()"
                @focusout="setInstallment()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Installment Amount"
              class="modern-form-group"
              invalid-feedback="Invalid Amount"
              ref="return_amount"
            >
              <b-form-input
                :disabled="loanObj.id > 0"
                ref="return_amount"
                type="number"
                class="modern-input"
                placeholder="Amount to return per month"
                v-model="loanObj.monthlyInstallments"
                @input="checkRetAmount()"
                @focusout="setbyRetAmount()"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col md="12">
            <b-form-group label="Deduct From" invalid-feedback="Invalid Amount">
              <v-select
                v-model="sameMonth"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="deductOption"
                label="text"
                :reduce="(opt) => opt.value"
                :clearable="false"
                placeholder="Select"
              />
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <label class="modern-inline-label">Deduct From</label>
          </b-col>

          <b-col md="6">
            <b-form-group label="" class="modern-form-group" invalid-feedback="Invalid Amount">
              <v-select
                v-model="loanMonth"
                class="modern-select"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="months"
                label="text"
                :reduce="(opt) => opt.value"
                :clearable="false"
                placeholder="Select"
                :disabled="loanObj.id > 0"
                @input="setInstallment()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="" class="modern-form-group" invalid-feedback="Invalid Amount">
              <v-select
                v-model="loanYear"
                class="modern-select"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="years"
                :clearable="false"
                placeholder="Select"
                :disabled="loanObj.id > 0"
                @input="setInstallment()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-table
              class="salary-install-table mt-50"
              :items="installData"
              :fields="installFields"
              show-empty
              responsive
              small
            >
              <template #empty>
                <div class="salary-sidebar-empty">
                  <feather-icon icon="ListIcon" size="32" />
                  <p class="salary-sidebar-empty__title">No installments yet</p>
                  <p class="salary-sidebar-empty__hint">
                    Fill amount, months, and deduct-from date to preview the
                    schedule.
                  </p>
                </div>
              </template>
              <template #cell(month)="data">
                <b-badge variant="light-primary">
                  {{ data.item.month }} {{ data.item.year }}
                </b-badge>
              </template>
              <template #cell(amount)="data">
                <b-badge variant="light-primary">
                  Rs.{{ data.item.amount }}
                </b-badge>
                <b-badge
                  v-if="data.item.isReturned"
                  variant="light-success"
                  class="ml-1"
                >
                  Returned
                </b-badge>
              </template>
            </b-table>
          </b-col>

          <b-col class="mt-1" md="12" v-if="loanObj.id == 0">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="modern-btn-submit"
              @click="AddLoan()"
              block
              :disabled="loanSaving"
            >
              <b-spinner v-if="loanSaving" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      </div>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility5"
      sidebar-class="sidebar-lg"
      class="salary-form-sidebar salary-form-sidebar--deposit"
      right
      no-header
      backdrop
      shadow
    >
      <div class="sidebar-header-modern">
        <div class="sidebar-header-content">
          <div class="sidebar-title-block">
            <div class="sidebar-title-wrapper">
              <feather-icon
                icon="ShieldIcon"
                size="22"
                class="sidebar-title-icon"
              />
              <h5 class="mb-0 sidebar-title">Add Deposit</h5>
            </div>
            <small class="sidebar-subtitle d-block"
              >Security deposit schedule</small
            >
          </div>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="sidebar-close-btn"
            @click="visibility5 = false"
          >
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
      </div>
      <div class="sidebar-body-modern">
      <b-form class="sidebar-form-modern" @submit.prevent>
        <b-row class="mt-0">
          <b-col cols="12">
            <b-form-group
              label="Deposit Amount"
              class="modern-form-group"
              invalid-feedback="Amount is required"
              ref="depo_amount"
            >
              <b-form-input
                ref="depo_amount"
                type="number"
                id="mc-first-name"
                class="modern-input"
                placeholder="Enter amount"
                v-model="depoObj.amount"
                @input="checkDAmount()"
                @focusout="setDInstallment()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Deposit Months"
              class="modern-form-group"
              invalid-feedback="Invalid Month"
              ref="depo_month"
            >
              <b-form-input
                ref="depo_month"
                type="number"
                class="modern-input"
                placeholder="Enter no. of months"
                v-model="depoObj.months"
                @input="checkDMonth()"
                @focusout="setDInstallment()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Amount"
              class="modern-form-group"
              invalid-feedback="Invalid Amount"
              ref="depo_return"
            >
              <b-form-input
                ref="depo_return"
                type="number"
                class="modern-input"
                placeholder="Amount to return per month"
                v-model="depoObj.monthlyInstallments"
                @input="checkDRetAmount()"
                @focusout="setbyDReturn()"
              />
            </b-form-group>
          </b-col>

          <!-- <b-col md="12">
            <b-form-group label="Deduct From" invalid-feedback="Invalid Amount">
              <v-select
                v-model="sameMonth"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="deductOption"
                label="text"
                :reduce="(opt) => opt.value"
                :clearable="false"
                placeholder="Select"
              />
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <label class="modern-inline-label">Deduct From</label>
          </b-col>

          <b-col md="6">
            <b-form-group label="" class="modern-form-group" invalid-feedback="Invalid Amount">
              <v-select
                v-model="deductMonth"
                class="modern-select"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="months"
                label="text"
                :reduce="(opt) => opt.value"
                :clearable="false"
                placeholder="Select"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="" class="modern-form-group" invalid-feedback="Invalid Amount">
              <v-select
                v-model="deductYear"
                class="modern-select"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="years"
                :clearable="false"
                placeholder="Select"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <label class="modern-inline-label">Skip Months</label>
          </b-col>
          <b-col md="12">
            <div class="salary-skip-panel">
              <div class="salary-month-chip-grid">
                <button
                  v-for="mon in months"
                  :key="mon.value"
                  type="button"
                  class="salary-month-chip"
                  :class="{ 'is-skipped': skipped.includes(mon.value) }"
                  :title="mon.text"
                  @click="setSkip(mon.value)"
                >
                  <span class="salary-month-chip__label">{{
                    mon.text.slice(0, 3)
                  }}</span>
                </button>
              </div>
            </div>
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="modern-btn-submit"
              @click="AddDeposit()"
              block
              :disabled="savingDepo"
            >
              <b-spinner v-if="savingDepo" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      </div>
    </b-sidebar>

    <!-- Leave Encashment Sidebar -->
    <b-sidebar
      id="sidebar-leave-encashment"
      bg-variant="white"
      v-model="visibility7"
      class="leave-encashment-sidebar"
      width="450px"
      right
      no-header
      backdrop
      shadow
    >
      <div class="sidebar-header-modern">
        <div class="sidebar-header-content">
          <div class="sidebar-title-block">
            <div class="sidebar-title-wrapper">
              <h5 class="mb-0 sidebar-title">{{ $t("Leave Encashment") }}</h5>
            </div>
            <small
              v-if="leaveEncashmentStaffTitle"
              class="sidebar-subtitle d-block"
              >{{ leaveEncashmentStaffTitle }}</small
            >
          </div>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="sidebar-close-btn"
            @click="visibility7 = false"
          >
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
      </div>

      <div class="sidebar-body-modern">
        <b-form @submit.prevent class="sidebar-form-modern">
          <b-form-group :label="$t('Date')" class="modern-form-group">
            <flat-pickr
              :config="config"
              v-model="leaveEncashmentObj.date"
              class="form-control modern-input"
              :placeholder="$t('Select date')"
            />
          </b-form-group>

          <b-form-group :label="$t('Session')" class="modern-form-group">
            <v-select
              v-model="leaveEncashmentObj.sessionID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sessions"
              :reduce="(opt) => opt.id"
              :clearable="false"
              label="session"
              :placeholder="$t('Select session')"
              :disabled="leaveEncashmentLoading"
              class="modern-select"
              @input="onLeaveEncashmentSessionSelected"
            />
          </b-form-group>

          <b-row>
            <b-col cols="6">
              <b-form-group
                :label="$t('Start Month')"
                class="modern-form-group"
              >
                <v-select
                  v-model="leaveEncashmentObj.startMonth"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  label="text"
                  :reduce="(month) => month.value"
                  :clearable="true"
                  :placeholder="$t('Use salary setting')"
                  :disabled="leaveEncashmentLoading"
                  class="modern-select"
                  @input="loadLeaveEncashmentAmount"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group :label="$t('End Month')" class="modern-form-group">
                <v-select
                  v-model="leaveEncashmentObj.endMonth"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  label="text"
                  :reduce="(month) => month.value"
                  :clearable="true"
                  :placeholder="$t('Use salary setting')"
                  :disabled="leaveEncashmentLoading"
                  class="modern-select"
                  @input="loadLeaveEncashmentAmount"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <div
            v-if="leaveEncashmentObj.sessionID"
            class="encashment-stats-card"
            :class="{ 'is-loading': leaveEncashmentLoading }"
          >
            <div class="encashment-stat-box">
              <small class="encashment-stat-label">{{
                $t("Remaining Leaves")
              }}</small>
              <span class="encashment-stat-value">{{
                leaveEncashmentObj.remaining_leaves != null
                  ? leaveEncashmentObj.remaining_leaves
                  : "—"
              }}</span>
            </div>
            <div class="encashment-stat-box">
              <small class="encashment-stat-label">{{
                $t("Remaining Sick Leaves")
              }}</small>
              <span class="encashment-stat-value">{{
                leaveEncashmentObj.remaining_sickLeaves != null
                  ? leaveEncashmentObj.remaining_sickLeaves
                  : "—"
              }}</span>
            </div>
          </div>

          <b-form-group
            :label="$t('Leave Encashment Amount')"
            class="modern-form-group"
          >
            <b-form-input
              type="number"
              :placeholder="$t('Select session to load amount')"
              v-model="leaveEncashmentObj.encashmentAmount"
              disabled
              class="modern-input"
            />
          </b-form-group>

          <b-form-group class="modern-form-group">
            <div
              class="d-flex justify-content-between align-items-center mb-50"
            >
              <label class="modern-inline-label mb-0">{{
                $t("Salary From")
              }}</label>
              <feather-icon
                class="cursor-pointer text-primary"
                icon="BriefcaseIcon"
                size="18"
                v-b-tooltip.hover.top
                :title="$t('Accounts')"
                @click="openAccount()"
              />
            </div>
            <v-select
              v-model="leaveEncashmentObj.accountID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="accTypes"
              :reduce="(opt) => opt.id"
              label="account"
              :clearable="false"
              :placeholder="$t('Select account type')"
              class="modern-select"
            />
          </b-form-group>

          <b-form-group :label="$t('Notes')" class="modern-form-group">
            <b-form-textarea
              :placeholder="$t('Enter notes')"
              v-model="leaveEncashmentObj.notes"
              rows="3"
              class="modern-textarea"
            />
          </b-form-group>

          <div class="sidebar-footer-modern">
            <b-row>
              <b-col cols="6" class="pr-1">
                <b-button
                  type="submit"
                  variant="gradient-primary"
                  @click="saveLeaveEncashment(false)"
                  :disabled="leaveEncashmentSaving || leaveEncashmentLoading"
                  block
                  class="modern-btn-submit"
                >
                  <b-spinner
                    v-if="leaveEncashmentSaving"
                    small
                    type="grow"
                    class="mr-1"
                  />
                  <template v-else>
                    <feather-icon icon="SaveIcon" size="16" class="mr-1" />
                    <span>{{ $t("Save") }}</span>
                  </template>
                </b-button>
              </b-col>
              <b-col cols="6" class="pl-1">
                <b-button
                  variant="outline-primary"
                  @click="saveLeaveEncashment(true)"
                  :disabled="leaveEncashmentSaving || leaveEncashmentLoading"
                  block
                  class="modern-btn-submit"
                >
                  <b-spinner
                    v-if="leaveEncashmentSaving"
                    small
                    type="grow"
                    class="mr-1"
                  />
                  <template v-else>
                    <feather-icon icon="PrinterIcon" size="16" class="mr-1" />
                    <span>{{ $t("Save & Print") }}</span>
                  </template>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </div>
    </b-sidebar>

    <b-card
      class="staff-salary-card"
      :class="{
        'staff-salary-card--history': isHistory,
        'staff-salary-card--attendance': showAtt,
      }"
    >
      <div class="gradient-line-wrapper"></div>
      <div class="salary-list-header">
        <div class="salary-list-heading">
          <h4 class="salary-list-title">Staff Salary</h4>
          <small class="salary-list-subtitle">
            Create and manage monthly salary, deposits and encashment
          </small>
        </div>
      </div>
      <div class="filter-row">
        <div
          class="filter-toolbar filter-toolbar--salary"
          :class="{ 'filter-toolbar--one-line': isStaffMainToolbarOneLine }"
        >
          <div class="filter-fields-group">
            <b-form-group class="filter-search-input mb-0">
              <b-input-group>
                <b-input-group-prepend
                  is-text
                  @click="isHistory ? applyHistoryFilters() : (!isAlternateListView && loadSearch())"
                >
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  ref="searchInput"
                  v-model="searchQuery"
                  :placeholder="$t('Search') + '...'"
                  @keyup.enter="isHistory ? applyHistoryFilters() : (!isAlternateListView && loadSearch())"
                />
              </b-input-group>
            </b-form-group>

            <div class="filter-control filter-control--dept">
              <v-select
                v-model="currentDep"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ name: 'All Departments', id: 0 }, ...departments]"
                :reduce="(opt) => opt.id"
                label="name"
                :clearable="false"
                placeholder="Select department"
                @input="onDepartmentFilterChange()"
              />
            </div>

            <div
              v-if="staffListStatusFilterVisible"
              class="filter-control"
            >
              <v-select
                v-model="staffStatusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="staffStatusOptions"
                :reduce="(opt) => opt.value"
                label="text"
                :clearable="false"
                placeholder="Select status"
                :disabled="dataLoading"
                @input="onStaffStatusFilterChange"
              />
            </div>

            <template v-if="isHistory">
              <div class="filter-control">
                <v-select
                  v-model="history.month"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  label="text"
                  :reduce="(month) => month.value"
                  :clearable="true"
                  placeholder="Select month"
                  @input="onHistoryMonthFilterInput"
                />
              </div>
              <div class="filter-control">
                <v-select
                  v-model="history.year"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :get-option-label="formatHistoryYearOptionLabel"
                  :options="years"
                  :clearable="true"
                  placeholder="Select year"
                  @input="onHistoryYearFilterInput"
                />
              </div>
              <div v-if="isKentSchoolDomain" class="filter-control">
                <v-select
                  v-model="historyPaidFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="text"
                  :options="historyPaidOptions"
                  :reduce="(opt) => opt.value"
                  :clearable="false"
                  placeholder="Paid"
                  @input="onHistoryPaidFilterInput"
                />
              </div>
            </template>

            <div v-if="isEncashmentHistory" class="filter-control">
              <v-select
                v-model="encashmentHistorySessionID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sessions"
                label="session"
                :reduce="(s) => s.id"
                :clearable="false"
                placeholder="Select session"
                @input="loadEncashmentHistory()"
              />
            </div>
          </div>

          <div class="filter-actions-row staff-salary-toolbar-actions">
            <b-button
              v-if="isAlternateListView"
              class="salary-filter-action-btn salary-filter-action-btn--primary"
              @click="onClearListView()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <feather-icon icon="XIcon" class="mr-50" />
              <span class="align-middle">Clear</span>
            </b-button>
            <b-button
              v-if="!isAlternateListView"
              class="salary-filter-action-btn salary-filter-action-btn--primary"
              @click="openHistory()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <span class="align-middle">History</span>
            </b-button>
            <b-button
              v-if="showSalarySheetButton && !isAlternateListView"
              class="salary-filter-action-btn salary-filter-action-btn--outline"
              @click="openSalarySheet()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
            >
              <feather-icon icon="GridIcon" class="mr-50" />
              <span class="align-middle">Salary Sheet</span>
            </b-button>
            <b-button
              v-if="showLeaveEncashmentTab && !isAlternateListView"
              class="salary-filter-action-btn salary-filter-action-btn--primary"
              @click="openEncashmentHistory()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <span class="align-middle">Encashment History</span>
            </b-button>
            <b-button
              class="salary-filter-action-btn salary-filter-action-btn--primary"
              @click="openPayroll()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <span class="align-middle">Payroll Report</span>
            </b-button>
            <b-button
              v-if="showLeaveEncashmentTab"
              class="salary-filter-action-btn salary-filter-action-btn--primary"
              @click="openEncashmentReportModal()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <span class="align-middle">Encashment Report</span>
            </b-button>
            <b-button
              v-if="
                !isAlternateListView &&
                (isHeadOffice ||
                  [
                    'myskool',
                    'myskoolelixir',
                    'myskoolalhameed',
                    'myskoolngs',
                    'myskoolbrightfuture',
                    'myskoolkentschool',
                    'myskooliuss',
                    'myskoolwhss',
                    'myskoolprofectus',
                    'myskoolroyal',
                    'myskooltrainerned',
                    'myskoolcrestviewacademy',
                  ].includes(reportDomain) ||
                  (['myskoolhpgs'].includes(reportDomain) &&
                    $store.state.loggedUser.campusID == 1))
              "
              class="salary-filter-action-btn salary-filter-action-btn--outline"
              @click="openCreate()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              :disabled="salSaving"
            >
              <span class="align-middle">Generate Salary</span>
            </b-button>
            <span
              class="salary-toolbar-tip-wrap"
              v-b-tooltip.hover="salaryToolbarTooltip('Settings')"
            >
              <b-button
                class="salary-filter-action-btn salary-filter-action-btn--icon"
                @click="openSetting()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
              >
                <feather-icon icon="SettingsIcon" size="18" />
              </b-button>
            </span>
            <span
              class="salary-toolbar-tip-wrap"
              v-b-tooltip.hover="salaryToolbarTooltip('WhatsApp Pay Slip')"
            >
              <b-button
                class="salary-filter-action-btn salary-filter-action-btn--icon"
                @click="openPayroll('msg')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
              >
                <feather-icon icon="MessageCircleIcon" size="18" />
              </b-button>
            </span>
          </div>
        </div>
      </div>

      <!-- hpgs-only campus / accounts row. Rendered conditionally so domains
           without it don't leave an empty row (and its margins) under the
           toolbar. -->
      <b-row class="mt-1" v-if="['myskoolhpgs'].includes(reportDomain)">
        <b-col lg="4" md="6" v-if="$store.state.userData.cId == 1">
          <b-form-group class="mt-lg-0 mt-md-1 mt-0">
            <v-select
              v-model="selectedCampus"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="campuses"
              :clearable="false"
              label="branch"
              :reduce="(val) => val.id"
              :disabled="dataLoading"
              placeholder="Select campus"
              @input="LoadData()"
            />
          </b-form-group>
        </b-col>
        <b-col class="d-flex align-items-start mt-lg-0 mt-md-1 mt-0">
          <span
            class="salary-toolbar-tip-wrap"
            v-b-tooltip.hover="salaryToolbarTooltip('Accounts')"
          >
            <b-button
              variant="outline-secondary"
              class="btn-icon"
              :disabled="salSaving"
              @click="openAccount()"
            >
              <feather-icon icon="BriefcaseIcon" size="18" />
            </b-button>
          </span>
        </b-col>
      </b-row>

      <b-row v-if="isSalarySheet" class="mt-1 salary-sheet-toolbar">
        <b-col cols="12" class="salary-sheet-toolbar-title mb-50">
          <h5 class="mb-0">Salary preparation sheet</h5>
          <small class="text-secondary"
            >Choose period and department, then load or recalculate rows.</small
          >
        </b-col>
        <b-col
          xl="2"
          lg="3"
          md="4"
          sm="6"
          cols="12"
          class="mb-1"
          v-if="!usesSalaryDateRange"
        >
          <b-form-group
            label="Salary Month"
            label-class="salary-sheet-label"
            class="mb-0 salary-sheet-form-group"
          >
            <v-select
              v-model="salarySheetFilter.month"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="months"
              label="text"
              :reduce="(month) => month.value"
              :clearable="false"
              placeholder="Select a month"
            />
          </b-form-group>
        </b-col>
        <b-col
          xl="2"
          lg="3"
          md="4"
          sm="6"
          cols="12"
          class="mb-1"
          v-if="!usesSalaryDateRange"
        >
          <b-form-group
            label="Year"
            label-class="salary-sheet-label"
            class="mb-0 salary-sheet-form-group"
          >
            <v-select
              v-model="salarySheetFilter.year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              :options="years"
              :clearable="false"
              placeholder="Select salary year"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          xl="4"
          lg="4"
          md="6"
          sm="12"
          class="mb-1"
          v-if="usesSalaryDateRange"
        >
          <b-form-group
            label="Salary Period"
            label-class="salary-sheet-label"
            class="mb-0 salary-sheet-form-group"
          >
            <flat-pickr
              :config="config2"
              v-model="salaryRange"
              class="form-control salary-sheet-input"
              placeholder="Select salary date range"
              @on-change="onSalarySheetRangeChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          xl="2"
          lg="3"
          md="4"
          sm="6"
          cols="12"
          class="mb-1"
          v-if="usesSalaryDateRange"
        >
          <b-form-group
            label="Month"
            label-class="salary-sheet-label"
            class="mb-0 salary-sheet-form-group"
          >
            <v-select
              v-model="salarySheetFilter.month"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="months"
              label="text"
              :reduce="(month) => month.value"
              :clearable="false"
              placeholder="Select a month"
            />
          </b-form-group>
        </b-col>
        <b-col xl="2" lg="3" md="4" sm="6" cols="12" class="mb-1">
          <b-form-group
            label="Department"
            label-class="salary-sheet-label"
            class="mb-0 salary-sheet-form-group"
          >
            <v-select
              v-model="salarySheetFilter.departmentID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ name: 'All Departments', id: 0 }, ...departments]"
              :reduce="(opt) => opt.id"
              label="name"
              :clearable="false"
              placeholder="Department"
            />
          </b-form-group>
        </b-col>
        <b-col
          xl="2"
          lg="3"
          md="4"
          sm="6"
          cols="12"
          class="mb-1"
          v-if="
            ['myskoolhpgs'].includes(reportDomain) &&
            $store.state.userData.cId == 1
          "
        >
          <b-form-group
            label="Campus"
            label-class="salary-sheet-label"
            class="mb-0 salary-sheet-form-group"
          >
            <v-select
              v-model="salarySheetFilter.campusID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="campuses"
              :clearable="false"
              label="branch"
              :reduce="(val) => val.id"
              placeholder="Campus"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mb-0">
          <div
            class="d-flex flex-wrap align-items-center justify-content-between salary-sheet-actions"
          >
            <div class="salary-sheet-action-group">
              <b-form-checkbox
                v-model="salarySheetRecalculate"
                switch
                class="salary-sheet-recalc-switch"
                :disabled="salarySheetLoading || salarySheetSaving"
              >
                <span class="salary-sheet-switch-label">Recalculate</span>
              </b-form-checkbox>
              <b-button
                size="sm"
                variant="primary"
                class="sheet-btn sheet-btn-primary"
                :disabled="salarySheetLoading || salarySheetSaving"
                @click="runSalarySheetCalculate()"
              >
                <b-spinner v-if="salarySheetLoading" small class="mr-50" />
                <span v-else>{{
                  salarySheetRecalculate && salarySheetRows.length
                    ? "Recalculate"
                    : "Load Sheet"
                }}</span>
              </b-button>
              <b-button
                size="sm"
                variant="outline-primary"
                class="sheet-btn sheet-btn-outline"
                :disabled="
                  salarySheetLoading ||
                  salarySheetSaving ||
                  !salarySheetRows.length
                "
                @click="bulkSaveSalarySheet(false)"
              >
                <b-spinner v-if="salarySheetSaving" small class="mr-50" />
                <span v-else>Save</span>
              </b-button>
            </div>
            <small
              v-if="salarySheetMeta.totalCount || salarySheetDirty"
              class="sheet-stat-text"
            >
              {{ salarySheetMeta.totalCount }} staff
              <span v-if="salarySheetDirty" class="text-warning">
                · unsaved changes
              </span>
            </small>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-1 deposit-loan-view" v-if="isDeposit || isLoan">
        <b-col cols="12">
          <!-- Back to the staff list -->
          <button
            type="button"
            class="deposit-back-btn"
            @click="closeDepositLoan()"
          >
            <feather-icon icon="ArrowLeftIcon" size="15" class="mr-50" />
            <span>Back</span>
          </button>
        </b-col>

        <b-col md="12" class="mb-1">
          <div v-if="otherLoading" class="deposit-staff-skeleton">
            <div class="deposit-staff-skeleton__avatar"></div>
            <div class="deposit-staff-skeleton__lines">
              <div class="deposit-staff-skeleton__bar is-name"></div>
              <div class="deposit-staff-skeleton__bar is-sub"></div>
            </div>
          </div>
          <div v-else class="deposit-staff">
            <b-avatar
              size="44"
              :src="getPicturePreview(currentStaff.staff.picture)"
              variant="light-primary"
              referrerpolicy="no-referrer"
              class="deposit-staff__avatar"
            />
            <div class="deposit-staff__text">
              <h4 class="deposit-staff__name">
                {{ currentStaff.staff.name }}
                <span class="deposit-staff__dept">{{ getDepName() }}</span>
              </h4>
              <span class="deposit-staff__role">
                {{ currentStaff.staff.designation }}
              </span>
            </div>
          </div>
        </b-col>

        <b-col md="12" v-if="isDeposit">
          <div v-if="otherLoading" class="deposit-stats">
            <div
              v-for="n in 4"
              :key="`deposit-stat-skel-${n}`"
              class="deposit-stat is-skeleton"
            >
              <div class="deposit-skel-bar is-label"></div>
              <div class="deposit-skel-bar is-value"></div>
            </div>
          </div>
          <div v-else class="deposit-stats">
            <div class="deposit-stat">
              <span class="deposit-stat__label">Salary</span>
              <span class="deposit-stat__value">
                <span class="deposit-stat__currency">Rs.</span>
                {{ formatSheetMoney(currentStaff.staff.totalSalary) }}
              </span>
            </div>
            <div class="deposit-stat is-deposited">
              <span class="deposit-stat__label">Deposited so far</span>
              <span class="deposit-stat__value">
                <span class="deposit-stat__currency">Rs.</span>
                {{ formatSheetMoney(currentDeposits) }}
              </span>
            </div>
            <div class="deposit-stat is-remaining">
              <span class="deposit-stat__label">Remaining Deposits</span>
              <span class="deposit-stat__value">
                <span class="deposit-stat__currency">Rs.</span>
                {{ formatSheetMoney(remainingDeposits) }}
                <b-badge
                  variant="light-danger"
                  class="deposit-stat__badge"
                  v-if="currentStaff.staff.totalSalary > totalDeposits"
                >
                  {{ currentStaff.staff.totalSalary - totalDeposits }}
                </b-badge>
              </span>
            </div>
            <div class="deposit-stat is-returned">
              <span class="deposit-stat__label">Returned Deposits</span>
              <span class="deposit-stat__value">
                <span class="deposit-stat__currency">Rs.</span>
                {{ formatSheetMoney(returnDeposits) }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-1" v-if="false">
        <b-col v-if="otherLoading">
          <b-row>
            <b-col class="text-center">
              <b-spinner
                style="width: 3rem; height: 3rem"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </b-col>
          </b-row>
        </b-col>

        <b-col v-else>
          <b-row>
            <b-col xl="3" lg="3" md="6" sm="6">
              <!-- bg-variant="light-secondary" -->
              <b-card>
                <h4 class="card-title">Salary</h4>
                <p class="card-text font-small-6 font-weight-bolder mb-0">
                  <span>Rs.</span>
                  <span class="font-weight-bolder mb-0">
                    <!-- {{ totalDeposits }} -->
                    {{ currentStaff.staff.totalSalary }}
                  </span>
                </p>
              </b-card>
            </b-col>
            <b-col xl="3" lg="3" md="6" sm="6">
              <b-card>
                <h4 class="card-title">Deposited so far</h4>
                <p class="card-text font-small-6 font-weight-bolder mb-0">
                  <span>Rs.</span
                  ><span class="font-weight-bolder mb-0">
                    {{ currentDeposits }}</span
                  >
                </p>
              </b-card>
            </b-col>
            <b-col xl="3" lg="3" md="6" sm="6">
              <b-card>
                <h4 class="card-title">Remaining Deposits</h4>
                <p
                  class="card-text font-small-6 font-weight-bolder mb-0 d-flex justify-content-between"
                >
                  <span class="font-weight-bolder mb-0">
                    Rs. {{ remainingDeposits }}</span
                  >
                  <b-badge
                    variant="light-danger"
                    v-if="currentStaff.staff.totalSalary > totalDeposits"
                    >{{
                      currentStaff.staff.totalSalary - totalDeposits
                    }}</b-badge
                  >
                </p>
              </b-card>
            </b-col>
            <b-col xl="3" lg="3" md="6" sm="6">
              <b-card>
                <h4 class="card-title">Returned Deposits</h4>
                <p class="card-text font-small-6 font-weight-bolder mb-0">
                  <span>Rs.</span
                  ><span class="font-weight-bolder mb-0">
                    {{ returnDeposits }}</span
                  >
                </p>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="deposit-toolbar" v-if="isDeposit || isLoan">
        <b-button
          v-if="isLoan"
          @click="LoanOpen()"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="deposit-toolbar__btn"
        >
          <feather-icon icon="PlusIcon" class="mr-50" />
          <span>Advance / Loan</span>
        </b-button>

        <template v-else-if="isDeposit">
          <b-button
            @click="depoOpen()"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="deposit-toolbar__btn"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span>Security Deposit</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-danger"
            class="deposit-toolbar__btn"
            :disabled="delAll"
            @click="depoDelAll()"
          >
            <feather-icon icon="Trash2Icon" size="14" class="mr-50" />
            <span>Delete undeposited</span>
          </b-button>
        </template>
      </div>

      <!-- loadn -->
      <b-table
        v-if="isLoan"
        class="mt-1 deposit-table"
        :busy="otherLoading"
        :items="loanData"
        :fields="loanFields"
        show-empty
        responsive
        hover
      >
        <template #empty="scope">
          <div class="deposit-empty">
            <feather-icon icon="FileTextIcon" size="26" />
            <p>No advance or loan records found</p>
          </div>
        </template>
        <template #table-busy>
          <div class="deposit-skeleton">
            <div
              v-for="n in 4"
              :key="`loan-skel-${n}`"
              class="deposit-skeleton__row"
            >
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar is-actions"></div>
            </div>
          </div>
        </template>

        <template #cell(date)="data">
          <span class="deposit-date">
            {{
              new Date(data.value).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </span>
        </template>
        <template #cell(amount)="data">
          <span class="deposit-amount">
            {{ formatSheetMoney(data.value) }}
          </span>
        </template>
        <template #cell(loanType)="data">
          <span class="deposit-type" :class="`is-${data.value}`">
            {{ data.value }}
          </span>
        </template>
        <template #cell(months)="data">
          <span class="deposit-months">{{ data.value }}</span>
        </template>
        <template #cell(actions)="data">
          <div class="deposit-actions">
            <button
              type="button"
              class="deposit-row-btn is-view"
              v-b-tooltip.hover.top
              title="View / Edit"
              @click="EditLoan(data.item, data.index)"
            >
              <feather-icon icon="EyeIcon" size="16" />
            </button>
            <button
              type="button"
              class="deposit-row-btn is-delete"
              v-b-tooltip.hover.top
              title="Delete"
              @click="DeleteLoan(data.item, data.index)"
            >
              <feather-icon icon="Trash2Icon" size="16" />
            </button>
          </div>
        </template>
      </b-table>

      <!-- deposit -->
      <b-table
        v-else-if="isDeposit"
        class="mt-1 deposit-table"
        :busy="otherLoading"
        :items="depositDetails"
        :fields="depoFields"
        show-empty
        responsive
        hover
      >
        <template #empty="scope">
          <div class="deposit-empty">
            <feather-icon icon="FileTextIcon" size="26" />
            <p>No security deposit records found</p>
          </div>
        </template>
        <template #table-busy>
          <div class="deposit-skeleton">
            <div
              v-for="n in 4"
              :key="`depo-skel-${n}`"
              class="deposit-skeleton__row"
            >
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar"></div>
              <div class="deposit-skel-bar is-actions"></div>
            </div>
          </div>
        </template>

        <template #cell(index)="data">
          <span class="deposit-index">{{ data.index + 1 }}</span>
        </template>
        <template #cell(date)="data">
          <span class="deposit-date">
            {{ data.item.month }} {{ data.item.year }}
          </span>
        </template>
        <template #cell(amount)="data">
          <span class="deposit-amount">
            {{ formatSheetMoney(data.value) }}
          </span>
          <button
            v-if="
              sdObj &&
              sdObj.valueBool &&
              data.item.salaryID == null &&
              data.item.isReturned == null
            "
            type="button"
            class="deposit-inline-edit"
            v-b-tooltip.hover.top
            title="Edit amount"
            @click="openAmountEdit(data.item, data.index)"
          >
            <feather-icon icon="EditIcon" size="13" />
          </button>
        </template>

        <template #cell(actions)="data">
          <div class="deposit-actions">
            <button
              v-if="data.item.salaryID != null"
              type="button"
              class="deposit-chip is-on is-deposited"
              v-b-tooltip.hover.top
              title="Click to mark as not deposited"
              @click="markUnDeposit(data.item)"
            >
              <feather-icon icon="CheckIcon" size="14" />
              <span>Deposited</span>
            </button>
            <button
              v-else
              type="button"
              class="deposit-chip is-off"
              v-b-tooltip.hover.top
              title="Mark as deposited"
              @click="markDeposit(data.item)"
            >
              <span>Deposit</span>
            </button>

            <button
              v-if="data.item.isReturned != null && data.item.isReturned == true"
              type="button"
              class="deposit-chip is-on is-returned"
              v-b-tooltip.hover.top
              title="Click to mark as not returned"
              @click="markUnReturned(data.item)"
            >
              <feather-icon icon="CheckIcon" size="14" />
              <span>Returned</span>
            </button>
            <button
              v-else-if="
                data.item.isReturned == null && data.item.salaryID != null
              "
              type="button"
              class="deposit-chip is-off"
              v-b-tooltip.hover.top
              title="Mark as returned"
              @click="markReturned(data.item)"
            >
              <span>Returned</span>
            </button>

            <button
              type="button"
              class="deposit-row-delete"
              v-b-tooltip.hover.top
              title="Delete"
              @click="DeleteDepo(data.item.id, data.index)"
            >
              <feather-icon icon="Trash2Icon" size="16" />
            </button>
          </div>
        </template>
      </b-table>

      <template v-else-if="isHistory">
      <!-- history pagination: the API returns one page + totalCount -->
      <div
        class="history-pagination pagination-controls-top d-flex justify-content-between align-items-center mb-2"
      >
        <div class="history-pagination__size page-size-wrapper">
          <label class="history-pagination__label page-size-label">Show:</label>
          <v-select
            :key="'history-page-size-' + historyPerPage"
            v-model="historyPerPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="historyPageSizeOptions"
            :reduce="(opt) => opt.value"
            label="label"
            :clearable="false"
            :searchable="false"
            append-to-body
            class="history-pagination__select page-size-select-compact"
            @input="onHistoryPageSizeChange"
          />
        </div>

        <div class="history-pagination__count pagination-count-display">
          <span v-if="historyDisplayRange.total" class="count-text">
            Showing <strong>{{ historyDisplayRange.start }}</strong> to
            <strong>{{ historyDisplayRange.end }}</strong> of
            <strong>{{ historyDisplayRange.total }}</strong>
          </span>
          <span v-else class="count-text">No records</span>
          <span
            v-if="historyDisplayRange.total"
            class="count-text history-pagination__pages ml-1"
          >
            · {{ historyPageSummary }}
          </span>
        </div>

        <div class="history-pagination__control pagination-wrapper-compact">
          <b-pagination
            v-model="historyPage"
            :total-rows="historyTotalCount"
            :per-page="historyPerPage"
            :disabled="otherLoading"
            size="sm"
            align="center"
            first-number
            last-number
            class="pagination-compact mb-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="onHistoryPageChange"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="16" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="16" />
            </template>
          </b-pagination>
        </div>
      </div>

      <!-- history -->
      <div class="salary-history-table-wrap">
      <b-table
        class="mt-0 salary-history-table"
        :busy="otherLoading"
        :items="historySearchFilters"
        :fields="hisFields"
        show-empty
        hover
        small
      >
        <!-- :items="historyData" -->
        <template #empty>
          <div class="salary-empty-state salary-empty-state--history">
            <div class="salary-empty-state__icon">
              <feather-icon icon="FileTextIcon" size="36" />
            </div>
            <h4 class="salary-empty-state__title">No salary history found</h4>
            <p class="salary-empty-state__hint">
              Try another month or year, clear search, or pick a different
              department.
            </p>
          </div>
        </template>

        <template #table-busy>
          <div class="list-skeleton">
            <div
              v-for="n in 5"
              :key="`hist-skel-${n}`"
              class="list-skeleton__row history-skeleton-row"
            >
              <div class="list-skeleton__cell">
                <div class="list-skeleton__bar staff-skel-sno"></div>
              </div>
              <div class="list-skeleton__cell">
                <div class="staff-skel-person">
                  <div class="skeleton-avatar"></div>
                  <div class="staff-skel-lines">
                    <div class="list-skeleton__bar staff-skel-name"></div>
                    <div class="list-skeleton__bar staff-skel-sub"></div>
                  </div>
                </div>
              </div>
              <div
                v-for="c in 8"
                :key="`hist-skel-cell-${n}-${c}`"
                class="list-skeleton__cell"
              >
                <div class="list-skeleton__bar staff-skel-chip"></div>
              </div>
            </div>
          </div>
        </template>
        <template #cell(index)="data">
          <b-badge variant="light-primary">
            {{
              (historyPage - 1) * historyPerPage +
              historySearchFilters.indexOf(data.item) +
              1
            }}
          </b-badge>
        </template>
        <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="44"
                :src="getPicturePreview(data.item.st.picture)"
                variant="light-primary"
                referrerpolicy="no-referrer"
              />
            </template>

            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <b-badge variant="light-primary">
                {{ data.item.st.name }}
              </b-badge>
            </b-link>
            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <b-badge variant="light-primary">
                F/N: {{ data.item.st.father_name }}
              </b-badge>
            </b-link>
            <b-link class="font-weight-bold d-block text-nowrap">
              <b-badge variant="light-primary">
                {{ getDep(data.item.st.departmentID) }}
              </b-badge>
            </b-link>
          </b-media>
        </template>

        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.item.us.date).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>

        <template #cell(forDate)="data">
          <b-badge variant="light-primary">
            {{ historyMonthLabel(data.item.us) }}
            {{ data.item.us.year }}
          </b-badge>
        </template>

        <template #cell(paid)="data">
          <b-badge
            :variant="
              normalizePaidValue(data.item.us.paid) === true
                ? 'light-success'
                : 'light-danger'
            "
          >
            {{ formatPaidLabel(data.item.us.paid) }}
          </b-badge>
        </template>

        <template #cell(basic)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.basicSalary }}
          </b-badge>
        </template>
        <template #cell(allownaces)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.totalAllownaces || 0 }}
          </b-badge>
        </template>
        <template #cell(securityDeposit)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.securityDeposit }}
          </b-badge>
        </template>
        <template #cell(remainingDeposit)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.remainingDeposit }}
          </b-badge>
        </template>
        <template #cell(depositUpto)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.depositUpto }}
          </b-badge>
        </template>
        <template #cell(depositReturn)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.depositReturn }}
          </b-badge>
        </template>
        <template #cell(absentDeduction)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.absentDeduction }}
          </b-badge>
        </template>
        <template #cell(lateDeduction)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.lateDeduction }}
          </b-badge>
        </template>
        <template #cell(totalDedcutions)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.totalDedcutions }}
          </b-badge>
        </template>
        <template #cell(contributions)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.totalContributions || 0 }}
          </b-badge>
        </template>
        <template #cell(working)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.workingDays }}
          </b-badge>
        </template>
        <template #cell(present)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.present }}
          </b-badge>
        </template>
        <template #cell(absent)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.absent }}
          </b-badge>
        </template>
        <template #cell(leave)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.leave }}
          </b-badge>
        </template>
        <template #cell(late)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.late }}
          </b-badge>
        </template>
        <template #cell(netSalary)="data">
          <b-badge variant="light-primary">
            {{ data.item.us.netSalary }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <div class="staff-actions">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
              @click="EditSalary(data.item, data.item.st.departmentID)"
              v-b-tooltip.hover.left
              title="Edit"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
              @click="printSlip(data.item.us)"
              v-b-tooltip.hover.left
              title="Print"
            >
              <feather-icon icon="PrinterIcon" class="" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="btn-icon"
              @click="sendSingle(data.item.us)"
              v-b-tooltip.hover.left
              title="WhatsApp Pay Slip"
              :disabled="singleSending && currentID == data.item.us.id"
            >
              <b-spinner
                v-if="singleSending && currentID == data.item.us.id"
                small
                variant="primary"
                label=""
              ></b-spinner>
              <feather-icon v-else icon="MailIcon" />
            </b-button>
            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              class="btn-icon"
              @click="DeleteSal(data.item.us.id)"
              v-b-tooltip.hover.left
              title="Delete"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
      </div>
      </template>

      <!-- salary sheet -->
      <div v-else-if="isSalarySheet" class="salary-sheet-wrap mt-1">
        <div class="salary-sheet-head">
          <div class="sheet-legend">
            <span v-if="getSheetLateScaleLabel()" class="sheet-legend-item">
              Late scale: {{ getSheetLateScaleLabel() }}
            </span>
          </div>
          <small class="sheet-head-hint text-muted">
            Load Sheet fetches rows. Recalculate sends your edits to BulkCalculate (no DB reload).
          </small>
        </div>

        <!-- Totals strip: mirrors the salary sheet columns -->
        <div v-if="salarySheetLoading" class="sheet-totals-skeleton">
          <div
            v-for="n in 5"
            :key="`sheet-totals-skel-${n}`"
            class="sheet-totals-skeleton__tile"
          >
            <div class="sheet-totals-skeleton__label"></div>
            <div class="sheet-totals-skeleton__value"></div>
          </div>
        </div>
        <div v-else-if="salarySheetTotals.count" class="sheet-totals">
          <div class="sheet-total">
            <span class="sheet-total__label">Staff</span>
            <span class="sheet-total__value">{{ salarySheetTotals.count }}</span>
          </div>
          <div class="sheet-total">
            <span class="sheet-total__label">Gross Salary</span>
            <span class="sheet-total__value">
              Rs. {{ formatSheetMoney(salarySheetTotals.grossSalary) }}
            </span>
          </div>
          <div class="sheet-total is-allow">
            <span class="sheet-total__label">Allowances</span>
            <span class="sheet-total__value">
              Rs. {{ formatSheetMoney(salarySheetTotals.allowances) }}
            </span>
          </div>
          <div class="sheet-total is-deduct">
            <span class="sheet-total__label">Deductions</span>
            <span class="sheet-total__value">
              Rs. {{ formatSheetMoney(salarySheetTotals.deductions) }}
            </span>
          </div>
          <div class="sheet-total is-net">
            <span class="sheet-total__label">Net Payable</span>
            <span class="sheet-total__value">
              Rs. {{ formatSheetMoney(salarySheetTotals.net) }}
            </span>
          </div>
          <div class="sheet-total">
            <span class="sheet-total__label">Avg. Net</span>
            <span class="sheet-total__value">
              Rs. {{ formatSheetMoney(salarySheetTotals.averageNet) }}
            </span>
          </div>
        </div>

        <b-table
          class="salary-sheet-table"
          :busy="salarySheetLoading"
          :items="salarySheetFilteredRows"
          :fields="salarySheetFields"
          show-empty
          responsive
          small
          sticky-header="520px"
        >
          <template #empty>
            <div class="sheet-empty py-2 text-center text-muted">
              No records found. Select filters and click Calculate Salary.
            </div>
          </template>

          <template #table-busy>
            <div class="sheet-skeleton">
              <div
                v-for="n in 8"
                :key="`sheet-skel-${n}`"
                class="sheet-skeleton__row"
              >
                <div class="sheet-skeleton__bar" style="width: 22px"></div>
                <div>
                  <div class="sheet-skeleton__bar sheet-skeleton__bar--name"></div>
                  <div class="sheet-skeleton__bar sheet-skeleton__bar--id"></div>
                </div>
                <div class="sheet-skeleton__bar"></div>
                <div class="sheet-skeleton__bar"></div>
                <div
                  v-for="c in 16"
                  :key="`sheet-skel-cell-${n}-${c}`"
                  class="sheet-skeleton__bar"
                ></div>
              </div>
            </div>
          </template>

          <template #cell(sno)="data">
            <span class="sheet-index">{{ data.item.sno || data.index + 1 }}</span>
          </template>

          <template #cell(name)="data">
            <div class="sheet-staff-block">
              <div class="sheet-staff-name">{{ data.item.name || "—" }}</div>
              <div class="sheet-staff-id">ID {{ data.item.tID || "—" }}</div>
            </div>
          </template>

          <template #cell(designation)="data">
            <span class="sheet-text-cell">{{ data.item.designation || "—" }}</span>
          </template>

          <template #cell(departmentName)="data">
            <span class="sheet-text-cell">{{ data.item.departmentName || "—" }}</span>
          </template>

          <template #cell(policyRem)="data">
            <span class="sheet-policy-val">{{
              formatSheetPolicyValue(getSheetRemainingLeaves(data.item))
            }}</span>
          </template>

          <template #cell(policyUse)="data">
            <span class="sheet-policy-val">{{
              formatSheetPolicyValue(getSheetUtilizeableLeaves(data.item))
            }}</span>
          </template>

          <template #cell(policyLvUsed)="data">
            <span class="sheet-policy-val sheet-policy-applied">{{
              formatSheetPolicyValue(getSheetLeaveUtilized(data.item))
            }}</span>
          </template>

          <template #cell(policyAbsDed)="data">
            <span class="sheet-policy-val sheet-policy-applied">{{
              formatSheetPolicyValue(getSheetAbsentDeduction(data.item))
            }}</span>
          </template>

          <template #cell(policyLtDed)="data">
            <span class="sheet-policy-val sheet-policy-applied">{{
              formatSheetPolicyValue(getSheetLateDeduction(data.item))
            }}</span>
          </template>

          <template #cell(workingDays)="data">
            <input
              type="number"
              class="sheet-cell-edit"
              title="Working Days"
              :value="getSheetSalaryValue(data.item, 'workingDays')"
              @input="setSheetSalaryValue(data.item, 'workingDays', $event.target.value)"
            />
          </template>

          <template #cell(present)="data">
            <input
              type="number"
              class="sheet-cell-edit"
              title="Present"
              :value="getSheetSalaryValue(data.item, 'present')"
              @input="setSheetSalaryValue(data.item, 'present', $event.target.value)"
            />
          </template>

          <template #cell(absent)="data">
            <input
              type="number"
              class="sheet-cell-edit"
              title="Absent"
              :value="getSheetSalaryValue(data.item, 'absent')"
              @input="setSheetSalaryValue(data.item, 'absent', $event.target.value)"
            />
          </template>

          <template #cell(leave)="data">
            <input
              type="number"
              class="sheet-cell-edit"
              title="Leave"
              :value="getSheetSalaryValue(data.item, 'leave')"
              @input="setSheetSalaryValue(data.item, 'leave', $event.target.value)"
            />
          </template>

          <template #cell(late)="data">
            <input
              type="number"
              class="sheet-cell-edit"
              title="Late"
              :value="getSheetSalaryValue(data.item, 'late')"
              @input="setSheetSalaryValue(data.item, 'late', $event.target.value)"
            />
          </template>

          <template #cell(basicSalary)="data">
            <input
              type="number"
              class="sheet-cell-edit sheet-cell-money"
              title="Basic Salary"
              :value="getSheetSalaryValue(data.item, 'basicSalary')"
              @input="setSheetSalaryValue(data.item, 'basicSalary', $event.target.value)"
            />
          </template>

          <template #cell(grossSalary)="data">
            <span class="sheet-money">{{
              formatSheetMoney(getSheetSalaryValue(data.item, "grossSalary"))
            }}</span>
          </template>

          <template #cell(totalAllownaces)="data">
            <span class="sheet-money sheet-money-allow">{{
              formatSheetMoney(getSheetSalaryValue(data.item, "totalAllownaces"))
            }}</span>
          </template>

          <template #cell(totalDedcutions)="data">
            <span class="sheet-money sheet-money-deduct">{{
              formatSheetMoney(getSheetSalaryValue(data.item, "totalDedcutions"))
            }}</span>
          </template>

          <template #cell(netSalary)="data">
            <input
              type="number"
              class="sheet-cell-edit sheet-cell-money sheet-cell-net"
              :class="getSheetNetInputClass(data.item)"
              title="Net Salary"
              :value="getSheetSalaryValue(data.item, 'netSalary')"
              @input="setSheetSalaryValue(data.item, 'netSalary', $event.target.value)"
            />
          </template>

          <template #cell(note)="data">
            <input
              type="text"
              class="sheet-cell-edit sheet-cell-note"
              placeholder="Note"
              :value="getSheetSalaryValue(data.item, 'note')"
              @input="setSheetSalaryValue(data.item, 'note', $event.target.value, false)"
            />
          </template>
        </b-table>

        <div
          v-if="salarySheetSkipped.length"
          class="salary-sheet-skipped p-1"
        >
          <strong>Skipped rows:</strong>
          <span
            v-for="(skip, idx) in salarySheetSkipped"
            :key="`skip-${skip.tID || idx}`"
            class="ml-50"
          >
            {{ skip.tID }} — {{ skip.reason || "Skipped" }}
          </span>
        </div>
      </div>

      <!-- encashment history -->
      <div
        v-else-if="isEncashmentHistory"
        class="salary-history-table-wrap salary-encashment-table-wrap"
      >
      <b-table
        class="mt-0 salary-history-table"
        :busy="encashmentHistoryLoading"
        :items="encashmentHistorySearchFilters"
        :fields="encashmentHisFields"
        show-empty
        responsive
        hover
        small
      >
        <template #empty>
          <div
            v-if="!encashmentHistoryLoading"
            class="salary-empty-state salary-empty-state--history"
          >
            <div class="salary-empty-state__icon">
              <feather-icon icon="FileTextIcon" size="36" />
            </div>
            <h4 class="salary-empty-state__title">No encashment records found</h4>
            <p class="salary-empty-state__hint">
              Try another session or year, clear search, or pick a different
              department.
            </p>
          </div>
        </template>

        <template #table-busy>
          <div class="list-skeleton">
            <div
              v-for="n in 6"
              :key="`encash-hist-skel-${n}`"
              class="list-skeleton__row history-skeleton-row encashment-skeleton-row"
            >
              <div class="list-skeleton__cell">
                <div class="list-skeleton__bar staff-skel-sno"></div>
              </div>
              <div class="list-skeleton__cell">
                <div class="staff-skel-person">
                  <div class="skeleton-avatar"></div>
                  <div class="staff-skel-lines">
                    <div class="list-skeleton__bar staff-skel-name"></div>
                    <div class="list-skeleton__bar staff-skel-sub"></div>
                  </div>
                </div>
              </div>
              <div
                v-for="c in 8"
                :key="`encash-hist-skel-cell-${n}-${c}`"
                class="list-skeleton__cell"
              >
                <div class="list-skeleton__bar staff-skel-chip"></div>
              </div>
            </div>
          </div>
        </template>

        <template #cell(index)="data">
          <b-badge variant="light-primary">
            {{ encashmentHistorySearchFilters.indexOf(data.item) + 1 }}
          </b-badge>
        </template>

        <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="44"
                :src="getPicturePreview(data.item.picture)"
                variant="light-primary"
                :text="data.item.name ? data.item.name.charAt(0) : '?'"
                referrerpolicy="no-referrer"
              />
            </template>

            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <b-badge variant="light-primary">
                {{ data.item.name }}
              </b-badge>
            </b-link>
            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <b-badge variant="light-primary">
                F/N: {{ data.item.father_name || "—" }}
              </b-badge>
            </b-link>
            <b-link class="font-weight-bold d-block text-nowrap">
              <b-badge variant="light-primary">
                {{ encashmentDepartmentName(data.item) }}
              </b-badge>
            </b-link>
          </b-media>
        </template>

        <template #cell(rfID)="data">
          <b-badge variant="light-primary">
            {{ data.item.rfID || "—" }}
          </b-badge>
        </template>

        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              data.item.date
                ? new Date(data.item.date).toLocaleDateString("en-UK", {
                    year: "numeric",
                    day: "numeric",
                    month: "short",
                  })
                : "—"
            }}
          </b-badge>
        </template>

        <template #cell(designation)="data">
          <b-badge variant="light-primary">
            {{ data.item.designation || "—" }}
          </b-badge>
        </template>

        <template #cell(department)="data">
          <b-badge variant="light-primary">
            {{ encashmentDepartmentName(data.item) }}
          </b-badge>
        </template>

        <template #cell(encashmentAmount)="data">
          <b-badge variant="light-success">
            {{ formatEncashmentAmount(data.item.encashmentAmount) }}
          </b-badge>
        </template>

        <template #cell(leavesEncashed)="data">
          <b-badge variant="light-primary">
            {{
              data.item.leavesEncashed != null ? data.item.leavesEncashed : "—"
            }}
          </b-badge>
        </template>

        <template #cell(notes)="data">
          <b-badge variant="light-secondary">
            {{ data.item.notes || "—" }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="btn-icon"
            @click="openLeaveEncashmentSlip(data.item)"
            v-b-tooltip.hover.left
            title="Print Slip"
          >
            <feather-icon icon="PrinterIcon" />
          </b-button>
        </template>
      </b-table>
      </div>

      <!-- calendar -->
      <div v-else-if="showAtt" class="attendance-view">
        <div class="attendance-view__top">
          <button
            type="button"
            class="deposit-back-btn attendance-back-btn"
            @click="closeAttendance()"
          >
            <feather-icon icon="ArrowLeftIcon" size="15" class="mr-50" />
            <span>Back to staff</span>
          </button>
          <span class="attendance-period-pill">
            <feather-icon icon="CalendarIcon" size="14" class="mr-25" />
            {{ attendancePeriodLabel }}
          </span>
        </div>

        <div class="attendance-profile">
          <b-avatar
            size="52"
            :src="getPicturePreview(stCurrent.picture)"
            variant="light-primary"
            class="attendance-profile__avatar"
            referrerpolicy="no-referrer"
          />
          <div class="attendance-profile__body">
            <h4 class="attendance-profile__name">{{ stCurrent.name }}</h4>
            <p class="attendance-profile__meta">
              <span>{{ getDep(stCurrent.departmentID) }}</span>
              <span class="attendance-profile__dot" aria-hidden="true">·</span>
              <span>{{ stCurrent.designation }}</span>
            </p>
          </div>
        </div>

        <div class="attendance-panel">
          <div class="attendance-panel__section">
            <div class="attendance-panel__head">
              <span class="attendance-panel__title">Period</span>
              <span class="attendance-panel__hint">Month &amp; year</span>
            </div>
            <div class="attendance-toolbar">
              <div class="attendance-toolbar__months">
                <button
                  v-for="mon in months"
                  :key="mon.value"
                  type="button"
                  class="attendance-month-chip"
                  :class="{ 'is-active': attMonth == mon.value }"
                  @click="change(mon.value)"
                >
                  {{ mon.text.slice(0, 3) }}
                </button>
              </div>
              <div class="attendance-toolbar__year">
                <v-select
                  v-model="attYear"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="years"
                  :clearable="false"
                  placeholder="Year"
                  @input="loadAtt()"
                />
              </div>
            </div>
          </div>

          <div class="attendance-panel__section attendance-panel__section--legend">
            <div class="attendance-legend" aria-label="Attendance status legend">
              <span
                v-for="item in attendanceStatusLegend"
                :key="item.code"
                class="attendance-legend__item"
                :class="'is-' + item.tone"
              >
                <span class="attendance-legend__chip">{{ item.code }}</span>
                <span class="attendance-legend__label">{{ item.label }}</span>
              </span>
            </div>
          </div>

          <div class="attendance-panel__section">
            <div class="attendance-panel__head">
              <span class="attendance-panel__title">Month summary</span>
              <span class="attendance-panel__hint">{{ attendancePeriodLabel }}</span>
            </div>
            <div v-if="attLoading" class="attendance-stats attendance-stats--skeleton">
              <div
                v-for="n in 7"
                :key="`att-stat-skel-${n}`"
                class="attendance-stat-skeleton"
              >
                <div class="attendance-stat-skeleton__value"></div>
                <div class="attendance-stat-skeleton__label"></div>
              </div>
            </div>
            <div v-else class="attendance-stats">
              <div
                v-for="card in attendanceSummaryCards"
                :key="card.key"
                class="attendance-stat"
                :class="'is-' + card.tone"
              >
                <span class="attendance-stat__code">{{ card.code }}</span>
                <span class="attendance-stat__label">{{ card.label }}</span>
                <span class="attendance-stat__value">{{ card.value }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="attendance-calendar">
          <div class="attendance-calendar__card">
            <div
              v-if="attLoading"
              class="attendance-calendar__loading"
              aria-busy="true"
            >
              <div class="attendance-skeleton">
                <div class="attendance-skeleton__toolbar">
                  <div class="attendance-skeleton__title-bar"></div>
                </div>
                <div class="attendance-skeleton__dow">
                  <div
                    v-for="d in 7"
                    :key="`att-dow-${d}`"
                    class="attendance-skeleton__dow-cell"
                  ></div>
                </div>
                <div
                  v-for="n in 5"
                  :key="`att-week-${n}`"
                  class="attendance-skeleton__week"
                >
                  <div
                    v-for="c in 7"
                    :key="`att-day-${n}-${c}`"
                    class="attendance-skeleton__day"
                  >
                    <div class="attendance-skeleton__day-num"></div>
                    <div class="attendance-skeleton__event-card">
                      <div class="attendance-skeleton__event-code"></div>
                      <div class="attendance-skeleton__event-line"></div>
                      <div class="attendance-skeleton__event-badge"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="attendance-calendar__body"
              :class="{ 'is-loading': attLoading }"
            >
              <full-calendar
                ref="refCalendar"
                :options="calendarOptions"
                class="full-calendar attendance-full-calendar"
              >
                <template v-slot:eventContent="arg">
                  <div
                    class="att-event-content"
                    :class="[
                      'att-event-content--' + getVariant(arg.event.title),
                      { 'att-event-content--empty': !arg.event.title },
                    ]"
                  >
                    <b class="att-event-content__status">{{
                      arg.event.title || "—"
                    }}</b>
                    <span class="att-event-content__title">{{
                      arg.event.title
                        ? attendanceStatusDisplay(arg.event.title)
                        : "Not marked — tap to add"
                    }}</span>
                    <div
                      class="att-event-content__times"
                      :class="{
                        'att-event-content__times--empty':
                          !arg.event.extendedProps.timeIn &&
                          !arg.event.extendedProps.timeOut,
                      }"
                    >
                      <p
                        v-if="arg.event.extendedProps.timeIn"
                        class="att-event-content__time mb-25"
                      >
                        <span class="att-event-content__time-label"
                          >Time in</span
                        >
                        <b-badge
                          :variant="getVariant(arg.event.title)"
                          class="font-small-2"
                        >
                          {{
                            formatAttendanceClock(
                              arg.event.extendedProps.timeIn
                            )
                          }}
                        </b-badge>
                      </p>
                      <p
                        v-if="arg.event.extendedProps.timeOut"
                        class="att-event-content__time mb-0"
                      >
                        <span class="att-event-content__time-label"
                          >Time out</span
                        >
                        <b-badge
                          :variant="getVariant(arg.event.title)"
                          class="font-small-2"
                        >
                          {{
                            formatAttendanceClock(
                              arg.event.extendedProps.timeOut
                            )
                          }}
                        </b-badge>
                      </p>
                    </div>
                  </div>
                </template>
              </full-calendar>
            </div>
          </div>
        </div>
      </div>

      <!-- all staffs -->
      <!-- :items="filters" -->
      <b-table
        v-else
        class="staff-salary-main-table mt-1"
        :busy="dataLoading"
        ref="selectableTable"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        show-empty
        responsive
        hover
        small
      >
        <template #empty>
          <div class="salary-empty-state">
            <div class="salary-empty-state__icon">
              <feather-icon icon="UsersIcon" size="36" />
            </div>
            <h4 class="salary-empty-state__title">No staff found</h4>
            <p class="salary-empty-state__hint">
              Adjust department or status filters, or clear your search.
            </p>
          </div>
        </template>
        <template #table-busy>
          <div class="list-skeleton list-skeleton--staff">
            <div
              v-for="n in 6"
              :key="`staff-skel-${n}`"
              class="list-skeleton__row staff-skeleton-row"
            >
              <div class="list-skeleton__cell">
                <div class="list-skeleton__bar staff-skel-sno"></div>
              </div>
              <div class="list-skeleton__cell">
                <div class="staff-skel-person">
                  <div class="skeleton-avatar"></div>
                  <div class="staff-skel-lines">
                    <div class="list-skeleton__bar staff-skel-name"></div>
                    <div class="list-skeleton__bar staff-skel-sub"></div>
                  </div>
                </div>
              </div>
              <div class="list-skeleton__cell">
                <div class="list-skeleton__bar staff-skel-chip"></div>
              </div>
              <div class="list-skeleton__cell">
                <div class="list-skeleton__bar staff-skel-date"></div>
              </div>
              <div class="list-skeleton__cell staff-skel-actions">
                <div class="list-skeleton__bar skeleton-icon-box"></div>
                <div class="list-skeleton__bar skeleton-icon-box"></div>
                <div class="list-skeleton__bar skeleton-icon-box"></div>
                <div class="list-skeleton__bar skeleton-icon-box"></div>
                <div class="list-skeleton__bar skeleton-text-btn"></div>
                <div class="list-skeleton__bar skeleton-text-btn"></div>
              </div>
            </div>
          </div>
        </template>

        <template #cell(index)="data">
          <b-badge variant="light-primary">
            <!-- {{ filters.indexOf(data.item) + 1 }} -->
            {{ (currentPage - 1) * perPage + data.index + 1 }}
          </b-badge>
        </template>

        <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="44"
                :src="getPicturePreview(data.item.picture)"
                variant="light-primary"
                referrerpolicy="no-referrer"
              />
            </template>

            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <b-badge variant="light-primary">
                {{ data.item.name }}
              </b-badge>
            </b-link>
            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <b-badge variant="light-primary">
                F/N: {{ data.item.father_name }}
              </b-badge>
              <br />
              <b-badge variant="light-primary" class="mt-25">
                ID: {{ data.item.id }}
              </b-badge>
            </b-link>
            <b-link
              v-if="isHeadOffice || ['myskoolhpgs'].includes(reportDomain)"
              class="font-weight-bold d-block text-nowrap"
            >
              <b-badge variant="light-primary">
                {{ getCampus(data.item.campusID) }}
              </b-badge>
            </b-link>
          </b-media>
        </template>

        <template #cell(designation)="data">
          <b-badge variant="light-primary">
            {{ data.item.designation }}
          </b-badge>
        </template>
        <template #cell(status)="data">
          <b-badge variant="light-primary">
            {{ data.item.status }}
          </b-badge>
        </template>
        <template #cell(appointedOn)="data">
          <b-badge variant="light-primary">
            <span
              v-if="
                reportDomain === 'myskoolstjacob' && data.item.rejoining_date
              "
            >
              {{
                new Date(data.item.rejoining_date).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </span>
            <span v-else-if="data.item.appointedOn">
              {{
                new Date(data.item.appointedOn).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </span>
            <span v-else>-</span>
          </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="text-right w-100">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="staff-actions staff-actions--row">
            <b-button
              v-if="rights.add"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
              @click="Edit(data.item, data.item.departmentID)"
              v-b-tooltip.hover.left
              title="Create Salary"
            >
              <feather-icon icon="PlusIcon" class="" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
              v-b-tooltip.hover.left
              title="View History"
              @click="singleHistory(data.item)"
            >
              <feather-icon icon="EyeIcon" class="" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
              v-b-tooltip.hover.left
              title="View Attendance"
              @click="openAtt(data.item)"
            >
              <feather-icon icon="CalendarIcon" class="" />
            </b-button>
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
              v-b-tooltip.hover.left
              title="View Profile"
              @click="viewProfile(data.item)"
            >
              <feather-icon icon="UserIcon" />
            </b-button>
            <b-button
              v-if="rights.add && showLeaveEncashmentTab"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="staff-action-text"
              @click="openLeaveEncashment(data.item)"
            >
              Leave Encashment
            </b-button>
            <b-button
              v-if="rights.add"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="staff-action-text"
              @click="showOthers(data.item.id, 'Security Deposit')"
            >
              Security Deposit
            </b-button>
            <b-button
              v-if="rights.add"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="staff-action-text"
              @click="showOthers(data.item.id, 'Advance / Loan')"
            >
              Advance / Loan
            </b-button>
          </div>
        </template>
      </b-table>

      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-center"
        v-if="
          !isLoan &&
          !isDeposit &&
          !isHistory &&
          !isEncashmentHistory &&
          !isSalarySheet &&
          !showAtt
        "
      >
        <!-- :total-rows="filters.length" -->
        <b-pagination
          v-model="currentPage"
          :total-rows="totalCount"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @input="LoadData()"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>

    <!-- Half Day Policy Sidebar -->
    <b-sidebar
      id="sidebar-half-day"
      bg-variant="white"
      v-model="visibility6"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Half Day Policy</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility6 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12" class="mb-1">
            <b-form-group
              label="Department"
              invalid-feedback="Department is required."
            >
              <v-select
                v-model="halfDayPolicy.departmentID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ name: 'All Departments', id: 0 }, ...departments]"
                :reduce="(opt) => opt.id"
                label="name"
                :clearable="false"
                placeholder="Select department"
              />
            </b-form-group>
          </b-col>

          <b-col md="6" class="mb-1">
            <b-form-group
              label="Half Day Start Time"
              invalid-feedback="Start time is required."
            >
              <b-form-input
                v-model="halfDayPolicy.startTime"
                type="time"
                placeholder="Select start time"
              />
            </b-form-group>
          </b-col>

          <b-col md="6" class="mb-1">
            <b-form-group
              label="Half Day End Time"
              invalid-feedback="End time is required."
            >
              <b-form-input
                v-model="halfDayPolicy.endTime"
                type="time"
                placeholder="Select end time"
              />
            </b-form-group>
          </b-col>

          <!-- <b-col md="12" class="mb-1">
            <b-form-group
              label="Half Day Hours"
              invalid-feedback="Hours is required."
            >
              <b-form-input
                v-model="halfDayPolicy.hours"
                type="number"
                step="0.5"
                placeholder="Enter hours (e.g., 4, 4.5)"
              />
            </b-form-group>
          </b-col>
          
          <b-col md="12" class="mb-1">
            <b-form-group
              label="Description"
            >
              <b-form-textarea
                v-model="halfDayPolicy.description"
                placeholder="Enter policy description (optional)"
                rows="3"
              />
            </b-form-group>
          </b-col> -->

          <b-col cols="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="saveHalfDayPolicy()"
              :disabled="savingHalfDayPolicy"
              block
            >
              <b-spinner v-if="savingHalfDayPolicy" small type="grow" />
              <span v-else>Save Policy</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BFormTextarea,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BForm,
  BMediaAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BAvatar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";
import * as XLSX from "xlsx";

import AccountBranch from "@/views/myskool/components/AccountBranch.vue";
import { getMediaPreviewUrl } from "@/utils/gdriveUpload";

/** Report host subdomain for Crest View Academy salary slips / payroll. */
const CREST_VIEW_REPORT_HOST = "myskoolcrestviewacademy";

/** St Jacob — allow-leaves “include months” multi-select (1 = Jan … 12 = Dec). */
const ST_JACOB_LEAVE_MONTH_OPTIONS = Object.freeze([
  { label: "Jan", value: 1 },
  { label: "Feb", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Apr", value: 4 },
  { label: "May", value: 5 },
  { label: "Jun", value: 6 },
  { label: "Jul", value: 7 },
  { label: "Aug", value: 8 },
  { label: "Sep", value: 9 },
  { label: "Oct", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dec", value: 12 },
]);

function normalizeSalaryReportDomain(report) {
  const d = String(report || "").replace(/_/g, "").trim().toLowerCase();
  if (
    d === "myskoolcrestview" ||
    d === CREST_VIEW_REPORT_HOST ||
    (d.startsWith("myskool") && d.includes("crestview"))
  ) {
    return CREST_VIEW_REPORT_HOST;
  }
  return d;
}

export default {
  components: {
    BFormCheckboxGroup,
    BCard,
    BRow,
    BBadge,
    BFormTextarea,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BPagination,
    BSpinner,
    BMedia,
    BMediaAside,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BLink,
    vSelect,
    flatPickr,
    FullCalendar,
    AccountBranch,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  mounted() {
    window.addEventListener("keydown", this.handleEvent);
    window.addEventListener("resize", this.onSettingsResize);

    // Set default date range for salary date-range domains after component is mounted
    if (this.usesSalaryDateRange) {
      this.$nextTick(() => {
        this.setDefaultSalaryRange();
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEvent);
    window.removeEventListener("resize", this.onSettingsResize);
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
        };
      });
    });

    this.$store.commit("setRights", right);

    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      // Staff list + departments first; other APIs deferred so the table appears faster.
      await Promise.all([this.LoadData(), this.loadDep()]);
      this.bootstrapSalaryPageDeferred();
      if (this.reportDomain == "myskoolhpgs") {
        this.reportOptions.push(
          { text: "Salary Hold", value: "salaryHold" },
          { text: "Salary Given", value: "salaryGiven" }
        );
      }

      // For salary date-range domains, set current month/year
      if (this.usesSalaryDateRange) {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth(); // 0-indexed

        // Set month and year based on the current month
        this.sal.month = currentMonth + 1;
        this.sal.year = currentYear;
      }
    }
  },
  watch: {
    "mSalary.salary.present"() {
      if (this.shouldHandleIussUpdates()) {
        // For myskooliuss domain, when present changes directly (user edits),
        // update basePresent to maintain the relationship: present = basePresent + late
        if (this.basePresent !== null && this.basePresent !== undefined) {
          const currentPresent = this.toNumber(this.mSalary.salary.present);
          const currentLate = this.toNumber(this.mSalary.salary.late);
          // Update basePresent: basePresent = present - late
          this.basePresent = Math.max(0, currentPresent - currentLate);
        }
        this.updateWorkingDaysFromParts();
      }
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateDeductionDays();
      }
    },
    "mSalary.salary.absent"() {
      if (this.shouldHandleIussUpdates()) {
        this.updateWorkingDaysFromParts();
      }
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateDeductionDays();
      }
    },
    "mSalary.salary.late"() {
      if (this.shouldHandleIussUpdates()) {
        // For myskooliuss domain, when late changes, update present to show basePresent + newLate
        // This ensures present field updates correctly when user edits late value
        if (this.basePresent !== null && this.basePresent !== undefined) {
          const newLate = this.toNumber(this.mSalary.salary.late);
          this.mSalary.salary.present = this.basePresent + newLate;
        }
        this.updateWorkingDaysFromParts();
      }
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateDeductionDays();
      }
    },
    "extraDays.offdays"() {
      if (this.shouldHandleIussUpdates()) {
        this.updateWorkingDaysFromParts();
      }
    },
    "extraDays.holidays"() {
      if (this.shouldHandleIussUpdates()) {
        this.updateWorkingDaysFromParts();
      }
    },
    "mSalary.salary.workingDays"() {
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateSalaryDays();
      }
      this.recalcStjacobAllowanceAmountsByDays();
    },
    "extraDays.deductionDays"() {
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateSalaryDays();
      }
    },
    "mSalary.salary.leave"() {
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateDeductionDays();
      }
    },
    "mSalary.salary.sickLeaves"() {
      if (this.shouldHandleExtraSalaryDayFields()) {
        this.updateDeductionDays();
      }
    },
    "mSalary.salary.basicSalary"() {
      this.recalcStjacobAllowanceAmountsByDays();
    },
  },
  computed: {
    isDynamicLeaveBalance() {
      const s = this.dynamicLeaveBalanceSetting;
      if (!s) return false;
      if (s.valueBool === true) return true;
      const v = s.value;
      return (
        v === true ||
        v === 1 ||
        String(v).toLowerCase() === "true" ||
        String(v) === "1"
      );
    },
    salaryLeaveBalancesList() {
      if (!this.mSalary || !Array.isArray(this.mSalary.leaveBalances)) {
        return [];
      }
      return this.mSalary.leaveBalances;
    },
    casualLeaveBalanceEntry() {
      return this.findSalaryLeaveBalanceEntry("casual");
    },
    sickLeaveBalanceEntry() {
      return this.findSalaryLeaveBalanceEntry("sick");
    },
    salaryOtherLeaveBalances() {
      if (!this.isDynamicLeaveBalance) return [];
      return this.salaryLeaveBalancesList.filter(
        (item) =>
          item.isActive !== false &&
          !this.isCasualLeaveBalanceItem(item) &&
          !this.isSickLeaveBalanceItem(item)
      );
    },
    primaryLeaveFieldLabel() {
      if (this.isDynamicLeaveBalance && this.casualLeaveBalanceEntry) {
        return this.leaveBalanceDisplayName(this.casualLeaveBalanceEntry);
      }
      return "Leave";
    },
    sickLeaveFieldLabel() {
      if (this.isDynamicLeaveBalance && this.sickLeaveBalanceEntry) {
        return this.leaveBalanceDisplayName(this.sickLeaveBalanceEntry);
      }
      return "Sick Leave";
    },
    primaryLeaveRemainingLabel() {
      if (this.isDynamicLeaveBalance && this.casualLeaveBalanceEntry) {
        return this.formatLeaveBalanceCount(
          this.casualLeaveBalanceEntry.remaining
        );
      }
      return this.mSalary.remainingLeaves;
    },
    sickLeaveRemainingLabel() {
      if (this.isDynamicLeaveBalance && this.sickLeaveBalanceEntry) {
        return this.formatLeaveBalanceCount(
          this.sickLeaveBalanceEntry.remaining
        );
      }
      return this.mSalary.remainingSickLeaves;
    },
    primaryLeaveTooltipHtml() {
      if (this.isDynamicLeaveBalance && this.casualLeaveBalanceEntry) {
        return this.leaveBalanceTooltipHtml(this.casualLeaveBalanceEntry);
      }
      return (
        `<b>Max leaves per month</b><hr style='margin: 0.15rem 0'/><p class='text-left m-0'>` +
        this.mSalary.maxLeavePerMonth +
        " Allowed</p>"
      );
    },
    sickLeaveTooltipHtml() {
      if (this.isDynamicLeaveBalance && this.sickLeaveBalanceEntry) {
        return this.leaveBalanceTooltipHtml(this.sickLeaveBalanceEntry);
      }
      return (
        `<b>Max sick leaves per month</b><hr style='margin: 0.15rem 0'/><p class='text-left m-0'>` +
        (this.mSalary.maxSickLeavesPerMonth || 0) +
        " Allowed</p>"
      );
    },
    primaryLeaveInputPlaceholder() {
      return this.isDynamicLeaveBalance
        ? this.primaryLeaveFieldLabel + " no. of days"
        : "Leave no. of days";
    },
    sickLeaveInputPlaceholder() {
      return this.isDynamicLeaveBalance
        ? this.sickLeaveFieldLabel + " no. of days"
        : "Sick leave no. of days";
    },
    /** Inverse of API `skipUtilizeableLeaves`: ON = apply leave balance to casual/sick pool. */
    enableDeductionFromSalary: {
      get() {
        return !this.skipUtilizeableLeaves;
      },
      set(value) {
        this.skipUtilizeableLeaves = !value;
      },
    },
    showAbsentLeaveBalanceHint() {
      const salary = this.mSalary && this.mSalary.salary;
      if (!salary) return false;
      return (
        this.toNumber(salary.absentDeductionCount) > 0 &&
        this.toNumber(salary.absent) === 0
      );
    },
    absentLeaveBalanceHintText() {
      const n = this.toNumber(
        this.mSalary && this.mSalary.salary
          ? this.mSalary.salary.absentDeductionCount
          : 0
      );
      return `${n} day(s) not covered by leave balance (see sick/casual breakdown).`;
    },
    showLeavesAllowedDepartment() {
      return ["myskool", "myskoolstjacob"].includes(this.reportDomain);
    },
    attDeptOptions() {
      return [{ name: "All Departments", id: 0 }, ...(this.departments || [])];
    },
    attDeptIsAll() {
      const list = Array.isArray(this.attDeptSelected)
        ? this.attDeptSelected
        : [this.attDeptSelected];
      return list.includes(0) || !list.filter((id) => Number(id) > 0).length;
    },
    showLeaveEncashmentTab() {
      const s = this.leaveEncashmentTabObj;
      if (!s || s.key !== "leave_encashment_tab") return false;
      if (s.valueBool === true || s.valueBool === 1) return true;
      if (typeof s.valueBool === "string") {
        const t = s.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },
    showSalarySheetButton() {
      const s = this.salarySheetTabObj;
      if (!s || s.key !== "salary_sheet_tab") return false;
      if (s.valueBool === true || s.valueBool === 1) return true;
      if (typeof s.valueBool === "string") {
        const t = s.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },
    showStaffLeftSalaryFilter() {
      const s = this.staffLeftSalaryObj;
      if (!s || s.key !== "staff_left_salary") return false;
      if (s.valueBool === true || s.valueBool === 1) return true;
      if (typeof s.valueBool === "string") {
        const t = s.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },
    staffListStatusFilterVisible() {
      return this.showStaffLeftSalaryFilter && !this.isAlternateListView;
    },
    /* Keep the settings sidebar usable on small screens instead of a fixed 820px.
       Backed by data (updated on resize) so it stays reactive. */
    /* Create/Update salary sidebar width. Wide enough that the top form's
       month/date/department selects are never squeezed, but never wider than
       the viewport on small screens. */
    createSidebarWidth() {
      const w = this.viewportWidth;
      if (!w) return "960px";
      if (w <= 480) return "100%";
      if (w <= 768) return "96vw";
      return `${Math.min(960, Math.floor(w * 0.94))}px`;
    },
    settingsSidebarWidth() {
      const w = this.viewportWidth;
      const cap = this.isMyskoolStJacobDomain ? 1040 : 780;
      if (!w) return `${cap}px`;
      if (w <= 480) return "100%";
      if (w <= 768) return "96vw";
      const ratio = this.isMyskoolStJacobDomain ? 0.96 : 0.92;
      return `${Math.min(cap, Math.floor(w * ratio))}px`;
    },
    settingsSidebarClasses() {
      return this.isMyskoolStJacobDomain
        ? "salary-settings-sidebar salary-settings-sidebar--stjacob"
        : "salary-settings-sidebar";
    },
    campusSelectOptions() {
      return (this.campuses || []).map((campus) => ({
        ...campus,
        id: Number(campus.id),
        branch:
          campus.branch ||
          campus.name ||
          campus.campus ||
          `Campus ${campus.id}`,
      }));
    },
    generateResultModalTitle() {
      if (!this.generateResult) return "Result";
      return this.generateResult.mode === "ledger"
        ? "Salary ledger sync result"
        : "Salary generation result";
    },
    generateResultHeadline() {
      if (!this.generateResult) return "";
      const g = this.generateResult;
      if (g.mode === "ledger") {
        if (g.skippedCount > 0 && !g.created && !g.updated) {
          return "Ledger sync completed with skips";
        }
        if (g.skippedCount > 0) return "Ledger synced with skipped staff";
        return "Salary ledger synced successfully";
      }
      if (g.skippedCount > 0) return "Salary generated with skipped staff";
      return "Salary generated successfully";
    },
    generateResultShortText() {
      if (!this.generateResult) return "";
      return this.generateResult.text || "";
    },
    staffSalaryListFilterLayout() {
      const alt = this.isAlternateListView;
      const status = this.staffListStatusFilterVisible;
      const enc = this.showLeaveEncashmentTab;

      // Filters fill one row; the action buttons get their own full-width row.
      // This keeps 7+ buttons from wrapping into a ragged block that leaves a
      // large empty area beside the filters.
      if (alt) {
        return {
          search: { xl: 6, lg: 6, md: 12 },
          dept: { xl: 3, lg: 3, md: 6 },
          status: null,
          toolbar: { xl: 12, lg: 12, md: 12 },
        };
      }
      if (enc && status) {
        return {
          search: { xl: 6, lg: 6, md: 12 },
          dept: { xl: 3, lg: 3, md: 6 },
          status: { xl: 3, lg: 3, md: 6 },
          toolbar: { xl: 12, lg: 12, md: 12 },
        };
      }
      if (enc && !status) {
        return {
          search: { xl: 6, lg: 6, md: 12 },
          dept: { xl: 3, lg: 3, md: 6 },
          status: null,
          toolbar: { xl: 12, lg: 12, md: 12 },
        };
      }
      if (!enc && status) {
        return {
          search: { xl: 6, lg: 6, md: 12 },
          dept: { xl: 3, lg: 3, md: 6 },
          status: { xl: 3, lg: 3, md: 6 },
          toolbar: { xl: 12, lg: 12, md: 12 },
        };
      }
      return {
        search: { xl: 6, lg: 6, md: 12 },
        dept: { xl: 3, lg: 3, md: 6 },
        status: null,
        toolbar: { xl: 12, lg: 12, md: 12 },
      };
    },
    isAlternateListView() {
      return (
        this.isHistory ||
        this.isEncashmentHistory ||
        this.isSalarySheet ||
        this.isDeposit ||
        this.isLoan ||
        this.showAtt
      );
    },
    isStaffMainToolbarOneLine() {
      return !this.isHistory && !this.isEncashmentHistory;
    },
    attendanceStatusLegend() {
      const items = [
        { code: "P", label: "Present", tone: "success" },
        { code: "A", label: "Absent", tone: "danger" },
        { code: "AA", label: "Double absent", tone: "danger" },
        { code: "L", label: "Leave", tone: "info" },
        { code: "SL", label: "Short leave", tone: "info" },
        { code: "H", label: "Holiday", tone: "info" },
        { code: "HL", label: "Half leave", tone: "info" },
        { code: "Late", label: "Late", tone: "warning" },
        { code: "Off", label: "Off day", tone: "secondary" },
        { code: "Extra Day", label: "Extra day", tone: "primary" },
        { code: "WFH", label: "Work from home", tone: "info" },
      ];
      if (!this.doubleObj || !this.doubleObj.valueBool) {
        return items.filter((item) => item.code !== "AA");
      }
      return items;
    },
    attendancePeriodLabel() {
      const month = (this.months || []).find(
        (m) => Number(m.value) === Number(this.attMonth)
      );
      const name = month ? month.text : "";
      const year = this.attYear || "";
      return [name, year].filter(Boolean).join(" ");
    },
    attendanceSummaryCards() {
      const s = this.summaryObj || {};
      const shortLabel =
        this.reportDomain === "myskoolalhameed" ? "Half day" : "Short leave";
      const shortVal =
        this.reportDomain === "myskoolalhameed" ? s.halfdays : s.shortLeave;

      const cards = [
        {
          key: "present",
          code: "P",
          label: "Present",
          tone: "present",
          value: s.present,
        },
        {
          key: "absent",
          code: "A",
          label: "Absent",
          tone: "absent",
          value: s.absent,
        },
        {
          key: "leave",
          code: "L",
          label: "Leave",
          tone: "leave",
          value: s.leave,
        },
        {
          key: "short",
          code: "SL",
          label: shortLabel,
          tone: "short",
          value: shortVal,
        },
        {
          key: "late",
          code: "Late",
          label: "Late",
          tone: "late",
          value: s.late,
        },
        {
          key: "holiday",
          code: "H",
          label: "Holiday",
          tone: "holiday",
          value: this.attendanceSummaryHolidayCount(),
        },
        {
          key: "off",
          code: "Off",
          label: "Off day",
          tone: "off",
          value: this.attendanceSummaryOffCount(),
        },
      ];

      return cards.map((card) => ({
        ...card,
        value: Number(card.value) || 0,
      }));
    },
    attendanceModalTitle() {
      const id = Number(this.currentObj && this.currentObj.id);
      if (!id || id <= 0) {
        return "Add Attendance";
      }
      return "Edit Attendance";
    },
    salarySheetFilteredRows() {
      const q = (this.searchQuery || "").trim().toLowerCase();
      if (!q) return this.salarySheetRows;
      return this.salarySheetRows.filter((row) => {
        const name = String(row.name || "").toLowerCase();
        const designation = String(row.designation || "").toLowerCase();
        const dept = String(row.departmentName || "").toLowerCase();
        return (
          name.includes(q) ||
          designation.includes(q) ||
          dept.includes(q) ||
          String(row.tID || "") === q
        );
      });
    },
    /* Totals for the salary sheet footer strip. Reads `row.salary` directly
       (the same shape the table cells render) so this stays a pure computed -
       the cell helper getSheetSalaryValue() calls ensureSheetRowObject(), which
       mutates rows, and a computed must not have side effects. */
    salarySheetTotals() {
      const rows = this.salarySheetFilteredRows || [];
      const sum = (key) =>
        rows.reduce((acc, row) => {
          const salary = (row && row.row && row.row.salary) || {};
          const num = Number(salary[key]);
          return acc + (Number.isFinite(num) ? num : 0);
        }, 0);

      const net = sum("netSalary");

      return {
        count: rows.length,
        grossSalary: sum("grossSalary"),
        allowances: sum("totalAllownaces"),
        deductions: sum("totalDedcutions"),
        net,
        // Only average over rows we actually have, never divide by zero.
        averageNet: rows.length ? net / rows.length : 0,
      };
    },
    encashmentReportDeptLabel() {
      const depId = this.encashmentReportDepID;
      if (!depId) return "All Departments";
      const dep = (this.departments || []).find((d) => d.id === depId);
      return dep ? dep.name : "All Departments";
    },
    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.id == this.searchQuery
        );
      });
    },
    /* History rows are already filtered and paged by the API (buildHistoryUrl),
       so the table must render them as-is. Re-filtering here would drop rows
       that the server matched but this page never received. */
    historySearchFilters() {
      return this.historyData;
    },
    historyDisplayRange() {
      const total = this.historyTotalCount || 0;
      if (!total) return { start: 0, end: 0, total: 0 };
      const start = (this.historyPage - 1) * this.historyPerPage + 1;
      const end = Math.min(this.historyPage * this.historyPerPage, total);
      return { start, end, total };
    },
    historyPageSummary() {
      const totalPages =
        this.historyTotalPages ||
        Math.max(
          1,
          Math.ceil((this.historyTotalCount || 0) / this.historyPerPage)
        );
      return `Page ${this.historyPage} of ${totalPages}`;
    },
    encashmentHistorySearchFilters() {
      const q = (this.searchQuery || "").trim().toLowerCase();
      if (!q) return this.encashmentHistoryData;
      return this.encashmentHistoryData.filter((row) => {
        const name = String(row.name || "").toLowerCase();
        const father = String(row.father_name || "").toLowerCase();
        const rf = String(row.rfID || "").toLowerCase();
        const dept = this.encashmentDepartmentName(row).toLowerCase();
        return (
          name.includes(q) ||
          father.includes(q) ||
          rf.includes(q) ||
          dept.includes(q) ||
          String(row.staffID || "") === q
        );
      });
    },
    encashmentHisFields() {
      return [
        { label: "S.No", key: "index" },
        { label: "name", key: "name" },
        { label: "RF ID", key: "rfID" },
        { label: "Date", key: "date" },
        { label: "Designation", key: "designation" },
        { label: "Department", key: "department" },
        { label: "Amount", key: "encashmentAmount" },
        { label: "Leaves", key: "leavesEncashed" },
        { label: "Notes", key: "notes" },
        { label: "actions", key: "actions" },
      ];
    },
    hisFields() {
      const fields = [
        { label: "S.No", key: "index" },
        { label: "name", key: "name" },
        { label: "Payment Date", key: "date" },
        { label: "Salary for", key: "forDate" },
        { label: "basic Salary", key: "basic" },
        { label: "current deposit", key: "securityDeposit" },
        { label: "remaining deposit", key: "remainingDeposit" },
        { label: "deposit upto", key: "depositUpto" },
        { label: "deposit return", key: "depositReturn" },
        { label: "working days", key: "working" },
        { label: "present", key: "present" },
        { label: "absent", key: "absent" },
        { label: "leave", key: "leave" },
        { label: "late", key: "late" },
        { label: "absent Deduction", key: "absentDeduction" },
        { label: "late Deduction", key: "lateDeduction" },
        { label: "allownaces", key: "allownaces" },
        { label: "dedcutions", key: "totalDedcutions" },
      ];

      // Add Contributions column only for myskooliuss
      if (this.reportDomain === "myskooliuss") {
        fields.push({ label: "Contributions", key: "contributions" });
      }

      // Add Paid column only for myskoolkentschool
      if (this.isKentSchoolDomain) {
        fields.push({ label: "paid", key: "paid" });
      }

      fields.push(
        { label: "net Salary", key: "netSalary" },
        { label: "actions", key: "actions" }
      );

      return fields;
    },

    totalDeposits() {
      return this.calculateFilteredDeposits(() => true);
    },
    currentDeposits() {
      return this.calculateFilteredDeposits((el) => el.salaryID != null);
    },
    remainingDeposits() {
      return this.calculateFilteredDeposits((el) => el.salaryID == null);
    },
    returnDeposits() {
      return this.calculateFilteredDeposits(
        (el) => el.isReturned != null && el.isReturned == true
      );
    },
    isIussDomain() {
      return this.reportDomain === "myskooliuss";
    },
    usesSalaryDateRange() {
      return ["myskool", "myskooliuss", "myskoolprofectus"].includes(
        this.reportDomain
      );
    },
    showSalaryPaymentDate() {
      return ["myskool", "myskoolkentschool"].includes(this.reportDomain);
    },
    /* Whether this salary record already exists.
       Prefers the API flags (isUpdate / mode) added to Salary/LoadData,
       falls back to salary.id > 0 for older payloads. */
    salaryIsUpdate() {
      const m = this.mSalary || {};
      if (typeof m.isUpdate === "boolean") return m.isUpdate;
      if (typeof m.mode === "string" && m.mode) return m.mode === "update";
      const id = m.salary && Number(m.salary.id);
      return Number.isFinite(id) && id > 0;
    },
    salaryModeLabel() {
      return this.salaryIsUpdate ? "Update Salary" : "Create Salary";
    },
    salaryModeActionLabel() {
      return this.salaryIsUpdate ? "Update Salary" : "Create Salary";
    },
    salaryModeIcon() {
      return this.salaryIsUpdate ? "Edit3Icon" : "PlusCircleIcon";
    },
    salaryModeHint() {
      return this.salaryIsUpdate
        ? "Editing an existing salary record"
        : "Creating a new salary record";
    },
    salaryHeaderPeriodLabel() {
      if (this.usesSalaryDateRange && this.salaryRange) {
        return String(this.salaryRange).replace(/\s+to\s+/i, " – ");
      }
      const m = this.sal && this.sal.month;
      const y = this.sal && this.sal.year;
      if (!m || !y) return "";
      const mo = (this.months || []).find((x) => x.value == m);
      const monthText = mo ? mo.text : m;
      return `Salary period · ${monthText} ${y}`;
    },
    isKentSchoolDomain() {
      const d = String(this.reportDomain || "")
        .toLowerCase()
        .replace(/[^a-z]/g, "");
      return d === "myskoolkentschool" || d.includes("kent");
    },
    isMyskoolStJacobDomain() {
      const d = normalizeSalaryReportDomain(this.$store.state.report);
      return d === "myskoolstjacob";
    },
    stjacobAllowanceDaySelectOptions() {
      const rows = [{ value: 0, label: "0" }];
      for (let d = 1; d <= 31; d += 1) {
        rows.push({ value: d, label: String(d) });
      }
      return rows;
    },
    // Holiday salary UI: present + off days + holidays + late (read-only)
    totalDaysCalculated() {
      if (!this.mSalary || !this.mSalary.salary) return 0;
      const present = this.toNumber(this.mSalary.salary.present);
      const off = this.toNumber(this.extraDays.offdays);
      const holiday = this.toNumber(this.extraDays.holidays);
      const late = this.toNumber(this.mSalary.salary.late);
      return present + off + holiday + late;
    },
  },
  data() {
    let yList = [];
    for (let i = 2020; i <= 2040; i++) {
      yList.push(i);
    }
    // console.log(yList);
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        headerToolbar: {
          start: "title",
          end: "",
        },
        events: [
          // { title: "P", start: new Date() },
          // { title: "A", start: "2024-03-05T00:00:00" },
        ],
        eventResizableFromStart: true,
        dragScroll: true,
        dayMaxEvents: 1,
        // navLinks: true,
        eventClassNames({ event: e }) {
          const colorName =
            e.title == "P"
              ? "success"
              : e.title == "A" || e.title == "AA"
              ? "danger"
              : ["L", "H", "SL", "HL", "WFH"].includes(e.title)
              ? "info"
              : e.title == "Off"
              ? "secondary"
              : e.title == "Extra Day"
              ? "primary"
              : "warning";

          return [`text-${colorName}`, "att-fc-event-shell"];
        },
        eventClick: this.openEditAtt,
        dateClick: this.onAttendanceDayClick,
        eventDidMount: this.stripAttendanceEventShell,
      },
      showAtt: false,
      attMonth: new Date().getMonth() + 1,
      attYear: new Date().getFullYear(),
      attLoading: false,
      stCurrent: {},
      summaryObj: {},
      currentObj: {
        status: "",
        timeIn: null,
        timeOut: null,
      },
      savingAtt: false,
      doubleObj: null,
      timeConfig: {
        altFormat: "h:i K",
        altInput: true,
        dateFormat: "Y-m-d\\TH:i:S",
        defaultHour: 8,
        defaultMinute: 0,
        noCalendar: true,
        enableTime: true,
        time_24hr: true,
      },
      decimalData: [1, 2, 3],
      rights: {},
      skipped: [],
      delAll: false,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      salaryRange: "",
      years: yList,
      months: [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
      ],
      deductMonth: new Date().getMonth() + 1,
      deductYear: new Date().getFullYear(),
      loanMonth: new Date().getMonth() + 1,
      loanYear: new Date().getFullYear(),
      request: false,
      requestCalculate: false,
      saving: false,
      colorDep: [],
      visibility1: false,
      sidebarTitle: "Employee's Salary",
      sidebarStaffName: "",
      sidebarStaffDesignation: "",
      sidebarStaffAppointedOn: "",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 50,
      totalCount: 0,
      index: null,
      fields: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name" },
        // { label: "father name", key: "father_name" },
        { label: "designation", key: "designation" },
        { label: "appointed on", key: "appointedOn" },
        // { label: "totalSalary", key: "totalSalary" },
        // { label: "status", key: "status" },
        "actions",
      ],
      items: [],
      selected: null,
      rangeDate: null,
      sal: {
        gross: null,
        totalDeduction: null,
        totalAllowance: null,
        netSalary: null,
        account: this.$store.state.accountType,
        date: new Date().toJSON(),
        month: this.$store.state.monthNo,
        year: this.$store.state.salYear,
      },
      deductInfo: [],
      AddingInfo: [],
      dedIDs: [],
      allowIDs: [],
      myObj: {},
      settObj: {
        isAllowed: false,
        leaveAllowed: 0,
        category: "",
        dateFrom: null,
        dateTo: null,
        onLate: false,
        lateScale: null,
        everyLate: false,
        onLeave: false,
        shortScale: null,
        everyLeave: false,
        onAttendance: false,
        attendanceType: "fixed",
        days: 0,
        amount: 0,
        percentage: 0,
        onEncashment: false,
        maxEncashment: 0,
      },
      settLoading: false,
      /* True after settingData has been mapped into leavesObj/lateObj/etc. */
      policiesUIReady: false,
      viewportWidth: typeof window !== "undefined" ? window.innerWidth : 0,
      maxObj: {},
      minuteObj: {},
      earlyObj: {},
      sandwichObj: {},
      sandwichDeptSelected: [0],
      leavePolicyRows: [],
      leavePolicyPendingDelete: [],
      leavePolicyRowSeq: 0,
      attDeptObj: {
        id: 0,
        tID: 0,
        categoy: "Attendance Allowance Department",
        enabled: false,
        number: 0,
        option: "0",
        campusID: this.$store.state.userData.cId,
      },
      attDeptSelected: [0],
      leavesAllowedDeptObj: {
        id: 0,
        tID: 0,
        categoy: "Leaves Allowed Department",
        enabled: false,
        number: 0,
        option: "",
        campusID: this.$store.state.userData.cId,
      },
      leavesAllowedDeptSelected: [],
      showEarly: true,
      leavesObj: {
        id: 0,
        tID: 0,
        categoy: "Leave Allowed",
        enabled: false,
        number: 0,
        option: "Monthly",
        campusID: this.$store.state.userData.cId,
      },
      lateObj: {
        id: 0,
        tID: 0,
        categoy: "Late Coming Scale",
        enabled: false,
        number: 0,
        option: "No",
        campusID: this.$store.state.userData.cId,
      },
      shortObj: {
        id: 0,
        tID: 0,
        categoy: "Short Leave Scale",
        enabled: false,
        number: 0,
        option: "No",
        campusID: this.$store.state.userData.cId,
      },
      attObj: {
        id: 0,
        tID: 0,
        categoy: "Attendance Allowance",
        enabled: false,
        number: 0,
        option: "Fixed amount",
        campusID: this.$store.state.userData.cId,
      },
      encashObj: {
        id: 0,
        tID: 0,
        categoy: "Leave Encashment",
        enabled: false,
        number: 0,
        option: "",
        campusID: this.$store.state.userData.cId,
      },
      settingData: [],
      bonusOptions: [
        { text: "Monthly", value: "monthly" },
        { text: "Yearly", value: "yearly" },
      ],
      attCount: {
        workingDays: 0,
        present: 0,
        absent: 0,
        leave: 0,
        late: 0,
        halfLeave: 0,
      },
      showHalfHint: true,
      showLateHint: true,
      attTypes: [
        { text: "Fixed amount", value: "fixed" },
        { text: "Percentage", value: "percentage" },
        { text: "One day salary", value: "one" },
      ],
      customObj: {
        show: true,
      },
      policyObj: [],
      leaveTypes: [
        { text: "Monthly", value: "monthly" },
        { text: "Yearly", value: "yearly" },
      ],
      salaryObj: {
        id: 0,
        details: "",
        amount: 0,
        salaryInfoID: 0,
        campusID: this.$store.state.userData.cId,
      },
      // deductObj: {
      //   id: 0,
      //   details: "",
      //   amount: 0,
      //   deductID: 0,
      //   campusID: this.$store.state.userData.cId,
      // },
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      detailObj: {},
      timeout: 10000,
      showSettings: false,
      showDetails: false,
      accTypes: [],
      allowances: [],
      deductions: [],
      currentDep: 0,
      departments: [],
      history: {
        month: null,
        year: null,
      },
      historyFiltersHydrating: false,
      // myskoolkentschool salary paid status
      historyPaidFilter: "all",
      historyPaidOptions: [
        { text: "All", value: "all" },
        { text: "Paid", value: "yes" },
        { text: "Unpaid", value: "no" },
      ],
      paidOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      payrollPaidFilter: "all",
      payrollPaidOptions: [
        { text: "All", value: "all" },
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" },
      ],
      payroll: {
        // depIDs: [],
        depIDs: 0,
        month: "",
        year: new Date().getFullYear(),
        date: new Date().toJSON().split("T")[0],
        cheque: "",
        report: "",
        cIDs: [0],
        accountID: 0,
        branchID: 0,
      },
      reportOptions: [
        { text: "Payroll", value: "" },
        { text: "Summary", value: "summary" },
        { text: "Bank Report", value: "bank" },
        { text: "Cash Salaries", value: "cash" },
        { text: "Salary Preparation Sheet", value: "preparation" },
        { text: "Salary Register", value: "register" },
        { text: "Salary Reconcilation Report", value: "reconcilation" },
        { text: "Salary Receiving Sheet", value: "receiving" },
        { text: "Salary Slips", value: "slips" },
      ],
      showMsg: false,
      isHistory: false,
      isEncashmentHistory: false,
      isSalarySheet: false,
      salarySheetRecalculate: false,
      salarySheetLoading: false,
      salarySheetSaving: false,
      salarySheetDirty: false,
      salarySheetRows: [],
      salarySheetSkipped: [],
      salarySheetMeta: {
        totalCount: 0,
        salaryExistsCount: 0,
      },
      salarySheetFilter: {
        campusID: this.$store.state.userData.cId,
        month: this.$store.state.monthNo,
        year: this.$store.state.salYear,
        departmentID: 0,
        dtFrom: null,
        dtTo: null,
      },
      salarySheetFields: [
        {
          key: "sno",
          label: "#",
          thClass: "sheet-sticky-col sheet-col-sno",
          tdClass: "sheet-sticky-col sheet-col-sno",
        },
        {
          key: "name",
          label: "Staff Name",
          thClass: "sheet-sticky-col sheet-col-name",
          tdClass: "sheet-sticky-col sheet-col-name",
        },
        {
          key: "designation",
          label: "Designation",
          thClass: "sheet-col-text",
          tdClass: "sheet-col-text",
        },
        {
          key: "departmentName",
          label: "Department",
          thClass: "sheet-col-text",
          tdClass: "sheet-col-text",
        },
        {
          key: "policyRem",
          label: "Remaining",
          thClass: "sheet-col-policy",
          tdClass: "sheet-col-policy",
        },
        {
          key: "policyUse",
          label: "Usable",
          thClass: "sheet-col-policy",
          tdClass: "sheet-col-policy",
        },
        {
          key: "policyLvUsed",
          label: "Leave Used",
          thClass: "sheet-col-policy sheet-col-readonly",
          tdClass: "sheet-col-policy sheet-col-readonly",
        },
        {
          key: "policyAbsDed",
          label: "Abs Ded",
          thClass: "sheet-col-policy sheet-col-readonly",
          tdClass: "sheet-col-policy sheet-col-readonly",
        },
        {
          key: "policyLtDed",
          label: "Late Ded",
          thClass: "sheet-col-policy sheet-col-readonly",
          tdClass: "sheet-col-policy sheet-col-readonly",
        },
        {
          key: "workingDays",
          label: "Working Days",
          thClass: "sheet-col-att",
          tdClass: "sheet-col-att",
        },
        {
          key: "present",
          label: "Present",
          thClass: "sheet-col-att",
          tdClass: "sheet-col-att",
        },
        {
          key: "absent",
          label: "Absent",
          thClass: "sheet-col-att",
          tdClass: "sheet-col-att",
        },
        {
          key: "leave",
          label: "Leave",
          thClass: "sheet-col-att",
          tdClass: "sheet-col-att",
        },
        {
          key: "late",
          label: "Late",
          thClass: "sheet-col-att",
          tdClass: "sheet-col-att",
        },
        {
          key: "basicSalary",
          label: "Basic",
          thClass: "sheet-col-pay",
          tdClass: "sheet-col-pay",
        },
        {
          key: "grossSalary",
          label: "Gross",
          thClass: "sheet-col-pay sheet-col-readonly",
          tdClass: "sheet-col-pay sheet-col-readonly",
        },
        {
          key: "totalAllownaces",
          label: "Allowances",
          thClass: "sheet-col-pay sheet-col-readonly",
          tdClass: "sheet-col-pay sheet-col-readonly",
        },
        {
          key: "totalDedcutions",
          label: "Deductions",
          thClass: "sheet-col-pay sheet-col-readonly",
          tdClass: "sheet-col-pay sheet-col-readonly",
        },
        {
          key: "netSalary",
          label: "Net",
          thClass: "sheet-col-pay sheet-col-net",
          tdClass: "sheet-col-pay sheet-col-net",
        },
        {
          key: "note",
          label: "Note",
          thClass: "sheet-col-note",
          tdClass: "sheet-col-note",
        },
      ],
      encashmentHistorySessionID: null,
      encashmentHistoryData: [],
      encashmentHistoryLoading: false,
      encashmentReportSessionID: null,
      encashmentReportDepID: 0,
      encashmentReportType: "cash",
      encashmentReportBankNo: "",
      encashmentReportExporting: false,
      encashmentReportTypeOptions: [
        { label: "Bank Report", value: "bank" },
        { label: "Cash Report", value: "cash" },
        { label: "Summary Report", value: "summary" },
      ],
      leaveEncashmentReportAccounts: {
        bank: "19,21",
        cash: "18,20",
      },
      historyData: [],
      allHistory: [],
      /* Server-side paging for the history view (Salary/LoadHistory). The API
         returns one page per request plus totalCount, so the table never holds
         more than historyPerPage rows. */
      historyPage: 1,
      historyPerPage: 10,
      historyTotalCount: 0,
      historyTotalPages: 0,
      historyHasNext: false,
      /* When the API ignores page/pageSize, we load once and slice client-side. */
      historyLegacyMode: false,
      historyLegacyCache: null,
      historyLegacyCacheKey: "",
      /* Set when the history view is scoped to one staff (singleHistory). */
      historyStaffID: 0,
      historyStaffCampusID: 0,
      historyPageSizeOptions: [
        { label: "10", value: 10 },
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
      ],
      currentHistoryStaff: null, // Track staff for single history view
      tID: 0,
      currentDate: this.$store.state.salPaymentDate,
      mSalary: {
        allowances: [],
        deductions: [],
        advanceIDs: [],
        loanIDs: [],
        sdIDs: [],
        isUpdate: false,
        mode: "new",
        salary: {
          absent: 0,
          absentDeductionCount: 0,
          shortLeaveDeductionCount: 0,
          lateDeductionCount: 0,
          accountID: 0,
          basicSalary: 0,
          campusID: 0,
          date: this.$store.state.salPaymentDate,
          grossSalary: 0,
          id: 0,
          late: 0,
          leave: 0,
          month: 0,
          monthYear: "",
          netSalary: 0,
          note: null,
          present: 0,
          shortLeave: 0,
          tID: 0,
          totalAllownaces: 0,
          totalDedcutions: 0,
          workingDays: 0,
          year: 0,
          utilizeableLeaves: 0,
          remainingLeaves: 0,
          bonusDaysAmount: 0,
          bonusDays: 0,
          leavesEncashed: 0,
          leavesEncashementAmount: 0,
          securityDeposit: 0,
          loanDeduction: 0,
          advanceDeduction: 0,
          shortLeaveDeductionCount: 0,
          lateDeductionCount: 0,
          departmentID: 0,
          grossPayable: 0,
          earlyDeparture: 0,
          branchID: 0,
          sickLeave: 0,
          salaryPaymentDate: null,
          paid: null,
        },
        maxLeavePerMonth: 0,
        remainingLeaves: 0,
        utilizeableLeaves: 0,
        maxSickLeavesPerMonth: 0,
        remainingSickLeaves: 0,
        utilizeableSickLeaves: 0,
        leaveBalances: [],
      },

      dynamicLeaveBalanceSetting: null,

      loanFields: [
        {
          label: "Date",
          key: "date",
          thClass: "deposit-th-date",
          tdClass: "deposit-td-date",
        },
        {
          label: "Type",
          key: "loanType",
          thClass: "deposit-th-type",
          tdClass: "deposit-td-type",
        },
        {
          label: "Amount",
          key: "amount",
          thClass: "deposit-th-amount",
          tdClass: "deposit-td-amount",
        },
        {
          label: "Months",
          key: "months",
          thClass: "deposit-th-months",
          tdClass: "deposit-td-months",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "deposit-th-actions",
          tdClass: "deposit-td-actions",
        },
      ],
      loanData: [],
      depoFields: [
        {
          label: "S.No",
          key: "index",
          thClass: "deposit-th-sno",
          tdClass: "deposit-td-sno",
        },
        {
          label: "Date",
          key: "date",
          thClass: "deposit-th-date",
          tdClass: "deposit-td-date",
        },
        {
          label: "Amount",
          key: "amount",
          thClass: "deposit-th-amount",
          tdClass: "deposit-td-amount",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "deposit-th-actions",
          tdClass: "deposit-td-actions",
        },
      ],
      depositDetails: [],
      otherLoading: false,
      /** LoadSelectedStaff by staff id (deposit/loan). */
      staffSelectedCache: Object.create(null),
      /** Attendance calendar by `${staffId}-${month}-${year}`. */
      staffAttendanceCache: Object.create(null),
      /** When true, closing deposit/loan/attendance refetches the staff list. */
      staffListNeedsRefresh: false,
      staffSelectedCacheTtlMs: 5 * 60 * 1000,
      staffAttendanceCacheTtlMs: 4 * 60 * 1000,
      isLoan: false,
      isDeposit: false,
      reportDomain: normalizeSalaryReportDomain(this.$store.state.report),
      stJacobLeaveMonthOptions: ST_JACOB_LEAVE_MONTH_OPTIONS,
      stJacobLeaveMonthCheckboxOptions: ST_JACOB_LEAVE_MONTH_OPTIONS.map(
        (m) => ({ text: m.label, value: m.value })
      ),

      // Sorting state
      sortBy: (() => {
        const domain = this.$store.state.report.replace(/_/g, "");
        if (domain === "myskoolstjacob") return "doa";
        if (domain === "myskooliuss") return "appointedOn";
        return "name";
      })(),
      sortOrder: "asc",

      returnIDs: [],
      returnLoading: false,
      extraDays: {
        offdays: 0,
        holidays: 0,
        deductionDays: 0,
        salaryDays: 0,
      },
      basePresent: null, // Store base present value (without late) for myskooliuss domain
      currentStaff: {},
      installLoading: false,
      visibility2: false,
      loanObj: {},
      loanSaving: false,
      loanDetails: [],
      installData: [],
      installFields: [
        { label: "month", key: "month" },
        { label: "amount", key: "amount" },
      ],
      newLoan: false,
      typeOptions: [
        { text: "Advance", value: "advance" },
        { text: "Loan", value: "loan" },
      ],
      visibility5: false,
      depoSaveList: [],
      depoObj: {},
      savingDepo: false,
      newDepo: true,
      deductOption: [
        { text: "Same Month", value: true },
        { text: "Next Month", value: false },
      ],
      sameMonth: true,

      sunObj: null,
      sunmonValue: false,
      sunmonDepID: null,
      toExpense: true,
      expOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      entryObj: null,
      coAccounts: [],
      accountObj: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        account: "",
        status: "active",
        accountID: 0,
      },
      accountbar: false,
      accIcon: "",
      savingacc: false,
      accFields: [
        { label: "Name", key: "account" },
        { key: "actions", label: "actions" },
      ],
      sending: false,
      currentID: 0,
      singleSending: false,
      exporting: false,
      campuses: [],
      updating: false,
      isTaxes: false,
      exludeSD: false,
      holdSalary: false,
      excludeCL: false,
      salObj: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        campusID: this.$store.state.userData.cId,
        dateRange: "",
        dtFrom: null,
        dtTo: null,
      },
      manualMonthSelected: false,
      manualYearSelected: false,
      salSaving: false,
      /* Result of Salary/GenerateSalaryAll, shown in the result modal. */
      generateResult: null,
      branchOptions: [],
      branchLoading: false,
      disBranch: false,
      selectedCampus: this.$store.state.userData.cId,
      accBranches: [],
      accBranchLoading: false,
      disAccBranch: false,
      currentAccount: {},
      modalTitle: "Account Branches",
      currentCampusID: null,
      isHeadOffice: null,
      sdObj: null,
      leaveEncashmentTabObj: null,
      staffLeftSalaryObj: null,
      staffStatusFilter: "present",
      staffStatusOptions: [
        { text: "Present", value: "present" },
        { text: "Left", value: "left" },
      ],
      salarySheetTabObj: null,
      visibility7: false,
      leaveEncashmentSaving: false,
      leaveEncashmentLoading: false,
      leaveEncashmentStaffTitle: "",
      leaveEncashmentStaffItem: null,
      leaveEncashmentObj: {
        id: 0,
        staffID: 0,
        campusID: 0,
        date: new Date().toISOString().slice(0, 10),
        sessionID: null,
        startMonth: null,
        endMonth: null,
        encashmentAmount: 0,
        leavesEncashed: 0,
        remaining_leaves: null,
        remaining_sickLeaves: null,
        accountID: null,
        notes: "",
      },
      isUpdatingAmount: false,
      editAmountObj: null,
      depositIndex: 0,
      sickLeaveObj: {
        id: 0,
        tID: 0,
        categoy: "Sick Leave",
        enabled: false,
        number: 0,
        option: "Monthly",
        campusID: this.$store.state.userData.cId,
      },
      maxSickObj: {
        id: 0,
        tID: 0,
        categoy: "Max Leave per Month",
        enabled: false,
        number: 0,
        option: "",
        campusID: this.$store.state.userData.cId,
      },
      halfDayPolicy: {
        departmentID: 0,
        startTime: "",
        endTime: "",
        hours: 0,
        description: "",
      },
      visibility6: false,
      savingHalfDayPolicy: false,
      skipUtilizeableLeaves: false,
      salaryLedgerObj: null,
      salaryExpenseObj: null,
      holidaySalaryObj: null,
      salaryPayableObj: null,
      showLeavesSessionSettings: false,
      leavesSessionObj: null,
      leavesStartMonthObj: null,
      leavesEndMonthObj: null,
      sessions: [],
      creatingLedger: false,
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    getPicturePreview(url) {
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },

    handleEvent(event) {
      // console.log(event.key);
      if (event.ctrlKey && event.keyCode === 83) {
        event.preventDefault();
        // if create sidebar is open and not save salary or calculate salary in process
        if (this.visibility && !this.request && !this.requestCalculate) {
          this.request = true;
          this.SaveSalary(false);
        }
      }
    },
    onSettingsResize() {
      this.viewportWidth = window.innerWidth;
    },
    shouldHandleIussUpdates() {
      return this.isIussDomain && this.mSalary && this.mSalary.salary;
    },
    shouldHandleExtraSalaryDayFields() {
      if (!this.mSalary || !this.mSalary.salary) return false;
      if (this.isIussDomain) return true;
      return !!(this.holidaySalaryObj && this.holidaySalaryObj.valueBool);
    },
    toNumber(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    },
    // myskoolkentschool: salary `paid` flag (Yes / No)
    /* Safe month label: us.month can be 0/invalid for legacy rows, and the old
       `months.find(...).text` threw a TypeError that blanked the whole table. */
    historyMonthLabel(us) {
      const monthNo = Number(us && us.month);
      const match = (this.months || []).find((m) => Number(m.value) === monthNo);
      return match ? String(match.text).slice(0, 3) : "—";
    },
    normalizePaidValue(value) {
      if (value === true || value === false) return value;
      if (value === null || value === undefined || value === "") return null;
      const raw = String(value).trim().toLowerCase();
      if (["true", "yes", "paid", "1"].includes(raw)) return true;
      if (["false", "no", "unpaid", "0"].includes(raw)) return false;
      return null;
    },
    formatPaidLabel(value) {
      const paid = this.normalizePaidValue(value);
      if (paid === true) return "Yes";
      if (paid === false) return "No";
      return "—";
    },
    updateWorkingDaysFromParts() {
      if (!this.shouldHandleIussUpdates()) return;
      let present = this.toNumber(this.mSalary.salary.present);
      const absent = this.toNumber(this.mSalary.salary.absent);
      const late = this.toNumber(this.mSalary.salary.late);
      const offdays = this.toNumber(this.extraDays.offdays);
      const holidays = this.toNumber(this.extraDays.holidays);

      // For myskooliuss domain, present field displays present + late (set during LoadSalary)
      // So we need to subtract late from present to get the base present value,
      // then add it back in the calculation to avoid double-counting
      // Formula: workingDays = (present - late) + absent + late + offdays + holidays
      // Which equals: present + absent + offdays + holidays (late cancels out, then added back)
      if (this.isIussDomain) {
        const basePresent = Math.max(0, present - late); // Ensure non-negative
        const total = basePresent + absent + late + offdays + holidays;
        if (!Number.isNaN(total)) {
          this.mSalary.salary.workingDays = total;
        }
      } else {
        // Normal calculation for other domains
        const total = present + absent + late + offdays + holidays;
        if (!Number.isNaN(total)) {
          this.mSalary.salary.workingDays = total;
        }
      }
      this.updateSalaryDays();
    },
    updateDeductionDays() {
      if (!this.shouldHandleExtraSalaryDayFields()) return;
      const absent = this.toNumber(this.mSalary.salary.absent);
      const late = this.toNumber(this.mSalary.salary.late);
      const leave = this.getSalaryLeaveDaysTotal();
      let deduction = absent + Math.floor(late / 3) - leave;
      if (deduction < 0) deduction = 0;
      this.extraDays.deductionDays = deduction;
      this.updateSalaryDays();
    },
    updateSalaryDays() {
      if (!this.shouldHandleExtraSalaryDayFields()) return;
      const working = this.toNumber(this.mSalary.salary.workingDays);
      const deduction = this.toNumber(this.extraDays.deductionDays);
      const salaryDays = working - deduction;
      this.extraDays.salaryDays = salaryDays < 0 ? 0 : salaryDays;
    },
    getSelectedPeriodRange() {
      const normalize = (value) => {
        if (!value) return null;
        const sanitized = String(value).trim();
        return sanitized ? sanitized : null;
      };

      if (this.salaryRange) {
        const [from, to] = String(this.salaryRange).split(" to ");
        const dtFrom = normalize(from);
        const dtTo = normalize(to ?? from);
        if (dtFrom && dtTo) {
          return { dtFrom, dtTo };
        }
      }

      if (this.salObj?.dtFrom && this.salObj?.dtTo) {
        return {
          dtFrom: normalize(this.salObj.dtFrom),
          dtTo: normalize(this.salObj.dtTo),
        };
      }

      return null;
    },
    extractSalaryMeta(source = {}) {
      const salary = source?.salary || {};
      return {
        offdays: source.offdays ?? salary.offdays,
        holidays: source.holidays ?? salary.holidays,
        deductionDays: source.deductionDays ?? salary.deductionDays,
        salaryDays: source.salaryDays ?? salary.salaryDays,
      };
    },
    applyExtraDaysToSalaryPayload(source) {
      const numberOrZero = (value) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
      };

      source.salary = source.salary || {};
      source.salary.offdays = numberOrZero(this.extraDays.offdays);
      source.salary.holidays = numberOrZero(this.extraDays.holidays);
      source.salary.deductionDays = numberOrZero(this.extraDays.deductionDays);
      source.salary.salaryDays = numberOrZero(this.extraDays.salaryDays);
    },
    prepareSalaryPayload() {
      if (
        this.isDynamicLeaveBalance &&
        !this.hasDynamicLeavePeriodFields()
      ) {
        this.syncSalaryLeaveFieldsToLeaveBalances();
      }
      const metaKeys = [
        "dtFrom",
        "dtTo",
        "isDateRangeFiltered",
        "offdays",
        "holidays",
        "deductionDays",
        "salaryDays",
      ];

      const source = this.mSalary
        ? JSON.parse(JSON.stringify(this.mSalary))
        : { salary: {} };
      source.salary = source.salary || {};
      if (this.isDynamicLeaveBalance) {
        this.applyDynamicLeavePeriodFieldsToPayload(source);
      }

      // myskoolkentschool: send the paid flag as Yes(true) / No(false)
      if (this.isKentSchoolDomain) {
        source.salary.paid =
          this.normalizePaidValue(source.salary.paid) === true;
      }

      if (!this.isIussDomain && !this.usesSalaryDateRange) {
        if (this.shouldHandleExtraSalaryDayFields()) {
          this.applyExtraDaysToSalaryPayload(source);
          metaKeys.forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              delete source[key];
            }
          });
          if (!this.showSalaryPaymentDate && source.salary) {
            delete source.salary.salaryPaymentDate;
          }
          this.sanitizeAllowancePayloadRows(source);
          return source;
        }

        metaKeys.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(source, key))
            delete source[key];
          if (Object.prototype.hasOwnProperty.call(source.salary, key))
            delete source.salary[key];
        });
        if (!this.showSalaryPaymentDate && source.salary) {
          delete source.salary.salaryPaymentDate;
        }
        this.sanitizeAllowancePayloadRows(source);
        return source;
      }

      if (this.usesSalaryDateRange && !this.isIussDomain) {
        const selectedRange = this.getSelectedPeriodRange() || {};
        source.salary.dtFrom =
          source.salary.dtFrom ??
          source.dtFrom ??
          selectedRange.dtFrom ??
          this.salObj.dtFrom ??
          null;
        source.salary.dtTo =
          source.salary.dtTo ??
          source.dtTo ??
          selectedRange.dtTo ??
          this.salObj.dtTo ??
          null;
        source.salary.isDateRangeFiltered = !!(
          source.salary.dtFrom && source.salary.dtTo
        );

        if (this.shouldHandleExtraSalaryDayFields()) {
          this.applyExtraDaysToSalaryPayload(source);
        }

        metaKeys.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            delete source[key];
          }
        });

        if (!this.showSalaryPaymentDate && source.salary) {
          delete source.salary.salaryPaymentDate;
        }

        this.sanitizeAllowancePayloadRows(source);
        return source;
      }

      source.salary = source.salary || {};

      const numberOrZero = (value) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
      };

      const selectedRange = this.getSelectedPeriodRange() || {};

      const metaDefaults = {
        dtFrom: null,
        dtTo: null,
        isDateRangeFiltered: false,
        offdays: 0,
        holidays: 0,
        deductionDays: 0,
        salaryDays: 0,
      };

      const metaFields = {
        dtFrom:
          source.salary.dtFrom ??
          source.dtFrom ??
          selectedRange.dtFrom ??
          this.salObj.dtFrom ??
          metaDefaults.dtFrom,
        dtTo:
          source.salary.dtTo ??
          source.dtTo ??
          selectedRange.dtTo ??
          this.salObj.dtTo ??
          metaDefaults.dtTo,
        offdays: numberOrZero(
          this.extraDays.offdays ??
            source.offdays ??
            source.salary.offdays ??
            metaDefaults.offdays
        ),
        holidays: numberOrZero(
          this.extraDays.holidays ??
            source.holidays ??
            source.salary.holidays ??
            metaDefaults.holidays
        ),
        deductionDays: numberOrZero(
          this.extraDays.deductionDays ??
            source.deductionDays ??
            source.salary.deductionDays ??
            metaDefaults.deductionDays
        ),
        salaryDays: numberOrZero(
          this.extraDays.salaryDays ??
            source.salaryDays ??
            source.salary.salaryDays ??
            metaDefaults.salaryDays
        ),
      };

      // Set isDateRangeFiltered based on whether dtFrom and dtTo exist
      // If both dtFrom and dtTo are present, set isDateRangeFiltered to true
      const hasDateRange = metaFields.dtFrom && metaFields.dtTo;
      metaFields.isDateRangeFiltered = hasDateRange
        ? true
        : this.isIussDomain
        ? true
        : metaDefaults.isDateRangeFiltered;

      Object.assign(source.salary, metaFields);

      // Calculate depositUpto based on rejoining date if available
      if (
        source.salary.depositUpto !== undefined &&
        this.depositDetails &&
        this.depositDetails.length > 0
      ) {
        const calculateDepositUpto = () => {
          if (
            !this.currentStaff ||
            !this.currentStaff.staff ||
            !this.currentStaff.staff.rejoining_date
          ) {
            // If no rejoining date, return the existing depositUpto value
            return source.salary.depositUpto;
          }

          const rejoiningDate = new Date(
            this.currentStaff.staff.rejoining_date
          );
          const rejoiningYear = rejoiningDate.getFullYear();
          const rejoiningMonth = rejoiningDate.getMonth() + 1;

          const monthMap = {
            jan: 1,
            feb: 2,
            mar: 3,
            apr: 4,
            may: 5,
            jun: 6,
            jul: 7,
            aug: 8,
            sep: 9,
            oct: 10,
            nov: 11,
            dec: 12,
          };

          const getMonthNumber = (m) =>
            monthMap[m?.toString().trim().substring(0, 3).toLowerCase()] ||
            parseInt(m) ||
            0;

          // Get current salary month and year
          const salaryYear =
            source.salary.year || this.sal?.year || new Date().getFullYear();
          const salaryMonth =
            source.salary.month || this.sal?.month || new Date().getMonth() + 1;

          // Filter deposits: on or after rejoining date AND up to current salary period
          return this.depositDetails.reduce((sum, el) => {
            const depositYear = parseInt(el.year);
            const depositMonth = getMonthNumber(el.month);

            // Check if deposit is on or after rejoining date
            const isOnOrAfterRejoin =
              depositYear > rejoiningYear ||
              (depositYear === rejoiningYear && depositMonth >= rejoiningMonth);

            // Check if deposit is up to current salary period
            const isUpToSalary =
              depositYear < salaryYear ||
              (depositYear === salaryYear && depositMonth <= salaryMonth);

            // Include deposit if it meets both conditions
            return isOnOrAfterRejoin && isUpToSalary
              ? sum + (el.amount || 0)
              : sum;
          }, 0);
        };

        source.salary.depositUpto = calculateDepositUpto();
      }

      // Calculate remainingDeposit based on rejoining date if available
      if (
        source.salary.remainingDeposit !== undefined &&
        this.depositDetails &&
        this.depositDetails.length > 0
      ) {
        const calculateRemainingDeposit = () => {
          if (
            !this.currentStaff ||
            !this.currentStaff.staff ||
            !this.currentStaff.staff.rejoining_date
          ) {
            // If no rejoining date, return the existing remainingDeposit value
            return source.salary.remainingDeposit;
          }

          const rejoiningDate = new Date(
            this.currentStaff.staff.rejoining_date
          );
          const rejoiningYear = rejoiningDate.getFullYear();
          const rejoiningMonth = rejoiningDate.getMonth() + 1;

          const monthMap = {
            jan: 1,
            feb: 2,
            mar: 3,
            apr: 4,
            may: 5,
            jun: 6,
            jul: 7,
            aug: 8,
            sep: 9,
            oct: 10,
            nov: 11,
            dec: 12,
          };

          const getMonthNumber = (m) =>
            monthMap[m?.toString().trim().substring(0, 3).toLowerCase()] ||
            parseInt(m) ||
            0;

          // Get current salary month and year
          const salaryYear =
            source.salary.year || this.sal?.year || new Date().getFullYear();
          const salaryMonth =
            source.salary.month || this.sal?.month || new Date().getMonth() + 1;

          // Calculate remaining deposits: deposits on or after rejoining date, up to current salary period, and not used (salaryID == null) and not returned
          return this.depositDetails.reduce((sum, el) => {
            const depositYear = parseInt(el.year);
            const depositMonth = getMonthNumber(el.month);

            // Check if deposit is on or after rejoining date
            const isOnOrAfterRejoin =
              depositYear > rejoiningYear ||
              (depositYear === rejoiningYear && depositMonth >= rejoiningMonth);

            // Check if deposit is up to current salary period
            const isUpToSalary =
              depositYear < salaryYear ||
              (depositYear === salaryYear && depositMonth <= salaryMonth);

            // Check if deposit is not used (salaryID == null) and not returned
            const isNotUsed = el.salaryID == null;
            const isNotReturned = !(
              el.isReturned != null && el.isReturned == true
            );

            // Include deposit if it meets all conditions
            return isOnOrAfterRejoin &&
              isUpToSalary &&
              isNotUsed &&
              isNotReturned
              ? sum + (el.amount || 0)
              : sum;
          }, 0);
        };

        source.salary.remainingDeposit = calculateRemainingDeposit();
      }

      metaKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          delete source[key];
        }
      });

      if (!this.showSalaryPaymentDate && source.salary) {
        delete source.salary.salaryPaymentDate;
      }

      this.sanitizeAllowancePayloadRows(source);
      return source;
    },
    getSalaryUserID() {
      return (
        this.$store.state.userData.userID ||
        this.$store.state.userData.localID ||
        1
      );
    },
    salaryUserQuery() {
      return `&userID=${this.getSalaryUserID()}`;
    },
    syncSalarySheetFiltersFromMain() {
      this.salarySheetFilter.campusID =
        this.selectedCampus || this.$store.state.userData.cId;
      this.salarySheetFilter.departmentID = this.currentDep || 0;

      if (this.usesSalaryDateRange) {
        if (!this.salaryRange) {
          this.setDefaultSalaryRange();
        }
        this.onSalarySheetRangeChange(null, this.salaryRange);
      } else {
        if (this.sal.month) this.salarySheetFilter.month = this.sal.month;
        if (this.sal.year) this.salarySheetFilter.year = this.sal.year;
      }
    },
    onSalarySheetRangeChange(selectedDates, dateStr) {
      const value = dateStr || this.salaryRange || "";
      if (!value) {
        this.salarySheetFilter.dtFrom = null;
        this.salarySheetFilter.dtTo = null;
        return;
      }

      const parts = String(value).split(" to ");
      this.salarySheetFilter.dtFrom = parts[0] || null;
      this.salarySheetFilter.dtTo = parts[1] || parts[0] || null;

      try {
        const end = parts[1] || parts[0] || value;
        const d = new Date(end);
        if (!isNaN(d.getTime())) {
          this.salarySheetFilter.month = d.getMonth() + 1;
          this.salarySheetFilter.year = d.getFullYear();
          this.sal.month = this.salarySheetFilter.month;
          this.sal.year = this.salarySheetFilter.year;
        }
      } catch (e) {
        // console.error("Error in onSalarySheetRangeChange:", e);
      }
    },
    buildSalarySheetUrl(calculate = false) {
      const f = this.salarySheetFilter;
      let url =
        `${this.$store.state.domain}Salary/LoadSheet?db=` +
        `${this.$store.state.userData.db}` +
        `&cID=${f.campusID}` +
        `&month=${f.month}` +
        `&year=${f.year}` +
        `&dID=${f.departmentID || 0}` +
        `&calculate=${calculate ? "true" : "false"}`;

      if (this.usesSalaryDateRange && f.dtFrom && f.dtTo) {
        url += `&dtFrom=${encodeURIComponent(f.dtFrom)}`;
        url += `&dtTo=${encodeURIComponent(f.dtTo)}`;
      }
      return url;
    },
    ensureSheetRowObject(item) {
      if (!item.row || typeof item.row !== "object") {
        this.$set(item, "row", { salary: {} });
      }
      if (!item.row.salary || typeof item.row.salary !== "object") {
        this.$set(item.row, "salary", {});
      }
      if (!item.row.salary.tID && item.tID) {
        item.row.salary.tID = item.tID;
      }
      if (!item.row.salary.month && this.salarySheetFilter.month) {
        item.row.salary.month = this.salarySheetFilter.month;
      }
      if (!item.row.salary.year && this.salarySheetFilter.year) {
        item.row.salary.year = this.salarySheetFilter.year;
      }
      if (!item.row.salary.campusID) {
        item.row.salary.campusID = this.salarySheetFilter.campusID;
      }
      return item.row;
    },
    getSheetSalaryValue(item, key) {
      const row = this.ensureSheetRowObject(item);
      const value = row.salary?.[key];
      if (value === null || value === undefined) return "";
      return value;
    },
    setSheetSalaryValue(item, key, value, numeric = true) {
      const row = this.ensureSheetRowObject(item);
      if (numeric) {
        const parsed = value === "" || value === null ? 0 : Number(value);
        this.$set(row.salary, key, Number.isFinite(parsed) ? parsed : 0);
      } else {
        this.$set(row.salary, key, value);
      }
      this.salarySheetDirty = true;
    },
    getSheetNetInputClass(item) {
      const net = Number(this.getSheetSalaryValue(item, "netSalary"));
      if (Number.isFinite(net) && net < 0) return "is-negative";
      return "";
    },
    getSheetRowData(item) {
      this.ensureSheetRowObject(item);
      return item.row || {};
    },
    pickSheetField(row, keys) {
      const salary = row.salary || {};
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const salaryVal = salary[key];
        if (salaryVal !== null && salaryVal !== undefined && salaryVal !== "") {
          return salaryVal;
        }
        const rowVal = row[key];
        if (rowVal !== null && rowVal !== undefined && rowVal !== "") {
          return rowVal;
        }
      }
      return null;
    },
    formatSheetPolicyValue(value) {
      if (value === null || value === undefined || value === "") return "—";
      const num = Number(value);
      if (Number.isFinite(num)) return num;
      return String(value);
    },
    getSheetRemainingLeaves(item) {
      return this.pickSheetField(this.getSheetRowData(item), [
        "remainingLeaves",
      ]);
    },
    getSheetUtilizeableLeaves(item) {
      return this.pickSheetField(this.getSheetRowData(item), [
        "utilizeableLeaves",
        "utilizableLeaves",
      ]);
    },
    getSheetLeaveUtilized(item) {
      return this.pickSheetField(this.getSheetRowData(item), [
        "leave_utilized",
        "leaveUtilized",
        "leaveUtilised",
      ]);
    },
    getSheetAbsentDeduction(item) {
      return this.pickSheetField(this.getSheetRowData(item), [
        "absentDeductionCount",
        "absentDeduction",
        "absent_deduction",
      ]);
    },
    getSheetLateDeduction(item) {
      return this.pickSheetField(this.getSheetRowData(item), [
        "lateDeductionCount",
        "lateDeduction",
        "late_deduction",
      ]);
    },
    getSheetLateScaleLabel() {
      if (!this.lateObj || !this.lateObj.enabled) return "";
      const scale = Number(this.lateObj.number);
      if (!Number.isFinite(scale) || scale <= 0) return "";
      return scale + " late = 1 absent";
    },
    hasSheetAppliedDeductions(item) {
      return (
        this.getSheetLeaveUtilized(item) !== null ||
        this.getSheetAbsentDeduction(item) !== null ||
        this.getSheetLateDeduction(item) !== null
      );
    },
    async ensureSheetPolicySettings() {
      if (this.lateObj) return;
      if (!this.settingData || !this.settingData.length) {
        await this.LoadPolicies();
      }
      if (!this.lateObj && Array.isArray(this.settingData)) {
        this.lateObj = this.settingData.find(
          (el) => el.categoy == "Late Coming Scale"
        );
      }
    },
    formatSheetMoney(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "—";
      return num.toLocaleString("en-PK");
    },
    async openSalarySheet() {
      this.isLoan = false;
      this.isDeposit = false;
      this.showAtt = false;
      this.isHistory = false;
      this.isEncashmentHistory = false;
      this.isSalarySheet = true;
      await this.ensureSheetPolicySettings();
      this.syncSalarySheetFiltersFromMain();
      await this.loadSalarySheet(false);
    },
    async runSalarySheetCalculate() {
      if (this.salarySheetRecalculate && this.salarySheetRows.length) {
        await this.bulkCalculateSalarySheet();
        return;
      }
      await this.loadSalarySheet(
        this.salarySheetRecalculate && !this.salarySheetRows.length
      );
    },
    prepareSalarySheetRowPayload(item) {
      const source = JSON.parse(JSON.stringify(this.ensureSheetRowObject(item)));
      const salary = source.salary || {};
      source.salary = salary;

      const numberOrZero = (value) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
      };

      const normalizeDateOnly = (value) => {
        if (!value) return null;
        const str = String(value).trim();
        if (!str) return null;
        return str.includes("T") ? str.slice(0, 10) : str;
      };

      const isInvalidDate = (value) => {
        if (!value) return true;
        const str = String(value);
        return str.startsWith("0001-") || str.startsWith("0000-");
      };

      salary.month = this.salarySheetFilter.month;
      salary.year = this.salarySheetFilter.year;
      salary.campusID = this.salarySheetFilter.campusID;
      if (!salary.tID && item.tID) salary.tID = item.tID;
      if ((!salary.departmentID || salary.departmentID === 0) && item.departmentID) {
        salary.departmentID = item.departmentID;
      }

      const metaKeys = [
        "dtFrom",
        "dtTo",
        "isDateRangeFiltered",
        "offdays",
        "holidays",
        "deductionDays",
        "salaryDays",
      ];

      if (this.usesSalaryDateRange) {
        const selectedRange = this.getSelectedPeriodRange() || {};
        salary.dtFrom = normalizeDateOnly(
          salary.dtFrom ??
            source.dtFrom ??
            this.salarySheetFilter.dtFrom ??
            selectedRange.dtFrom
        );
        salary.dtTo = normalizeDateOnly(
          salary.dtTo ??
            source.dtTo ??
            this.salarySheetFilter.dtTo ??
            selectedRange.dtTo
        );
        salary.isDateRangeFiltered = !!(salary.dtFrom && salary.dtTo);
        salary.offdays = numberOrZero(source.offdays ?? salary.offdays);
        salary.holidays = numberOrZero(source.holidays ?? salary.holidays);
        salary.deductionDays = numberOrZero(
          source.deductionDays ?? salary.deductionDays
        );
        salary.salaryDays = numberOrZero(source.salaryDays ?? salary.salaryDays);
      } else if (!this.isIussDomain) {
        metaKeys.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(salary, key)) {
            delete salary[key];
          }
        });
      }

      metaKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          delete source[key];
        }
      });

      if (isInvalidDate(salary.date)) {
        salary.date =
          this.currentDate ||
          this.$store.state.salPaymentDate ||
          normalizeDateOnly(new Date().toISOString());
      } else if (String(salary.date).includes("T")) {
        salary.date = normalizeDateOnly(salary.date);
      }

      [
        "workingDays",
        "present",
        "absent",
        "leave",
        "late",
        "sickLeaves",
        "shortLeave",
        "bonusDays",
        "leavesEncashed",
        "earlyDeparture",
      ].forEach((key) => {
        if (salary[key] !== undefined && salary[key] !== null) {
          salary[key] = parseInt(salary[key], 10) || 0;
        }
      });

      delete salary.metaCampusName;

      if (!this.showSalaryPaymentDate) {
        delete salary.salaryPaymentDate;
      }

      this.sanitizeAllowancePayloadRows(source);
      return source;
    },
    buildSalarySheetPayloadRows() {
      return this.salarySheetRows.map((item) =>
        this.prepareSalarySheetRowPayload(item)
      );
    },
    getSheetItemTid(entry) {
      if (!entry) return null;
      const rowData = entry.row || entry;
      return (
        entry.tID ||
        rowData.tID ||
        rowData.salary?.tID ||
        entry.salary?.tID ||
        null
      );
    },
    mergeSalarySheetGridItem(item, updatedEntry) {
      if (!updatedEntry) return false;

      if (updatedEntry.row) {
        this.$set(item, "row", updatedEntry.row);
      } else if (updatedEntry.salary) {
        this.$set(item, "row", updatedEntry);
      }

      const metaKeys = [
        "name",
        "designation",
        "departmentName",
        "departmentID",
        "basicSalary",
        "totalSalary",
        "payMode",
        "salaryExists",
        "salaryID",
        "remainingLeaves",
        "utilizeableLeaves",
      ];
      metaKeys.forEach((key) => {
        if (updatedEntry[key] !== undefined && updatedEntry[key] !== null) {
          item[key] = updatedEntry[key];
        }
      });

      const salaryId = item.row && item.row.salary && item.row.salary.id;
      if (salaryId) {
        item.salaryExists = true;
        item.salaryID = salaryId;
      }

      this.ensureSheetRowObject(item);
      return true;
    },
    applySalarySheetRowsFromResponse(savedItems) {
      if (!Array.isArray(savedItems) || !savedItems.length) return false;

      const byTid = {};
      savedItems.forEach((entry) => {
        const tid = this.getSheetItemTid(entry);
        if (tid) byTid[tid] = entry;
      });

      let applied = false;
      this.salarySheetRows.forEach((item) => {
        if (this.mergeSalarySheetGridItem(item, byTid[item.tID])) {
          applied = true;
        }
      });

      if (applied) {
        this.salarySheetMeta.salaryExistsCount = this.salarySheetRows.filter(
          (row) => row.salaryExists
        ).length;
      }
      return applied;
    },
    async bulkCalculateSalarySheet() {
      if (!this.salarySheetRows.length) {
        this.$bvToast.toast("Load the salary sheet before recalculating.", {
          title: this.$t("Error!"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.salarySheetLoading = true;

      try {
        const rows = this.buildSalarySheetPayloadRows();
        const response = await axios.post(
          `${this.$store.state.domain}Salary/BulkCalculate?db=${this.$store.state.userData.db}${this.salaryUserQuery()}`,
          rows,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              "Content-Type": "application/json",
              accept: "application/json",
            },
          }
        );

        const body = response.data || {};
        if (body.status && body.status !== "success") {
          throw new Error(body.message || "Failed to recalculate salary sheet.");
        }

        const updatedRows = Array.isArray(body.data)
          ? body.data
          : Array.isArray(body.calculated)
          ? body.calculated
          : Array.isArray(body.rows)
          ? body.rows
          : [];

        const applied = this.applySalarySheetRowsFromResponse(updatedRows);
        if (!applied) {
          throw new Error("Recalculate returned no updated rows.");
        }

        this.salarySheetSkipped = Array.isArray(body.skipped) ? body.skipped : [];
        this.salarySheetDirty = true;
        this.$bvToast.toast("Policy and net salary updated from your edits.", {
          title: "Recalculated",
          variant: "success",
          solid: true,
          toaster: "b-toaster-top-center",
        });
      } catch (error) {
        // console.error("Salary sheet bulk calculate error:", error);
        this.$bvToast.toast(
          (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            "Failed to recalculate salary sheet.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } finally {
        this.salarySheetLoading = false;
      }
    },
    async confirmSalarySheetReload() {
      if (!this.salarySheetDirty || !this.salarySheetRows.length) return true;
      const result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Reloading the sheet will discard unsaved edits.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      return result.isConfirmed;
    },
    async loadSalarySheet(calculate = false, options = {}) {
      await this.ensureSheetPolicySettings();

      if (!options.skipDirtyCheck) {
        const canReload = await this.confirmSalarySheetReload();
        if (!canReload) return;
      }

      if (this.usesSalaryDateRange) {
        if (!this.salarySheetFilter.dtFrom || !this.salarySheetFilter.dtTo) {
          this.$bvToast.toast("Please select salary period.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
          return;
        }
      } else if (!this.salarySheetFilter.month || !this.salarySheetFilter.year) {
        this.$bvToast.toast("Please select month and year for salary sheet.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.salarySheetLoading = true;
      this.salarySheetSkipped = [];

      try {
        const response = await axios.get(this.buildSalarySheetUrl(calculate), {
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
            accept: "application/json",
          },
        });

        const payload = response.data || {};
        if (payload.status && payload.status !== "success") {
          throw new Error(payload.message || "Failed to load salary sheet.");
        }

        const rows = Array.isArray(payload.data)
          ? payload.data
          : Array.isArray(payload)
          ? payload
          : [];

        this.salarySheetRows = rows.map((item, index) => {
          const rowItem = { ...item, sno: item.sno || index + 1 };
          this.ensureSheetRowObject(rowItem);
          return rowItem;
        });

        this.salarySheetMeta.totalCount =
          payload?.totalCount ?? this.salarySheetRows.length;
        this.salarySheetMeta.salaryExistsCount =
          payload?.salaryExistsCount ??
          this.salarySheetRows.filter((row) => row.salaryExists).length;
        this.salarySheetSkipped = Array.isArray(payload?.skipped)
          ? payload.skipped
          : [];
        this.salarySheetDirty = false;
      } catch (error) {
        // console.error("Salary sheet load error:", error);
        this.$bvToast.toast("Failed to load salary sheet.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.salarySheetRows = [];
      } finally {
        this.salarySheetLoading = false;
      }
    },
    async bulkSaveSalarySheet(recalculate = false, options = {}) {
      const reloadAfter =
        options.reloadAfter !== undefined ? options.reloadAfter : true;
      const successTitle = options.successTitle || "Salary sheet saved";
      const successMessage = options.successMessage || "";

      if (!this.salarySheetRows.length) {
        this.$bvToast.toast("Load the salary sheet before saving.", {
          title: this.$t("Error!"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.salarySheetSaving = true;

      try {
        const rows = this.buildSalarySheetPayloadRows();

        const response = await axios.post(
          `${this.$store.state.domain}Salary/BulkSave?db=${this.$store.state.userData.db}${this.salaryUserQuery()}&recalculate=${recalculate ? "true" : "false"}`,
          rows,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const body = response.data || {};
        if (body.status === "success") {
          const summary = body.summary || {};
          const savedCount = summary.totalSaved ?? 0;
          const skippedCount = summary.totalSkipped ?? 0;
          const attemptedCount = summary.totalAttempted ?? rows.length;
          this.salarySheetSkipped = Array.isArray(body.skipped)
            ? body.skipped
            : [];

          if (savedCount > 0) {
            const toastMessage =
              successMessage ||
              `Saved ${savedCount} of ${attemptedCount} (Created: ${summary.totalCreated ?? 0}, Updated: ${summary.totalUpdated ?? 0})`;
            this.$bvToast.toast(toastMessage, {
              title: successTitle,
              variant: "success",
              solid: true,
              toaster: "b-toaster-top-center",
            });
            this.salarySheetDirty = false;
          } else if (skippedCount > 0) {
            const firstReason =
              this.salarySheetSkipped[0] && this.salarySheetSkipped[0].reason
                ? this.salarySheetSkipped[0].reason
                : "All rows were skipped.";
            this.$bvToast.toast(
              `${skippedCount} row(s) skipped. ${firstReason}`,
              {
                title: "Save failed",
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
              }
            );
          } else {
            this.$bvToast.toast(body.data || "No salary rows were saved.", {
              title: "Save failed",
              variant: "warning",
              solid: true,
              toaster: "b-toaster-top-center",
            });
          }

          const applied = this.applySalarySheetRowsFromResponse(
            body.saved || body.data || []
          );
          if (savedCount > 0 && !applied && reloadAfter) {
            await this.loadSalarySheet(false, { skipDirtyCheck: true });
          }
        } else {
          this.$bvToast.toast(body.message || "Failed to save salary sheet.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        // console.error("Salary sheet bulk save error:", error);
        this.$bvToast.toast(
          error?.response?.data?.message || "Failed to save salary sheet.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } finally {
        this.salarySheetSaving = false;
      }
    },
    applyIussMeta(meta = {}) {
      if (
        !this.isIussDomain &&
        (!this.holidaySalaryObj || !this.holidaySalaryObj.valueBool)
      ) {
        this.extraDays.offdays = 0;
        this.extraDays.holidays = 0;
        this.extraDays.deductionDays = 0;
        this.extraDays.salaryDays = 0;
        return;
      }
      this.extraDays.offdays = this.toNumber(meta.offdays);
      this.extraDays.holidays = this.toNumber(meta.holidays);
      this.extraDays.deductionDays = this.toNumber(meta.deductionDays);
      this.extraDays.salaryDays = this.toNumber(meta.salaryDays);
      this.$nextTick(() => {
        this.updateWorkingDaysFromParts();
        this.updateDeductionDays();
      });
    },
    bootstrapSalaryPageDeferred() {
      const run = () => {
        this.loadAllowances();
        this.loadDeductions();
        this.LoadAccounts();
        this.loadCOA();
        this.LoadSettings();
        this.LoadSettingsAll();
        this.preloadSalaryPolicies();
      };
      if (typeof window !== "undefined" && window.requestIdleCallback) {
        window.requestIdleCallback(run, { timeout: 1500 });
      } else {
        setTimeout(run, 50);
      }
    },
    sideBarHidden() {
      this.searchQuery = "";
      this.sidebarStaffName = "";
      this.sidebarStaffDesignation = "";
      this.sidebarStaffAppointedOn = "";
      // Auto focus the search input
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
    formatStaffAppointedOn(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
      });
    },
    setSidebarStaffMeta({ name, designation, appointedOn }) {
      this.sidebarStaffName = name || "";
      this.sidebarStaffDesignation = designation || "";
      this.sidebarStaffAppointedOn = this.formatStaffAppointedOn(appointedOn);
    },
    setDefaultSalaryRange() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();

      const dtToDate = new Date(currentYear, currentMonth, 26);
      const dtTo = `${dtToDate.getFullYear()}-${String(
        dtToDate.getMonth() + 1
      ).padStart(2, "0")}-${String(dtToDate.getDate()).padStart(2, "0")}`;

      let prevMonthYear = currentYear;
      let prevMonth = currentMonth - 1;
      if (prevMonth < 0) {
        prevMonth = 11;
        prevMonthYear--;
      }
      const dtFromDate = new Date(prevMonthYear, prevMonth, 25);
      const dtFrom = `${dtFromDate.getFullYear()}-${String(
        dtFromDate.getMonth() + 1
      ).padStart(2, "0")}-${String(dtFromDate.getDate()).padStart(2, "0")}`;

      this.salaryRange = `${dtFrom} to ${dtTo}`;
    },
    onRangeChange() {
      try {
        if (!this.usesSalaryDateRange) return;
        if (!this.salaryRange) return;
        const parts = String(this.salaryRange).split(" to ");
        const end = parts[1] || parts[0] || this.salaryRange;
        const d = new Date(end);

        if (!isNaN(d.getTime())) {
          this.sal.month = d.getMonth() + 1;
          this.sal.year = d.getFullYear();
          this.LoadSalary();
        }
      } catch (e) {
        // console.error("Error in onRangeChange:", e);
      }
    },
    formatDateValue(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    onGenerateRangeChange(selectedDates) {
      if (!this.usesSalaryDateRange) return;
      if (!Array.isArray(selectedDates) || selectedDates.length === 0) {
        this.salObj.dtFrom = null;
        this.salObj.dtTo = null;
        this.manualMonthSelected = false;
        this.manualYearSelected = false;
        return;
      }

      const start = selectedDates[0];
      const end = selectedDates[1] || selectedDates[0];
      this.salObj.dtFrom = this.formatDateValue(start);
      this.salObj.dtTo = this.formatDateValue(end);

      this.manualMonthSelected = false;
      this.manualYearSelected = false;

      if (end instanceof Date && !isNaN(end.getTime())) {
        this.salObj.month = end.getMonth() + 1;
        this.salObj.year = end.getFullYear();
      }
    },
    onGenerateMonthChange(value) {
      this.salObj.month = value ? Number(value) : null;
      this.manualMonthSelected = true;
    },
    onGenerateYearChange(value) {
      this.salObj.year = value ? Number(value) : null;
      this.manualYearSelected = true;
    },
    async openCreate() {
      this.manualMonthSelected = false;
      this.manualYearSelected = false;
      if (
        this.reportDomain !== "myskoolbrightfuture" &&
        (this.reportDomain !== "myskooliuss" ||
          this.$store.state.userData.cId == 1)
      ) {
        if (!this.campuses?.length) {
          await this.LoadCampuses();
        }
        const preferred =
          Number(this.selectedCampus) ||
          Number(this.$store.state.userData.cId);
        const match = this.campusSelectOptions.find(
          (c) => Number(c.id) === preferred
        );
        this.salObj.campusID = match
          ? match.id
          : this.campusSelectOptions[0]?.id ?? preferred;
      } else if (
        this.reportDomain === "myskooliuss" &&
        this.$store.state.userData.cId != 1
      ) {
        this.salObj.campusID = this.$store.state.userData.cId;
      }
      this.$bvModal.show("modal-create");
    },
    async createSalary() {
      if (this.usesSalaryDateRange) {
        if (!this.salObj.dtFrom || !this.salObj.dtTo) {
          this.$bvToast.toast("Please select a salary date range.", {
            title: "Date range required",
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
          return;
        }

        const rangeLabel = `${this.salObj.dtFrom} to ${this.salObj.dtTo}`;
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: `Do you want to create salary for ${rangeLabel}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes"),
        });

        if (result.isConfirmed) {
          this.salSaving = true;
          const url =
            this.$store.state.domain +
            "Salary/GenerateSalaryAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.salObj.campusID +
            "&dID=0" +
            `&dtFrom=${encodeURIComponent(this.salObj.dtFrom)}` +
            `&dtTo=${encodeURIComponent(this.salObj.dtTo)}` +
            `&month=${encodeURIComponent(this.salObj.month)}` +
            `&year=${encodeURIComponent(this.salObj.year)}` +
            this.salaryUserQuery();
          await this.runGenerateSalary(url);
        }
        return;
      }

      if (this.salObj.month > 0 || this.salObj.year > 0) {
        let month =
          this.months.find((el) => el.value == this.salObj.month)?.text || "";

        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: `Do You want to create salary for ${month}-${this.salObj.year}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes"),
        });

        if (result.isConfirmed) {
          this.salSaving = true;
          await this.runGenerateSalary(
            this.$store.state.domain +
              "Salary/GenerateSalaryAll?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.salObj.campusID +
              "&dID=0&month=" +
              this.salObj.month +
              "&year=" +
              this.salObj.year +
              this.salaryUserQuery()
          );
        }
      }
    },

    /* GenerateSalaryAll returns { status, data, summary, createdEmployees,
       updatedEmployees, skippedEmployees }. Show that payload in a result modal
       instead of collapsing it into a "created successfully" toast. */
    async runGenerateSalary(url) {
      let body = null;
      try {
        body = await this.post({
          url,
          context: this,
          token: this.$store.state.userData.token,
          // Return the raw response so the summary/skipped lists survive.
          allResponse: true,
        });
      } finally {
        this.salSaving = false;
      }

      if (!body) return false;

      this.generateResult = this.normalizeGenerateResult(body, "generate");
      // Hide the create modal first so the two backdrops never stack; the result
      // modal takes over once the hide transition has released the body lock.
      this.$bvModal.hide("modal-create");
      this.$nextTick(() => {
        this.$bvModal.show("modal-generate-result");
      });
      return true;
    },
    formatGenerateResultPeriod(summary = {}) {
      const monthNo = Number(summary.month);
      const year = Number(summary.year);
      if (!monthNo && !year) return "";
      const monthEntry = (this.months || []).find(
        (el) => Number(el.value) === monthNo
      );
      const monthLabel = monthEntry
        ? monthEntry.text
        : monthNo
        ? `Month ${monthNo}`
        : "";
      if (monthLabel && year) {
        return `Payroll period: ${monthLabel} ${year}`;
      }
      return monthLabel || (year ? `Year ${year}` : "");
    },
    buildSkippedReasonSummary(skippedRows) {
      if (!skippedRows.length) return "";
      const counts = {};
      skippedRows.forEach((row) => {
        const reason = String(row.reason || "Skipped").trim() || "Skipped";
        counts[reason] = (counts[reason] || 0) + 1;
      });
      return Object.entries(counts)
        .map(([reason, count]) => `${count}× ${reason}`)
        .join(" · ");
    },
    buildSkippedSummary(skippedRows) {
      if (!skippedRows.length) return "";
      const reasons = [
        ...new Set(
          skippedRows.map((row) => String(row.reason || "").trim()).filter(Boolean)
        ),
      ];
      if (reasons.length === 1) {
        return `${skippedRows.length} staff skipped — ${reasons[0]}`;
      }
      return `${skippedRows.length} staff skipped (${reasons.length} different reasons). See list below.`;
    },
    formatLedgerResultMoney(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "—";
      return this.formatSheetMoney ? this.formatSheetMoney(num) : String(num);
    },
    mapLedgerEmployeeRow(row, index, prefix) {
      const staffID = row && row.staffID != null ? row.staffID : "—";
      const staffName = (row && row.staffName) || "—";
      const salaryID = row && row.salaryID != null ? row.salaryID : null;
      const journalEntryID =
        row && row.journalEntryID != null ? row.journalEntryID : null;
      const amount =
        row && row.amount != null
          ? row.amount
          : row && row.netSalary != null
          ? row.netSalary
          : null;

      const metaParts = [];
      if (salaryID != null) metaParts.push(`Salary #${salaryID}`);
      if (journalEntryID != null) metaParts.push(`Journal #${journalEntryID}`);
      if (amount != null) metaParts.push(`Rs. ${this.formatLedgerResultMoney(amount)}`);
      if (row && row.netSalary != null && amount !== row.netSalary) {
        metaParts.push(`Net Rs. ${this.formatLedgerResultMoney(row.netSalary)}`);
      }

      let replacedLine = "";
      if (
        row &&
        (row.replacedJournalEntryID != null || row.replacedAmount != null)
      ) {
        const repParts = [];
        if (row.replacedJournalEntryID != null) {
          repParts.push(`Replaced journal #${row.replacedJournalEntryID}`);
        }
        if (row.replacedAmount != null) {
          repParts.push(`Rs. ${this.formatLedgerResultMoney(row.replacedAmount)}`);
        }
        replacedLine = repParts.join(" · ");
      }

      return {
        key: `${prefix}-${staffID}-${index}`,
        staffID,
        staffName,
        metaLine: metaParts.length ? metaParts.join(" · ") : "Ledger entry synced",
        replacedLine,
      };
    },
    buildStaffResultSummary(rows, label) {
      if (!rows.length) return "";
      if (rows.length === 1) {
        const r = rows[0];
        return `${label}: ${r.staffName} (ID ${r.staffID}) — ${r.metaLine}`;
      }
      return `${rows.length} staff ${label.toLowerCase()}.`;
    },
    normalizeGenerateResult(body, mode = "generate") {
      const source = body && typeof body === "object" ? body : {};
      const summary = source.summary || {};
      const text =
        typeof source.data === "string"
          ? source.data
          : typeof source.message === "string"
          ? source.message
          : "";

      const toCount = (value) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
      };

      const skipped = Array.isArray(source.skippedEmployees)
        ? source.skippedEmployees
        : [];

      const skippedMapped = skipped.map((row, index) => ({
        key: `${row && row.staffID ? row.staffID : "row"}-${index}`,
        staffID: row && row.staffID != null ? row.staffID : "—",
        staffName: (row && row.staffName) || "—",
        reason: (row && row.reason) || "Skipped",
      }));

      const skippedCount = toCount(
        summary.totalSkipped !== undefined
          ? summary.totalSkipped
          : skippedMapped.length
      );

      const createdRaw = Array.isArray(source.createdEmployees)
        ? source.createdEmployees
        : [];
      const updatedRaw = Array.isArray(source.updatedEmployees)
        ? source.updatedEmployees
        : [];

      const createdList = createdRaw.map((row, index) =>
        this.mapLedgerEmployeeRow(row, index, "created")
      );
      const updatedList = updatedRaw.map((row, index) =>
        this.mapLedgerEmployeeRow(row, index, "updated")
      );

      const isLedger = mode === "ledger";
      const inlineListLimit = isLedger ? 500 : 12;
      const showSkippedList =
        skippedMapped.length > 0 &&
        (isLedger || skippedMapped.length <= inlineListLimit);
      const showCreatedList =
        createdList.length > 0 &&
        (isLedger || createdList.length <= inlineListLimit);
      const showUpdatedList =
        updatedList.length > 0 &&
        (isLedger || updatedList.length <= inlineListLimit);

      return {
        mode,
        text,
        periodLabel: this.formatGenerateResultPeriod(summary),
        attempted: toCount(summary.totalAttempted),
        created: toCount(summary.totalCreated),
        updated: toCount(summary.totalUpdated),
        skippedCount,
        skipped: skippedMapped,
        skippedSummary: this.buildSkippedSummary(skippedMapped),
        skippedReasonSummary: this.buildSkippedReasonSummary(skippedMapped),
        showSkippedList,
        createdList,
        updatedList,
        showCreatedList,
        showUpdatedList,
        createdSummary: this.buildStaffResultSummary(createdList, "Created"),
        updatedSummary: this.buildStaffResultSummary(updatedList, "Updated"),
      };
    },
    showOperationResult(body, mode) {
      this.generateResult = this.normalizeGenerateResult(body, mode);
      this.$nextTick(() => {
        this.$bvModal.show("modal-generate-result");
      });
    },
    closeGenerateResult() {
      this.$bvModal.hide("modal-generate-result");
    },

    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "";
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },

    getVariant(title) {
      const vt =
        title == "P"
          ? "success"
          : title == "A" || title == "AA"
          ? "danger"
          : ["L", "H", "SL", "HL", "WFH"].includes(title)
          ? "info"
          : title == "Off"
          ? "secondary"
          : title == "Extra Day"
          ? "primary"
          : "warning";

      return vt;
    },
    attendanceStatusDisplay(title) {
      const labels = {
        P: "Present",
        A: "Absent",
        AA: "Double absent",
        L: "Leave",
        SL: "Short leave",
        H: "Holiday",
        HL: "Half leave",
        Late: "Late",
        Off: "Off",
        "Extra Day": "Extra day",
        WFH: "WFH",
      };
      return labels[title] || title;
    },
    formatAttendanceClock(value) {
      if (!value) return "";
      try {
        return new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "numeric",
        }).format(new Date(value));
      } catch (_) {
        return "";
      }
    },
    pickSummaryNumber(summary, keys) {
      if (!summary || !keys) return null;
      for (let i = 0; i < keys.length; i++) {
        const raw = summary[keys[i]];
        if (raw !== null && raw !== undefined && raw !== "") {
          const n = Number(raw);
          if (Number.isFinite(n)) return n;
        }
      }
      return null;
    },
    attendanceSummaryHolidayCount() {
      const picked = this.pickSummaryNumber(this.summaryObj, [
        "holidays",
        "holiday",
        "holidayCount",
      ]);
      if (picked != null) return picked;
      const events = this.calendarOptions.events || [];
      return events.filter((e) =>
        ["H", "HL"].includes(String(e.title || e.status))
      ).length;
    },
    attendanceSummaryOffCount() {
      const picked = this.pickSummaryNumber(this.summaryObj, [
        "off",
        "offDays",
        "offs",
        "offday",
      ]);
      if (picked != null) return picked;
      const events = this.calendarOptions.events || [];
      return events.filter(
        (e) => String(e.title || e.status) === "Off"
      ).length;
    },
    openAtt(item) {
      this.stCurrent = item;
      this.showAtt = true;
      this.attMonth = new Date().getMonth() + 1;
      this.attYear = new Date().getFullYear();
      this.loadAtt();
    },
    staffAttendanceCacheKey(staffId, month, year) {
      return `${Number(staffId) || 0}-${Number(month) || 0}-${Number(year) || 0}`;
    },
    getCachedAttendance(staffId, month, year) {
      const entry = this.staffAttendanceCache[
        this.staffAttendanceCacheKey(staffId, month, year)
      ];
      if (!entry) return null;
      if (Date.now() - entry.fetchedAt > this.staffAttendanceCacheTtlMs) {
        return null;
      }
      return entry.payload;
    },
    setCachedAttendance(staffId, month, year, payload) {
      const key = this.staffAttendanceCacheKey(staffId, month, year);
      this.$set(this.staffAttendanceCache, key, {
        fetchedAt: Date.now(),
        payload,
      });
    },
    invalidateStaffAttendanceCache(staffId) {
      const prefix = `${Number(staffId) || 0}-`;
      Object.keys(this.staffAttendanceCache).forEach((key) => {
        if (key.startsWith(prefix)) {
          this.$delete(this.staffAttendanceCache, key);
        }
      });
    },
    applyAttendanceCalendarResponse(res) {
      if (res && res.data && res.data.length > 0) {
        this.calendarOptions.events = res.data.map((el) => ({
          ...el,
          title: el.status != null ? el.status : "",
          start: el.date,
          backgroundColor: "transparent",
          borderColor: "transparent",
          textColor: "inherit",
        }));
      } else {
        this.calendarOptions.events = [];
      }
      this.summaryObj = (res && res.summary) || {};
    },
    async loadAtt() {
      const staffId = this.stCurrent && this.stCurrent.id;
      const cached = this.getCachedAttendance(
        staffId,
        this.attMonth,
        this.attYear
      );
      if (cached) {
        this.applyAttendanceCalendarResponse(cached);
        this.attLoading = false;
        this.$nextTick(() => {
          const cal = this.$refs.refCalendar;
          if (cal && cal.getApi) {
            try {
              cal.getApi().gotoDate(
                `${this.attYear}-${String(this.attMonth).padStart(2, "0")}-01`
              );
            } catch (_) {
              /* calendar ref not ready */
            }
          }
        });
        return;
      }

      this.attLoading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "Staff/LoadAttendanceCalendar?db=" +
          this.$store.state.userData.db +
          "&tID=" +
          staffId +
          "&month=" +
          this.attMonth +
          "&year=" +
          this.attYear,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      this.setCachedAttendance(staffId, this.attMonth, this.attYear, res);
      this.applyAttendanceCalendarResponse(res);

      this.attLoading = false;
      const goto = `${this.attYear}-${String(this.attMonth).padStart(2, "0")}-01`;
      setTimeout(() => {
        const cal = this.$refs.refCalendar;
        if (cal && cal.getApi) {
          try {
            cal.getApi().gotoDate(goto);
          } catch (_) {
            /* calendar ref not ready */
          }
        }
      }, 200);
    },
    change(val) {
      this.attMonth = val;
      this.loadAtt();
    },
    stripAttendanceEventShell(info) {
      const el = info && info.el;
      if (!el || !el.classList) return;
      el.style.background = "transparent";
      el.style.backgroundColor = "transparent";
      el.style.border = "none";
      el.style.boxShadow = "none";
      el.style.outline = "none";
      const main = el.querySelector(".fc-event-main");
      if (main) {
        main.style.background = "transparent";
        main.style.backgroundColor = "transparent";
        main.style.border = "none";
        main.style.boxShadow = "none";
        main.style.padding = "0";
      }
      const frame = el.querySelector(".fc-event-main-frame");
      if (frame) {
        frame.style.background = "transparent";
        frame.style.backgroundColor = "transparent";
      }
    },
    openEditAtt({ event: clickedEvent }) {
      this.openAttendanceEditorFromEvent(clickedEvent);
    },
    canEditStaffAttendance() {
      if (!this.rights || !Object.keys(this.rights).length) return true;
      return !!(this.rights.add || this.rights.edit);
    },
    getAttendanceEventStatus(ev) {
      if (!ev) return "";
      if (ev.title != null && String(ev.title).trim() !== "") {
        return String(ev.title).trim();
      }
      if (ev.status != null && String(ev.status).trim() !== "") {
        return String(ev.status).trim();
      }
      return "";
    },
    isAttendanceDayAddable(dateStr, dateValue) {
      if (!this.canEditStaffAttendance()) return false;
      if (dateValue) {
        const d =
          dateValue instanceof Date ? dateValue : new Date(dateValue);
        if (
          d.getMonth() + 1 !== Number(this.attMonth) ||
          d.getFullYear() !== Number(this.attYear)
        ) {
          return false;
        }
      }
      const events = this.calendarOptions.events || [];
      const dayEvent = events.find((ev) =>
        this.attendanceEventMatchesDate(ev, dateStr)
      );
      if (dayEvent && this.getAttendanceEventStatus(dayEvent)) {
        return false;
      }
      return true;
    },
    onAttendanceDayClick(info) {
      const dateStr = this.formatAttendanceDateKey(info.date);
      if (!this.isAttendanceDayAddable(dateStr, info.date)) {
        return;
      }
      const events = this.calendarOptions.events || [];
      const dayEvent = events.find((ev) =>
        this.attendanceEventMatchesDate(ev, dateStr)
      );
      if (dayEvent) {
        const status = this.getAttendanceEventStatus(dayEvent);
        if (status) return;
        this.currentObj = {
          ...dayEvent,
          id: parseInt(dayEvent.id, 10) || 0,
          tID: dayEvent.tID || this.getAttendanceStaffId(),
          date: dateStr,
          status: "",
          timeIn: dayEvent.timeIn || null,
          timeOut: dayEvent.timeOut || null,
          isOverRide:
            dayEvent.isOverRide != null ? dayEvent.isOverRide : true,
        };
        this.$bvModal.show("modal-att");
        return;
      }
      this.openAttendanceEditorForDate(dateStr);
    },
    formatAttendanceDateKey(dateValue) {
      const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    attendanceEventMatchesDate(event, dateStr) {
      if (!event) return false;
      const raw = event.start || event.date;
      if (!raw) return false;
      if (typeof raw === "string" && raw.length >= 10) {
        return raw.slice(0, 10) === dateStr;
      }
      return this.formatAttendanceDateKey(raw) === dateStr;
    },
    getAttendanceStaffId() {
      return this.stCurrent && this.stCurrent.id;
    },
    openAttendanceEditorFromEvent(clickedEvent) {
      const { id, extendedProps, start, title } = clickedEvent;
      const dt = this.formatAttendanceDateKey(start);
      const status =
        (title != null && title !== undefined ? title : "") ||
        (extendedProps && extendedProps.status) ||
        "";
      this.currentObj = {
        ...(extendedProps || {}),
        id: parseInt(id, 10) || 0,
        tID:
          (extendedProps && extendedProps.tID) || this.getAttendanceStaffId(),
        date: dt,
        status,
        timeIn: (extendedProps && extendedProps.timeIn) || null,
        timeOut: (extendedProps && extendedProps.timeOut) || null,
        isOverRide:
          extendedProps && extendedProps.isOverRide != null
            ? extendedProps.isOverRide
            : true,
      };
      this.$bvModal.show("modal-att");
    },
    openAttendanceEditorForDate(dateStr) {
      this.currentObj = {
        id: 0,
        tID: this.getAttendanceStaffId(),
        date: dateStr,
        status: "",
        timeIn: null,
        timeOut: null,
        isOverRide: true,
      };
      this.$bvModal.show("modal-att");
    },
    computeMetaHours(timeIn, timeOut) {
      if (!timeIn || !timeOut) return 0;
      const ms = new Date(timeOut).getTime() - new Date(timeIn).getTime();
      if (!Number.isFinite(ms) || ms <= 0) return 0;
      return Math.round((ms / 3600000) * 100) / 100;
    },
    buildAttendanceSaveBody() {
      const meta =
        this.currentObj.meta_hours != null &&
        this.currentObj.meta_hours !== ""
          ? Number(this.currentObj.meta_hours)
          : this.computeMetaHours(
              this.currentObj.timeIn,
              this.currentObj.timeOut
            );
      return {
        id: Number(this.currentObj.id) || 0,
        tID: Number(this.currentObj.tID) || Number(this.getAttendanceStaffId()),
        date: this.currentObj.date,
        status: this.currentObj.status,
        timeIn: this.currentObj.timeIn || null,
        timeOut: this.currentObj.timeOut || null,
        meta_hours: meta,
        isOverRide:
          this.currentObj.isOverRide != null
            ? this.currentObj.isOverRide
            : true,
      };
    },
    async saveAtt() {
      if (!this.currentObj.status) {
        this.$bvToast.toast("Please select a status", {
          title: "Error!",
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.savingAtt = true;
      const userID = this.getSalaryUserID();
      const body = this.buildAttendanceSaveBody();
      const recordId = Number(body.id) || 0;
      const staffId = this.getAttendanceStaffId();

      try {
        let status;
        if (recordId > 0) {
          status = await this.put({
            url:
              this.$store.state.domain +
              "staffAttendance/" +
              recordId +
              "?db=" +
              this.$store.state.userData.db +
              this.salaryUserQuery(),
            message: "Attendance updated successfully.",
            context: this,
            body: { ...body, userID },
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.post({
            url:
              this.$store.state.domain +
              "StaffAttendance/Save?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&userID=" +
              userID,
            message: "Attendance saved successfully.",
            context: this,
            body,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.invalidateStaffAttendanceCache(staffId);
          this.loadAtt();
          this.$bvModal.hide("modal-att");
        }
      } finally {
        this.savingAtt = false;
      }
    },

    getDep(id) {
      let obj = this.departments.find((el) => el.id == id);
      return obj ? obj.name : "";
    },

    async loadCOA() {
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.coAccounts = await this.get(obj);
      // console.log(this.coAccounts);
    },
    setCOA(el) {
      if (el == null || el == "") this.accountObj.accountID = 0;
    },
    openAccount() {
      this.accIcon = "PlusIcon";
      this.accountbar = true;
      this.accountObj = {
        id: 0,
        campusID: this.$store.state.userData.cId,
        account: "",
        status: "active",
        accountID: 0,
      };
      var elem = this.$refs["accname"];
      elem.state = undefined;
    },
    checkAccount() {
      var elem = this.$refs["accname"];
      if (this.accountObj.account == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveAcc() {
      if (this.checkAccount() == true) {
        this.savingacc = true;
        if (this.accountObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "CollectionAccounts?db=" +
              this.$store.state.userData.db,
            body: this.accountObj,
            message: "Account added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "CollectionAccounts/" +
              this.accountObj.id +
              "?db=" +
              this.$store.state.userData.db,

            message: "Account updated successfully.",
            context: this,
            body: this.accountObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.LoadAccounts();
          this.accountObj = {
            id: 0,
            campusID: this.$store.state.userData.cId,
            account: "",
            status: "active",
            accountID: 0,
          };
          var elem = this.$refs["accname"];
          elem.state = undefined;
        }
        this.savingacc = false;
      }
    },
    async editAcc(acc) {
      this.accountObj = { ...acc };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["accname"];
      elem.state = undefined;
      // console.log(this.accountObj);
    },
    async deleteAcc(acc) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "CollectionAccounts/" +
            acc.id +
            "?db=" +
            this.$store.state.userData.db,

          message: "Account deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadAccounts();
      }
    },
    async showAccBranch(item) {
      this.currentAccount = { ...item };
      this.modalTitle = "Account Branches - " + item.account;
      this.$bvModal.show("modal-account");
    },

    getDepName() {
      let obj = this.departments.find(
        (el) => el.id == this.currentStaff.staff.departmentID
      );
      return obj ? " - " + obj.name : " - ";
    },

    // Helper method to calculate filtered deposits (respecting rejoining date)
    calculateFilteredDeposits(filterFn) {
      const filtered = this.depositDetails.filter(filterFn);
      if (!this.currentStaff.staff || !this.currentStaff.staff.rejoining_date) {
        return filtered.reduce((sum, el) => sum + el.amount, 0);
      }

      const rejoiningDate = new Date(this.currentStaff.staff.rejoining_date);
      const rejoiningYear = rejoiningDate.getFullYear();
      const rejoiningMonth = rejoiningDate.getMonth() + 1;
      const monthMap = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        oct: 10,
        nov: 11,
        dec: 12,
      };
      const getMonthNumber = (m) =>
        monthMap[m?.toString().trim().substring(0, 3).toLowerCase()] ||
        parseInt(m) ||
        0;

      return filtered.reduce((sum, el) => {
        const depositYear = parseInt(el.year);
        const depositMonth = getMonthNumber(el.month);
        const isOnOrAfter =
          depositYear > rejoiningYear ||
          (depositYear === rejoiningYear && depositMonth >= rejoiningMonth);
        return isOnOrAfter ? sum + el.amount : sum;
      }, 0);
    },

    LoanOpen() {
      this.loanObj = {
        id: 0,
        tID: this.currentStaff.staff.id,
        amount: null,
        loanType: "advance",
        date: new Date(),
        months: null,
        monthlyInstallments: null,
        campusID: this.currentStaff.staff.campusID,
        records: [],
      };
      this.installData = [];

      this.loanMonth = new Date().getMonth() + 1;
      this.loanYear = new Date().getFullYear();

      this.visibility2 = true;
      this.newLoan = true;
      var elem = this.$refs["loan_amount"];
      elem.state = undefined;
      var elem = this.$refs["loan_month"];
      elem.state = undefined;
      var elem = this.$refs["return_amount"];
      elem.state = undefined;
    },

    checkLoanAmount() {
      var elem = this.$refs["loan_amount"];
      if (this.loanObj.amount <= 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkMonth() {
      var elem = this.$refs["loan_month"];
      if (this.loanObj.months <= 0) {
        // || this.loanObj.months > 12
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async setInstallment() {
      if (this.checkLoanAmount() == true && this.checkMonth() == true) {
        this.installLoading = true;

        this.loanObj.monthlyInstallments = parseInt(
          this.loanObj.amount / this.loanObj.months
        );

        // console.log(this.loanObj.monthlyInstallments);
        this.checkRetAmount();

        this.loanObj.amount = parseInt(this.loanObj.amount);
        this.loanObj.months = parseInt(this.loanObj.months);
        this.loanObj.monthlyInstallments = parseInt(
          this.loanObj.monthlyInstallments
        );

        this.loanObj.date = new Date(
          `${this.loanYear}-${this.loanMonth}-05`
        ).toJSON();
        // console.log(this.loanObj);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/Installments?db=" +
            this.$store.state.userData.db +
            "&sameMonth=" +
            this.sameMonth +
            this.salaryUserQuery(),
          body: { ...this.loanObj, userID: this.getSalaryUserID() },
          subjects: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        // console.log(status);
        if (status) {
          this.installData = status;
          this.loanObj.records = status;
        }

        this.installLoading = false;
      }
    },
    async setbyRetAmount() {
      if (this.checkLoanAmount() == true && this.checkRetAmount() == true) {
        this.installLoading = true;

        this.loanObj.amount = parseInt(this.loanObj.amount);
        // this.loanObj.months = parseInt(this.loanObj.months);

        this.loanObj.months = Math.ceil(
          this.loanObj.amount / this.loanObj.monthlyInstallments
        );

        // console.log(this.loanObj.months);
        this.checkMonth();

        this.loanObj.monthlyInstallments = parseInt(
          this.loanObj.monthlyInstallments
        );

        this.loanObj.date = new Date(
          `${this.loanYear}-${this.loanMonth}-05`
        ).toJSON();
        // console.log(this.loanObj);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/Installments?db=" +
            this.$store.state.userData.db +
            "&sameMonth=" +
            this.sameMonth +
            this.salaryUserQuery(),
          body: { ...this.loanObj, userID: this.getSalaryUserID() },
          subjects: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        // console.log(status);
        if (status) {
          this.installData = status;
          this.loanObj.records = status;
        }

        this.installLoading = false;
      }
    },
    checkRetAmount() {
      var elem = this.$refs["return_amount"];
      if (
        this.loanObj.monthlyInstallments <= 0 ||
        parseInt(this.loanObj.monthlyInstallments) >
          parseInt(this.loanObj.amount)
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async AddLoan() {
      let maxWait = 50;
      while (this.installLoading && maxWait > 0) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        maxWait--;
      }

      // this.checkLoanDate() == true &&
      if (
        this.checkLoanAmount() == true &&
        this.checkMonth() == true &&
        this.checkRetAmount() == true
      ) {
        this.loanSaving = true;

        this.loanObj.amount = parseInt(this.loanObj.amount);
        this.loanObj.months = parseInt(this.loanObj.months);
        this.loanObj.monthlyInstallments = parseInt(
          this.loanObj.monthlyInstallments
        );

        this.loanData.push(this.loanObj);
        let newLoadDet = this.loanData.reduce((acc, el) => {
          if (el.records) {
            acc = [...acc, ...el.records];
          }
          return acc;
        }, []);
        // console.log(newLoadDet);

        let saveObj = {
          staff: this.currentStaff.staff,
          timings: this.currentStaff.timings,
          incrementHistory: this.currentStaff.incrementHistory,
          staffAllowances: this.currentStaff.staffAllowances,
          staffDeductions: this.currentStaff.staffDeductions,
          advanceAndLoans: this.loanData,
          policy: this.currentStaff.policy,
          loanDetails: [...this.loanDetails, ...newLoadDet],
          securityDeposit: this.currentStaff.securityDeposit,
          securityDepositGrid: this.currentStaff.securityDepositGrid,
        };

        var status = await this.postObj({
          url:
            this.$store.state.domain +
            "staff/SaveWithPolicy?db=" +
            this.$store.state.userData.db,
          body: saveObj,
          message: this.loanObj.loanType + " saved successfully",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.loanSaving = false;
        this.visibility2 = false;

        if (status) {
          this.markStaffListStale();
          await this.showOthers(this.currentStaff.staff.id, "Advance / Loan", {
            forceRefresh: true,
          });
        }
      }
    },
    EditLoan(item, ind) {
      // console.log(item);
      this.loanObj = { ...item };
      let date = new Date(this.loanObj.date);
      this.loanMonth = date.getMonth() + 1;
      this.loanYear = date.getFullYear();
      if (item.id == 0) this.installData = item.records;
      else
        this.installData = this.loanDetails.filter(
          (el) => el.advanceAndLoanID == item.id
        );
      this.loanIndex = ind;
      this.newLoan = false;
      this.visibility2 = true;

      var elem = this.$refs["loan_amount"];
      elem.state = undefined;
      var elem = this.$refs["loan_date"];
      elem.state = undefined;
      var elem = this.$refs["loan_month"];
      elem.state = undefined;
      var elem = this.$refs["return_amount"];
      elem.state = undefined;
    },

    async DeleteLoan(item, ind) {
      if (item.id == 0) {
        this.loanData.splice(ind, 1);
        // console.log(this.loanData);
      } else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You won't be able to revert this!"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });

        if (result.isConfirmed) {
          var status = await this.delete({
            url:
              this.$store.state.domain +
              "StaffAdvaceAndLoans/" +
              item.id +
              "?db=" +
              this.$store.state.userData.db +
              this.salaryUserQuery(),
            message: item.loanType + " removed successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          if (status) {
            this.loanData.splice(ind, 1);
            this.markStaffListStale();
            await this.reloadCurrentStaffDetail();
          }
          // console.log(this.loanData);
        }
      }
    },

    depoOpen() {
      this.depoObj = {
        id: 0,
        tID: this.currentStaff.staff.id,
        amount: this.currentStaff.staff.totalSalary,
        loanType: "security deposit",
        date: new Date(),
        months: 12,
        monthlyInstallments: null,
        campusID: this.currentStaff.staff.campusID,
      };
      this.depoObj.monthlyInstallments = parseInt(
        this.depoObj.amount / this.depoObj.months
      );

      this.deductMonth = new Date().getMonth() + 1;
      this.deductYear = new Date().getFullYear();

      this.skipped = [];

      if (this.reportDomain == "myskoolhpgs") {
        this.skipped = [6, 7]; // skip june july
        this.depoObj.months = 10;
        this.depoObj.monthlyInstallments = parseInt(
          this.depoObj.amount / this.depoObj.months
        );

        // After 25, deposit month after 2 months else next month
        if (this.currentStaff.staff.appointedOn) {
          let appointedDate = new Date(this.currentStaff.staff.appointedOn);

          let day = appointedDate.getDate();
          appointedDate.setDate(20); // to avoid feb conflict
          appointedDate.setMonth(appointedDate.getMonth() + 1);

          let nextDate = new Date(appointedDate);
          if (day > 25) {
            nextDate = new Date(nextDate.setMonth(nextDate.getMonth() + 1));
          }
          // console.log(nextDate);
          this.deductMonth = nextDate.getMonth() + 1;
          this.deductYear = nextDate.getFullYear();
        }
      }

      this.visibility5 = true;
      this.newDepo = true;
      var elem = this.$refs["depo_amount"];
      elem.state = undefined;
      var elem = this.$refs["depo_month"];
      elem.state = undefined;
      var elem = this.$refs["depo_return"];
      elem.state = undefined;
    },
    checkDAmount() {
      var elem = this.$refs["depo_amount"];
      if (this.depoObj.amount <= 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkDMonth() {
      var elem = this.$refs["depo_month"];
      if (this.depoObj.months <= 0) {
        // || this.depoObj.months > 12
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkDRetAmount() {
      var elem = this.$refs["depo_return"];
      if (
        this.depoObj.monthlyInstallments <= 0 ||
        parseInt(this.depoObj.monthlyInstallments) >
          parseInt(this.depoObj.amount)
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    setDInstallment() {
      if (this.checkDAmount() == true && this.checkDMonth() == true) {
        this.depoObj.monthlyInstallments = parseInt(
          this.depoObj.amount / this.depoObj.months
        );

        // console.log(this.depoObj.monthlyInstallments);
      }
    },
    setbyDReturn() {
      if (this.checkDAmount() == true && this.checkDRetAmount() == true) {
        this.depoObj.amount = parseInt(this.depoObj.amount);
        this.depoObj.monthlyInstallments = parseInt(
          this.depoObj.monthlyInstallments
        );

        this.depoObj.months = Math.ceil(
          this.depoObj.amount / this.depoObj.monthlyInstallments
        );
      }
    },
    setSkip(val) {
      if (this.skipped.includes(val)) {
        this.skipped = this.skipped.filter((el) => el != val);
      } else this.skipped.push(val);
      // console.log(this.skipped);
    },
    async AddDeposit() {
      if (
        this.checkDAmount() == true &&
        this.checkDMonth() == true &&
        this.checkDRetAmount() == true
      ) {
        this.savingDepo = true;

        this.depoObj.amount = parseInt(this.depoObj.amount);
        this.depoObj.months = parseInt(this.depoObj.months);
        this.depoObj.monthlyInstallments = parseInt(
          this.depoObj.monthlyInstallments
        );

        this.depoObj.date = new Date(
          `${this.deductYear}-${this.deductMonth}-05`
        ).toJSON();

        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/InstallmentsDep?db=" +
            this.$store.state.userData.db +
            "&sameMonth=true&skip=" +
            this.skipped +
            this.salaryUserQuery(),
          body: { ...this.depoObj, userID: this.getSalaryUserID() },
          subjects: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        // console.log(status);
        if (status) {
          this.depoSaveList.push(this.depoObj);

          let saveObj = {
            staff: this.currentStaff.staff,
            timings: this.currentStaff.timings,
            incrementHistory: this.currentStaff.incrementHistory,
            staffAllowances: this.currentStaff.staffAllowances,
            staffDeductions: this.currentStaff.staffDeductions,
            advanceAndLoans: this.currentStaff.advanceAndLoans,
            policy: this.currentStaff.policy,
            loanDetails: this.currentStaff.loanDetails,
            securityDeposit: this.depoSaveList,
            securityDepositGrid: [...this.depositDetails, ...status],
          };

          var saveStatus = await this.postObj({
            url:
              this.$store.state.domain +
              "staff/SaveWithPolicy?db=" +
              this.$store.state.userData.db,
            body: saveObj,
            message: "Deposits saved successfully",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.savingDepo = false;
          this.visibility5 = false;

          if (saveStatus) {
            this.markStaffListStale();
            await this.showOthers(
              this.currentStaff.staff.id,
              "Security Deposit",
              { forceRefresh: true }
            );
          }
        } else this.savingDepo = false;
      }
    },
    openAmountEdit(item, index) {
      this.editAmountObj = { ...item };
      this.depositIndex = index;
      this.$bvModal.show("deposit-amount-edit-modal");
    },
    async saveEditAmount() {
      // Validate amount
      let x = this.editAmountObj.amount;
      if (isNaN(x) || x <= 0) {
        this.$refs.edit_amount.state = false;
        return;
      }

      if (this.editAmountObj.id == 0) {
        this.editAmountObj.amount = parseInt(this.editAmountObj.amount);
        this.depositDetails[this.depositIndex].amount =
          this.editAmountObj.amount;
        this.$bvModal.hide("deposit-amount-edit-modal");

        this.$bvToast.toast("Amount updated successfully!", {
          title: this.$t("Success"),
          variant: "success",
          solid: true,
        });
        return;
      }

      // Show confirmation dialog before proceeding
      const result = await Swal.fire({
        title: "Confirm",
        text: "Are you sure you want to update this amount?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#7367F0",
        cancelButtonColor: "#EA5455",
        confirmButtonText: "Yes, update",
        cancelButtonText: this.$t("Cancel"),
      });

      // If user cancels, exit the function
      if (!result.isConfirmed) {
        return;
      }

      this.isUpdatingAmount = true;
      this.editAmountObj.amount = parseInt(this.editAmountObj.amount);

      try {
        const status = await this.put({
          url:
            this.$store.state.domain +
            "StaffAdvaceAndLoansInstallmentPlan/" +
            this.editAmountObj.id +
            "?db=" +
            this.$store.state.userData.db +
            this.salaryUserQuery(),
          body: {
            ...this.editAmountObj,
            userID: this.getSalaryUserID(),
          },
          message: "Amount updated successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.$bvModal.hide("deposit-amount-edit-modal");

          this.$set(
            this.depositDetails[this.depositIndex],
            "amount",
            this.editAmountObj.amount
          );
          this.markStaffListStale();
          this.syncStaffSelectedCacheFromCurrent();
        }
      } catch (error) {
        // console.error("Error updating amount:", error);
      } finally {
        this.isUpdatingAmount = false;
      }
    },
    async markReturned(item) {
      if (item.id == 0) {
        this.$set(item, "isReturned", true);
        this.syncStaffSelectedCacheFromCurrent();
        return;
      }

      var status = await this.put({
        url:
          this.$store.state.domain +
          "StaffAdvaceAndLoansInstallmentPlan/" +
          item.id +
          "?db=" +
          this.$store.state.userData.db +
          this.salaryUserQuery(),
        token: this.$store.state.userData.token,
        message: "Marked as Returned",
        context: this,
        body: { ...item, userID: this.getSalaryUserID() },
      });
      if (status) {
        this.$set(item, "isReturned", true);
        this.markStaffListStale();
        this.syncStaffSelectedCacheFromCurrent();
      }
    },
    async markDeposit(item) {
      if (item.id == 0) {
        this.$set(item, "salaryID", 0);
        this.syncStaffSelectedCacheFromCurrent();
        return;
      }

      var status = await this.put({
        url:
          this.$store.state.domain +
          "StaffAdvaceAndLoansInstallmentPlan/" +
          item.id +
          "?db=" +
          this.$store.state.userData.db +
          this.salaryUserQuery(),
        token: this.$store.state.userData.token,
        message: "Marked as Deposited",
        context: this,
        body: { ...item, userID: this.getSalaryUserID() },
      });
      if (status) {
        this.$set(item, "salaryID", 0);
        this.markStaffListStale();
        this.syncStaffSelectedCacheFromCurrent();
      }
    },
    async markUnDeposit(item) {
      if (item.id == 0) {
        this.$set(item, "salaryID", null);
        this.$set(item, "isReturned", null);
        this.syncStaffSelectedCacheFromCurrent();
      } else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "Do you want to undeposit this amount?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes!",
        });

        if (result.isConfirmed) {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "StaffAdvaceAndLoansInstallmentPlan/" +
              item.id +
              "?db=" +
              this.$store.state.userData.db +
              this.salaryUserQuery(),
            token: this.$store.state.userData.token,
            message: "Marked as Undeposit",
            context: this,
            body: {
              ...item,
              salaryID: null,
              isReturned: null,
              userID: this.getSalaryUserID(),
            },
          });
          if (status) {
            this.$set(item, "salaryID", null);
            this.$set(item, "isReturned", null);
            this.markStaffListStale();
            this.syncStaffSelectedCacheFromCurrent();
          }
        }
      }
    },
    async markUnReturned(item) {
      if (item.id == 0) {
        this.$set(item, "isReturned", null);
        this.syncStaffSelectedCacheFromCurrent();
      } else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "Do you want to unreturn this deposit?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes!",
        });

        if (result.isConfirmed) {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "StaffAdvaceAndLoansInstallmentPlan/" +
              item.id +
              "?db=" +
              this.$store.state.userData.db +
              this.salaryUserQuery(),
            token: this.$store.state.userData.token,
            message: "Marked as unreturned",
            context: this,
            body: {
              ...item,
              isReturned: null,
              userID: this.getSalaryUserID(),
            },
          });
          if (status) {
            this.$set(item, "isReturned", null);
            this.markStaffListStale();
            this.syncStaffSelectedCacheFromCurrent();
          }
        }
      }
    },
    async DeleteDepo(id, ind) {
      if (id == 0) {
        this.depositDetails.splice(ind, 1);
        this.syncStaffSelectedCacheFromCurrent();
        // console.log(this.depositDetails);
      } else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You won't be able to revert this!"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });

        if (result.isConfirmed) {
          var status = await this.delete({
            url:
              this.$store.state.domain +
              "StaffAdvaceAndLoansInstallmentPlan/" +
              id +
              "?db=" +
              this.$store.state.userData.db +
              this.salaryUserQuery(),
            message: "Deposit removed successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          if (status) {
            this.depositDetails.splice(ind, 1);
            this.markStaffListStale();
            this.syncStaffSelectedCacheFromCurrent();
          }
          // console.log(this.depositDetails);
        }
      }
    },
    async depoDelAll() {
      if (this.depositDetails.length > 0) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "This will delete all Undeposited amount!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });

        if (result.isConfirmed) {
          this.delAll = true;

          var status = await this.post({
            url:
              this.$store.state.domain +
              "Staff/ClearDeposits?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.currentStaff.staff.campusID +
              "&tID=" +
              this.currentStaff.staff.id +
              this.salaryUserQuery(),
            message: "Deposits removed successfully.",
            context: this,
            savingMarks: true,
            token: this.$store.state.userData.token,
          });
          this.delAll = false;

          this.depositDetails = status;
          this.markStaffListStale();
          this.syncStaffSelectedCacheFromCurrent();
        }
      }
    },

    setAbsent() {
      if (this.shouldHandleIussUpdates()) {
        this.updateWorkingDaysFromParts();
        this.updateDeductionDays();
        return;
      }
      let dCount = parseInt(this.mSalary.salary.workingDays) || 0;
      let pCount = parseInt(this.mSalary.salary.present) || 0;

      if (this.holidaySalaryObj && this.holidaySalaryObj.valueBool) {
        let off = this.toNumber(this.extraDays.offdays);
        let holiday = this.toNumber(this.extraDays.holidays);
        let leaveTotal = this.getSalaryLeaveDaysTotal();
        this.mSalary.salary.absent = Math.max(
          0,
          dCount - (pCount + off + holiday + leaveTotal)
        );
        this.mSalary.salary.leave = 0;
      } else {
        this.mSalary.salary.absent = Math.max(0, dCount - pCount);
        this.mSalary.salary.leave = 0;
      }
    },
    setPresent() {
      if (this.checkWDays() == true && this.checkPresent() == true) {
        let dCount = parseInt(this.mSalary.salary.workingDays) || 0;
        let pCount = parseInt(this.mSalary.salary.present) || 0;

        if (this.holidaySalaryObj && this.holidaySalaryObj.valueBool) {
          let off = this.toNumber(this.extraDays.offdays);
          let holiday = this.toNumber(this.extraDays.holidays);
          let leaveTotal = this.getSalaryLeaveDaysTotal();
          this.mSalary.salary.absent = Math.max(
            0,
            dCount - (pCount + off + holiday + leaveTotal)
          );
        } else {
          if (pCount <= dCount) {
            this.mSalary.salary.absent = dCount - pCount;
          }
        }
      }
    },
    setP() {
      if (this.shouldHandleIussUpdates()) {
        this.updateWorkingDaysFromParts();
        this.updateDeductionDays();
        return;
      }
      let dCount = parseInt(this.mSalary.salary.workingDays) || 0;
      let aCount = parseInt(this.mSalary.salary.absent) || 0;
      let leaveTotal = this.getSalaryLeaveDaysTotal();
      let lCount = parseInt(this.mSalary.salary.leave) || 0;

      // Original logic: check if regular leave is within working days
      if (lCount <= dCount) {
        let che = dCount - aCount;
        if (this.holidaySalaryObj && this.holidaySalaryObj.valueBool) {
          let off = this.toNumber(this.extraDays.offdays);
          let holiday = this.toNumber(this.extraDays.holidays);
          // Subtract off and holiday days when calculating present base
          this.mSalary.salary.present = Math.max(
            0,
            che - leaveTotal - off - holiday
          );
        } else {
          // Subtract both regular leave and sick leave (if any) from present days
          this.mSalary.salary.present = Math.max(0, che - leaveTotal);
        }
        // console.log(this.mSalary.salary.absent);
      }
    },
    normalizeLeaveTypeCode(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },
    isCasualLeaveBalanceItem(item) {
      if (!item) return false;
      const code = this.normalizeLeaveTypeCode(item.code);
      const name = this.normalizeLeaveTypeCode(item.name);
      return code === "casual leave" || name === "casual leave";
    },
    isSickLeaveBalanceItem(item) {
      if (!item) return false;
      const code = this.normalizeLeaveTypeCode(item.code);
      const name = this.normalizeLeaveTypeCode(item.name);
      return code === "sick leave" || name === "sick leave";
    },
    findSalaryLeaveBalanceEntry(kind) {
      const list = this.salaryLeaveBalancesList;
      if (!list.length) return null;
      if (kind === "casual") {
        return list.find((item) => this.isCasualLeaveBalanceItem(item)) || null;
      }
      if (kind === "sick") {
        return list.find((item) => this.isSickLeaveBalanceItem(item)) || null;
      }
      return null;
    },
    leaveBalanceDisplayName(item) {
      if (!item) return "";
      return item.name || item.code || "Leave";
    },
    formatLeaveBalanceCount(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    },
    leaveBalanceTooltipHtml(item) {
      const allowed = this.formatLeaveBalanceCount(item && item.allowed);
      const name = this.leaveBalanceDisplayName(item);
      return (
        `<b>${name}</b><hr style='margin: 0.15rem 0'/><p class='text-left m-0'>` +
        allowed +
        " Allowed</p>"
      );
    },
    ensureSalaryLeaveBalancesArray() {
      if (!this.mSalary) return;
      if (!Array.isArray(this.mSalary.leaveBalances)) {
        this.$set(this.mSalary, "leaveBalances", []);
      }
    },
    afterSalaryDataLoaded() {
      this.ensureSalaryLeaveBalancesArray();
      if (!this.isDynamicLeaveBalance) return;
      this.applyDynamicLeaveDaysFromApi();
    },
    hasDynamicLeavePeriodFields() {
      if (!this.mSalary) return false;
      return (
        Object.prototype.hasOwnProperty.call(
          this.mSalary,
          "casualLeaveDaysInPeriod"
        ) ||
        Object.prototype.hasOwnProperty.call(
          this.mSalary,
          "sickLeaveDaysInPeriod"
        ) ||
        Array.isArray(this.mSalary.otherLeaveDaysInPeriod)
      );
    },
    hasSalaryLeaveBalanceDetails() {
      return this.salaryLeaveBalancesList.some(
        (item) =>
          item &&
          item.isActive !== false &&
          (item.leaveTypeID || item.code || item.name)
      );
    },
    ensureOtherLeaveDaysInPeriodArray() {
      if (!this.mSalary) return;
      if (!Array.isArray(this.mSalary.otherLeaveDaysInPeriod)) {
        this.$set(this.mSalary, "otherLeaveDaysInPeriod", []);
      }
    },
    findOtherLeavePeriodRow(leaveBal) {
      this.ensureOtherLeaveDaysInPeriodArray();
      const list = this.mSalary.otherLeaveDaysInPeriod;
      if (!leaveBal || !list.length) return null;
      const typeId = Number(leaveBal.leaveTypeID ?? 0);
      if (typeId > 0) {
        const byId = list.find(
          (row) => Number(row.leaveTypeID ?? row.leaveTypeId ?? 0) === typeId
        );
        if (byId) return byId;
      }
      const code = this.normalizeLeaveTypeCode(
        leaveBal.code ?? leaveBal.name
      );
      if (!code) return null;
      return (
        list.find((row) => {
          const rowCode = this.normalizeLeaveTypeCode(
            row.code ?? row.leaveType ?? row.name
          );
          return rowCode === code;
        }) || null
      );
    },
    otherLeavePeriodDayCount(leaveBal) {
      const row = this.findOtherLeavePeriodRow(leaveBal);
      if (row) return this.otherLeaveDaysInPeriodCount(row);
      return 0;
    },
    upsertOtherLeavePeriodRow(leaveBal, days) {
      if (!leaveBal) return;
      this.ensureOtherLeaveDaysInPeriodArray();
      const list = this.mSalary.otherLeaveDaysInPeriod;
      const dayCount = this.toNumber(days);
      let row = this.findOtherLeavePeriodRow(leaveBal);
      if (row) {
        this.$set(row, "days", dayCount);
        return;
      }
      row = {
        leaveTypeID: leaveBal.leaveTypeID,
        code: leaveBal.code,
        name: leaveBal.name,
        days: dayCount,
      };
      list.push(row);
    },
    onOtherLeavePeriodInput(leaveBal, value) {
      this.upsertOtherLeavePeriodRow(leaveBal, value);
      this.onOtherLeaveBalanceInput();
    },
    otherLeaveDaysInPeriodCount(row) {
      if (!row) return 0;
      return this.toNumber(
        row.days ??
          row.dayCount ??
          row.count ??
          row.totalDays
      );
    },
    findLeaveBalanceEntryForPeriodRow(row) {
      const list = this.salaryLeaveBalancesList;
      if (!row || !list.length) return null;
      const typeId = Number(row.leaveTypeID ?? row.leaveTypeId ?? 0);
      if (typeId > 0) {
        const byId = list.find((item) => Number(item.leaveTypeID) === typeId);
        if (byId) return byId;
      }
      const code = this.normalizeLeaveTypeCode(
        row.code ?? row.leaveType ?? row.name
      );
      if (!code) return null;
      return (
        list.find((item) => {
          const itemCode = this.normalizeLeaveTypeCode(item.code);
          const itemName = this.normalizeLeaveTypeCode(item.name);
          return itemCode === code || itemName === code;
        }) || null
      );
    },
    applyOtherLeaveDaysInPeriod(list) {
      const entries = Array.isArray(list) ? list : [];
      if (!entries.length) return;
      this.ensureOtherLeaveDaysInPeriodArray();
      const merged = [...this.mSalary.otherLeaveDaysInPeriod];
      entries.forEach((row) => {
        const balance = this.findLeaveBalanceEntryForPeriodRow(row);
        if (
          balance &&
          (this.isCasualLeaveBalanceItem(balance) ||
            this.isSickLeaveBalanceItem(balance))
        ) {
          return;
        }
        const days = this.otherLeaveDaysInPeriodCount(row);
        const typeId = Number(row.leaveTypeID ?? row.leaveTypeId ?? 0);
        const code = row.code ?? row.leaveType ?? row.name;
        const existingIdx = merged.findIndex((item) => {
          const itemTypeId = Number(item.leaveTypeID ?? item.leaveTypeId ?? 0);
          if (typeId > 0 && itemTypeId === typeId) return true;
          const itemCode = this.normalizeLeaveTypeCode(
            item.code ?? item.leaveType ?? item.name
          );
          const rowCode = this.normalizeLeaveTypeCode(code);
          return rowCode && itemCode === rowCode;
        });
        const next = {
          leaveTypeID: row.leaveTypeID ?? row.leaveTypeId,
          code: row.code ?? row.leaveType,
          name: row.name,
          days,
        };
        if (existingIdx >= 0) {
          merged.splice(existingIdx, 1, { ...merged[existingIdx], ...next });
        } else {
          merged.push(next);
        }
      });
      this.$set(this.mSalary, "otherLeaveDaysInPeriod", merged);
    },
    buildOtherLeaveDaysInPeriodFromForm() {
      return this.salaryOtherLeaveBalances.map((item) => ({
        leaveTypeID: item.leaveTypeID,
        code: item.code,
        name: item.name,
        days: this.otherLeavePeriodDayCount(item),
      }));
    },
    applyDynamicLeavePeriodFieldsToPayload(source) {
      if (!source || !source.salary) return;
      const casualDays = this.toNumber(source.salary.leave);
      const sickPeriodDays = this.toNumber(source.salary.sickLeaves);
      source.casualLeaveDaysInPeriod = casualDays;
      source.sickLeaveDaysInPeriod = sickPeriodDays;
      source.otherLeaveDaysInPeriod =
        this.buildOtherLeaveDaysInPeriodFromForm();
      if (Object.prototype.hasOwnProperty.call(source, "exemptLeaveDaysInPeriod")) {
        source.exemptLeaveDaysInPeriod = this.toNumber(
          source.exemptLeaveDaysInPeriod
        );
      }
      // IUSS: sick pool comes from DB SL + sickLeaveDaysInPeriod — do not also send salary.sickLeaves.
      if (this.isIussDomain) {
        delete source.salary.sickLeaves;
        delete source.salary.sickLeaves_utilized;
      }
    },
    correctLegacySalaryLeaveFromAbsentDeduction() {
      if (!this.mSalary || !this.mSalary.salary) return;
      const salary = this.mSalary.salary;
      const leave = this.toNumber(salary.leave);
      const absentDed = this.toNumber(salary.absentDeductionCount);
      const leaveUtil = this.toNumber(salary.leave_utilized);
      if (
        leave > 0 &&
        absentDed > 0 &&
        leave === absentDed &&
        leave !== leaveUtil
      ) {
        this.$set(salary, "leave", Math.max(0, leaveUtil));
      }
    },
    applyDynamicLeaveDaysFromApi() {
      if (!this.mSalary || !this.mSalary.salary) return;
      const salary = this.mSalary.salary;

      if (this.hasDynamicLeavePeriodFields()) {
        const casualDays = this.toNumber(this.mSalary.casualLeaveDaysInPeriod);
        const sickDays = this.toNumber(this.mSalary.sickLeaveDaysInPeriod);
        this.$set(salary, "leave", casualDays);
        this.$set(salary, "leave_utilized", casualDays);
        this.$set(salary, "sickLeaves", sickDays);
        this.$set(salary, "sickLeaves_utilized", sickDays);

        this.applyOtherLeaveDaysInPeriod(this.mSalary.otherLeaveDaysInPeriod);
        return;
      }

      if (this.hasSalaryLeaveBalanceDetails()) {
        this.correctLegacySalaryLeaveFromAbsentDeduction();
        if (Array.isArray(this.mSalary.otherLeaveDaysInPeriod)) {
          this.applyOtherLeaveDaysInPeriod(this.mSalary.otherLeaveDaysInPeriod);
        }
        return;
      }

      this.correctLegacySalaryLeaveFromAbsentDeduction();
      if (!this.isDynamicLeaveBalance) {
        this.syncSalaryLeaveFieldsToLeaveBalances();
      }
    },
    syncLeaveBalancesToSalaryLeaveFields() {
      if (!this.mSalary || !this.mSalary.salary) return;
      const salary = this.mSalary.salary;
      const casual = this.findSalaryLeaveBalanceEntry("casual");
      const sick = this.findSalaryLeaveBalanceEntry("sick");
      if (casual) {
        const casualUtil = this.toNumber(casual.utilized);
        this.$set(salary, "leave", casualUtil);
        this.$set(salary, "leave_utilized", casualUtil);
      } else {
        this.correctLegacySalaryLeaveFromAbsentDeduction();
        if (Object.prototype.hasOwnProperty.call(salary, "leave_utilized")) {
          this.$set(salary, "leave", this.toNumber(salary.leave_utilized));
        }
      }
      if (sick) {
        const sickUtil = this.toNumber(sick.utilized);
        this.$set(salary, "sickLeaves", sickUtil);
        this.$set(salary, "sickLeaves_utilized", sickUtil);
      } else if (
        Object.prototype.hasOwnProperty.call(salary, "sickLeaves_utilized")
      ) {
        this.$set(
          salary,
          "sickLeaves",
          this.toNumber(salary.sickLeaves_utilized)
        );
      }
    },
    syncSalaryLeaveFieldsToLeaveBalances() {
      this.ensureSalaryLeaveBalancesArray();
      const casual = this.findSalaryLeaveBalanceEntry("casual");
      const sick = this.findSalaryLeaveBalanceEntry("sick");
      const leaveDays = this.toNumber(this.mSalary.salary.leave);
      const sickDays = this.toNumber(this.mSalary.sickLeaves);
      if (casual) {
        this.$set(casual, "utilized", leaveDays);
      }
      if (sick) {
        this.$set(sick, "utilized", sickDays);
      }
    },
    getSalaryLeaveDaysTotal() {
      const leave = this.toNumber(this.mSalary.salary.leave);
      const sick = this.toNumber(this.mSalary.salary.sickLeaves);
      if (!this.isDynamicLeaveBalance) {
        return leave + sick;
      }
      const others = this.salaryOtherLeaveBalances.reduce(
        (sum, item) => sum + this.otherLeavePeriodDayCount(item),
        0
      );
      return leave + sick + others;
    },
    onPrimaryLeaveInput() {
      if (
        this.isDynamicLeaveBalance &&
        this.hasDynamicLeavePeriodFields() &&
        this.mSalary
      ) {
        this.$set(
          this.mSalary,
          "casualLeaveDaysInPeriod",
          this.toNumber(this.mSalary.salary.leave)
        );
      } else if (this.isDynamicLeaveBalance) {
        this.syncSalaryLeaveFieldsToLeaveBalances();
      }
      this.setP();
    },
    onSickLeaveInput() {
      if (
        this.isDynamicLeaveBalance &&
        this.hasDynamicLeavePeriodFields() &&
        this.mSalary
      ) {
        this.$set(
          this.mSalary,
          "sickLeaveDaysInPeriod",
          this.toNumber(this.mSalary.salary.sickLeaves)
        );
      } else if (this.isDynamicLeaveBalance) {
        this.syncSalaryLeaveFieldsToLeaveBalances();
      }
      this.setP();
    },
    onOtherLeaveBalanceInput() {
      this.setP();
    },
    saveDate() {
      this.$store.commit("setSalPaymentDate", this.currentDate);
    },
    async LoadSalary() {
      if (this.holidaySalaryObj === null) {
        await this.LoadSettings();
      }
      this.$store.commit("setMonthNo", this.sal.month);
      this.$store.commit("setSalYear", this.sal.year);
      // Reset basePresent when loading new salary data
      this.basePresent = null;
      if (this.sal.month && this.sal.year) {
        this.mSalary = {
          allowances: [],
          deductions: [],
          advanceIDs: [],
          loanIDs: [],
          sdIDs: [],
          isUpdate: false,
          mode: "new",
          salary: {
            absent: 0,
            absentDeductionCount: 0,
            shortLeaveDeductionCount: 0,
            lateDeductionCount: 0,
            accountID: 0,
            basicSalary: 0,
            campusID: 0,
            date: this.$store.state.salPaymentDate,
            grossSalary: 0,
            id: 0,
            late: 0,
            leave: 0,
            month: 0,
            monthYear: "",
            netSalary: 0,
            note: null,
            present: 0,
            shortLeave: 0,
            tID: 0,
            totalAllownaces: 0,
            totalDedcutions: 0,
            workingDays: 0,
            year: 0,
            utilizeableLeaves: 0,
            remainingLeaves: 0,
            bonusDaysAmount: 0,
            bonusDays: 0,
            leavesEncashed: 0,
            leavesEncashementAmount: 0,
            securityDeposit: 0,
            loanDeduction: 0,
            advanceDeduction: 0,
            shortLeaveDeductionCount: 0,
            lateDeductionCount: 0,
            departmentID: this.sunmonDepID,
            grossPayable: 0,
            earlyDeparture: 0,
            branchID: 0,
            sickLeave: 0,
            paid: null,
          },
          maxLeavePerMonth: 0,
          remainingLeaves: 0,
          utilizeableLeaves: 0,
          maxSickLeavesPerMonth: 0,
          remainingSickLeaves: 0,
          utilizeableSickLeaves: 0,
          leaveBalances: [],
        };

        const campID = this.currentCampusID || this.$store.state.userData.cId;

        // Build URL with dtFrom and dtTo for salary date-range domains
        let url = `${this.$store.state.domain}Salary/LoadData?db=${this.$store.state.userData.db}&cID=${campID}&tID=${this.tID}&month=${this.sal.month}&year=${this.sal.year}&skipUtilizeableLeaves=${this.skipUtilizeableLeaves}`;

        if (this.usesSalaryDateRange && this.salaryRange) {
          const parts = this.salaryRange.split(" to ");
          const dtFrom = parts[0] || "";
          const dtTo = parts[1] || "";
          if (dtFrom && dtTo) {
            url += `&dtFrom=${dtFrom}&dtTo=${dtTo}`;
          }
        }

        // console.log("Final API URL:", url);

        var obj = {
          url: url,
          token: this.$store.state.userData.token,
        };
        let res = await this.get(obj);

        if (!Array.isArray(res)) {
          this.mSalary = res;
          this.afterSalaryDataLoaded();
          if (
            this.showSalaryPaymentDate &&
            this.mSalary.salary &&
            !Object.prototype.hasOwnProperty.call(
              this.mSalary.salary,
              "salaryPaymentDate"
            )
          ) {
            this.$set(this.mSalary.salary, "salaryPaymentDate", null);
          }
          if (this.isKentSchoolDomain && this.mSalary.salary) {
            this.$set(
              this.mSalary.salary,
              "paid",
              this.normalizePaidValue(this.mSalary.salary.paid)
            );
          }
          if (this.mSalary.salary.departmentID == 0)
            this.mSalary.salary.departmentID = this.sunmonDepID;

          // Auto-select salary from based on payMode for new salaries
          // Only auto-select if salary is new (id === 0) and payMode exists
          if (this.mSalary.salary.id === 0 && res.payMode) {
            // Ensure accTypes is loaded, if not, load it first
            if (!this.accTypes || this.accTypes.length === 0) {
              await this.LoadAccounts();
            }

            if (this.accTypes && this.accTypes.length > 0) {
              const payMode = (res.payMode || "").trim();
              let selectedAccount = null;

              if (!payMode) {
                // If payMode is null/empty, don't select anything
                selectedAccount = null;
              } else {
                const payModeLower = payMode.toLowerCase();

                // Check for exact matches first
                if (payModeLower === "cash") {
                  selectedAccount = this.accTypes.find(
                    (acc) => acc.account && acc.account.toLowerCase() === "cash"
                  );
                } else if (
                  payModeLower === "cheque" ||
                  payModeLower === "check"
                ) {
                  selectedAccount = this.accTypes.find(
                    (acc) =>
                      acc.account &&
                      (acc.account.toLowerCase() === "cheque" ||
                        acc.account.toLowerCase() === "check")
                  );
                } else if (payModeLower.startsWith("bank")) {
                  // If payMode starts with "Bank", try to find exact match first
                  selectedAccount = this.accTypes.find(
                    (acc) =>
                      acc.account && acc.account.toLowerCase() === payModeLower
                  );

                  // If no exact match, find first bank account
                  if (!selectedAccount) {
                    selectedAccount = this.accTypes.find(
                      (acc) =>
                        acc.account &&
                        acc.account.toLowerCase().includes("bank")
                    );
                  }
                } else {
                  // Try to find exact match by name
                  selectedAccount = this.accTypes.find(
                    (acc) =>
                      acc.account && acc.account.toLowerCase() === payModeLower
                  );

                  // If no exact match and payMode contains "bank", select first bank
                  if (!selectedAccount && payModeLower.includes("bank")) {
                    selectedAccount = this.accTypes.find(
                      (acc) =>
                        acc.account &&
                        acc.account.toLowerCase().includes("bank")
                    );
                  }
                }
              }

              // Set the accountID if found
              if (selectedAccount) {
                this.mSalary.salary.accountID = selectedAccount.id;
              }
            }
          }

          if (this.reportDomain == "myskoolhpgs") {
            this.setBranches();
          }

          // For myskooliuss domain, adjust present to show present + late
          if (this.isIussDomain && this.mSalary && this.mSalary.salary) {
            const present = this.toNumber(this.mSalary.salary.present);
            const late = this.toNumber(this.mSalary.salary.late);
            // Store the base present value (without late) for later use when late changes
            this.basePresent = present;
            // Display present as present + late for myskooliuss domain
            // Combine present and late for display in the present field
            this.mSalary.salary.present = present + late;
            // Keep the original late value visible in the late field
            // The calculation in updateWorkingDaysFromParts will handle this correctly
            // by subtracting late from present before adding it back
          } else {
            // Reset basePresent when not in myskooliuss domain or when loading new data
            this.basePresent = null;
          }
        }

        if (this.shouldHandleExtraSalaryDayFields()) {
          this.applyIussMeta(this.extractSalaryMeta(res));
        } else {
          this.applyIussMeta();
        }
        if (this.isDynamicLeaveBalance) {
          this.$nextTick(() => this.applyDynamicLeaveDaysFromApi());
        }

        // console.log(Array.isArray(res));
        await this.loadAllowances();
        await this.loadDeductions();
        this.allowIDs = [];
        this.dedIDs = [];
        // this.mSalary.allowances;
        if (this.mSalary.allowances.length > 0) {
          this.mSalary.allowances.forEach((item) => {
            this.allowIDs.push(item.staffAllowanceID);
          });
        } else {
          this.mSalary.allowances = [
            {
              id: 0,
              amount: 0,
              campusID: campID,
              salaryID: this.mSalary.salary.id,
              tID: this.tID,
              staffAllowanceID: 0,
            },
          ];
        }

        if (this.mSalary.deductions.length > 0) {
          this.mSalary.deductions.forEach((item) => {
            this.dedIDs.push(item.staffDeductionID);
          });
        } else {
          this.mSalary.deductions = [
            {
              id: 0,
              amount: 0,
              campusID: campID,
              salaryID: this.mSalary.salary.id,
              tID: this.tID,
              staffDeductionID: 0,
            },
          ];
        }

        this.normalizeAllowanceRowDaysProp();

        // console.log(this.mSalary);
        // console.log(this.allowIDs);
      }
    },
    async CalculateSalary() {
      if (
        this.sal.month &&
        this.sal.year &&
        this.checkWDays() == true &&
        this.checkPresent() == true &&
        this.checkAbsent() == true &&
        this.checkAttLeave() == true &&
        this.checkAttLate() == true &&
        this.checkAttHalf() == true &&
        this.checkBonus() == true &&
        this.checkEncashDays() == true &&
        this.checkEarlyDep() == true
      ) {
        if (this.checkSum() == false) {
          this.$bvToast.toast(
            "The total of present,absent & leave is greater than working days",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-right",
            }
          );
          return false;
        } else if (this.CheckValues() == false) {
          this.$bvToast.toast(
            "Invalid amount entered on allowances or deductions",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-right",
            }
          );
          return false;
        } else {
          this.requestCalculate = true;

          this.mSalary.salary.workingDays = parseInt(
            this.mSalary.salary.workingDays
          );
          this.mSalary.salary.present = parseInt(this.mSalary.salary.present);
          this.mSalary.salary.absent = parseInt(this.mSalary.salary.absent);
          this.mSalary.salary.leave = parseInt(this.mSalary.salary.leave);
          this.mSalary.salary.late = parseInt(this.mSalary.salary.late);
          this.mSalary.salary.sickLeaves = parseInt(
            this.mSalary.salary.sickLeaves
          );
          this.mSalary.salary.shortLeave = parseInt(
            this.mSalary.salary.shortLeave
          );
          this.mSalary.salary.bonusDays = parseInt(
            this.mSalary.salary.bonusDays
          );
          this.mSalary.salary.leavesEncashed = parseInt(
            this.mSalary.salary.leavesEncashed
          );
          this.mSalary.salary.earlyDeparture = parseInt(
            this.mSalary.salary.earlyDeparture
          );

          let params = `&taxes=false&excludeSD=false&holdSalary=false&excludeCL=false&skipUtilizeableLeaves=${this.skipUtilizeableLeaves}`;
          if (this.reportDomain == "myskoolhpgs") {
            params = `&taxes=${this.isTaxes}&excludeSD=${this.exludeSD}&holdSalary=${this.holdSalary}&excludeCL=${this.excludeCL}&skipUtilizeableLeaves=${this.skipUtilizeableLeaves}`;
          }

          const payload = this.prepareSalaryPayload();
          let res = await this.postObj({
            url:
              this.$store.state.domain +
              "Salary/CalculateSalary?db=" +
              this.$store.state.userData.db +
              params +
              this.salaryUserQuery(),
            body: payload,
            attendance: true,
            context: this,
            token: this.$store.state.userData.token,
          });
          if (res != false) {
            const prevSalaryPaymentDate =
              this.showSalaryPaymentDate && this.mSalary?.salary
                ? this.mSalary.salary.salaryPaymentDate
                : undefined;
            const prevPaid =
              this.isKentSchoolDomain && this.mSalary?.salary
                ? this.mSalary.salary.paid
                : undefined;
            this.mSalary = res;
            this.afterSalaryDataLoaded();
            if (this.isKentSchoolDomain && this.mSalary?.salary) {
              this.$set(
                this.mSalary.salary,
                "paid",
                prevPaid !== undefined
                  ? prevPaid
                  : this.normalizePaidValue(this.mSalary.salary.paid)
              );
            }
            if (this.showSalaryPaymentDate && this.mSalary?.salary) {
              const nextSalaryPaymentDate =
                prevSalaryPaymentDate !== undefined &&
                prevSalaryPaymentDate !== null &&
                prevSalaryPaymentDate !== ""
                  ? prevSalaryPaymentDate
                  : this.mSalary.salary.salaryPaymentDate ?? null;
              this.$set(
                this.mSalary.salary,
                "salaryPaymentDate",
                nextSalaryPaymentDate
              );
            }
          }
          await this.loadAllowances();
          await this.loadDeductions();
          this.allowIDs = [];
          this.dedIDs = [];
          // this.mSalary.allowances;
          if (this.mSalary.allowances.length > 0) {
            this.mSalary.allowances.forEach((item) => {
              this.allowIDs.push(item.staffAllowanceID);
            });
          } else {
            this.mSalary.allowances = [
              {
                id: 0,
                amount: 0,
                campusID:
                  this.currentCampusID || this.$store.state.userData.cId,
                salaryID: this.mSalary.salary.id,
                tID: this.tID,
                staffAllowanceID: 0,
              },
            ];
          }

          if (this.mSalary.deductions.length > 0) {
            this.mSalary.deductions.forEach((item) => {
              this.dedIDs.push(item.staffDeductionID);
            });
          } else {
            this.mSalary.deductions = [
              {
                id: 0,
                amount: 0,
                campusID:
                  this.currentCampusID || this.$store.state.userData.cId,
                salaryID: this.mSalary.salary.id,
                tID: this.tID,
                staffDeductionID: 0,
              },
            ];
          }

          this.normalizeAllowanceRowDaysProp();

          this.requestCalculate = false;
          return true;
        }
      } else return false;
    },
    async SaveSalary(print) {
      this.request = true;
      let res = await this.CalculateSalary();
      if (res) {
        this.mSalary.salary.workingDays = parseInt(
          this.mSalary.salary.workingDays
        );
        this.mSalary.salary.present = parseInt(this.mSalary.salary.present);
        this.mSalary.salary.absent = parseInt(this.mSalary.salary.absent);
        this.mSalary.salary.leave = parseInt(this.mSalary.salary.leave);
        this.mSalary.salary.late = parseInt(this.mSalary.salary.late);
        this.mSalary.salary.sickLeaves = parseInt(
          this.mSalary.salary.sickLeaves
        );
        this.mSalary.salary.shortLeave = parseInt(
          this.mSalary.salary.shortLeave
        );
        this.mSalary.salary.bonusDays = parseInt(this.mSalary.salary.bonusDays);
        this.mSalary.salary.leavesEncashed = parseInt(
          this.mSalary.salary.leavesEncashed
        );
        this.mSalary.salary.earlyDeparture = parseInt(
          this.mSalary.salary.earlyDeparture
        );
        this.mSalary.salary.date = this.currentDate;

        // Fix contributions: Use contribution deduction ID instead of deduction ID
        if (
          this.mSalary.contributions &&
          this.mSalary.contributions.length > 0 &&
          this.deductions
        ) {
          this.mSalary.contributions.forEach((contribution) => {
            // Find the contribution deduction directly by title
            let contributionDeduction = null;

            if (
              contribution.contributionPFAmount != null &&
              contribution.contributionPFAmount !== undefined
            ) {
              // Find "PF Contribution" deduction (ID 18)
              contributionDeduction = this.deductions.find(
                (d) => d.title && d.title.toLowerCase() === "pf contribution"
              );
            } else if (
              contribution.contributionEOBIAmount != null &&
              contribution.contributionEOBIAmount !== undefined
            ) {
              // Find "EOBI Contribution" deduction (ID 19)
              contributionDeduction = this.deductions.find(
                (d) => d.title && d.title.toLowerCase() === "eobi contribution"
              );
            }

            if (contributionDeduction) {
              // Use the contribution deduction ID (e.g., 18 for PF Contribution, 19 for EOBI Contribution)
              contribution.staffDeductionID = contributionDeduction.id;
            }
          });
        }

        let params = `&taxes=false&excludeSD=false&holdSalary=false&excludeCL=false&skipUtilizeableLeaves=${this.skipUtilizeableLeaves}`;
        if (this.reportDomain == "myskoolhpgs") {
          params = `&taxes=${this.isTaxes}&excludeSD=${this.exludeSD}&holdSalary=${this.holdSalary}&excludeCL=${this.excludeCL}&skipUtilizeableLeaves=${this.skipUtilizeableLeaves}`;
        }

        const payload = this.prepareSalaryPayload();
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Salary/Save?db=" +
            this.$store.state.userData.db +
            params +
            this.salaryUserQuery(),
          body: payload,
          context: this,
          savingMarks: true,
          message: "Salary created!",
          token: this.$store.state.userData.token,
        });
        // console.log(status);
        if (status && print) {
          const campID = this.currentCampusID || this.$store.state.userData.cId;
          let url = `https://${this.reportDomain}.myskool.app/Account/SalarySlip?dbb=${this.$store.state.userData.db}&cID=${campID}&salaryID=${status.salary.id}`;
          window.open(url, "_blank");
          // window.open("https://cdn.cloudious.net/salarySlip.jpeg", "_blank");
        }
        this.request = false;
        if (status) this.visibility = false;
      }
      this.request = false;
    },
    onDepartmentFilterChange() {
      if (this.isHistory) this.onHistoryDepartmentChange();
      else if (this.isEncashmentHistory) this.loadEncashmentHistory();
      else this.LoadData();
    },
    async openEncashmentReportModal() {
      if (!this.showLeaveEncashmentTab) return;
      if (!this.sessions || !this.sessions.length) {
        await this.LoadSessions();
      }
      const defaultSession = Number(this.leavesSessionObj?.valueNumber);
      this.encashmentReportSessionID =
        !Number.isNaN(defaultSession) && defaultSession > 0
          ? defaultSession
          : null;
      this.encashmentReportDepID = this.currentDep || 0;
      this.encashmentReportType = "cash";
      this.encashmentReportBankNo = "";
      this.$bvModal.show("modal-encashment-report");
    },
    validateEncashmentReportForm() {
      if (!this.encashmentReportSessionID) {
        this.$bvToast.toast("Please select a session first.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return false;
      }
      if (
        this.encashmentReportType === "bank" &&
        !String(this.encashmentReportBankNo || "").trim()
      ) {
        this.$bvToast.toast("Please enter bank number.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return false;
      }
      return true;
    },
    async fetchEncashmentSummaryReportData() {
      if (!this.validateEncashmentReportForm()) return null;

      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(this.$store.state.userData.cId),
          sessionID: String(this.encashmentReportSessionID),
        });

        const res = await this.get({
          url:
            this.$store.state.domain +
            "StaffLeaveEncashment/ReportSummary?" +
            params.toString(),
          token: this.$store.state.userData.token,
          returnData: true,
        });

        if (res && res.status === "success" && res.data) {
          return res.data;
        }

        this.$bvToast.toast("Failed to load summary report data.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
        return null;
      } catch (error) {
        // console.error("Encashment summary report fetch error:", error);
        this.$bvToast.toast("Failed to load summary report data.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
        return null;
      }
    },
    async fetchEncashmentReportRows() {
      if (!this.validateEncashmentReportForm()) return [];

      const reportType = this.encashmentReportType || "cash";
      if (reportType === "summary") return [];
      const accountID = this.leaveEncashmentReportAccounts[reportType];
      if (!accountID) return [];

      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(this.$store.state.userData.cId),
          sessionID: String(this.encashmentReportSessionID),
          depID: String(this.encashmentReportDepID || 0),
          accountID,
        });

        const res = await this.get({
          url:
            this.$store.state.domain +
            "StaffLeaveEncashment/Report?" +
            params.toString(),
          token: this.$store.state.userData.token,
          returnData: true,
        });

        let list = [];
        if (res && res.status === "success" && Array.isArray(res.data)) {
          list = res.data;
        } else if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }

        return list.sort((a, b) => {
          const idA = Number(a.rfID || a.staffID) || 0;
          const idB = Number(b.rfID || b.staffID) || 0;
          if (idA !== idB) return idA - idB;
          return String(a.name || "").localeCompare(String(b.name || ""));
        });
      } catch (error) {
        // console.error("Encashment report fetch error:", error);
        this.$bvToast.toast("Failed to load encashment report data.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
        return [];
      }
    },
    getEncashmentStaffId(row) {
      return row.rfID || row.staffID || "";
    },
    buildEncashmentCashExportSheet(rows) {
      const now = new Date();
      const monthName = now.toLocaleString("en-US", { month: "long" });
      const year = now.getFullYear();
      const campus =
        this.$store.state.currentBranch?.organizationName ||
        this.$store.state.currentBranch?.branch ||
        "School";

      const sheetData = [
        [campus],
        [
          `Following are the payroll of ${campus} for the month of ${monthName} ${year} issued by Cheque or Cash.`,
        ],
        [],
        ["S.No", "ID", "NAME", "AMOUNT"],
      ];

      rows.forEach((row, index) => {
        sheetData.push([
          index + 1,
          this.getEncashmentStaffId(row),
          String(row.name || "").toUpperCase(),
          Number(row.encashmentAmount) || 0,
        ]);
      });

      const total = rows.reduce(
        (sum, row) => sum + (Number(row.encashmentAmount) || 0),
        0
      );
      sheetData.push([]);
      sheetData.push(["", "", "Grand Total", total]);

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      ws["!cols"] = [{ wch: 8 }, { wch: 10 }, { wch: 36 }, { wch: 14 }];
      return ws;
    },
    getEncashmentAccountTitle(row) {
      const title = row.staffAccountTitle || row.name || "";
      return String(title).toUpperCase();
    },
    getEncashmentAccountNumber(row) {
      return row.staffAccountNumber ? String(row.staffAccountNumber) : "";
    },
    getEncashmentBankGroups(rows) {
      const depId = this.encashmentReportDepID || 0;
      const deptLabel = this.encashmentReportDeptLabel;

      if (depId && deptLabel && deptLabel !== "All Departments") {
        return [{ title: String(deptLabel).toUpperCase(), rows }];
      }

      const groups = {};
      rows.forEach((row) => {
        let dept = "STAFF";
        if (row.department && row.department.name) dept = row.department.name;
        else if (typeof row.department === "string") dept = row.department;
        else if (row.departmentID) dept = this.getDep(row.departmentID);

        const title = String(dept || "STAFF").toUpperCase();
        if (!groups[title]) groups[title] = [];
        groups[title].push(row);
      });

      return Object.keys(groups)
        .sort()
        .map((title) => ({ title, rows: groups[title] }));
    },
    buildEncashmentBankExportSheet(rows) {
      const now = new Date();
      const monthName = now.toLocaleString("en-US", { month: "long" });
      const year = now.getFullYear();
      const dateStr = now.toISOString().slice(0, 10);
      const campus =
        this.$store.state.currentBranch?.organizationName ||
        this.$store.state.currentBranch?.branch ||
        "School";
      const bankNo = String(this.encashmentReportBankNo || "").trim();
      const letterLines = [
        ["The Manager,"],
        ["Bank Al-Habib,"],
        ["Karachi"],
        [],
        [`Date: ${dateStr}`],
        [],
        ["Respected Sir,"],
        [],
        [
          `Kindly process the payroll of ${campus} for the month of ${monthName} ${year}. Below is the list of individuals, their Bank Al-Habib account number and the corresponding amounts to be credited to their accounts by debiting our bank account # ${bankNo}.`,
        ],
        [],
      ];

      const sheetData = [];
      const groups = this.getEncashmentBankGroups(rows);

      groups.forEach((group, groupIndex) => {
        if (groupIndex > 0) {
          sheetData.push([]);
          sheetData.push(["---"]);
          sheetData.push([]);
        }

        sheetData.push(...letterLines);
        sheetData.push([group.title]);
        sheetData.push([
          "S.No",
          "ID",
          "NAME / TITLE OF ACCOUNT",
          "ACCOUNT NUMBER",
          "AMOUNT",
        ]);

        group.rows.forEach((row, index) => {
          sheetData.push([
            index + 1,
            this.getEncashmentStaffId(row),
            this.getEncashmentAccountTitle(row),
            this.getEncashmentAccountNumber(row),
            Number(row.encashmentAmount) || 0,
          ]);
        });

        sheetData.push([]);
      });

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      ws["!cols"] = [
        { wch: 8 },
        { wch: 10 },
        { wch: 34 },
        { wch: 24 },
        { wch: 14 },
      ];
      return ws;
    },
    buildEncashmentSummaryExportSheet(summaryData) {
      const departments = Array.isArray(summaryData?.departments)
        ? summaryData.departments
        : [];
      const totals = summaryData?.grandTotal || {};
      const sessionLabel = summaryData?.session || "";
      const campus =
        this.$store.state.currentBranch?.organizationName ||
        this.$store.state.currentBranch?.branch ||
        "School";

      const sheetData = [
        [campus],
        ["Leave Encashment Summary Report"],
        sessionLabel ? [`Session: ${sessionLabel}`] : [],
        [],
        [
          "S.No",
          "Department",
          "Staff Count",
          "Record Count",
          "Encashment Amount",
        ],
      ];

      departments.forEach((row, index) => {
        sheetData.push([
          index + 1,
          row.departmentName || `Department ${row.departmentID || ""}`,
          Number(row.staffCount) || 0,
          Number(row.recordCount) || 0,
          Number(row.totalEncashmentAmount) || 0,
        ]);
      });

      sheetData.push([]);
      sheetData.push([
        "",
        "Grand Total",
        Number(totals.staffCount) || 0,
        Number(totals.recordCount) || 0,
        Number(totals.totalEncashmentAmount) || 0,
      ]);

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      ws["!cols"] = [
        { wch: 8 },
        { wch: 28 },
        { wch: 14 },
        { wch: 14 },
        { wch: 20 },
      ];
      return ws;
    },
    async exportLeaveEncashmentReport() {
      if (!this.showLeaveEncashmentTab) return;

      this.encashmentReportExporting = true;
      try {
        const reportType = this.encashmentReportType || "cash";
        let ws = null;
        let sheetName = "Report";
        let typeLabel = "Report";

        if (reportType === "summary") {
          const summaryData = await this.fetchEncashmentSummaryReportData();
          const departments = Array.isArray(summaryData?.departments)
            ? summaryData.departments
            : [];
          if (!departments.length) {
            this.$bvToast.toast("No summary records found to export.", {
              title: "Info",
              variant: "warning",
              toaster: "b-toaster-top-right",
            });
            return;
          }
          ws = this.buildEncashmentSummaryExportSheet(summaryData);
          sheetName = "Summary Report";
          typeLabel = "Summary";
        } else {
          const rows = await this.fetchEncashmentReportRows();
          if (!rows.length) {
            this.$bvToast.toast("No encashment records found to export.", {
              title: "Info",
              variant: "warning",
              toaster: "b-toaster-top-right",
            });
            return;
          }
          const isCash = reportType === "cash";
          ws = isCash
            ? this.buildEncashmentCashExportSheet(rows)
            : this.buildEncashmentBankExportSheet(rows);
          sheetName = isCash ? "Cash Report" : "Bank Report";
          typeLabel = isCash ? "Cash" : "Bank";
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);

        const fileName = `Leave_Encashment_${typeLabel}_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`;
        XLSX.writeFile(wb, fileName);
      } finally {
        this.encashmentReportExporting = false;
      }
    },
    openLeaveEncashmentReport() {
      if (!this.showLeaveEncashmentTab) return;
      if (!this.validateEncashmentReportForm()) return;

      const reportType = this.encashmentReportType || "cash";
      const accountID =
        reportType === "summary"
          ? ""
          : this.leaveEncashmentReportAccounts[reportType];
      if (reportType !== "summary" && !accountID) return;

      const session = (this.sessions || []).find(
        (s) => s.id === this.encashmentReportSessionID
      );
      const now = new Date();
      const query = {
        db: this.$store.state.userData.db,
        cID: String(this.$store.state.userData.cId),
        sessionID: String(this.encashmentReportSessionID),
        reportType,
        sessionLabel: session ? session.session : "",
        deptLabel: this.encashmentReportDeptLabel,
        reportMonth: String(now.getMonth() + 1),
        reportYear: String(now.getFullYear()),
      };
      if (reportType !== "summary") {
        query.depID = String(this.encashmentReportDepID || 0);
        query.accountID = accountID;
      }

      if (reportType === "bank") {
        query.bankNo = String(this.encashmentReportBankNo || "").trim();
      }

      const route = this.$router.resolve({
        name: "leave-encashment-report",
        query,
      });
      window.open(route.href, "_blank");
      this.$bvModal.hide("modal-encashment-report");
    },
    async openHistory() {
      // this.$bvModal.show("modal-history");

      this.isLoan = false;
      this.isDeposit = false;
      this.showAtt = false;
      this.isEncashmentHistory = false;
      this.isSalarySheet = false;
      this.isHistory = true;
      this.currentHistoryStaff = null; // Clear single staff mode
      this.historyStaffID = 0;
      this.historyStaffCampusID = 0;
      this.searchQuery = "";
      this.historyFiltersHydrating = true;
      this.applyStoredHistoryPrefs();
      this.syncHistoryFilterModels();
      this.historyPage = 1;
      this.resetHistoryPagingMode();

      await this.loadHistoryPage();
      this.$nextTick(() => {
        this.historyFiltersHydrating = false;
      });
    },
    resetHistoryPagingMode() {
      this.historyLegacyMode = false;
      this.historyLegacyCache = null;
      this.historyLegacyCacheKey = "";
      this.historyTotalPages = 0;
      this.historyHasNext = false;
    },
    historyPrefsStorageKey() {
      const db = this.$store.state.userData?.db || "";
      const userID =
        this.$store.state.userData?.userID ||
        this.$store.state.userData?.localID ||
        "";
      const cId = this.$store.state.userData?.cId || "";
      return `myskool-staff-salary-history-prefs:${db}:${cId}:${userID}`;
    },
    readHistoryPrefs() {
      try {
        const raw = localStorage.getItem(this.historyPrefsStorageKey());
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : null;
      } catch (_) {
        return null;
      }
    },
    writeHistoryPrefs() {
      try {
        const month = this.coerceHistoryMonth(this.history.month);
        const year = this.coerceHistoryYear(this.history.year);
        localStorage.setItem(
          this.historyPrefsStorageKey(),
          JSON.stringify({
            month,
            year,
            paidFilter: this.historyPaidFilter,
            depID: this.currentDep,
            perPage: this.historyPerPage,
          })
        );
      } catch (_) {
        /* ignore quota / private mode */
      }
    },
    coerceHistoryMonth(value) {
      if (value == null || value === "") return null;
      const m = Number(value);
      return Number.isFinite(m) && m >= 1 && m <= 12 ? m : null;
    },
    coerceHistoryYear(value) {
      if (value == null || value === "") return null;
      const y = Number(value);
      return Number.isFinite(y) && y >= 2020 && y <= 2040 ? y : null;
    },
    syncHistoryFilterModels() {
      const month = this.coerceHistoryMonth(this.history.month);
      const year = this.coerceHistoryYear(this.history.year);
      if (this.history.month !== month) {
        this.$set(this.history, "month", month);
      }
      if (this.history.year !== year) {
        this.$set(this.history, "year", year);
      }
    },
    formatHistoryYearOptionLabel(option) {
      return option == null ? "" : String(option);
    },
    onHistoryMonthFilterInput(value) {
      if (this.historyFiltersHydrating || !this.isHistory) return;
      this.$set(this.history, "month", this.coerceHistoryMonth(value));
      this.applyHistoryFilters();
    },
    onHistoryYearFilterInput(value) {
      if (this.historyFiltersHydrating || !this.isHistory) return;
      this.$set(this.history, "year", this.coerceHistoryYear(value));
      this.applyHistoryFilters();
    },
    onHistoryPaidFilterInput(value) {
      if (this.historyFiltersHydrating || !this.isHistory) return;
      this.historyPaidFilter = value || "all";
      this.applyHistoryFilters();
    },
    applyStoredHistoryPrefs() {
      const prefs = this.readHistoryPrefs();
      if (!prefs) return;
      const month = this.coerceHistoryMonth(prefs.month);
      const year = this.coerceHistoryYear(prefs.year);
      if (month != null) {
        this.$set(this.history, "month", month);
      }
      if (year != null) {
        this.$set(this.history, "year", year);
      }
      if (prefs.paidFilter != null && prefs.paidFilter !== "") {
        this.historyPaidFilter = prefs.paidFilter;
      }
      if (
        prefs.depID != null &&
        Number(prefs.depID) >= 0 &&
        !this.currentHistoryStaff
      ) {
        this.currentDep = Number(prefs.depID) || 0;
      }
      const perPage = Number(prefs.perPage);
      if (Number.isFinite(perPage) && perPage > 0) {
        this.historyPerPage = perPage;
      }
    },
    resolveHistoryMonthYear() {
      const month = Number(this.history.month);
      const year = Number(this.history.year);
      return {
        month: Number.isFinite(month) && month > 0 ? month : 0,
        year: Number.isFinite(year) && year > 0 ? year : 0,
      };
    },
    /* Client-side filtering only when we already fell back to the legacy
       LoadHistory URL (no page/pageSize). Month, year, keyword, and paid are
       sent on the paginated request via buildHistoryUrl — forcing legacy mode
       when those filters are set would load an unpaginated slice and make
       totalCount look like the current page length. */
    shouldFilterLegacyHistoryRows() {
      if (!this.historyLegacyMode) return false;
      const keyword = String(this.searchQuery || "").trim();
      const paid =
        this.isKentSchoolDomain &&
        this.historyPaidFilter &&
        this.historyPaidFilter !== "all";
      const { month, year } = this.resolveHistoryMonthYear();
      return !!(keyword || paid || month || year);
    },
    buildHistoryLegacyCacheKey() {
      return [
        this.historyStaffCampusID || this.selectedCampus,
        this.historyStaffID || 0,
        this.historyStaffID ? 0 : this.currentDep || 0,
      ].join("|");
    },
    historyRowMatchesFilters(row) {
      if (!row) return false;
      const us = row.us || row;
      const rowMonth = us.month != null ? us.month : row.month;
      const rowYear = us.year != null ? us.year : row.year;
      const { month, year } = this.resolveHistoryMonthYear();

      if (month > 0 && Number(rowMonth) !== Number(month)) {
        return false;
      }
      if (year > 0 && Number(rowYear) !== Number(year)) {
        return false;
      }

      if (this.isKentSchoolDomain) {
        const paidFilter = this.historyPaidFilter || "all";
        if (paidFilter !== "all") {
          const paid = this.normalizePaidValue(
            us.paid != null ? us.paid : row.paid
          );
          if (paidFilter === "yes" && paid !== true) return false;
          if (paidFilter === "no" && paid !== false) return false;
        }
      }

      const keyword = String(this.searchQuery || "").trim().toLowerCase();
      if (keyword) {
        const st = row.st || {};
        const haystack = [
          st.name,
          st.father_name,
          st.rfID,
          st.id,
          us.id,
          us.tID,
        ]
          .filter((v) => v != null && v !== "")
          .map((v) => String(v).toLowerCase());
        if (!haystack.some((part) => part.includes(keyword))) {
          return false;
        }
      }

      return true;
    },
    filterHistoryRows(rows) {
      if (!Array.isArray(rows)) return [];
      return rows.filter((row) => this.historyRowMatchesFilters(row));
    },
    /* Builds the LoadHistory URL for the current filter + page state.
       Every filter is sent to the API (not applied client-side) because the
       endpoint paginates: filtering an already-paged array would only ever
       search the rows on the current page. */
    buildHistoryUrl() {
      const { month, year } = this.resolveHistoryMonthYear();
      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.historyStaffCampusID || this.selectedCampus),
        tID: String(this.historyStaffID || 0),
        dptID: String(this.historyStaffID ? 0 : this.currentDep || 0),
        month: String(month),
        year: String(year),
        page: String(this.historyPage),
        pageSize: String(this.historyPerPage),
      });

      // myskoolkentschool exposes a Paid filter; other domains don't send it.
      const paid = this.isKentSchoolDomain
        ? this.historyPaidFilter || "all"
        : "all";
      if (paid && paid !== "all") params.append("paid", paid);

      const keyword = String(this.searchQuery || "").trim();
      if (keyword) params.append("keyword", keyword);

      return (
        this.$store.state.domain + "Salary/LoadHistory?" + params.toString()
      );
    },
    /* Fetches one page of history. `dashboard: true` makes the store return the
       whole body ({ data, totalCount, status }) instead of unwrapping .data, so
       totalCount survives for the pagination control. */
    parseHistoryResponse(res) {
      if (!res) {
        return {
          rows: [],
          total: 0,
          page: 1,
          pageSize: this.historyPerPage,
          totalPages: 0,
          hasNext: false,
        };
      }

      const readMeta = (payload) => {
        const rows = Array.isArray(payload?.data) ? payload.data : [];
        const total = Number(
          payload?.totalCount ?? payload?.count ?? payload?.total ?? rows.length
        );
        const page = Number(payload?.page);
        const pageSize = Number(payload?.pageSize);
        const totalPages = Number(payload?.totalPages);
        return {
          rows,
          total: Number.isFinite(total) ? total : rows.length,
          page: Number.isFinite(page) && page > 0 ? page : this.historyPage,
          pageSize:
            Number.isFinite(pageSize) && pageSize > 0
              ? pageSize
              : this.historyPerPage,
          totalPages: Number.isFinite(totalPages) && totalPages >= 0
            ? totalPages
            : 0,
          hasNext: payload?.hasNext === true,
        };
      };

      if (Array.isArray(res)) {
        return {
          rows: res,
          total: res.length,
          page: this.historyPage,
          pageSize: this.historyPerPage,
          totalPages: Math.ceil(res.length / this.historyPerPage) || 0,
          hasNext: false,
        };
      }
      if (Array.isArray(res.data)) {
        return readMeta(res);
      }
      if (res.data && Array.isArray(res.data.data)) {
        return readMeta(res.data);
      }
      return {
        rows: [],
        total: 0,
        page: 1,
        pageSize: this.historyPerPage,
        totalPages: 0,
        hasNext: false,
      };
    },
    applyHistoryResponseMeta(meta) {
      const total = meta.total || 0;
      const pageSize = meta.pageSize || this.historyPerPage;
      this.historyTotalCount = total;
      this.historyTotalPages =
        meta.totalPages ||
        (total ? Math.max(1, Math.ceil(total / pageSize)) : 0);
      this.historyHasNext = meta.hasNext === true;
    },
    /* Full history list (no pagination). Month/year/search are applied client-side
       because many LoadHistory deployments ignore those query params and return []. */
    buildLegacyHistoryFullUrl() {
      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        cID: String(this.historyStaffCampusID || this.selectedCampus),
        tID: String(this.historyStaffID || 0),
        dptID: String(this.historyStaffID ? 0 : this.currentDep || 0),
      });
      return (
        this.$store.state.domain + "Salary/LoadHistory?" + params.toString()
      );
    },
    buildLegacyHistoryUrl() {
      return this.buildLegacyHistoryFullUrl();
    },
    async loadHistoryLegacyPage() {
      const cacheKey = this.buildHistoryLegacyCacheKey();
      if (
        !this.historyLegacyCache ||
        this.historyLegacyCacheKey !== cacheKey
      ) {
        const legacyRes = await this.get({
          url: this.buildLegacyHistoryFullUrl(),
          token: this.$store.state.userData.token,
        });
        const legacy = this.parseHistoryResponse(legacyRes);
        this.historyLegacyCache = legacy.rows || [];
        this.historyLegacyCacheKey = cacheKey;
      }

      const filtered = this.shouldFilterLegacyHistoryRows()
        ? this.filterHistoryRows(this.historyLegacyCache)
        : this.historyLegacyCache || [];
      const total = filtered.length;
      const start = (this.historyPage - 1) * this.historyPerPage;
      const rows = filtered.slice(start, start + this.historyPerPage);
      this.historyData = rows;
      this.allHistory = filtered;
      this.historyTotalCount = total;
      this.historyTotalPages = total
        ? Math.max(1, Math.ceil(total / this.historyPerPage))
        : 0;
      this.historyHasNext =
        this.historyPage * this.historyPerPage < total;
      return total;
    },
    async loadHistoryPage() {
      this.otherLoading = true;
      try {
        if (this.historyLegacyMode) {
          await this.loadHistoryLegacyPage();
        } else {
          this.historyLegacyMode = false;
          this.historyLegacyCache = null;
          this.historyLegacyCacheKey = "";

          const res = await this.get({
            url: this.buildHistoryUrl(),
            token: this.$store.state.userData.token,
            dashboard: true,
          });

          const meta = this.parseHistoryResponse(res);
          const { rows } = meta;

          if (!rows.length && this.historyPage === 1) {
            const legacyRes = await this.get({
              url: this.buildLegacyHistoryFullUrl(),
              token: this.$store.state.userData.token,
            });
            const legacy = this.parseHistoryResponse(legacyRes);
            if (legacy.rows.length) {
              this.historyLegacyMode = true;
              this.historyLegacyCache = legacy.rows;
              this.historyLegacyCacheKey = this.buildHistoryLegacyCacheKey();
              await this.loadHistoryLegacyPage();
            } else {
              this.historyData = [];
              this.allHistory = [];
              this.historyTotalCount = 0;
              this.historyTotalPages = 0;
              this.historyHasNext = false;
            }
          } else {
            this.historyData = rows;
            this.allHistory = rows;
            this.applyHistoryResponseMeta(meta);
          }
        }

        // A filter change can leave us past the last page (e.g. page 5 of 5,
        // then narrow the month). Drop back to the last valid page.
        const lastPage = Math.max(
          1,
          Math.ceil(this.historyTotalCount / this.historyPerPage)
        );
        if (this.historyPage > lastPage) {
          this.historyPage = lastPage;
          this.otherLoading = false;
          return this.loadHistoryPage();
        }
      } catch (error) {
        // console.error("Salary history load error:", error);
        this.historyData = [];
        this.allHistory = [];
        this.historyTotalCount = 0;
        this.$bvToast.toast("Failed to load salary history.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.otherLoading = false;
      }
    },
    onHistoryPageChange(page) {
      this.historyPage = page;
      this.loadHistoryPage();
    },
    onHistoryPageSizeChange(size) {
      this.historyPerPage = size;
      this.historyPage = 1;
      this.writeHistoryPrefs();
      this.loadHistoryPage();
    },
    /* Month/Year/Paid/Search changed: reset to page 1 and refetch. */
    applyHistoryFilters() {
      this.resetHistoryPagingMode();
      this.historyPage = 1;
      this.writeHistoryPrefs();
      this.loadHistoryPage();
    },
    /* Department changed while in history view. */
    onHistoryDepartmentChange() {
      if (this.currentHistoryStaff) {
        // A department filter makes no sense inside one staff's history.
        return;
      }
      this.applyHistoryFilters();
    },
    async openEncashmentHistory() {
      if (!this.showLeaveEncashmentTab) return;

      this.isLoan = false;
      this.isDeposit = false;
      this.showAtt = false;
      this.isHistory = false;
      this.isSalarySheet = false;
      this.isEncashmentHistory = true;
      this.encashmentHistoryLoading = true;
      this.encashmentHistoryData = [];

      if (!this.sessions || !this.sessions.length) {
        await this.LoadSessions();
      }

      if (!this.encashmentHistorySessionID) {
        const defaultSession = Number(this.leavesSessionObj?.valueNumber);
        this.encashmentHistorySessionID =
          !Number.isNaN(defaultSession) && defaultSession > 0
            ? defaultSession
            : this.sessions[0]?.id || null;
      }

      await this.loadEncashmentHistory();
    },
    getEncashmentReportAccountIds() {
      const bank = this.leaveEncashmentReportAccounts.bank || "";
      const cash = this.leaveEncashmentReportAccounts.cash || "";
      return [cash, bank].filter(Boolean).join(",");
    },
    encashmentDepartmentName(row) {
      if (!row) return "—";
      if (row.department && row.department.name) return row.department.name;
      if (typeof row.department === "string") return row.department;
      if (row.departmentID) return this.getDep(row.departmentID);
      return "—";
    },
    formatEncashmentAmount(amount) {
      const num = Number(amount) || 0;
      return num.toLocaleString("en-PK", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    async loadEncashmentHistory() {
      if (!this.showLeaveEncashmentTab || !this.isEncashmentHistory) return;

      if (!this.encashmentHistorySessionID) {
        this.encashmentHistoryData = [];
        this.encashmentHistoryLoading = false;
        return;
      }

      this.encashmentHistoryLoading = true;
      this.encashmentHistoryData = [];
      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(this.selectedCampus),
          sessionID: String(this.encashmentHistorySessionID),
          depID: String(this.currentDep || 0),
        });

        const res = await this.get({
          url:
            this.$store.state.domain +
            "StaffLeaveEncashment/Report?" +
            params.toString(),
          token: this.$store.state.userData.token,
          returnData: true,
        });

        let list = [];
        if (res && res.status === "success" && Array.isArray(res.data)) {
          list = res.data;
        } else if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }

        this.encashmentHistoryData = list.sort((a, b) => {
          const deptA = this.encashmentDepartmentName(a).toLowerCase();
          const deptB = this.encashmentDepartmentName(b).toLowerCase();
          if (deptA !== deptB) return deptA.localeCompare(deptB);
          return String(a.name || "").localeCompare(String(b.name || ""));
        });
      } catch (error) {
        // console.error("Encashment history load error:", error);
        this.encashmentHistoryData = [];
        this.$bvToast.toast("Failed to load encashment history.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } finally {
        this.encashmentHistoryLoading = false;
      }
    },
    /* Filters are applied server-side now (see buildHistoryUrl); the table
       renders historyData directly. Kept as a named entry point because the
       history modal's Show button and legacy callers use it. */
    filterHistory() {
      this.applyHistoryFilters();
    },
    checkHMonth() {
      var elem = this.$refs["his_month"];
      if (this.history.month == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkHYear() {
      var elem = this.$refs["his_year"];
      if (!this.history.year) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async showHistory() {
      if (this.checkHMonth() == true && this.checkHYear() == true) {
        this.isEncashmentHistory = false;
        this.isHistory = true;
        this.$bvModal.hide("modal-history");
        // The month/year pickers in the modal feed the same server-side
        // filters, so reload instead of just toggling the view flag.
        this.applyHistoryFilters();
      }
    },
    openPayroll(text) {
      if (text == "msg") this.showMsg = true;
      else this.showMsg = false;
      this.$bvModal.show("modal-payroll");
    },
    setDeps() {
      if (this.payroll.depIDs.at(-1) == 0) {
        this.payroll.depIDs = [0];
      } else {
        this.payroll.depIDs = this.payroll.depIDs.filter((el) => el != 0);
      }
    },
    setCampus() {
      if (this.payroll.cIDs.at(-1) == 0) {
        this.payroll.cIDs = [0];
      } else {
        this.payroll.cIDs = this.payroll.cIDs.filter((el) => el != 0);
      }
    },
    checkPDeps() {
      var elem = this.$refs["pay_depart"];
      if (this.payroll.depIDs.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPMonth() {
      var elem = this.$refs["pay_month"];
      if (!this.payroll.month) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPYear() {
      var elem = this.$refs["pay_year"];
      if (!this.payroll.year) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPDate() {
      if (this.payroll.report == "bank") {
        var elem = this.$refs["pay_date"];
        if (!this.payroll.date) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkPCheque() {
      if (this.payroll.report == "bank") {
        var elem = this.$refs["pay_cheq"];
        if (this.payroll.cheque == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    async updateSalary(month, year, ids) {
      this.updating = true;
      let res = await this.get({
        url:
          this.$store.state.domain +
          "salary/UpdateSalarySheetData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&month=" +
          month +
          "&year=" +
          year +
          "&campusIDs=" +
          ids,
        token: this.$store.state.userData.token,
      });
      this.updating = false;
    },
    async showPayroll() {
      if (
        // this.checkPDeps() == true &&
        this.checkPMonth() == true &&
        this.checkPYear() == true &&
        this.checkPDate() == true &&
        this.checkPCheque() == true
      ) {
        // console.log(this.payroll);
        let ids = "";
        let bankParams = "";
        if (["myskoolhpgs"].includes(this.reportDomain)) {
          ids = this.payroll.cIDs[0] == 0 ? "" : this.payroll.cIDs;
          bankParams = `&accountID=${this.payroll.accountID}&branchID=${this.payroll.branchID}`;
        }
        let paidParams = "";
        if (this.isKentSchoolDomain && !this.payroll.report) {
          paidParams = `&paid=${this.payrollPaidFilter || "all"}`;
        }

        if (this.payroll.report == "bank") {
          let url = `https://${this.reportDomain}.myskool.app/Account/BankList?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}&date=${this.payroll.date}&cheque=${this.payroll.cheque}&campusIDs=${ids}${bankParams}`;
          window.open(url, "_blank");
        } else if (this.payroll.report == "cash") {
          let url = `https://${this.reportDomain}.myskool.app/Account/PayrollCash?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}&type=${this.payroll.report}&campusIDs=${ids}`;
          window.open(url, "_blank");
        } else if (this.payroll.report == "slips") {
          let url = `https://${this.reportDomain}.myskool.app/Account/SalarySlipAll?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}`;
          window.open(url, "_blank");
        } else {
          if (
            ["myskoolhpgs", "myskoolprofectus"].includes(this.reportDomain) &&
            ["reconcilation", "receiving"].includes(this.payroll.report)
          ) {
            await this.updateSalary(this.payroll.month, this.payroll.year, ids);
          }
          let url = `https://${this.reportDomain}.myskool.app/Account/Payroll?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}&type=${this.payroll.report}&campusIDs=${ids}${paidParams}`;
          window.open(url, "_blank");
        }
      }
    },
    async exportPayroll() {
      if (
        // this.checkPDeps() == true &&
        this.checkPMonth() == true &&
        this.checkPYear() == true &&
        this.checkPDate() == true &&
        this.checkPCheque() == true
      ) {
        // console.log(this.payroll);
        this.exporting = true;
        let url = "";

        let ids = "";
        let bankParams = "";
        if (["myskoolhpgs"].includes(this.reportDomain)) {
          ids = this.payroll.cIDs[0] == 0 ? "" : this.payroll.cIDs;
          bankParams = `&accountID=${this.payroll.accountID}&branchID=${this.payroll.branchID}`;
        }
        let paidParams = "";
        if (this.isKentSchoolDomain && !this.payroll.report) {
          paidParams = `&paid=${this.payrollPaidFilter || "all"}`;
        }

        if (this.payroll.report == "bank") {
          url = `https://${this.reportDomain}.myskool.app/Account/BankListExport?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}&date=${this.payroll.date}&cheque=${this.payroll.cheque}&campusIDs=${ids}${bankParams}`;
        } else if (this.payroll.report == "cash") {
          url = `https://${this.reportDomain}.myskool.app/Account/PayrollCashExport?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}&type=${this.payroll.report}&campusIDs=${ids}`;
        } else if (this.payroll.report == "slips") {
          url = `https://${this.reportDomain}.myskool.app/Account/SalarySlipAll?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}`;
        } else {
          if (
            ["myskoolhpgs", "myskoolprofectus"].includes(this.reportDomain) &&
            ["reconcilation", "receiving"].includes(this.payroll.report)
          ) {
            await this.updateSalary(this.payroll.month, this.payroll.year, ids);
          }
          url = `https://${this.reportDomain}.myskool.app/Account/PayrollExport?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.payroll.month}&year=${this.payroll.year}&dptID=${this.payroll.depIDs}&type=${this.payroll.report}&campusIDs=${ids}${paidParams}`;
        }

        if (this.payroll.report == "slips") {
          window.open(url, "_blank");
          this.exporting = false;
        } else {
          axios
            .get(url)
            .then((response) => {
              // console.log(response.data.data);
              window.open(response.data.data, "_blank");
            })
            .catch((error) => {
              // Handle errors here
              // console.error("There was an error!", error);
            })
            .finally(() => {
              this.exporting = false;
            });
        }
      }
    },
    async createLedger() {
      if (this.checkPMonth() == true && this.checkPYear() == true) {
        this.creatingLedger = true;
        try {
          const body = await this.post({
            url:
              this.$store.state.domain +
              "salary/SyncSalaryLedger?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&dID=" +
              this.payroll.depIDs +
              "&month=" +
              this.payroll.month +
              "&year=" +
              this.payroll.year,
            context: this,
            token: this.$store.state.userData.token,
            allResponse: true,
          });
          if (body && body.status === "success") {
            this.$bvModal.hide("modal-payroll");
            this.showOperationResult(body, "ledger");
          }
        } finally {
          this.creatingLedger = false;
        }
      }
    },
    async send() {
      if (
        // this.checkPDeps() == true &&
        this.checkPMonth() == true &&
        this.checkPYear() == true
      ) {
        try {
          // console.log(this.payroll);
          this.sending = true;
          await this.postObj({
            url:
              this.$store.state.domain +
              "Salary/SendPaySlip?db=" +
              this.$store.state.userData.db +
              "&salaryID=0&dID=" +
              this.payroll.depIDs +
              "&month=" +
              this.payroll.month +
              "&year=" +
              this.payroll.year +
              "&cID=" +
              this.$store.state.userData.cId +
              "&userID=" +
              this.$store.state.userData.userID,
            message: "Pay Slip sent on WhatsApp!",
            context: this,
            token: this.$store.state.userData.token,
          });
        } catch (error) {
        } finally {
          this.sending = false;
        }
      }
    },
    async sendSingle(item) {
      try {
        this.currentID = item.id;
        this.singleSending = true;
        await this.postObj({
          url:
            this.$store.state.domain +
            "Salary/SendPaySlip?db=" +
            this.$store.state.userData.db +
            "&salaryID=" +
            item.id +
            "&dID=0&month=" +
            item.month +
            "&year=" +
            item.year +
            "&cID=" +
            item.campusID +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Pay Slip sent on WhatsApp!",
          context: this,
          token: this.$store.state.userData.token,
        });
      } catch (error) {
      } finally {
        this.singleSending = false;
      }
    },
    printSlip(ss) {
      let url = `https://${this.reportDomain}.myskool.app/Account/SalarySlip?dbb=${this.$store.state.userData.db}&cID=${ss.campusID}&salaryID=${ss.id}`;
      window.open(url, "_blank");
    },
    async DeleteSal(id) {
      // console.log(id);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Salary/DeleteSelected?db=" +
            this.$store.state.userData.db +
            "&salaryID=" +
            id +
            this.salaryUserQuery(),
          body: null,
          message: "Salary deleted successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          // Refresh the current history page in place so the active
          // month/year/department/paid filters and page survive the delete.
          // loadHistoryPage() clamps back a page if this was the last row on it.
          if (this.isHistory) {
            this.loadHistoryPage();
          } else {
            this.LoadData();
          }
        }
      }
    },

    async preloadSalaryPolicies() {
      try {
        if (!Array.isArray(this.settingData) || !this.settingData.length) {
          await this.LoadPolicies({ silent: true });
        }
        this.ensureSettingsSessions();
      } catch (_) {
        /* warm list only; settings sidebar always refetches on open */
      }
    },
    normalizePolicyRecord(item) {
      if (!item || typeof item !== "object") return item;
      const next = { ...item };
      if (next.enabled === true || next.enabled === 1 || next.enabled === "1") {
        next.enabled = true;
      } else if (
        next.enabled === false ||
        next.enabled === 0 ||
        next.enabled === "0"
      ) {
        next.enabled = false;
      }
      if (next.number !== null && next.number !== undefined && next.number !== "") {
        const n = Number(next.number);
        if (Number.isFinite(n)) next.number = n;
      }
      if (next.option != null) next.option = String(next.option);
      return next;
    },
    parseIncludeMonthsFromPolicy(source) {
      if (!source) return [];
      const raw = source.includeMonths;
      if (raw === 0 || raw === "0" || raw == null || raw === "") return [];
      if (Array.isArray(raw)) {
        return [...new Set(raw.map((n) => Number(n)).filter((n) => n >= 1 && n <= 12))].sort(
          (a, b) => a - b
        );
      }
      if (typeof raw === "string") {
        return [
          ...new Set(
            raw
              .split(",")
              .map((s) => parseInt(String(s).trim(), 10))
              .filter((n) => n >= 1 && n <= 12)
          ),
        ].sort((a, b) => a - b);
      }
      return [];
    },
    normalizeIncludeMonthsArray(value) {
      if (!Array.isArray(value)) return [];
      return [...new Set(value.map((n) => Number(n)).filter((n) => n >= 1 && n <= 12))].sort(
        (a, b) => a - b
      );
    },
    coerceLeaveRowIncludeMonths(row) {
      if (!row || !Array.isArray(row.includeMonths)) return;
      const next = this.normalizeIncludeMonthsArray(row.includeMonths);
      if (
        next.length !== row.includeMonths.length ||
        next.some((n, i) => n !== Number(row.includeMonths[i]))
      ) {
        this.$set(row, "includeMonths", next);
      }
    },
    serializeIncludeMonthsForApi(raw, categoy) {
      if (categoy !== "Leave Allowed" || !this.isMyskoolStJacobDomain) {
        return "0";
      }
      if (raw === 0 || raw === "0" || raw == null || raw === "") {
        return "0";
      }
      let months = [];
      if (Array.isArray(raw)) {
        months = this.normalizeIncludeMonthsArray(raw);
      } else if (typeof raw === "string") {
        months = this.parseIncludeMonthsFromPolicy({ includeMonths: raw });
      } else if (typeof raw === "number" && raw >= 1 && raw <= 12) {
        months = [raw];
      }
      return months.length ? months.join(",") : "0";
    },
    resolveLeavePolicyIncludeMonths(row, categoy) {
      if (categoy !== "Leave Allowed" || !this.isMyskoolStJacobDomain) {
        return "0";
      }
      return this.serializeIncludeMonthsForApi(row.includeMonths, categoy);
    },
    sanitizePolicySaveIncludeMonths(items) {
      if (!Array.isArray(items)) return items;
      return items.map((item) => {
        if (!item || typeof item !== "object") return item;
        return {
          ...item,
          includeMonths: this.serializeIncludeMonthsForApi(
            item.includeMonths,
            item.categoy
          ),
        };
      });
    },
    ensureLeaveRowIncludeMonths(row) {
      if (!row) return;
      let months = row.includeMonths;
      if (!Array.isArray(months)) {
        months = this.parseIncludeMonthsFromPolicy(row.leavesObj);
      }
      months = this.normalizeIncludeMonthsArray(months);
      this.$set(row, "includeMonths", months);
    },
    ensureSettingsSessions() {
      if (this.sessions?.length) return;
      this.LoadSessions().catch(() => {});
    },
    salaryToolbarTooltip(title) {
      return {
        title,
        placement: "top",
        boundary: "window",
        customClass: "salary-ui-tooltip",
        delay: { show: 450, hide: 80 },
        offset: 10,
      };
    },
    async openSetting() {
      this.leavePolicyPendingDelete = [];
      this.showHalfHint = true;
      this.showLateHint = true;
      this.showEarly = true;
      this.showSettings = true;
      this.policiesUIReady = false;
      this.settLoading = true;

      try {
        await Promise.all([
          this.LoadSessions(),
          this.departments?.length ? Promise.resolve() : this.loadDep(),
          this.LoadPolicies({ silent: true }),
        ]);
        await this.hydratePolicyObjects();
        this.ensureSettingsSessions();
      } finally {
        this.settLoading = false;
      }
    },
    async hydratePolicyObjects() {
      const findPolicy = (category, departmentID = undefined) => {
        const matches = (this.settingData || []).filter(
          (el) => String(el.categoy || el.category || "") === category
        );
        if (!matches.length) return null;
        let row;
        if (departmentID === undefined) {
          row =
            matches.find((el) => !(Number(el.departmentID) > 0)) || matches[0];
        } else {
          const dep = Number(departmentID) || 0;
          row = matches.find(
            (el) => (Number(el.departmentID) || 0) === dep
          );
        }
        return row ? this.normalizePolicyRecord(row) : null;
      };

      this.leavesObj =
        findPolicy("Leave Allowed", 0) ||
        this.normalizePolicyRecord({ ...this.leavesObj });
      // console.log(this.leavesObj);
      this.lateObj =
        findPolicy("Late Coming Scale") ||
        this.normalizePolicyRecord({ ...this.lateObj });
      // console.log(this.lateObj);
      this.shortObj =
        findPolicy("Short Leave Scale") ||
        this.normalizePolicyRecord({ ...this.shortObj });
      // console.log(this.shortObj);
      this.attObj =
        findPolicy("Attendance Allowance") ||
        this.normalizePolicyRecord({ ...this.attObj });
      // console.log(this.attObj);
      const savedAttDeptObj = findPolicy("Attendance Allowance Department");
      if (savedAttDeptObj) {
        this.attDeptObj = savedAttDeptObj;
        // Backend: disabled/empty/0 means the allowance applies to every department.
        const savedIds = this.parseAttDeptIds(savedAttDeptObj.option).filter(
          (id) => id > 0
        );
        this.attDeptSelected =
          savedAttDeptObj.enabled === true && savedIds.length ? savedIds : [0];
      } else {
        this.attDeptObj = {
          id: 0,
          tID: 0,
          categoy: "Attendance Allowance Department",
          enabled: false,
          number: 0,
          option: "0",
          campusID: this.$store.state.userData.cId,
        };
        this.attDeptSelected = [0];
      }
      this.encashObj =
        findPolicy("Leave Encashment") ||
        this.normalizePolicyRecord({ ...this.encashObj });
      // console.log(this.encashObj);
      this.maxObj = findPolicy("Max Leave per Month", 0);
      if (!this.maxObj) {
        this.maxObj = {
          id: 0,
          tID: 0,
          categoy: "Max Leave per Month",
          enabled: this.leavesObj.option == "Yearly",
          number: 0,
          option: "",
          campusID: this.$store.state.userData.cId,
        };
      }
      // console.log(this.maxObj);
      this.minuteObj = findPolicy("Late Coming Deduction per Minute");
      if (!this.minuteObj) {
        this.minuteObj = {
          id: 0,
          tID: 0,
          categoy: "Late Coming Deduction per Minute",
          enabled: false,
          number: 0,
          option: "",
          campusID: this.$store.state.userData.cId,
        };
      }
      // console.log(this.minuteObj);
      this.earlyObj = findPolicy("Early Departure");
      if (!this.earlyObj) {
        this.earlyObj = {
          id: 0,
          tID: 0,
          categoy: "Early Departure",
          enabled: false,
          number: 0,
          option: "No",
          campusID: this.$store.state.userData.cId,
        };
      }
      // console.log(this.earlyObj);
      this.sandwichObj = findPolicy("Sandwich Policy");
      if (!this.sandwichObj) {
        this.sandwichObj = {
          id: 0,
          tID: 0,
          categoy: "Sandwich Policy",
          enabled: false,
          number: 0,
          option: "",
          campusID: this.$store.state.userData.cId,
        };
      }
      // console.log(this.sandwichObj);
      this.loadSandwichDepartments();

      if (this.showLeavesAllowedDepartment) {
        this.leavesAllowedDeptObj = findPolicy("Leaves Allowed Department");
        if (!this.leavesAllowedDeptObj) {
          this.leavesAllowedDeptObj = {
            id: 0,
            tID: 0,
            categoy: "Leaves Allowed Department",
            enabled: false,
            number: 0,
            option: "",
            campusID: this.$store.state.userData.cId,
          };
        }
        this.loadLeavesAllowedDepartments();
      }

      this.sickLeaveObj = findPolicy("Sick Leave", 0);
      if (!this.sickLeaveObj) {
        this.sickLeaveObj = {
          id: 0,
          tID: 0,
          categoy: "Sick Leave",
          enabled: false,
          number: 0,
          option: "Monthly",
          campusID: this.$store.state.userData.cId,
        };
      }
      // console.log(this.sickLeaveObj);

      this.maxSickObj = findPolicy("Max Sick Leave per Month");
      if (!this.maxSickObj) {
        this.maxSickObj = {
          id: 0,
          tID: 0,
          categoy: "Max Sick Leave per Month",
          enabled: this.sickLeaveObj.option == "Yearly",
          number: 0,
          option: "",
          campusID: this.$store.state.userData.cId,
        };
      }
      // console.log(this.maxSickObj);

      this.buildLeavePolicyRows();

      // Department overrides and account settings are independent of each other.
      await Promise.all([
        this.loadLeaveDeptPolicies(),
        this.LoadSalaryAccounts(),
      ]);

      this.finalizeLeavePolicyRowsAfterLoad();
      this.syncAllowLeavesMasterFromPolicies();
      (this.leavePolicyRows || []).forEach((row) => {
        this.ensureLeaveRowIncludeMonths(row);
        this.coerceLeaveRowIncludeMonths(row);
      });
      this.policiesUIReady = true;
    },
    policyRecordEnabled(rec) {
      if (!rec) return false;
      const e = rec.enabled;
      return e === true || e === 1 || e === "1";
    },
    syncAllowLeavesMasterFromPolicies() {
      const category = (el) => String(el.categoy || el.category || "");
      const list = this.settingData || [];

      const campusLeave = list.find(
        (el) =>
          category(el) === "Leave Allowed" &&
          (Number(el.departmentID) || 0) === 0
      );

      const anyLeaveEnabled =
        this.policyRecordEnabled(campusLeave) ||
        list.some(
          (el) =>
            category(el) === "Leave Allowed" &&
            Number(el.departmentID) > 0 &&
            this.policyRecordEnabled(el)
        ) ||
        (this.leavePolicyRows || []).some((row) =>
          this.policyRecordEnabled(row.leavesObj)
        );

      this.leavesObj.enabled = !!anyLeaveEnabled;
    },
    findCampusPolicyId(categoy) {
      const row = (this.settingData || []).find(
        (el) =>
          String(el.categoy || el.category || "") === categoy &&
          (Number(el.departmentID) || 0) === 0
      );
      return row ? Number(row.id) || 0 : 0;
    },
    hasCampusLeavePolicyRow() {
      return (this.leavePolicyRows || []).some(
        (row) => (Number(row.departmentID) || 0) === 0
      );
    },
    queueCampusLeavePolicyDeletesForDeptOnlyMode() {
      ["Leave Allowed", "Sick Leave", "Max Leave per Month"].forEach(
        (categoy) => {
          const id = this.findCampusPolicyId(categoy);
          if (id > 0 && !this.leavePolicyPendingDelete.includes(id)) {
            this.leavePolicyPendingDelete.push(id);
          }
        }
      );
    },
    ensureCampusLeaveMasterOnSave(saveObj) {
      const hasCampusLeaveInPayload = saveObj.some(
        (p) =>
          p.categoy === "Leave Allowed" &&
          (Number(p.departmentID) || 0) === 0
      );
      if (hasCampusLeaveInPayload || this.hasCampusLeavePolicyRow()) {
        return;
      }

      // Per-department leave policies only — do not POST campus (All Departments) rows.
      if (this.leavePoliciesAreDeptOnly()) {
        this.queueCampusLeavePolicyDeletesForDeptOnlyMode();
        return;
      }

      const campusID = this.$store.state.userData.cId;
      const masterOn = !!this.leavesObj.enabled;
      const leaveSrc = this.leavesObj || {};
      const sickSrc = this.sickLeaveObj || {};
      const maxSrc = this.maxObj || {};
      const leaveNum = parseInt(leaveSrc.number, 10);
      const sickNum = parseInt(sickSrc.number, 10);
      const maxNum = parseInt(maxSrc.number, 10);
      const yearly = String(leaveSrc.option || "") === "Yearly";

      saveObj.push(
        {
          id: this.findCampusPolicyId("Leave Allowed") || Number(leaveSrc.id) || 0,
          tID: 0,
          departmentID: 0,
          categoy: "Leave Allowed",
          enabled: masterOn,
          number: Number.isNaN(leaveNum) ? 0 : leaveNum,
          option: String(leaveSrc.option || "Monthly"),
          campusID: leaveSrc.campusID || campusID,
          includeMonths: "0",
        },
        {
          id: this.findCampusPolicyId("Sick Leave") || Number(sickSrc.id) || 0,
          tID: 0,
          departmentID: 0,
          categoy: "Sick Leave",
          enabled: masterOn && this.policyRecordEnabled(sickSrc),
          number: Number.isNaN(sickNum) ? 0 : sickNum,
          option: String(sickSrc.option || "Monthly"),
          campusID: sickSrc.campusID || campusID,
          includeMonths: "0",
        },
        {
          id:
            this.findCampusPolicyId("Max Leave per Month") ||
            Number(maxSrc.id) ||
            0,
          tID: 0,
          departmentID: 0,
          categoy: "Max Leave per Month",
          enabled: masterOn && yearly && this.policyRecordEnabled(maxSrc),
          number: Number.isNaN(maxNum) ? 0 : maxNum,
          option: String(maxSrc.option || ""),
          campusID: maxSrc.campusID || campusID,
          includeMonths: "0",
        }
      );
    },
    async LoadSalaryAccounts() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "salary-expense",
          "salary-payable",
          "holiday_salary",
          "leaves-session",
          "leaves-start-month",
          "leaves-end-month",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      let obj1 = res.find((el) => el.key == "salary-expense");
      let obj2 = res.find((el) => el.key == "salary-payable");
      let obj3 = res.find((el) => el.key == "holiday_salary");
      let obj4 = res.find((el) => el.key == "leaves-session");
      let obj5 = res.find((el) => el.key == "leaves-start-month");
      let obj6 = res.find((el) => el.key == "leaves-end-month");

      this.showLeavesSessionSettings = !!(obj4 && obj5 && obj6);
      this.leavesSessionObj = obj4 || null;
      this.leavesStartMonthObj = obj5 || null;
      this.leavesEndMonthObj = obj6 || null;

      if (!obj1) {
        this.salaryExpenseObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "salary-expense",
          value: "salary-expense",
          valueBool: true,
          valueNumber: 0,
        };
      } else this.salaryExpenseObj = obj1;
      if (!obj2) {
        this.salaryPayableObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "salary-payable",
          value: "salary-payable",
          valueBool: true,
          valueNumber: 0,
        };
      } else this.salaryPayableObj = obj2;

      if (!obj3) {
        this.holidaySalaryObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "holiday_salary",
          value: "holiday_salary",
          valueBool: false,
          valueNumber: 0,
        };
      } else this.holidaySalaryObj = obj3;
    },
    async LoadSessions() {
      try {
        const url = `https://apiv26.myskool.app/api/Sessions?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`;
        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
          },
          // Sessions only feed the (optional) session dropdowns; never let a slow
          // external host hold up the settings sidebar.
          timeout: 8000,
        });
        if (res.data && res.data.status === "success") {
          this.sessions = res.data.data || [];
        } else if (res.data && Array.isArray(res.data.data)) {
          this.sessions = res.data.data;
        } else if (Array.isArray(res.data)) {
          this.sessions = res.data;
        }
      } catch (e) {
        // console.error("Failed to load sessions", e);
      }
    },
    newLeavePolicyObjects() {
      const campusID = this.$store.state.userData.cId;
      return {
        leavesObj: {
          id: 0,
          tID: 0,
          departmentID: 0,
          categoy: "Leave Allowed",
          enabled: false,
          number: 0,
          option: "Monthly",
          campusID,
        },
        sickLeaveObj: {
          id: 0,
          tID: 0,
          departmentID: 0,
          categoy: "Sick Leave",
          enabled: false,
          number: 0,
          option: "Monthly",
          campusID,
        },
        maxObj: {
          id: 0,
          tID: 0,
          departmentID: 0,
          categoy: "Max Leave per Month",
          enabled: false,
          number: 0,
          option: "",
          campusID,
        },
      };
    },
    leaveRequiredState(value) {
      if (value === "" || value === null || value === undefined) return null;
      const re = /^[0-9]+$/;
      const x = parseInt(value, 10);
      return re.test(value) && !isNaN(x) && x >= 0;
    },
    leaveMaxState(row) {
      const value = row.maxObj.number;
      if (value === "" || value === null || value === undefined) return null;
      const re = /^[0-9]+$/;
      const x = parseInt(value, 10);
      const cl = parseInt(row.leavesObj.number, 10);
      return re.test(value) && !isNaN(x) && x > 0 && x <= cl;
    },
    leaveDeptOptions(row) {
      // Departments already used by another row are hidden, so each department has
      // exactly one policy (the backend upserts on campus+tID+department+category,
      // so duplicates would silently overwrite each other).
      const used = new Set(
        this.leavePolicyRows
          .filter((other) => other !== row && Number(other.departmentID) > 0)
          .map((other) => Number(other.departmentID))
      );
      const depts = (this.departments || []).filter(
        (d) => !used.has(Number(d.id))
      );
      // "All Departments" (id 0) is also unique - only offered when no other row
      // currently holds it. Any row, including the first one, may claim it.
      const allTakenByAnotherRow = this.leavePolicyRows.some(
        (other) => other !== row && Number(other.departmentID) === 0
      );
      if (allTakenByAnotherRow) return depts;
      return [{ name: "All Departments", id: 0 }, ...depts];
    },
    queueLeavePolicyRecordDeletes(row) {
      if (!row) return;
      [row.leavesObj, row.sickLeaveObj, row.maxObj].forEach((obj) => {
        if (!obj) return;
        const id = Number(obj.id);
        if (id > 0 && !this.leavePolicyPendingDelete.includes(id)) {
          this.leavePolicyPendingDelete.push(id);
        }
        obj.id = 0;
      });
    },
    onLeaveDeptChange(row, newDepID) {
      // Backend upserts on campus + tID + departmentID + category — changing
      // department must create new rows and remove the old department's records.
      const depID = Number(newDepID);
      const safeDepID = Number.isFinite(depID) ? depID : 0;
      const prevDepID = Number(row._prevDepartmentID);
      const hadPrev =
        row._prevDepartmentID !== undefined && row._prevDepartmentID !== null;

      if (hadPrev && prevDepID !== safeDepID) {
        this.queueLeavePolicyRecordDeletes(row);
      }

      row.departmentID = safeDepID;
      row.leavesObj.departmentID = safeDepID;
      row.sickLeaveObj.departmentID = safeDepID;
      row.maxObj.departmentID = safeDepID;
      row._prevDepartmentID = safeDepID;
    },
    onLeaveCategoryChange(row) {
      const yearly = row.leavesObj.option === "Yearly";
      row.maxObj.enabled = yearly;
      if (!yearly) row.maxObj.number = 0;
    },
    onAllowLeavesToggle(enabled) {
      this.leavePolicyRows.forEach((row) => {
        row.leavesObj.enabled = enabled;
        row.sickLeaveObj.enabled = enabled;
        if (!enabled) row.maxObj.enabled = false;
        else row.maxObj.enabled = row.leavesObj.option === "Yearly";
      });
    },
    buildLeavePolicyRows() {
      // Rows are filled by loadLeaveDeptPolicies + finalizeLeavePolicyRowsAfterLoad.
      // leavesObj / sickLeaveObj / maxObj always stay available for the master toggle.
      this.leavePolicyRows = [];
    },
    leavePoliciesAreDeptOnly() {
      return (
        Array.isArray(this.leavePolicyRows) &&
        this.leavePolicyRows.length > 0 &&
        this.leavePolicyRows.every((r) => Number(r.departmentID) > 0)
      );
    },
    finalizeLeavePolicyRowsAfterLoad() {
      const hasDeptOnly = this.leavePoliciesAreDeptOnly();
      if (hasDeptOnly) {
        // Campus (dept 0) may still exist in the API as the master on/off flag only.
        this.leavesObj.departmentID = 0;
        this.sickLeaveObj.departmentID = 0;
        this.maxObj.departmentID = 0;
        return;
      }

      const hasCampusRow = this.leavePolicyRows.some(
        (r) => (Number(r.departmentID) || 0) === 0
      );
      if (hasCampusRow) return;

      if (this.leavePolicyRows.length === 0) {
        const dep0 = Number(this.leavesObj.departmentID) || 0;
        this.leavesObj.departmentID = dep0;
        this.sickLeaveObj.departmentID = dep0;
        this.maxObj.departmentID = dep0;
        this.leavePolicyRows = [
          {
            uid: "leave-row-default",
            departmentID: dep0,
            _prevDepartmentID: dep0,
            includeMonths: this.parseIncludeMonthsFromPolicy(this.leavesObj),
            leavesObj: this.leavesObj,
            sickLeaveObj: this.sickLeaveObj,
            maxObj: this.maxObj,
          },
        ];
      }
    },
    addLeavePolicyRow() {
      const used = new Set(
        this.leavePolicyRows
          .map((r) => Number(r.departmentID))
          .filter((id) => id > 0)
      );
      // Only departments without a policy yet. Never fall back to 0
      // ("All Departments") - that slot belongs to the fallback row.
      const firstFree = (this.departments || []).find(
        (d) => !used.has(Number(d.id))
      );
      if (!firstFree) {
        this.$bvToast.toast("Every department already has a leave policy.", {
          title: this.$t("Info"),
          variant: "info",
          toaster: "b-toaster-top-right",
        });
        return;
      }
      const departmentID = Number(firstFree.id);

      const fresh = this.newLeavePolicyObjects();
      fresh.leavesObj.enabled = this.leavesObj.enabled;
      fresh.sickLeaveObj.enabled = this.leavesObj.enabled;
      fresh.leavesObj.option = this.leavesObj.option;
      fresh.sickLeaveObj.option = this.leavesObj.option;
      fresh.leavesObj.departmentID = departmentID;
      fresh.sickLeaveObj.departmentID = departmentID;
      fresh.maxObj.departmentID = departmentID;

      this.leavePolicyRows.push({
        uid: "leave-row-" + (this.leavePolicyRowSeq += 1),
        departmentID,
        _prevDepartmentID: departmentID,
        includeMonths: [],
        ...fresh,
      });
    },
    removeLeavePolicyRow(index) {
      const row = this.leavePolicyRows[index];
      if (!row) return;
      // Always keep at least one row so the policy list never renders empty.
      if (this.leavePolicyRows.length <= 1) return;

      // Defer the delete until Save succeeds, so cancelling the sidebar keeps the data.
      [
        row.leavesObj && row.leavesObj.id,
        row.sickLeaveObj && row.sickLeaveObj.id,
        row.maxObj && row.maxObj.id,
      ]
        .filter((id) => Number(id) > 0)
        .forEach((id) => {
          if (!this.leavePolicyPendingDelete.includes(Number(id))) {
            this.leavePolicyPendingDelete.push(Number(id));
          }
        });

      if (row.leavesObj === this.leavesObj) {
        this.leavesObj.id = 0;
        this.sickLeaveObj.id = 0;
        this.maxObj.id = 0;
        this.leavesObj.departmentID = 0;
        this.sickLeaveObj.departmentID = 0;
        this.maxObj.departmentID = 0;
      }

      this.leavePolicyRows.splice(index, 1);
    },
    async flushLeavePolicyDeletes() {
      const ids = this.leavePolicyPendingDelete.slice();
      if (!ids.length) return true;

      let allOk = true;
      for (const id of ids) {
        const ok = await this.delete({
          url:
            this.$store.state.domain +
            "SalaryPolicy/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          token: this.$store.state.userData.token,
          context: this,
          message: "Department leave policy removed.",
          grading: true,
        });
        if (!ok) allOk = false;
      }
      if (allOk) this.leavePolicyPendingDelete = [];
      return allOk;
    },
    async loadLeaveDeptPolicies() {
      const deptIds = (this.departments || [])
        .map((d) => Number(d.id))
        .filter((id) => id > 0);
      if (!deptIds.length) return;

      const base =
        this.$store.state.domain +
        "SalaryPolicy/LoadData?db=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&tID=0";

      const results = await Promise.all(
        deptIds.map(async (id) => {
          const res = await this.get({
            url: base + "&departmentID=" + id,
            token: this.$store.state.userData.token,
          });
          return { id, rows: Array.isArray(res) ? res : [] };
        })
      );

      const existingDeps = new Set(
        this.leavePolicyRows.map((r) => Number(r.departmentID) || 0)
      );

      results.forEach(({ id, rows }) => {
        if (existingDeps.has(id)) return;
        // LoadData also returns inherited copies of the default rows with id = 0;
        // only rows with a real id were saved for this department.
        const saved = rows.filter((r) => Number(r.id) > 0);
        if (!saved.length) return;

        const fresh = this.newLeavePolicyObjects();
        let found = false;

        saved.forEach((policy) => {
          const target =
            policy.categoy === "Leave Allowed"
              ? fresh.leavesObj
              : policy.categoy === "Sick Leave"
              ? fresh.sickLeaveObj
              : policy.categoy === "Max Leave per Month"
              ? fresh.maxObj
              : null;
          if (!target) return;
          Object.assign(target, policy, { departmentID: id });
          found = true;
        });

        if (found) {
          existingDeps.add(id);
          this.leavePolicyRows.push({
            uid: "leave-row-" + (this.leavePolicyRowSeq += 1),
            departmentID: id,
            _prevDepartmentID: id,
            includeMonths: this.parseIncludeMonthsFromPolicy(fresh.leavesObj),
            ...fresh,
          });
        }
      });
    },
    shouldSkipLeavePolicyRowOnSave(row) {
      const depID = Number(row.departmentID) || 0;
      if (depID !== 0) return false;
      const hasSavedIds = [row.leavesObj, row.sickLeaveObj, row.maxObj].some(
        (o) => Number(o && o.id) > 0
      );
      if (hasSavedIds) return false;
      return this.leavePolicyRows.some(
        (other) => other !== row && Number(other.departmentID) > 0
      );
    },
    buildLeavePolicySavePayload(row) {
      const depID = Number(row.departmentID) || 0;
      const campusID = this.$store.state.userData.cId;
      const enabledMaster = !!this.leavesObj.enabled;
      const payloads = [];

      const pushPolicy = (src, categoy, opts = {}) => {
        if (!src) return;
        const number = parseInt(src.number, 10);
        payloads.push({
          id: Number(src.id) || 0,
          tID: 0,
          departmentID: depID,
          categoy,
          enabled:
            opts.enabled !== undefined ? !!opts.enabled : !!src.enabled,
          number: Number.isNaN(number) ? 0 : number,
          option: String(src.option || ""),
          campusID: src.campusID || campusID,
          includeMonths: this.resolveLeavePolicyIncludeMonths(row, categoy),
        });
      };

      // Leave Allowed is stored per department (matches SalaryPolicy upsert keys).
      const depIsCampusDefault = depID === 0;
      pushPolicy(row.leavesObj, "Leave Allowed", {
        enabled: depIsCampusDefault
          ? enabledMaster
          : enabledMaster && !!row.leavesObj.enabled,
      });
      pushPolicy(row.sickLeaveObj, "Sick Leave", {
        enabled: enabledMaster && !!row.sickLeaveObj.enabled,
      });
      const yearly = row.leavesObj && row.leavesObj.option === "Yearly";
      pushPolicy(row.maxObj, "Max Leave per Month", {
        enabled: enabledMaster && yearly && !!row.maxObj.enabled,
      });

      return payloads;
    },

    setDate() {
      let d = this.rangeDate.split(" to ");
      this.settObj.dateFrom = d[0];
      this.settObj.dateTo = d[1];
      // console.log(this.rangeDate);
      // console.log(this.settObj.dateFrom, this.settObj.dateTo);
    },

    setHalfHint() {
      var elem = this.$refs["shortScale"];
      var re = /^[0-9]+$/;

      if (this.shortObj.number != "" && this.shortObj.number != 0) {
        if (re.test(this.shortObj.number) && this.shortObj.number > 0) {
          this.showHalfHint = true;
          return (elem.state = true);
        } else {
          this.showHalfHint = false;
          return (elem.state = false);
        }
      } else {
        this.showHalfHint = false;
        return (elem.state = false);
      }
    },
    setLateHint() {
      var elem = this.$refs["lateScale"];
      if (this.lateObj.number != "" && this.lateObj.number != 0) {
        var re = /^[0-9]+$/;

        if (re.test(this.lateObj.number) && this.lateObj.number > 0) {
          this.showLateHint = true;
          return (elem.state = true);
        } else {
          this.showLateHint = false;
          return (elem.state = false);
        }
      } else {
        this.showLateHint = false;
        return (elem.state = false);
      }
    },
    checkAllowed() {
      if (!this.leavesObj.enabled) return true;
      if (this.leavePoliciesAreDeptOnly()) {
        return this.checkLeavePolicyRows();
      }
      if (!this.leavesObj.option) return false;
      if (this.checkLeaves() == false) return false;
      if (this.leavesObj.option == "Yearly") return this.checkMaxLeave();
      return true;
    },
    checkLeaves() {
      const re = /^[0-9]+$/;
      const x = parseInt(this.leavesObj.number, 10);
      if (!re.test(this.leavesObj.number) || isNaN(x) || x < 0) {
        return false;
      }
      return true;
    },
    checkMaxLeave() {
      const re = /^[0-9]+$/;
      const x = parseInt(this.maxObj.number, 10);
      if (
        !re.test(this.maxObj.number) ||
        isNaN(x) ||
        x <= 0 ||
        x > this.leavesObj.number
      ) {
        return false;
      }
      return true;
    },
    checkLeavePolicyRows() {
      if (!this.leavesObj.enabled) return true;
      // Every row is a real policy, including the first one (it may point at a
      // department or at "All Departments"). Validate all of them uniformly.
      const rows = this.leavePolicyRows;
      if (!rows.length) return true;

      const seen = new Set();
      for (let i = 0; i < rows.length; i += 1) {
        const row = rows[i];
        const depID = Number(row.departmentID) || 0;
        if (seen.has(depID)) {
          this.$bvToast.toast(
            "Please select a different department for each leave policy.",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-right",
            }
          );
          return false;
        }
        seen.add(depID);

        if (!row.leavesObj.option) {
          this.$bvToast.toast("Please select a leave category.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          });
          return false;
        }

        const cl = parseInt(row.leavesObj.number, 10);
        const sl = parseInt(row.sickLeaveObj.number, 10);
        if (isNaN(cl) || cl < 0 || isNaN(sl) || sl < 0) {
          this.$bvToast.toast("Leave allowed values must be valid numbers.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          });
          return false;
        }

        if (row.leavesObj.option === "Yearly") {
          const ml = parseInt(row.maxObj.number, 10);
          if (isNaN(ml) || ml <= 0 || ml > cl) {
            this.$bvToast.toast(
              "Max leaves per month must be greater than 0 and not more than C.L Allowed.",
              {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-right",
              }
            );
            return false;
          }
        }
      }
      return true;
    },
    checkYear() {
      var elem = this.$refs["yearDate"];
      if (!this.rangeDate || !this.settObj.dateFrom || !this.settObj.dateTo) {
        return (elem.state = false);
      } else return (elem.state = true);
    },
    checkLate() {
      if (this.lateObj.enabled) {
        return this.setLateHint();
      } else return true;
    },
    checkShort() {
      if (this.shortObj.enabled) {
        return this.setHalfHint();
      } else return true;
    },
    checkFields() {
      setTimeout(() => {
        this.checkAtt();
      }, 200);
    },
    checkAtt() {
      if (this.attObj.enabled) {
        if (this.attObj.option == "Fixed amount") return this.checkAmount();
        else if (this.attObj.option == "Percentage") return this.checkPerc();
        // else return this.checkDays();
        else return true;
      } else return true;
    },
    checkAmount() {
      var elem = this.$refs["amount"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.attObj.number);
      if (!re.test(this.attObj.number) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPerc() {
      var elem = this.$refs["percentage"];
      // let x = parseFloat(this.attObj.number);
      var re = /^[0-9]+$/;
      let x = parseInt(this.attObj.number);
      if (!re.test(this.attObj.number) || isNaN(x) || x < 0 || x > 100) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkDays() {
      var elem = this.$refs["days"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.attObj.number);
      if (!re.test(this.attObj.number) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkMax() {
      if (this.encashObj.enabled) {
        var elem = this.$refs["maxEn"];
        var re = /^[0-9]+$/;
        let x = parseInt(this.encashObj.number);
        if (
          !re.test(this.encashObj.number) ||
          isNaN(x) ||
          x < 0 ||
          x > this.leavesObj.number
        ) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkPerMin() {
      if (this.minuteObj.enabled) {
        var elem = this.$refs["lateAmount"];
        var re = /^[0-9]+$/;
        let x = parseInt(this.minuteObj.number);
        if (!re.test(this.minuteObj.number) || isNaN(x) || x < 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      }
      return true;
    },
    setEarlyHint() {
      var elem = this.$refs["earlyScale"];
      if (this.earlyObj.number != "" && this.earlyObj.number != 0) {
        var re = /^[0-9]+$/;

        if (re.test(this.earlyObj.number) && this.earlyObj.number > 0) {
          this.showEarly = true;
          return (elem.state = true);
        } else {
          this.showEarly = false;
          return (elem.state = false);
        }
      } else {
        this.showEarly = false;
        return (elem.state = false);
      }
    },
    checkEarly() {
      if (this.earlyObj.enabled) {
        return this.setEarlyHint();
      } else return true;
    },
    getAllDepartmentIds() {
      return (this.departments || [])
        .map((dept) => Number(dept.id))
        .filter((id) => id > 0);
    },
    parseLeavesAllowedDeptIds(option) {
      if (!option) return [];
      return String(option)
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter((id) => !isNaN(id) && id > 0);
    },
    parseSandwichDeptIds(option) {
      if (option === null || option === undefined || option === "") {
        return [0];
      }
      const raw = String(option).trim();
      if (raw === "0") return [0];
      const ids = raw
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter((id) => !isNaN(id) && id > 0);
      return ids.length ? ids : [0];
    },
    loadSandwichDepartments() {
      this.sandwichDeptSelected = this.parseSandwichDeptIds(
        this.sandwichObj?.option
      );
    },
    setSandwichDep() {
      if (!Array.isArray(this.sandwichDeptSelected)) {
        this.sandwichDeptSelected = [this.sandwichDeptSelected];
      }
      if (this.sandwichDeptSelected.at(-1) === 0) {
        this.sandwichDeptSelected = [0];
      } else {
        this.sandwichDeptSelected = this.sandwichDeptSelected.filter(
          (el) => el !== 0
        );
        if (!this.sandwichDeptSelected.length) {
          this.sandwichDeptSelected = [0];
        }
      }
    },
    syncSandwichDeptOption() {
      if (!this.sandwichObj) return;
      if (!this.sandwichObj.enabled) return;
      this.setSandwichDep();
      const list = Array.isArray(this.sandwichDeptSelected)
        ? this.sandwichDeptSelected
        : [this.sandwichDeptSelected];
      if (!list.length || list.includes(0)) {
        this.sandwichObj.option = "0";
      } else {
        this.sandwichObj.option = list.join(",");
      }
    },
    checkSandwichDept() {
      if (!this.sandwichObj?.enabled) return true;
      this.syncSandwichDeptOption();
      const elem = this.$refs.sandwich_dept;
      if (elem) elem.state = true;
      return true;
    },
    parseAttDeptIds(option) {
      if (option === null || option === undefined || option === "") {
        return [0];
      }
      const raw = String(option).trim();
      if (raw === "" || raw === "0") return [0];
      const ids = raw
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter((id) => !isNaN(id) && id >= 0);
      if (!ids.length || ids.includes(0)) return [0];
      return ids;
    },
    loadAttDepartments() {
      this.attDeptSelected = this.parseAttDeptIds(this.attDeptObj?.option);
    },
    setAttDept() {
      if (!Array.isArray(this.attDeptSelected)) {
        this.attDeptSelected = [this.attDeptSelected];
      }
      // "All Departments" (0) is exclusive - picking it clears every other choice
      // (and picking a real department removes it).
      if (this.attDeptSelected.at(-1) === 0) {
        this.attDeptSelected = [0];
      } else {
        this.attDeptSelected = this.attDeptSelected.filter((el) => el !== 0);
        if (!this.attDeptSelected.length) {
          this.attDeptSelected = [0];
        }
      }
    },
    syncAttDeptOption() {
      if (!this.attDeptObj) return;
      this.setAttDept();
      const list = Array.isArray(this.attDeptSelected)
        ? this.attDeptSelected
        : [this.attDeptSelected];
      const ids = list.filter((id) => Number(id) > 0); // 0 = all departments
      this.attDeptObj.option = ids.length ? ids.join(",") : "0";
      // The backend treats a disabled row as "all departments"; keep the row enabled
      // whenever a specific department list is chosen so the filter actually applies.
      this.attDeptObj.enabled = ids.length > 0;
      this.attDeptObj.tID = 0;
      this.attDeptObj.departmentID = 0;
    },
    loadLeavesAllowedDepartments() {
      const savedIds = this.parseLeavesAllowedDeptIds(
        this.leavesAllowedDeptObj?.option
      );
      if (savedIds.length > 0) {
        this.leavesAllowedDeptSelected = savedIds;
      } else if (this.leavesAllowedDeptObj?.enabled) {
        this.leavesAllowedDeptSelected = this.getAllDepartmentIds();
      } else {
        this.leavesAllowedDeptSelected = [];
      }
    },
    onLeavesAllowedDeptToggle(enabled) {
      if (!enabled) return;
      if (
        !this.leavesAllowedDeptSelected ||
        this.leavesAllowedDeptSelected.length === 0
      ) {
        this.leavesAllowedDeptSelected = this.getAllDepartmentIds();
      }
    },
    syncLeavesAllowedDeptOption() {
      if (!this.leavesAllowedDeptObj) return;
      if (!this.leavesAllowedDeptObj.enabled) return;
      if (
        !this.leavesAllowedDeptSelected ||
        this.leavesAllowedDeptSelected.length === 0
      ) {
        this.leavesAllowedDeptSelected = this.getAllDepartmentIds();
      }
      this.leavesAllowedDeptObj.option =
        this.leavesAllowedDeptSelected.join(",");
    },
    buildLeavesAllowedDeptPayload() {
      this.syncLeavesAllowedDeptOption();
      const src = this.leavesAllowedDeptObj || {};
      return {
        id: src.id || 0,
        tID: src.tID || 0,
        departmentID: 0,
        categoy: "Leaves Allowed Department",
        enabled: !!src.enabled,
        number: 0,
        option: String(src.option || ""),
        campusID: src.campusID || this.$store.state.userData.cId,
      };
    },
    checkLeavesAllowedDept() {
      if (
        !this.showLeavesAllowedDepartment ||
        !this.leavesAllowedDeptObj?.enabled
      ) {
        return true;
      }
      this.syncLeavesAllowedDeptOption();
      const elem = this.$refs.leaves_allowed_dept;
      if (!this.leavesAllowedDeptSelected.length) {
        if (elem) elem.state = false;
        return false;
      }
      if (elem) elem.state = true;
      return true;
    },
    async saveSettings() {
      // console.log(this.settObj);
      if (
        this.checkAllowed() == false ||
        this.checkLate() == false ||
        this.checkShort() == false ||
        this.checkAtt() == false ||
        this.checkMax() == false ||
        this.checkPerMin() == false ||
        this.checkEarly() == false ||
        this.checkSandwichDept() == false ||
        this.checkLeavesAllowedDept() == false ||
        this.checkLeavePolicyRows() == false
      ) {
        this.$bvToast.toast(this.$t("Enter the details correctly!"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } else {
        this.saving = true;

        let tempData = [];
        if (this.salaryExpenseObj) tempData.push(this.salaryExpenseObj);
        if (this.salaryPayableObj) tempData.push(this.salaryPayableObj);

        if (this.showLeavesSessionSettings) {
          if (this.leavesSessionObj) tempData.push(this.leavesSessionObj);
          if (this.leavesStartMonthObj) tempData.push(this.leavesStartMonthObj);
          if (this.leavesEndMonthObj) tempData.push(this.leavesEndMonthObj);
        }

        if (tempData.length > 0) this.SaveSalaryAccounts(tempData);

        if (!this.leavesObj.number) this.leavesObj.number = 0;
        else this.leavesObj.number = parseInt(this.leavesObj.number);
        if (!this.sickLeaveObj.number) this.sickLeaveObj.number = 0;
        else this.sickLeaveObj.number = parseInt(this.sickLeaveObj.number);
        if (!this.lateObj.number) this.lateObj.number = 0;
        else this.lateObj.number = parseInt(this.lateObj.number);
        if (!this.shortObj.number) this.shortObj.number = 0;
        else this.shortObj.number = parseInt(this.shortObj.number);
        if (!this.attObj.number) this.attObj.number = 0;
        else this.attObj.number = parseInt(this.attObj.number);
        if (!this.encashObj.number) this.encashObj.number = 0;
        else this.encashObj.number = parseInt(this.encashObj.number);
        if (!this.maxObj.number) this.maxObj.number = 0;
        else this.maxObj.number = parseInt(this.maxObj.number);
        if (!this.maxSickObj.number) this.maxSickObj.number = 0;
        else this.maxSickObj.number = parseInt(this.maxSickObj.number);
        if (!this.minuteObj.number) this.minuteObj.number = 0;
        else this.minuteObj.number = parseInt(this.minuteObj.number);
        if (!this.earlyObj.number) this.earlyObj.number = 0;
        else this.earlyObj.number = parseInt(this.earlyObj.number);

        this.syncSandwichDeptOption();
        this.syncAttDeptOption();

        let saveObj = [
          this.lateObj,
          this.shortObj,
          this.attObj,
          this.encashObj,
          this.maxSickObj,
          this.minuteObj,
          this.earlyObj,
          this.sandwichObj,
          this.attDeptObj,
        ];
        // Leave policies are driven entirely by leavePolicyRows: one Leave Allowed /
        // Sick Leave / Max Leave per Month set per row. Each row carries its own
        // departmentID (0 = the general fallback used by departments with no override).
        // Row 0 is not special any more - the user may repoint it at a department.
        // Always sent (even when the feature is off) so disabling persists.
        this.leavePolicyRows.forEach((row) => {
          if (this.shouldSkipLeavePolicyRowOnSave(row)) return;
          saveObj.push(...this.buildLeavePolicySavePayload(row));
        });
        this.ensureCampusLeaveMasterOnSave(saveObj);
        if (this.showLeavesAllowedDepartment) {
          saveObj.push(this.buildLeavesAllowedDeptPayload());
        }
        saveObj = this.sanitizePolicySaveIncludeMonths(saveObj);
        // console.log(saveObj);

        var status = await this.post({
          url:
            this.$store.state.domain +
            "SalaryPolicy/SaveData?db=" +
            this.$store.state.userData.db,
          body: saveObj,
          message: "Salary Settings saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          await this.flushLeavePolicyDeletes();
          await this.LoadPolicies({ silent: true });
          await this.hydratePolicyObjects();
          this.showSettings = false;
        }
        this.saving = false;
      }
    },
    async SaveSalaryAccounts(data) {
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Settings/SaveNew?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: data,
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
    },

    openDetails() {
      // this.AddingInfo = [];
      // this.AddingInfo.push(this.salaryObj);
      this.showDetails = true;
    },

    sanitizeAllowancePayloadRows(source) {
      if (!source || !Array.isArray(source.allowances)) return;
      source.allowances.forEach((row) => {
        if (row && Object.prototype.hasOwnProperty.call(row, "allowanceDays")) {
          delete row.allowanceDays;
        }
      });
    },
    normalizeAllowanceRowDaysProp() {
      if (!this.mSalary || !Array.isArray(this.mSalary.allowances)) return;
      this.mSalary.allowances.forEach((item) => {
        if (item.allowanceDays === undefined || item.allowanceDays === null) {
          this.$set(item, "allowanceDays", 0);
        }
      });
    },
    applyStjacobAllowanceAmountFromDays(item) {
      if (!this.isMyskoolStJacobDomain || !item) return;
      const days = this.toNumber(item.allowanceDays);
      if (days <= 0) {
        this.$set(item, "amount", "");
        return;
      }
      const basic = this.toNumber(this.mSalary?.salary?.basicSalary);
      const wd = this.toNumber(this.mSalary?.salary?.workingDays);
      const divisor = wd > 0 ? wd : 30;
      if (basic <= 0) {
        this.$set(item, "amount", 0);
        return;
      }
      const perDay = basic / divisor;
      const raw = perDay * days;
      const dec = Number.isFinite(this.$store.state.decimal)
        ? this.$store.state.decimal
        : 2;
      this.$set(item, "amount", Number(raw.toFixed(dec)));
    },
    recalcStjacobAllowanceAmountsByDays() {
      if (!this.isMyskoolStJacobDomain || !this.mSalary?.allowances) return;
      this.mSalary.allowances.forEach((row) => {
        if (this.toNumber(row.allowanceDays) > 0) {
          this.applyStjacobAllowanceAmountFromDays(row);
        }
      });
    },

    changeAllow() {
      this.allowIDs = this.mSalary.allowances.reduce((acc, el) => {
        acc.push(el.staffAllowanceID);
        return acc;
      }, []);
      // console.log(this.allowIDs);
    },
    changeDed() {
      this.dedIDs = this.mSalary.deductions.reduce((acc, el) => {
        acc.push(el.staffDeductionID);
        return acc;
      }, []);
      // console.log(this.dedIDs);
    },
    AddDetail(item) {
      this.mSalary.allowances.push({
        id: 0,
        amount: 0,
        campusID: this.mSalary.salary.campusID,
        salaryID: this.mSalary.salary.id,
        tID: this.tID,
        staffAllowanceID: 0,
      });
    },
    async removeDetail(item, ind) {
      //console.log(ind, item);
      if (item.id == 0) {
        this.mSalary.allowances.splice(ind, 1);
        this.changeAllow();

        let curr = this.allowances.find((el) => el.id == item.staffAllowanceID);
        if (curr.title == "Deposit Return") this.mSalary.sdReturnIDs = [];
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "salaryAllowances/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.mSalary.allowances.splice(ind, 1);
          this.changeAllow();

          let curr = this.allowances.find(
            (el) => el.id == item.staffAllowanceID
          );
          if (curr.title == "Deposit Return") this.mSalary.sdReturnIDs = [];
        }
      }
    },
    AddDeduct(item) {
      this.mSalary.deductions.push({
        id: 0,
        amount: 0,
        campusID: this.mSalary.salary.campusID,
        salaryID: this.mSalary.salary.id,
        tID: this.tID,
        staffDeductionID: 0,
      });
    },
    async removeDeduct(item, ind) {
      if (item.id == 0) {
        this.mSalary.deductions.splice(ind, 1);
        this.changeDed();
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "salaryDeductions/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.mSalary.deductions.splice(ind, 1);
          this.changeDed();
        }
        // console.log(this.deductInfo);
      }
    },

    // Method to identify if deduction is Loan deduction or Advance return
    isLoanOrAdvanceDeduction(deductionID) {
      if (!deductionID) return false;
      const deduction = this.deductions.find((d) => d.id === deductionID);
      if (!deduction) return false;

      const title = deduction.title.toLowerCase();
      return (
        title.includes("loan deduction") ||
        title.includes("advance return") ||
        title.includes("loan") ||
        title.includes("advance")
      );
    },

    // Method to handle skip deduction
    async skipDeduction(item, index) {
      try {
        // Mark the deduction as skipped and set amount to 0
        this.$set(item, "skipped", true);
        this.$set(item, "skipDate", new Date().toISOString());
        this.$set(item, "amount", 0); // Set amount to 0 when skipped

        // Call SkipInstallments API
        const requestBody = {
          tID: this.tID,
          month: this.sal.month,
          year: this.sal.year,
          loanType: this.getLoanType(item),
        };

        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/SkipInstallments?db=" +
            this.$store.state.userData.db,
          body: requestBody,
          message: "Deduction skipped successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          // Show success message
          this.$bvToast.toast("Deduction skipped successfully.", {
            title: "Skipped",
            variant: "warning",
            solid: true,
          });
        }
      } catch (error) {
        // console.error("Error skipping deduction:", error);
        this.$bvToast.toast("Error skipping deduction", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      }
    },

    // Method to get loan type from deduction item
    getLoanType(item) {
      // Find the deduction title to determine loan type
      const deduction = this.deductions.find(
        (d) => d.id === item.staffDeductionID
      );
      if (deduction) {
        const title = deduction.title.toLowerCase();
        if (title.includes("loan")) {
          return "loan";
        } else if (title.includes("advance")) {
          return "advance";
        }
      }
      return "loan"; // Default to loan if not found
    },

    async openReturns() {
      if (
        this.sal.month &&
        this.sal.year &&
        this.checkWDays() == true &&
        this.checkPresent() == true &&
        this.checkAbsent() == true &&
        this.checkAttLeave() == true &&
        this.checkAttLate() == true &&
        this.checkAttHalf() == true &&
        this.checkBonus() == true &&
        this.checkEncashDays() == true &&
        this.checkEarlyDep() == true
      ) {
        if (this.checkSum() == false) {
          this.$bvToast.toast(
            "The total of present,absent & leave is greater than working days",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-right",
            }
          );
        } else if (this.CheckValues() == false) {
          this.$bvToast.toast(
            "Invalid amount entered on allowances or deductions",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-right",
            }
          );
        } else {
          this.returnLoading = true;

          this.mSalary.salary.workingDays = parseInt(
            this.mSalary.salary.workingDays
          );
          this.mSalary.salary.present = parseInt(this.mSalary.salary.present);
          this.mSalary.salary.absent = parseInt(this.mSalary.salary.absent);
          this.mSalary.salary.leave = parseInt(this.mSalary.salary.leave);
          this.mSalary.salary.late = parseInt(this.mSalary.salary.late);
          this.mSalary.salary.sickLeaves = parseInt(
            this.mSalary.salary.sickLeaves
          );
          this.mSalary.salary.shortLeave = parseInt(
            this.mSalary.salary.shortLeave
          );
          this.mSalary.salary.bonusDays = parseInt(
            this.mSalary.salary.bonusDays
          );
          this.mSalary.salary.leavesEncashed = parseInt(
            this.mSalary.salary.leavesEncashed
          );
          this.mSalary.salary.earlyDeparture = parseInt(
            this.mSalary.salary.earlyDeparture
          );

          // console.log(this.mSalary);
          this.mSalary = await this.postObj({
            url:
              this.$store.state.domain +
              "Salary/ReturnDeposit?db=" +
              this.$store.state.userData.db +
              this.salaryUserQuery(),
            body: this.mSalary,
            attendance: true,
            context: this,
            token: this.$store.state.userData.token,
          });
          this.returnLoading = false;

          this.CalculateSalary();
        }
      }

      // this.loadAllowances();
      // this.loadDeductions();
    },
    async saveReturns() {
      if (this.returnIDs.length > 0) {
        this.returnLoading = true;
        // console.log(this.returnIDs);
      } else {
        var elem = this.$refs["ret_deds"];
        elem.state = false;
      }
    },

    async singleHistory(item) {
      this.isLoan = false;
      this.isDeposit = false;
      this.showAtt = false;
      this.isHistory = true;
      this.isEncashmentHistory = false;
      this.isSalarySheet = false;
      this.currentHistoryStaff = item; // Store the staff being viewed
      this.historyStaffID = item.id;
      this.historyStaffCampusID = item.campusID || this.selectedCampus;
      this.historyPage = 1;
      this.resetHistoryPagingMode();
      this.searchQuery = "";
      this.historyFiltersHydrating = true;
      this.$set(this.history, "month", null);
      this.$set(this.history, "year", null);

      await this.loadHistoryPage();
      this.$nextTick(() => {
        this.historyFiltersHydrating = false;
      });
    },    getDefaultLeaveEncashmentMonths() {
      const start = Number(this.leavesStartMonthObj?.valueNumber);
      const end = Number(this.leavesEndMonthObj?.valueNumber);
      return {
        startMonth: !Number.isNaN(start) && start > 0 ? start : 7,
        endMonth: !Number.isNaN(end) && end > 0 ? end : 6,
      };
    },
    applyLeaveEncashmentSessionMonths() {
      const defaults = this.getDefaultLeaveEncashmentMonths();
      this.leaveEncashmentObj.startMonth = defaults.startMonth;
      this.leaveEncashmentObj.endMonth = defaults.endMonth;
    },
    onLeaveEncashmentSessionSelected(sessionID) {
      if (!sessionID) {
        this.leaveEncashmentObj.startMonth = null;
        this.leaveEncashmentObj.endMonth = null;
        this.clearLeaveEncashmentLoadData();
        return;
      }
      this.applyLeaveEncashmentSessionMonths();
      this.loadLeaveEncashmentAmount();
    },
    resolveAccountIdFromPayMode(payMode) {
      const mode = (payMode || "").trim();
      if (!mode || !this.accTypes || !this.accTypes.length) return null;

      const payModeLower = mode.toLowerCase();
      let selectedAccount = null;

      if (payModeLower === "cash") {
        selectedAccount = this.accTypes.find(
          (acc) => acc.account && acc.account.toLowerCase() === "cash"
        );
      } else if (payModeLower === "cheque" || payModeLower === "check") {
        selectedAccount = this.accTypes.find(
          (acc) =>
            acc.account &&
            (acc.account.toLowerCase() === "cheque" ||
              acc.account.toLowerCase() === "check")
        );
      } else if (payModeLower.startsWith("bank")) {
        selectedAccount = this.accTypes.find(
          (acc) => acc.account && acc.account.toLowerCase() === payModeLower
        );
        if (!selectedAccount) {
          selectedAccount = this.accTypes.find(
            (acc) => acc.account && acc.account.toLowerCase().includes("bank")
          );
        }
      } else {
        selectedAccount = this.accTypes.find(
          (acc) => acc.account && acc.account.toLowerCase() === payModeLower
        );
        if (!selectedAccount && payModeLower.includes("bank")) {
          selectedAccount = this.accTypes.find(
            (acc) => acc.account && acc.account.toLowerCase().includes("bank")
          );
        }
      }

      return selectedAccount ? selectedAccount.id : null;
    },
    resetLeaveEncashmentForm(staffItem) {
      const defaultSession = Number(this.leavesSessionObj?.valueNumber);
      const sessionID =
        !Number.isNaN(defaultSession) && defaultSession > 0
          ? defaultSession
          : null;
      const defaults = this.getDefaultLeaveEncashmentMonths();
      this.leaveEncashmentObj = {
        id: 0,
        staffID: staffItem.id,
        campusID: staffItem.campusID || this.$store.state.userData.cId,
        date: new Date().toISOString().slice(0, 10),
        sessionID,
        startMonth: sessionID ? defaults.startMonth : null,
        endMonth: sessionID ? defaults.endMonth : null,
        encashmentAmount: 0,
        leavesEncashed: 0,
        remaining_leaves: null,
        remaining_sickLeaves: null,
        accountID: null,
        notes: "",
      };
    },
    normalizeLeaveEncashmentDate(val) {
      if (val == null || val === "") return null;
      const s = String(val);
      if (s.includes("T")) return s.slice(0, 10);
      return s.length >= 10 ? s.slice(0, 10) : s;
    },
    resolveLeaveEncashmentSaveId(data) {
      if (!data || typeof data !== "object") return 0;
      const raw =
        data.encashmentID != null
          ? data.encashmentID
          : data.encashmentId != null
          ? data.encashmentId
          : null;
      if (raw == null || raw === "") return 0;
      const n = Number(raw);
      return !Number.isNaN(n) && n > 0 ? n : 0;
    },
    applyLeaveEncashmentLoadData(data) {
      if (!data || typeof data !== "object") return;

      this.leaveEncashmentObj.id = this.resolveLeaveEncashmentSaveId(data);
      this.leaveEncashmentObj.encashmentAmount =
        Number(data.encashmentAmount) || 0;
      const encashed =
        data.leavesEncashed != null
          ? data.leavesEncashed
          : data.leaves_encashed != null
          ? data.leaves_encashed
          : data.encashableLeaves != null
          ? data.encashableLeaves
          : 0;
      this.leaveEncashmentObj.leavesEncashed = Number(encashed) || 0;
      this.leaveEncashmentObj.remaining_leaves =
        data.remaining_leaves != null ? data.remaining_leaves : null;
      this.leaveEncashmentObj.remaining_sickLeaves =
        data.remaining_sickLeaves != null ? data.remaining_sickLeaves : null;

      const accountId = this.resolveAccountIdFromPayMode(data.payMode);
      if (accountId) this.leaveEncashmentObj.accountID = accountId;
    },
    clearLeaveEncashmentLoadData() {
      this.leaveEncashmentObj.id = 0;
      this.leaveEncashmentObj.encashmentAmount = 0;
      this.leaveEncashmentObj.leavesEncashed = 0;
      this.leaveEncashmentObj.remaining_leaves = null;
      this.leaveEncashmentObj.remaining_sickLeaves = null;
    },
    async openLeaveEncashment(item) {
      if (!this.showLeaveEncashmentTab) return;
      if (!this.sessions || !this.sessions.length) {
        await this.LoadSessions();
      }
      if (!this.accTypes || !this.accTypes.length) {
        await this.LoadAccounts();
      }
      this.resetLeaveEncashmentForm(item);
      this.leaveEncashmentStaffItem = item;
      this.leaveEncashmentStaffTitle = `${item.name} - ${
        item.designation || ""
      }`;
      this.visibility7 = true;
      if (this.leaveEncashmentObj.sessionID) {
        this.applyLeaveEncashmentSessionMonths();
        await this.loadLeaveEncashmentAmount();
      }
    },
    async loadLeaveEncashmentAmount() {
      const o = this.leaveEncashmentObj;
      if (!o.sessionID || !o.staffID) {
        this.clearLeaveEncashmentLoadData();
        return;
      }

      this.leaveEncashmentLoading = true;
      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          staffID: String(o.staffID),
          sessionID: String(o.sessionID),
          cID: String(o.campusID || this.$store.state.userData.cId),
        });
        if (o.startMonth) params.set("startMonth", String(o.startMonth));
        if (o.endMonth) params.set("endMonth", String(o.endMonth));

        const res = await this.get({
          url:
            this.$store.state.domain +
            "StaffLeaveEncashment/loadEncashmentAmount?" +
            params.toString(),
          token: this.$store.state.userData.token,
          returnData: true,
        });

        let data = res;
        if (res && res.data && typeof res.data === "object") {
          data =
            res.data.status === "success" && res.data.data
              ? res.data.data
              : res.data.data || res.data;
        } else if (res && res.status === "success" && res.data) {
          data = res.data;
        }

        this.applyLeaveEncashmentLoadData(data);
      } catch (e) {
        // console.warn("loadEncashmentAmount", e);
        this.clearLeaveEncashmentLoadData();
        this.$bvToast.toast("Failed to load leave encashment amount.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } finally {
        this.leaveEncashmentLoading = false;
      }
    },
    buildLeaveEncashmentSlipQuery(source) {
      const row = source || {};
      const dept =
        row.department && typeof row.department === "object"
          ? row.department.name
          : row.department || this.encashmentDepartmentName(row);
      return {
        db: this.$store.state.userData.db,
        cID: String(row.campusID || this.$store.state.userData.cId),
        rfID: String(row.rfID || row.staffID || ""),
        name: row.name || "",
        designation: row.designation || "",
        department: dept && dept !== "—" ? dept : "",
        date: this.normalizeLeaveEncashmentDate(row.date) || "",
        encashmentAmount: String(row.encashmentAmount ?? ""),
        remaining_leaves:
          row.remaining_leaves != null && row.remaining_leaves !== ""
            ? String(row.remaining_leaves)
            : row.remainingLeaves != null && row.remainingLeaves !== ""
            ? String(row.remainingLeaves)
            : "",
        remaining_sickLeaves:
          row.remaining_sickLeaves != null && row.remaining_sickLeaves !== ""
            ? String(row.remaining_sickLeaves)
            : row.remainingSickLeaves != null && row.remainingSickLeaves !== ""
            ? String(row.remainingSickLeaves)
            : "",
        notes: (row.notes || "").trim(),
      };
    },
    buildLeaveEncashmentSlipQueryFromForm() {
      const o = this.leaveEncashmentObj;
      const staff = this.leaveEncashmentStaffItem || {};
      return {
        rfID: staff.rfID,
        staffID: staff.id || o.staffID,
        name: staff.name || "",
        designation: staff.designation || "",
        department: staff.department,
        departmentID: staff.departmentID,
        campusID: o.campusID || staff.campusID,
        date: o.date,
        encashmentAmount: o.encashmentAmount,
        remaining_leaves: o.remaining_leaves,
        remaining_sickLeaves: o.remaining_sickLeaves,
        notes: o.notes,
      };
    },
    openLeaveEncashmentSlip(source, autoPrint = false) {
      const query = this.buildLeaveEncashmentSlipQuery(source || {});
      if (autoPrint) query.autoPrint = "1";
      const route = this.$router.resolve({
        name: "leave-encashment-slip",
        query,
      });
      window.open(route.href, "_blank");
    },
    async saveLeaveEncashment(printAfterSave = false) {
      const o = this.leaveEncashmentObj;
      if (!o.date) {
        this.$bvToast.toast("Please select date.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return;
      }
      if (!o.sessionID) {
        this.$bvToast.toast("Please select session.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return;
      }
      if (!o.accountID) {
        this.$bvToast.toast("Please select salary from account.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return;
      }
      const encashmentAmount = Number(o.encashmentAmount);
      if (Number.isNaN(encashmentAmount) || encashmentAmount < 0) {
        this.$bvToast.toast("Leave encashment amount is not available.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return;
      }
      const leavesEncashed = Number(o.leavesEncashed);
      if (Number.isNaN(leavesEncashed) || leavesEncashed < 0) {
        this.$bvToast.toast("Leaves encashed count is not available.", {
          title: "Validation",
          variant: "warning",
          toaster: "b-toaster-top-right",
        });
        return;
      }

      const payload = {
        id: Number(o.id) || 0,
        staffID: Number(o.staffID),
        campusID: Number(o.campusID || this.$store.state.userData.cId),
        sessionID: Number(o.sessionID),
        date: this.normalizeLeaveEncashmentDate(o.date),
        encashmentAmount,
        leavesEncashed,
        accountID: Number(o.accountID),
        notes: (o.notes || "").trim(),
      };

      this.leaveEncashmentSaving = true;
      try {
        const status = await this.post({
          url:
            this.$store.state.domain +
            "StaffLeaveEncashment/Save?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: payload,
          message: "Leave encashment saved successfully.",
          context: this,
          token: this.$store.state.userData.token,
          showError: true,
        });
        if (status) {
          if (printAfterSave) {
            this.openLeaveEncashmentSlip(
              this.buildLeaveEncashmentSlipQueryFromForm(),
              true
            );
          }
          this.visibility7 = false;
        }
      } finally {
        this.leaveEncashmentSaving = false;
      }
    },
    onClearListView() {
      if (this.isDeposit || this.isLoan) {
        this.closeDepositLoan();
        return;
      }
      if (this.showAtt) {
        this.closeAttendance();
        return;
      }
      if (this.isHistory || this.isEncashmentHistory || this.isSalarySheet) {
        this.isHistory = false;
        this.isEncashmentHistory = false;
        this.isSalarySheet = false;
        this.currentHistoryStaff = null;
        this.historyStaffID = 0;
        this.historyStaffCampusID = 0;
        this.LoadData();
        return;
      }
      this.LoadData();
    },
    markStaffListStale() {
      this.staffListNeedsRefresh = true;
    },
    invalidateStaffSelectedCache(staffId) {
      const id = Number(staffId);
      if (!id) return;
      if (this.staffSelectedCache[id]) {
        this.$delete(this.staffSelectedCache, id);
      }
    },
    syncStaffSelectedCacheFromCurrent() {
      const id =
        this.currentStaff &&
        this.currentStaff.staff &&
        Number(this.currentStaff.staff.id);
      if (!id || !this.currentStaff.staff) return;
      const base =
        (this.staffSelectedCache[id] && this.staffSelectedCache[id].data) ||
        this.currentStaff;
      const next = {
        ...base,
        staff: this.currentStaff.staff,
        securityDepositGrid: [...(this.depositDetails || [])],
        securityDeposit: [...(this.depoSaveList || [])],
        advanceAndLoans: [...(this.loanData || [])],
        loanDetails: [...(this.loanDetails || [])],
      };
      this.$set(this.staffSelectedCache, id, {
        fetchedAt: Date.now(),
        data: next,
      });
    },
    applyStaffSelectedResponse(res) {
      this.currentStaff = res;
      this.loanData = res.advanceAndLoans || [];
      this.loanDetails = res.loanDetails || [];
      this.depositDetails = res.securityDepositGrid || [];
      this.depoSaveList = res.securityDeposit || [];
      const id = res && res.staff && res.staff.id;
      if (id) {
        this.$set(this.staffSelectedCache, Number(id), {
          fetchedAt: Date.now(),
          data: res,
        });
      }
    },
    async loadSelectedStaff(staffId, { useCache = true } = {}) {
      const id = Number(staffId);
      if (!id) return;

      if (useCache) {
        const cached = this.staffSelectedCache[id];
        if (
          cached &&
          cached.data &&
          Date.now() - cached.fetchedAt < this.staffSelectedCacheTtlMs
        ) {
          this.applyStaffSelectedResponse(cached.data);
          return;
        }
      }

      this.otherLoading = true;
      try {
        var res = await this.get({
          url:
            this.$store.state.domain +
            "staff/LoadSelectedStaff?db=" +
            this.$store.state.userData.db +
            "&id=" +
            id,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.applyStaffSelectedResponse(res);
      } finally {
        this.otherLoading = false;
      }
    },
    async reloadCurrentStaffDetail() {
      const id =
        this.currentStaff &&
        this.currentStaff.staff &&
        Number(this.currentStaff.staff.id);
      if (!id) return;
      this.invalidateStaffSelectedCache(id);
      await this.loadSelectedStaff(id, { useCache: false });
    },
    restoreStaffListView() {
      this.isDeposit = false;
      this.isLoan = false;
      this.showAtt = false;
      this.currentStaff = {};
      this.stCurrent = {};
      this.depositDetails = [];
      this.loanData = [];
      this.loanDetails = [];
      this.depoSaveList = [];
      this.calendarOptions.events = [];
      this.attLoading = false;

      if (this.staffListNeedsRefresh) {
        this.staffListNeedsRefresh = false;
        return this.LoadData();
      }
      return Promise.resolve();
    },
    async showOthers(id, text, options = {}) {
      this.isHistory = false;
      this.isEncashmentHistory = false;
      this.isSalarySheet = false;
      this.showAtt = false;

      if (text == "Advance / Loan") this.isLoan = true;
      else this.isDeposit = true;

      const staffId = Number(id);
      const forceRefresh = options.forceRefresh === true;
      if (forceRefresh) {
        this.invalidateStaffSelectedCache(staffId);
      }
      await this.loadSelectedStaff(staffId, { useCache: !forceRefresh });
    },
    /* Leaves the deposit/loan detail view and returns to the staff list.
       Uses LoadData (not openHistory) because that is where the user came from. */
    closeDepositLoan() {
      this.restoreStaffListView();
    },
    closeAttendance() {
      this.restoreStaffListView();
    },
    viewProfile(item) {
      const routeData = this.$router.resolve({
        name: this.$store.state.rights["manage-staff"]?.singlePage
          ? "manage-staff-accounts"
          : "manage-staff",
        params: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    async Edit(item, depID) {
      this.currentCampusID = item.campusID;
      this.sunmonDepID = depID;
      this.skipUtilizeableLeaves = false; // Reset toggle when switching to new teacher
      if (this.sunObj && this.sunmonDepID != 9) {
        this.sunmonValue = true;
      } else this.sunmonValue = false;
      // console.log("THis is", this.sunmonDepID, this.sunmonValue, item, depID);

      this.tID = item.id;
      this.mSalary = {
        allowances: [],
        deductions: [],
        advanceIDs: [],
        loanIDs: [],
        sdIDs: [],
        isUpdate: false,
        mode: "new",
        salary: {
          absent: 0,
          absentDeductionCount: 0,
          shortLeaveDeductionCount: 0,
          lateDeductionCount: 0,
          accountID: 0,
          basicSalary: 0,
          campusID: 0,
          date: this.$store.state.salPaymentDate,
          grossSalary: 0,
          id: 0,
          late: 0,
          leave: 0,
          month: 0,
          monthYear: "",
          netSalary: 0,
          note: null,
          present: 0,
          shortLeave: 0,
          tID: 0,
          totalAllownaces: 0,
          totalDedcutions: 0,
          workingDays: 0,
          year: 0,
          utilizeableLeaves: 0,
          remainingLeaves: 0,
          bonusDaysAmount: 0,
          bonusDays: 0,
          leavesEncashed: 0,
          leavesEncashementAmount: 0,
          securityDeposit: 0,
          loanDeduction: 0,
          advanceDeduction: 0,
          shortLeaveDeductionCount: 0,
          lateDeductionCount: 0,
          departmentID: depID,
          grossPayable: 0,
          earlyDeparture: 0,
          branchID: 0,
          sickLeave: 0,
          salaryPaymentDate: null,
          paid: null,
        },
        maxLeavePerMonth: 0,
        remainingLeaves: 0,
        utilizeableLeaves: 0,
        maxSickLeavesPerMonth: 0,
        remainingSickLeaves: 0,
        utilizeableSickLeaves: 0,
      };

      this.sal.month = this.$store.state.monthNo;
      this.sal.year = this.$store.state.salYear;

      if (this.reportDomain == "myskoolhpgs") {
        const today = new Date();
        // 0-11 where 0 is January, for our month array it will be previous month
        let prevMonth = today.getMonth();
        this.sal.month = prevMonth === 0 ? 12 : prevMonth;
        this.sal.year =
          prevMonth === 0 ? today.getFullYear() - 1 : today.getFullYear();

        this.currentDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        ).toJSON();

        this.$store.commit("setSalPaymentDate", this.currentDate);
      }
      this.LoadSalary();

      this.visibility = true;

      this.mSalary.allowances = [
        {
          id: 0,
          amount: 0,
          campusID: item.campusID,
          salaryID: this.mSalary.salary.id,
          tID: this.tID,
          staffAllowanceID: 0,
        },
      ];

      this.mSalary.deductions = [
        {
          id: 0,
          amount: 0,
          campusID: item.campusID,
          salaryID: this.mSalary.salary.id,
          tID: this.tID,
          staffDeductionID: 0,
        },
      ];

      this.setSidebarStaffMeta({
        name: item.name,
        designation: item.designation,
        appointedOn: item.appointedOn,
      });
      this.sidebarButton = "Save";
    },
    async EditSalary(item, depID) {
      this.currentCampusID = item.us.campusID;
      this.sunmonDepID = depID;
      this.skipUtilizeableLeaves = false; // Reset toggle when switching to new teacher
      if (this.sunObj && this.sunmonDepID != 9) {
        this.sunmonValue = true;
      } else this.sunmonValue = false;
      this.tID = item.us.tID;
      this.mSalary = {
        allowances: [],
        deductions: [],
        advanceIDs: [],
        loanIDs: [],
        sdIDs: [],
        isUpdate: false,
        mode: "new",
        salary: {
          absent: 0,
          absentDeductionCount: 0,
          shortLeaveDeductionCount: 0,
          lateDeductionCount: 0,
          accountID: 0,
          basicSalary: 0,
          campusID: 0,
          date: this.$store.state.salPaymentDate,
          grossSalary: 0,
          id: 0,
          late: 0,
          leave: 0,
          month: 0,
          monthYear: "",
          netSalary: 0,
          note: null,
          present: 0,
          shortLeave: 0,
          tID: 0,
          totalAllownaces: 0,
          totalDedcutions: 0,
          workingDays: 0,
          year: 0,
          utilizeableLeaves: 0,
          remainingLeaves: 0,
          bonusDaysAmount: 0,
          bonusDays: 0,
          leavesEncashed: 0,
          leavesEncashementAmount: 0,
          securityDeposit: 0,
          loanDeduction: 0,
          advanceDeduction: 0,
          shortLeaveDeductionCount: 0,
          lateDeductionCount: 0,
          departmentID: depID,
          grossPayable: 0,
          earlyDeparture: 0,
          branchID: 0,
          sickLeave: 0,
          salaryPaymentDate: null,
          paid: null,
        },
        maxLeavePerMonth: 0,
        remainingLeaves: 0,
        utilizeableLeaves: 0,
        maxSickLeavesPerMonth: 0,
        remainingSickLeaves: 0,
        utilizeableSickLeaves: 0,
      };
      this.mSalary.salary = item.us;
      this.sal.month = item.us.month;
      this.sal.year = item.us.year;
      this.currentDate = this.mSalary.salary.date;
      this.LoadSalary();

      this.visibility = true;

      this.mSalary.allowances = [
        {
          id: 0,
          amount: 0,
          campusID: item.us.campusID,
          salaryID: this.mSalary.salary.id,
          tID: this.tID,
          staffAllowanceID: 0,
        },
      ];

      this.mSalary.deductions = [
        {
          id: 0,
          amount: 0,
          campusID: item.us.campusID,
          salaryID: this.mSalary.salary.id,
          tID: this.tID,
          staffDeductionID: 0,
        },
      ];
      this.setSidebarStaffMeta({
        name: item.st.name,
        designation: item.st.designation,
        appointedOn: item.st.appointedOn,
      });
      this.sidebarButton = "Save";
      this.LoadData();
    },
    setTillDate(item) {
      let d = new Date(item.dateFrom);
      item.dateTo = d.setFullYear(d.getFullYear() + 1);
      // console.log(this.policyObj);
    },

    AddPolicy(item) {
      if (item.type != "" && item.days !== "") {
        if (item.type == "yearly" && item.dateFrom) {
          let d = new Date(item.dateTo);

          let newfrom = new Date(d);
          newfrom.setDate(d.getDate() + 1);

          let newto = new Date(newfrom);
          newto.setFullYear(newfrom.getFullYear() + 1);

          this.policyObj.push({
            id: 0,
            tID: this.myObj.id,
            type: "yearly",
            month: "",
            dateFrom: newfrom.toISOString().split("T")[0],
            dateTo: newto.toISOString().split("T")[0],
            days: 0,
            campusID: this.$store.state.userData.cId,
          });
        } else if (item.type == "monthly" && item.month != "") {
          let currentDate = new Date(`1 ${item.month} 2000`);
          currentDate.setMonth(currentDate.getMonth() + 1);
          let nextMonthString = currentDate.toLocaleString("default", {
            month: "long",
          });

          this.policyObj.push({
            id: 0,
            tID: this.myObj.id,
            type: "monthly",
            month: nextMonthString,
            dateFrom: null,
            dateTo: null,
            days: 0,
            campusID: this.$store.state.userData.cId,
          });
        }
      }
      // console.log(this.policyObj);
    },
    removePolicy(ind) {
      this.policyObj.splice(ind, 1);
    },
    checkBonus() {
      var elem = this.$refs["bDays"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.bonusDays);
      if (!re.test(this.mSalary.salary.bonusDays) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkEncashDays() {
      var elem = this.$refs["bDays"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.leavesEncashed);
      if (!re.test(this.mSalary.salary.leavesEncashed) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkWDays() {
      var elem = this.$refs["wDays"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.workingDays);
      if (!re.test(this.mSalary.salary.workingDays) || isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPresent() {
      var elem = this.$refs["present"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.present);
      if (!re.test(this.mSalary.salary.present) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkAbsent() {
      var elem = this.$refs["absent"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.absent);
      if (!re.test(this.mSalary.salary.absent) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkAttLeave() {
      var elem = this.$refs["leave"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.leave);
      if (!re.test(this.mSalary.salary.leave) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkAttLate() {
      var elem = this.$refs["late"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.late);
      if (!re.test(this.mSalary.salary.late) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkAttHalf() {
      var elem = this.$refs["half"];
      var re = /^[0-9]+$/;
      let x = parseInt(this.mSalary.salary.shortLeave);
      if (!re.test(this.mSalary.salary.shortLeave) || isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkEarlyDep() {
      if (["myskoolhpgs"].includes(this.reportDomain)) {
        var elem = this.$refs["earlyDep"];
        let x = parseInt(this.mSalary.salary.earlyDeparture);

        if (isNaN(x) || x < 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else {
        this.mSalary.salary.earlyDeparture = 0;
        return true;
      }
    },
    checkSum() {
      let total =
        parseInt(this.mSalary.salary.present) +
        parseInt(this.mSalary.salary.absent) +
        parseInt(this.mSalary.salary.leave);
      // console.log(
      //   total,
      //   total > this.mSalary.salary.workingDays,
      //   total < this.mSalary.salary.workingDays
      // );
      return total <= this.mSalary.salary.workingDays;
    },
    CheckValues() {
      let state = true;
      this.mSalary.allowances = this.mSalary.allowances.filter(
        (el) => el.staffAllowanceID != 0
      );
      this.mSalary.allowances.forEach((el) => {
        el.amount = parseInt(el.amount);
        if (isNaN(el.amount) || el.amount < 0) {
          state = false;
        }
      });

      this.mSalary.deductions = this.mSalary.deductions.filter(
        (el) => el.staffDeductionID != 0
      );
      this.mSalary.deductions.forEach((el) => {
        el.amount = parseInt(el.amount);
        if (isNaN(el.amount) || el.amount < 0) {
          state = false;
        }
      });

      return state;
    },

    hideSideBar() {
      this.visibility = false;
    },
    async getBranches(accID, campID) {
      var obj = {
        url:
          this.$store.state.domain +
          "CollectionAccountBranch/LoadData?db=" +
          this.$store.state.userData.db +
          "&accID=" +
          accID +
          "&campID=" +
          campID,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      return res;
    },
    async setBranches() {
      let item = this.accTypes.find(
        (el) => el.id == this.mSalary.salary.accountID
      );
      if (
        item &&
        !["cash", "cheque", "paypro", "online"].some((word) =>
          item.account.toLowerCase().includes(word)
        )
      ) {
        this.disBranch = false;
        this.branchLoading = true;

        let res = await this.getBranches(item.id, this.mSalary.salary.campusID);

        if (res.status == "success") {
          this.branchOptions = res.data;
        }
        this.branchLoading = false;
      } else this.disBranch = true;
    },
    async LoadBranches() {
      this.mSalary.salary.branchID = 0;
      this.branchOptions = [];
      let item = this.accTypes.find(
        (el) => el.id == this.mSalary.salary.accountID
      );
      if (
        item &&
        !["cash", "cheque", "paypro", "online"].some((word) =>
          item.account.toLowerCase().includes(word)
        )
      ) {
        this.disBranch = false;
        this.branchLoading = true;

        let res = await this.getBranches(item.id, this.mSalary.salary.campusID);

        if (res.status == "success") {
          this.branchOptions = res.data;
          this.mSalary.salary.branchID = res.selectedID;
        }
        this.branchLoading = false;
      } else this.disBranch = true;
    },
    async LoadAccBranch() {
      this.payroll.branchID = 0;
      this.accBranches = [];
      let item = this.accTypes.find((el) => el.id == this.payroll.accountID);
      if (
        item &&
        !["cash", "cheque", "paypro", "online"].some((word) =>
          item.account.toLowerCase().includes(word)
        )
      ) {
        this.disAccBranch = false;
        this.accBranchLoading = true;

        let res = await this.getBranches(item.id, item.campusID);

        if (res.status == "success") {
          this.accBranches = res.data;
          this.payroll.branchID = res.selectedID;
        }
        this.accBranchLoading = false;
      } else this.disAccBranch = true;
    },
    async LoadAccounts() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "CollectionAccounts?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.accTypes = await this.get(obj2);
      // console.log("acc", this.accTypes);
    },
    async loadAllowances() {
      var obj = {
        url:
          this.$store.state.domain +
          "Allowances?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allowances = await this.get(obj);
    },
    async loadDeductions() {
      var obj = {
        url:
          this.$store.state.domain +
          "Deductions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.deductions = await this.get(obj);
      this.deductions = this.deductions.filter((el) => !el.isHidden);
    },
    /** myskooliuss: staff list oldest appointedOn → newest */
    sortStaffByAppointedOn(list) {
      if (!Array.isArray(list)) return [];
      return [...list].sort((a, b) => {
        const ta = a?.appointedOn ? new Date(a.appointedOn).getTime() : NaN;
        const tb = b?.appointedOn ? new Date(b.appointedOn).getTime() : NaN;
        const aMissing = Number.isNaN(ta);
        const bMissing = Number.isNaN(tb);
        if (aMissing && bMissing) return 0;
        if (aMissing) return 1;
        if (bMissing) return -1;
        return ta - tb;
      });
    },
    async LoadData(options = {}) {
      const keepView = options && options.keepView === true;
      this.dataLoading = true;
      if (!keepView) {
        this.isHistory = false;
        this.isEncashmentHistory = false;
        this.isSalarySheet = false;
        this.isDeposit = false;
        this.isLoan = false;
        this.showAtt = false;
      }
      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "staff/LoadDataPagination?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.selectedCampus +
          "&dptID=" +
          this.currentDep +
          "&status=" +
          this.getStaffListStatusParam() +
          "&page=" +
          this.currentPage +
          "&sortBy=" +
          this.sortBy +
          "&sortOrder=" +
          this.sortOrder,
        token: this.$store.state.userData.token,
        dashboard: true,
      });
      this.items = myitem.data;
      if (this.reportDomain === "myskooliuss") {
        this.items = this.sortStaffByAppointedOn(this.items);
      }
      this.totalCount = myitem.count;
      this.dataLoading = false;
      this.staffListNeedsRefresh = false;
      // console.log("items", this.items);
    },
    async loadSearch() {
      if (this.searchQuery.trim() == "") {
        this.currentPage = 1;
        this.LoadData();
      } else {
        this.dataLoading = true;
        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "staff/Search?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&keyword=" +
            this.searchQuery +
            "&status=" +
            this.getStaffListStatusParam(),
          token: this.$store.state.userData.token,
        });
        this.items = myitem;
        if (this.reportDomain === "myskooliuss") {
          this.items = this.sortStaffByAppointedOn(this.items);
        }
        this.totalCount = 0;
        this.currentPage = 1;
        this.dataLoading = false;

        // auto open create salary for first searched item
        if (
          ["myskoolhpgs"].includes(this.reportDomain) &&
          this.items.length > 0
        ) {
          let obj = this.items[0];
          this.Edit(obj, obj.departmentID);
        }
      }
    },
    async loadDep() {
      this.departments = await this.get({
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
    },
    async LoadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "sunmon",
          "double_entry",
          "double-absent",
          "head_office",
          "holiday_salary",
          "dynamic_leave_balance",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.sunObj = res.find((el) => el.key == "sunmon");
      // console.log(this.sunObj);
      this.entryObj = res.find(
        (el) => el.key.replace(/\r\n/g, "") == "double_entry"
      );
      // console.log(this.entryObj);
      this.doubleObj = res.find((el) => el.key == "double-absent");
      // console.log(this.doubleObj);
      this.isHeadOffice = res.find((el) => el.key == "head_office");
      this.holidaySalaryObj = res.find((el) => el.key == "holiday_salary");
      this.dynamicLeaveBalanceSetting =
        res.find((el) => el.key === "dynamic_leave_balance") || null;
      if (
        this.isHeadOffice ||
        [
          "myskoolhpgs",
          "myskoolelixir",
          "myskoolalhameed",
          "myskoolngs",
          "myskoolkentschool",
          "myskooliuss",
          "myskoolwhss",
          "myskoolprofectus",
          "myskoolroyal",
          "myskooltrainerned",
          "myskoolcrestviewacademy",
        ].includes(this.reportDomain)
      ) {
        this.LoadCampuses();
      }
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: [
          "sd_amount_edit",
          "salary_ledger",
          "leave_encashment_tab",
          "salary_sheet_tab",
          "staff_left_salary",
          "dynamic_leave_balance",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.sdObj = res.find((el) => el.key == "sd_amount_edit");
      this.salaryLedgerObj = res.find((el) => el.key == "salary_ledger");
      this.leaveEncashmentTabObj = res.find(
        (el) => el.key == "leave_encashment_tab"
      );
      this.salarySheetTabObj = res.find((el) => el.key == "salary_sheet_tab");
      this.staffLeftSalaryObj = res.find((el) => el.key == "staff_left_salary");
      const dynamicLeaveSetting = res.find(
        (el) => el.key === "dynamic_leave_balance"
      );
      if (dynamicLeaveSetting) {
        this.dynamicLeaveBalanceSetting = dynamicLeaveSetting;
      }
    },

    getStaffListStatusParam() {
      if (!this.showStaffLeftSalaryFilter) return "present";
      const s = String(this.staffStatusFilter || "present")
        .toLowerCase()
        .trim();
      return s === "left" ? "left" : "present";
    },

    onStaffStatusFilterChange() {
      this.currentPage = 1;
      this.searchQuery = "";
      this.LoadData();
    },

    async LoadPolicies({ silent = false } = {}) {
      if (!silent) this.settLoading = true;

      const res = await this.get({
        url:
          this.$store.state.domain +
          "SalaryPolicy/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&tID=0",
        token: this.$store.state.userData.token,
      });
      this.settingData = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
        ? res.data
        : [];
      this.policiesUIReady = false;
      // console.log(this.settingData);

      if (!silent) this.settLoading = false;
    },

    async Add() {
      /* console.log(
        this.myObj,
        this.sal,
        this.attCount,
        this.deductInfo,
        this.AddingInfo
      ); */
    },
    setMaxSickLeaves() {
      if (this.sickLeaveObj.option == "Yearly") {
        this.maxSickObj.enabled = true;
      } else this.maxSickObj.enabled = false;
      // console.log(this.maxObj);
    },
    openHalfDayPolicy() {
      // Initialize default values
      this.halfDayPolicy = {
        departmentID: 0,
        startTime: "", // Let user manually select
        endTime: "", // Let user manually select
        hours: 0,
        description: "",
      };
      // Open the sidebar
      this.visibility6 = true;
    },
    saveHalfDayPolicy() {
      // Validate required fields
      if (
        this.halfDayPolicy.departmentID === null ||
        this.halfDayPolicy.departmentID === undefined
      ) {
        this.$bvToast.toast("Please select a department!", {
          title: "Validation Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
        return;
      }

      if (!this.halfDayPolicy.startTime || !this.halfDayPolicy.endTime) {
        this.$bvToast.toast("Please select both start and end times!", {
          title: "Validation Error",
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
        return;
      }

      this.savingHalfDayPolicy = true;

      // Format time values properly for TimeSpan format (HH:MM:SS)
      const formatTimeForTimeSpan = (timeString) => {
        if (!timeString) return "00:00:00";

        // Remove any extra spaces
        timeString = timeString.trim();

        // If already in HH:MM:SS format, return as is
        if (timeString.match(/^\d{1,2}:\d{2}:\d{2}$/)) {
          return timeString;
        }

        // If in HH:MM format, add seconds
        if (timeString.match(/^\d{1,2}:\d{2}$/)) {
          return timeString + ":00";
        }

        // Default fallback
        return "00:00:00";
      };

      // Get current date in YYYY-MM-DD format
      const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // Returns YYYY-MM-DD
      };

      // Prepare the request body according to the API specification
      const requestBody = {
        id: 0, // New policy
        departmentID: this.halfDayPolicy.departmentID, // Allow 0 for "All Departments"
        startsAt:
          getCurrentDate() +
          "T" +
          formatTimeForTimeSpan(this.halfDayPolicy.startTime),
        endsAt:
          getCurrentDate() +
          "T" +
          formatTimeForTimeSpan(this.halfDayPolicy.endTime),
        campusID: this.$store.state.userData.cId,
      };

      // console.log("Sending request body:", requestBody); // Debug log

      // Make API call to save the half day policy
      this.post({
        url: `${this.$store.state.domain}HalfDayPolicy/Save?db=${
          this.$store.state.userData.db
        }&campusID=${this.$store.state.userData.cId}&userID=${
          this.$store.state.userData.id || 1
        }`,
        body: requestBody,
        message: "Half Day Policy saved successfully!",
        context: this,
        token: this.$store.state.userData.token,
      })
        .then((status) => {
          this.savingHalfDayPolicy = false;
          if (status) {
            this.visibility6 = false;
          }
        })
        .catch((error) => {
          // console.error("Error saving half day policy:", error);
          this.$bvToast.toast("Error saving Half Day Policy!", {
            title: this.$t("Error"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          });
          this.savingHalfDayPolicy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

::v-deep #sidebar-leave-encashment .b-sidebar-header {
  display: none !important;
}

.leave-encashment-sidebar {
  ::v-deep .b-sidebar-body {
    padding: 0 !important;
    overflow-y: auto;
  }
}

.sidebar-header-modern {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border-bottom: 2px solid #e0d8ff;
  padding: 1.25rem 1.5rem;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 50%, #cbb9ff 100%);
  }

  .sidebar-header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    z-index: 1;
  }

  .sidebar-title-block {
    min-width: 0;
    padding-right: 0.75rem;
  }

  .sidebar-title-wrapper {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .sidebar-title-icon {
    color: #7c5dfa;
    stroke-width: 2.5;
    flex-shrink: 0;
  }

  .sidebar-title {
    font-size: 1.25rem;
    font-weight: 800;
    color: #2d1b69;
    letter-spacing: -0.3px;
    margin: 0;
  }

  .sidebar-subtitle {
    margin-top: 0.35rem;
    margin-left: 2rem;
    color: #64748b;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .sidebar-close-btn {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid #e0d8ff;
    background: #fff;
    color: #64748b;
    transition: all 0.3s ease;
    flex-shrink: 0;

    &:hover {
      background: #f3f0ff;
      border-color: #b8a9ff;
      color: #7c5dfa;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(124, 93, 250, 0.15);
    }
  }
}

.sidebar-body-modern {
  padding: 1.5rem;
  background: #ffffff;
  min-height: calc(100vh - 100px);
}

.salary-form-sidebar {
  ::v-deep .b-sidebar-body {
    padding: 0 !important;
    overflow-y: auto;
  }
}

.salary-type-segment {
  position: relative;
  display: flex;
  gap: 0.35rem;
  padding: 0.3rem;
  border-radius: 12px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  isolation: isolate;
}

.salary-type-segment__glide {
  position: absolute;
  top: 0.3rem;
  bottom: 0.3rem;
  left: 0.3rem;
  width: calc((100% - 0.6rem - 0.35rem) / 2);
  border-radius: 8px;
  background: #0f172a;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
  transform: translateX(0);
  transition: transform 0.1s ease-out;
  will-change: transform;
  z-index: 0;
  pointer-events: none;
}

.salary-type-segment--loan .salary-type-segment__glide {
  transform: translateX(calc(100% + 0.35rem));
}

.salary-type-segment__btn {
  position: relative;
  z-index: 1;
  flex: 1 1 50%;
  border: none;
  border-radius: 8px;
  padding: 0.62rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: #64748b;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  transition: color 0.08s ease;

  &:hover:not(:disabled):not(.is-active) {
    color: #334155;
  }

  &.is-active {
    color: #fff;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
}

.salary-skip-panel {
  padding: 0.75rem;
  margin-bottom: 0.35rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.salary-month-chip-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem;
}

.salary-month-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  width: 100%;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 0.8125rem;
  font-weight: 800;
  padding: 0.5rem 0.35rem;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.1s ease, border-color 0.1s ease, color 0.1s ease,
    box-shadow 0.1s ease;

  &:hover {
    border-color: #cbd5e1;
    background: #fff;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
  }

  &.is-skipped {
    border-color: #f87171;
    background: linear-gradient(145deg, #fef2f2 0%, #fee2e2 100%);
    color: #b91c1c;
    box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.25);
  }
}

.salary-month-chip__label {
  letter-spacing: 0.35px;
}

@media (min-width: 420px) {
  .salary-month-chip-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

.salary-install-table {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 0.25rem;

  ::v-deep table {
    margin-bottom: 0 !important;
  }

  ::v-deep tbody tr:hover td {
    background: #f8fafc !important;
  }
}

.salary-sidebar-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1.75rem 1rem;
  color: #94a3b8;
}

.salary-sidebar-empty__title {
  margin: 0.65rem 0 0.25rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #475569;
}

.salary-sidebar-empty__hint {
  margin: 0;
  max-width: 280px;
  font-size: 0.78rem;
  font-weight: 500;
  color: #94a3b8;
  line-height: 1.4;
}

.sidebar-form-modern {
  .modern-form-group {
    margin-bottom: 1.25rem;

    label,
    .modern-inline-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #475569;
      margin-bottom: 0.5rem;
      display: block;
    }
  }

  .modern-input {
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    padding: 0.625rem 0.875rem;
    min-height: 44px;
    background: #fff;
    transition: all 0.2s ease;
    color: #1e293b;
    font-weight: 500;
    width: 100%;

    &:hover:not(:disabled) {
      border-color: #b8a9ff;
    }

    &:focus {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
      outline: none;
    }

    &:disabled {
      background: #f8fafc;
      color: #64748b;
    }
  }

  .modern-textarea {
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    padding: 0.75rem 0.875rem;
    background: #fff;
    transition: all 0.2s ease;
    color: #1e293b;
    font-weight: 500;
    resize: vertical;

    &:hover {
      border-color: #b8a9ff;
    }

    &:focus {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
      outline: none;
    }
  }

  .modern-select {
    ::v-deep .vs__dropdown-toggle {
      border-radius: 10px;
      border: 1.5px solid #e0d8ff;
      padding: 0.5rem 0.875rem;
      min-height: 44px;
      background: #fff;
      transition: all 0.2s ease;
    }

    ::v-deep .vs__dropdown-toggle:hover {
      border-color: #b8a9ff;
    }

    ::v-deep .vs__dropdown-toggle:focus-within {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
    }
  }
}

.encashment-stats-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 1.25rem;

  &.is-loading {
    opacity: 0.65;
  }
}

.encashment-stat-box {
  background: linear-gradient(135deg, #faf9ff 0%, #f3f0ff 100%);
  border: 1.5px solid #e0d8ff;
  border-radius: 12px;
  padding: 0.9rem 1rem;
}

.encashment-stat-label {
  display: block;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 0.35rem;
}

.encashment-stat-value {
  display: block;
  color: #2d1b69;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.2;
}

.sidebar-footer-modern {
  padding: 1.5rem;
  background: #faf9ff;
  border-top: 2px solid #e0d8ff;
  position: sticky;
  bottom: 0;
  margin: 0.5rem -1.5rem -1.5rem -1.5rem;

  .modern-btn-submit {
    border-radius: 10px;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

/* ===== Salary settings sidebar (revamped) ===== */
.settings-header {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  background: #fff;
  border-bottom: 1px solid #ece9f8;
}

/* Short accent line under the title instead of a full-width bar */
.settings-header__text {
  position: relative;
}

.settings-header__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
  color: #2d1b69;
  letter-spacing: -0.2px;
}

.settings-header__subtitle {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.78rem;
  font-weight: 500;
  color: #8a86b7;
}

.settings-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #e6e2f5;
  border-radius: 8px;
  background: #fff;
  color: #7c7a92;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    color: #7c5dfa;
    border-color: #cfc4ff;
    background: #f7f5ff;
    transform: translateY(-1px);
  }
}

.salary-settings-sidebar {
  ::v-deep .b-sidebar-body {
    padding: 0 !important;
    overflow: hidden !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100vh;
  }
}

.settings-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 100vh;
  max-height: 100vh;
  background: #fff;
}

.settings-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0.85rem 1rem 0.75rem;
  max-width: 100%;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

/* Legacy alias — some responsive rules still reference .settings-body */
.settings-body {
  padding: 0.85rem 1rem 0.5rem;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

.settings-footer {
  flex-shrink: 0;
  position: relative;
  z-index: 20;
  padding: 0.85rem 1rem 1rem;
  margin: 0;
  background: #fff;
  border-top: 1px solid #ece9f8;
  box-shadow: 0 -4px 14px rgba(45, 27, 105, 0.05);
  box-sizing: border-box;
  max-width: 100%;
}

.settings-save {
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border-radius: 10px;
  border: none;
  /* Matches the app's primary purple used across the UI. */
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.32);
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.42);
    background: linear-gradient(135deg, #6558e8 0%, #8d83f2 100%);
    color: #fff;
  }

  &:focus,
  &:active {
    color: #fff;
    box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.25);
  }

  &:disabled {
    opacity: 0.7;
  }
}

/* Policy card */
.policy-card {
  position: relative;
  border: 1px solid #ece9f8;
  border-radius: 14px;
  background: #fff;
  margin-bottom: 0.85rem;
  /* No overflow:hidden and no animation-fill: both would clip/trap the
     v-select dropdown menu. */
  transition: border-color 0.25s ease, box-shadow 0.25s ease;

  &.is-on {
    border-color: #ddd4ff;
    box-shadow: 0 4px 16px rgba(115, 103, 240, 0.1);
  }

  /* Each card is a positioned element, so later siblings paint over earlier
     ones and would cover an open dropdown. Raise the card being interacted
     with above its siblings. */
  &:focus-within {
    z-index: 10;
  }
}

/* No entrance animation on cards: an active animation creates a stacking
   context per card, which traps the v-select dropdown underneath the next
   card. Interaction feedback is provided by the hover/focus styles instead. */

/* While a dropdown is open, lift its row above the siblings. */
.leave-policy-row:focus-within {
  position: relative;
  z-index: 3;
}

.policy-head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.1rem;
}

.policy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #f3f0ff;
  color: #7c5dfa;
  flex-shrink: 0;
  transition: all 0.25s ease;

  /* Keep the glyph proportional to the tile, whatever size is passed. */
  ::v-deep .feather-icon,
  ::v-deep svg {
    width: 18px;
    height: 18px;
    stroke-width: 2;
  }

  .policy-card.is-on & {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(124, 93, 250, 0.3);
  }
}

.policy-heading {
  flex: 1;
  min-width: 0;
}

.policy-title {
  margin: 0;
  font-size: 0.94rem;
  font-weight: 700;
  color: #2d1b69;
  line-height: 1.3;
}

.policy-desc {
  margin: 0.1rem 0 0;
  font-size: 0.76rem;
  line-height: 1.2rem;
  color: #8a86b7;
}

.policy-switch {
  flex-shrink: 0;
  margin: 0;
}

.policy-body {
  padding: 0 1.1rem 1rem;
  border-top: 1px solid #f3f1fb;
  padding-top: 0.9rem;
  /* No animation here: this element directly contains the v-select, and an
     active animation would create a stacking context that traps the menu. */
}

.policy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.85rem 1rem;
}

.policy-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-field--switch {
  align-items: flex-start;

  .custom-control {
    margin-top: 0.25rem;
  }
}

.policy-label {
  margin-bottom: 0.4rem;
  font-size: 0.76rem;
  font-weight: 700;
  color: #5e5873;
  text-transform: uppercase;
  letter-spacing: 0.35px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.policy-hint {
  margin: 0.35rem 0 0;
  font-size: 0.72rem;
  line-height: 1.15rem;
  color: #9b96c0;
}

.policy-body ::v-deep .form-control {
  height: 38px;
  border-radius: 8px;
  border-color: #e4e1f2;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #a99bff;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.12);
  }
}

.policy-body ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
  border-radius: 8px;
  border-color: #e4e1f2;
  padding: 1px 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.policy-body ::v-deep .vs__dropdown-toggle:focus-within {
  border-color: #a99bff;
  box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.12);
}

.policy-body ::v-deep .vs__selected {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.policy-body ::v-deep .vs__selected-options {
  flex-wrap: nowrap;
  padding: 0;
  min-width: 0;
}

/* Reset multi-select chips back to the library default look. */
.policy-body ::v-deep .vs__dropdown-option--selected,
.policy-body ::v-deep .vs__dropdown-option--highlight {
  background: #7c5dfa;
  color: #fff;
}

.policy-body ::v-deep .vs__dropdown-menu {
  z-index: 20;
  border-radius: 10px;
  border-color: #e4e1f2;
  box-shadow: 0 10px 28px rgba(45, 27, 105, 0.14);
  padding: 6px;
  margin-top: 4px;
  max-height: 240px;

  .vs__dropdown-option {
    border-radius: 6px;
    padding: 7px 10px;
    font-size: 0.86rem;
    color: #2d1b69;
    line-height: 1.35;
  }

  .vs__dropdown-option--highlight {
    background: #f3f0ff;
    color: #2d1b69;
  }
}

.policy-body ::v-deep .vs__clear {
  margin-right: 2px;
}

/* Selected department chips */
.policy-body ::v-deep .vs__selected-options .vs__selected {
  background: #f3f0ff;
  color: #5e50a3;
  border: 1px solid #ddd4ff;
  border-radius: 6px;
  padding: 1px 6px;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.5;
  margin: 2px 4px 2px 0;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.policy-body ::v-deep .vs__deselect {
  margin-left: 2px;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
}

/* Per-department leave rows */
.leave-policy-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  gap: 0.7rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid #ece9f8;
  border-radius: 12px;
  background: #fbfaff;
  margin-bottom: 0.6rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  /* No animation/transform here: those create a stacking context that would trap
     the v-select dropdown behind the following row. */
  &:hover {
    border-color: #ddd4ff;
    box-shadow: 0 2px 10px rgba(115, 103, 240, 0.08);
  }
}

/* Fixed column track so every row lines up, including rows where the
   "M.L per Month" field is hidden (Yearly only). */
.leave-policy-grid {
  flex: 1 1 auto;
  min-width: 0;
  display: grid;
  grid-template-columns:
    minmax(150px, 1.5fr)
    minmax(110px, 0.9fr)
    minmax(84px, 0.6fr)
    minmax(84px, 0.6fr)
    minmax(84px, 0.6fr);
  gap: 0.75rem;
  align-items: end;
}

.leave-policy-grid--stjacob {
  grid-template-columns:
    minmax(130px, 1.25fr)
    minmax(96px, 0.8fr)
    minmax(68px, 0.5fr)
    minmax(68px, 0.5fr)
    minmax(68px, 0.5fr);
}

.leave-policy-grid--stjacob .leave-policy-months {
  grid-column: 1 / -1;
  width: 100%;
  min-width: 0;
}

.stjacob-months-btn-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0;

  ::v-deep .btn-group {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    width: 100%;
  }

  ::v-deep .btn-group > .btn {
    flex: 0 0 auto;
    min-width: 2.75rem;
    margin: 0 !important;
    border-radius: 8px !important;
    padding: 0.35rem 0.55rem;
    font-size: 0.78rem;
    font-weight: 600;
    line-height: 1.2;
    border-color: #e4e1f2;
    color: #5e5873;
  }

  ::v-deep .btn-group > .btn.active,
  ::v-deep .btn-group > .btn:active {
    background: #7c5dfa !important;
    border-color: #7c5dfa !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(124, 93, 250, 0.35);
  }
}

.salary-settings-sidebar--stjacob ::v-deep .b-sidebar {
  max-width: 100vw;
}

.leave-policy-months {
  grid-column: span 1;
  min-width: 0;
}

.leave-policy-field {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.leave-policy-label {
  font-weight: 700;
  color: #5e5873;
  font-size: 0.7rem;
  line-height: 1.1rem;
  margin-bottom: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.leave-policy-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
  padding-bottom: 1px;
}

.leave-policy-row ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
  border-radius: 8px;
  border-color: #e4e1f2;
  padding: 1px 8px;
}

.leave-policy-row ::v-deep .vs__selected {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.leave-policy-row ::v-deep .vs__selected-options {
  flex-wrap: nowrap;
  padding: 0;
  min-width: 0;
}

.leave-policy-row .form-control {
  height: 38px;
  border-radius: 8px;
  border-color: #e4e1f2;
  padding: 0.4rem 0.5rem;
}

/* ===== Create / Update salary sidebar ===== */
.salary-create-body {
  padding: 0.75rem 0.85rem 1rem;
}

/* Top meta row (period / month / date / department). Each select is forced to
   the same 42px height as the flat-pickr inputs, otherwise the v-select boxes
   render taller and the row looks ragged. */
.salary-top-fields {
  margin-bottom: 0.25rem;

  &.is-date-range,
  &.is-standard-row {
    margin-left: 0;
    margin-right: 0;
  }

  &.is-date-range {
    @media (min-width: 992px) {
      display: grid;
      grid-template-columns:
        minmax(0, 1.55fr)
        minmax(0, 0.95fr)
        minmax(0, 0.95fr)
        minmax(0, 1.05fr);
      column-gap: 0.65rem;
      row-gap: 0;
      align-items: start;

      > [class*="col-"] {
        flex: none;
        max-width: 100%;
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        margin: 0;
      }
    }
  }

  /* Month / year / payment date / department — one row in the salary sidebar. */
  &.is-standard-row {
    @media (min-width: 520px) {
      display: grid;
      grid-template-columns:
        minmax(0, 1.15fr)
        minmax(0, 0.72fr)
        minmax(0, 1.05fr)
        minmax(0, 1.35fr);
      column-gap: 0.55rem;
      row-gap: 0;
      align-items: start;

      > [class*="col-"] {
        flex: none;
        max-width: 100%;
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        margin: 0;
      }
    }
  }

  ::v-deep .form-group {
    margin-bottom: 0.85rem;
  }

  &.is-date-range ::v-deep .salary-top-field .form-group,
  &.is-standard-row ::v-deep .salary-top-field .form-group {
    margin-bottom: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .salary-top-field__label {
    display: block;
    min-height: 1.125rem;
    line-height: 1.125rem;
    margin-bottom: 0.35rem !important;
    padding: 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: #5e5873;
    white-space: nowrap;
  }

  ::v-deep .col-form-label,
  ::v-deep label:not(.salary-top-field__label) {
    margin-bottom: 0.35rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: #5e5873;
  }

  ::v-deep .salary-top-field__control,
  ::v-deep .salary-top-field .form-control {
    width: 100%;
    min-width: 0;
  }

  ::v-deep .vs__dropdown-toggle {
    height: 42px;
    min-height: 42px;
    padding: 1px 10px;
    border-radius: 10px;
    border-color: #e4e1f2;
  }

  ::v-deep .vs__selected {
    margin: 0;
    font-size: 0.86rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
    padding: 0;
    min-width: 0;
    overflow: hidden;
  }

  ::v-deep .form-control {
    height: 42px;
    border-radius: 10px;
    border-color: #e4e1f2;
    font-size: 0.86rem;
  }

  ::v-deep .flatpickr-input,
  ::v-deep input.form-control {
    text-overflow: ellipsis;
  }

  ::v-deep .vs__dropdown-menu {
    z-index: 30;
    border-radius: 10px;
    border-color: #e4e1f2;
    box-shadow: 0 10px 28px rgba(45, 27, 105, 0.14);
    padding: 6px;
    margin-top: 4px;
    max-height: 260px;
  }
}

.salary-create-header {
  padding: 0.75rem 1rem 0.8rem;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 20;
}

.salary-create-header__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  min-width: 0;
}

.salary-create-header__lead {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  flex: 1 1 auto;
}

.salary-create-header__headline {
  min-width: 0;
}

.salary-create-header__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #7367f0;
  color: #fff;
  flex-shrink: 0;

  &.is-update {
    background: #64748b;
  }
}

.salary-create-header__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.2px;
  line-height: 1.2;
}

.salary-create-header__subtitle {
  margin: 0.12rem 0 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.35;
}

.salary-create-header__context {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-top: 0.65rem;
  padding: 0.55rem 0.7rem;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.salary-create-header__identity {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.5rem;
  min-width: 0;
  flex: 1 1 160px;
}

.salary-create-header__staff-name {
  font-size: 0.9rem;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: -0.12px;
  line-height: 1.25;
  word-break: break-word;
}

.salary-create-header__staff-role {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.28px;
  line-height: 1.3;
}

.salary-create-header__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  flex: 1 1 auto;
}

.salary-create-header__chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
  white-space: nowrap;

  &.is-period {
    color: #334155;
    background: #fff;
    border-color: #cbd5e1;
  }
}

.salary-create-header__bar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.salary-create-header__decimal {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.25rem 0.35rem 0.25rem 0.5rem;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.salary-create-header__decimal-group {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.15rem;
  border-radius: 7px;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.salary-create-header__label {
  font-size: 0.65rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.28px;
  white-space: nowrap;
}

.salary-create-header__decimal-btn {
  border: none;
  background: transparent;
  min-width: 1.65rem;
  height: 1.55rem;
  padding: 0 0.35rem;
  border-radius: 5px;
  font-size: 0.72rem;
  font-weight: 800;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  transition: background-color 0.1s ease, color 0.1s ease;

  &:hover:not(.is-active) {
    background: #f1f5f9;
    color: #334155;
  }

  &.is-active {
    background: #7367f0;
    color: #fff;
  }
}

.salary-create-header__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid #e6e2f5;
  border-radius: 8px;
  background: #fff;
  color: #7c7a92;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #7c5dfa;
    border-color: #cfc4ff;
    background: #f7f5ff;
  }
}

/* ===== Create/Update sidebar panels ===== */
.salary-panel {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff !important;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(115, 103, 240, 0.08);
  overflow: visible;
}

.salary-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #f0edff;
}

.salary-panel__title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.salary-panel__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #f3f0ff;
  color: #7367f0;
  flex-shrink: 0;
}

.salary-panel__title {
  color: #2d1b69;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.2px;
}

.salary-panel__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #f3f0ff;
  border: 1px solid #e0d8ff;
  color: #6d5bd0;
  font-size: 0.68rem;
  font-weight: 800;
}

.salary-panel__icon--allow {
  background: #eafaf2;
  color: #1a9e5c;
}

.salary-panel__icon--deduct {
  background: #fff1f0;
  color: #e5534b;
}

.salary-panel__icon--summary {
  background: #f3f0ff;
  color: #7367f0;
}

.salary-panel__total {
  font-size: 0.78rem;
  font-weight: 800;
  color: #1a9e5c;
  white-space: nowrap;

  &.is-deduct {
    color: #e5534b;
  }
}

.salary-panel__action-btn {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 0.7rem;
  border-radius: 8px;
  border: 1px solid #d9d2ff !important;
  color: #6d5bd0 !important;
  background: #fff !important;
  font-size: 0.76rem;
  font-weight: 700;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #f5f3ff !important;
    border-color: #b8a9ff !important;
  }
}

/* Allowance / deduction rows */
.salary-row-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.salary-row {
  display: flex;
  align-items: flex-end;
  gap: 0.6rem;
  padding: 0.6rem 0.7rem;
  border: 1px solid #ece9f8;
  border-radius: 10px;
  background: #fbfaff;

  &.is-skipped {
    background: #fafafa;
    border-style: dashed;
  }
}

.salary-row__fields {
  flex: 1 1 auto;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(130px, 0.42fr);
  gap: 0.6rem;
  align-items: end;

  &.has-days {
    grid-template-columns: minmax(0, 1fr) 90px minmax(130px, 0.42fr);
  }
}

.salary-row__field {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.salary-row__label {
  margin-bottom: 0.3rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #8a86b7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.salary-row__money {
  ::v-deep .input-group-text {
    background: #f7f5ff;
    border-color: #e4e1f2;
    color: #8a86b7;
    font-size: 0.74rem;
    font-weight: 700;
    padding: 0 0.5rem;
    border-radius: 8px 0 0 8px;
  }

  ::v-deep .form-control {
    border-radius: 0 8px 8px 0;
  }
}

.salary-row__currency {
  font-size: 0.72rem;
}

.salary-row__actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
  padding-bottom: 1px;
}

.salary-row__badge {
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  background: #fff4e5;
  border: 1px solid #ffdca8;
  color: #b76e00;
  font-size: 0.64rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.salary-row__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #fff;
  cursor: pointer;
  transition: all 0.18s ease;

  &.is-add {
    border-color: #d9d2ff;
    color: #7367f0;

    &:hover {
      background: #7367f0;
      border-color: #7367f0;
      color: #fff;
    }
  }

  &.is-remove {
    border-color: #f6d9d7;
    color: #e5534b;

    &:hover {
      background: #fdeceb;
      border-color: #f2c1bd;
    }
  }

  &.is-skip {
    border-color: #ffe6bd;
    color: #b76e00;

    &:hover {
      background: #fff4e5;
      border-color: #ffdca8;
    }
  }
}

/* Contributions */
.contribution-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid #ece9f8;
  border-radius: 10px;
  background: #fbfaff;
}

.contribution-row__name {
  display: inline-flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: #5e5873;
}

.contribution-row__amount {
  font-size: 0.86rem;
  font-weight: 800;
  color: #2d1b69;
  white-space: nowrap;
}

/* Summary */
.salary-summary-net {
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
  padding: 0.28rem 0.7rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  box-shadow: 0 3px 10px rgba(115, 103, 240, 0.25);
}

.salary-summary-net__label {
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.82);
}

.salary-summary-net__value {
  font-size: 0.9rem;
  font-weight: 800;
  color: #fff;
  white-space: nowrap;
}

.salary-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;
}

.salary-summary-tile {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  padding: 0.6rem 0.7rem;
  border: 1px solid #ece9f8;
  border-radius: 10px;
  background: #fbfaff;

  &.is-net {
    background: #f5f3ff;
    border-color: #ddd4ff;
  }
}

.salary-summary-tile__label {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #8a86b7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.salary-summary-tile__value {
  font-size: 0.94rem;
  font-weight: 800;
  color: #2d1b69;
  white-space: nowrap;

  &.is-allow {
    color: #1a9e5c;
  }

  &.is-deduct {
    color: #e5534b;
  }
}

.salary-summary-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin-top: 0.85rem;
  padding-top: 0.85rem;
  border-top: 1px dashed #e8e4f7;
}

.salary-summary-field {
  min-width: 0;
}

.salary-summary-field__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.salary-summary-field__label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #8a86b7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Row skeletons for allowances / deductions while calculating */
.salary-row-skeleton {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.salary-row-skeleton__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(130px, 0.42fr);
  gap: 0.6rem;
  padding: 0.6rem 0.7rem;
  border: 1px solid #f0edff;
  border-radius: 10px;
  background: #fbfaff;
}

.salary-row-skeleton__field {
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

/* Summary loading skeleton (Calculate in progress) */
.salary-summary-skeleton {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;
}

.salary-summary-skeleton__tile {
  padding: 0.6rem 0.7rem;
  border: 1px solid #f0edff;
  border-radius: 10px;
  background: #fbfaff;
}

.salary-summary-skeleton__label,
.salary-summary-skeleton__value {
  border-radius: 6px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.salary-summary-skeleton__label {
  height: 8px;
  width: 55%;
  margin-bottom: 0.45rem;
}

.salary-summary-skeleton__value {
  height: 15px;
  width: 78%;
}

.salary-panel__refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #e6e2f5;
  border-radius: 7px;
  background: #fff;
  color: #8a86b7;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #7367f0;
    border-color: #cfc4ff;
    background: #f7f5ff;
  }
}

.salary-panel__tools {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.salary-panel__switch {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;

  /* The slot content renders inside .custom-control-label; keep it on the
     same line as the switch track. */
  ::v-deep .custom-control-label {
    margin-bottom: 0;
    white-space: nowrap;
  }
}

.salary-panel__switch-label {
  font-size: 0.76rem;
  font-weight: 600;
  color: #8a86b7;
  white-space: nowrap;
}

.salary-panel__deduction-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;

  .custom-control {
    margin: 0;
  }
}

.salary-panel__info {
  color: #b9b3d6;
  cursor: pointer;

  &:hover {
    color: #7367f0;
  }
}

.salary-panel__body {
  padding-top: 0.85rem;
}

/* Calculate Salary button */
.salary-calc-actions {
  margin-top: 0.9rem;
  padding-top: 0.85rem;
  border-top: 1px solid #f0edff;
}

.salary-calc-btn {
  width: 100%;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: #fff;
  font-weight: 700;
  font-size: 0.86rem;
  letter-spacing: 0.2px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.3);
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #6558e8 0%, #8d83f2 100%);
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.4);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
    box-shadow: none;
  }

  /* Keep the label legible while the shimmer grid is showing. */
  &.is-loading {
    opacity: 1;
    cursor: progress;
    background: linear-gradient(135deg, #8d83f2 0%, #b3aaf8 100%);
  }
}

/* Calculation skeleton overlay for the attendance panel */
.salary-calc-skeleton {
  padding: 0.5rem 0;
}

.salary-calc-skeleton__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem 1rem;
}

.salary-calc-skeleton__field {
  min-width: 0;
}

.salary-calc-skeleton__label {
  height: 9px;
  width: 55%;
  border-radius: 5px;
  margin-bottom: 0.45rem;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.salary-calc-skeleton__input {
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

/* Shared field styling inside the sidebar panels */
.salary-panel__body ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
  border-radius: 8px;
  border-color: #e4e1f2;
  padding: 1px 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.salary-panel__body ::v-deep .vs__dropdown-toggle:focus-within {
  border-color: #a99bff;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
}

.salary-panel__body ::v-deep .vs__selected {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.salary-panel__body ::v-deep .vs__selected-options {
  flex-wrap: nowrap;
  padding: 0;
  min-width: 0;
}

.salary-panel__body ::v-deep .form-control {
  height: 38px;
  border-radius: 8px;
  border-color: #e4e1f2;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #a99bff;
    box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
  }
}

.salary-panel__body ::v-deep .vs__dropdown-menu {
  z-index: 20;
  border-radius: 10px;
  border-color: #e4e1f2;
  box-shadow: 0 10px 28px rgba(45, 27, 105, 0.14);
  padding: 6px;
  margin-top: 4px;
  max-height: 220px;
}

.salary-panel__body ::v-deep .vs__dropdown-option--highlight {
  background: #f3f0ff;
  color: #2d1b69;
}

@media (max-width: 768px) {
  .salary-calc-skeleton__grid {
    grid-template-columns: 1fr;
  }

  .salary-panel__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .salary-row {
    flex-wrap: wrap;
    align-items: stretch;
  }

  .salary-row__fields,
  .salary-row__fields.has-days {
    grid-template-columns: minmax(0, 1fr);
  }

  .salary-row__actions {
    justify-content: flex-end;
  }

  .salary-summary-grid,
  .salary-summary-skeleton {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .salary-summary-grid,
  .salary-summary-skeleton {
    grid-template-columns: minmax(0, 1fr);
  }

  .salary-summary-fields {
    grid-template-columns: minmax(0, 1fr);
  }
}

.salary-create-actions .btn {
  height: 42px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.83rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
}

.salary-create-save {
  border: none !important;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.3);

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #6558e8 0%, #8d83f2 100%) !important;
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.4);
  }
}

.salary-create-save-print {
  border: 1.5px solid #7367f0 !important;
  color: #7367f0 !important;
  background: #fff !important;

  &:hover:not(:disabled) {
    background: #f5f3ff !important;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.2);
  }
}

/* ===== Generate Salary ===== */
.generate-modal-footer {
  margin-top: 1.1rem;
  padding-top: 0.85rem;
  border-top: 1px solid #f0edff;
}

.generate-create-btn {
  border: none !important;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%) !important;
  color: #fff !important;
  font-weight: 700;
  height: 44px;
  min-height: 44px;
  padding: 0 1.25rem !important;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.3);
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(115, 103, 240, 0.38);
  }
}

.gen-modal__skipped-summary {
  margin: 0.85rem 0 0;
  padding: 0.75rem 0.9rem;
  border-radius: 10px;
  background: #fff8ef;
  border: 1px solid #ffe2b8;
  color: #8a5a00;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1.45;
}

.generate-progress__head {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #6d5bd0;
  margin-top: 0.75rem;
}

.generate-progress__skeleton {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;
  margin-top: 0.7rem;
}

.generate-progress__tile {
  height: 56px;
  border-radius: 10px;
  border: 1px solid #f0edff;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

/* Generate Salary result modal */
.gen-modal__head {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #f0edff;
}

.gen-modal__status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #e8f9ef;
  color: #1a9e5c;
  flex-shrink: 0;

  &.is-warn {
    background: #fff4e5;
    color: #b76e00;
  }
}

.gen-modal__head-text {
  min-width: 0;
}

.gen-modal__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 800;
  color: #2d1b69;
}

.gen-modal__subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.78rem;
  line-height: 1.35rem;
  color: #8a86b7;
  word-break: break-word;
}

.gen-modal__stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.6rem;
  margin-top: 0.9rem;
}

.gen-stat {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid #ece9f8;
  border-radius: 10px;
  background: #fbfaff;

  &.is-created .gen-stat__value {
    color: #1a9e5c;
  }

  &.is-updated .gen-stat__value {
    color: #7367f0;
  }

  &.is-skipped .gen-stat__value {
    color: #b76e00;
  }
}

.gen-stat__label {
  font-size: 0.64rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #8a86b7;
  white-space: nowrap;
}

.gen-stat__value {
  font-size: 1.05rem;
  font-weight: 800;
  color: #2d1b69;
  line-height: 1.2;
}

.gen-modal__staff-block {
  margin-top: 0.9rem;

  &.is-created {
    .gen-modal__block-title {
      color: #1a9e5c;
    }
  }

  &.is-updated {
    .gen-modal__block-title {
      color: #6d5bd0;
    }
  }
}

.gen-modal__block-title {
  display: flex;
  align-items: center;
  margin: 0 0 0.5rem;
  font-size: 0.78rem;
  font-weight: 800;
}

.gen-modal__period-label {
  margin: 0.65rem 0 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: #6e6b8a;
  text-align: center;
}

.gen-modal__skipped-reason-hint {
  margin: 0 0 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: #9a7340;
  line-height: 1.4;
}

.gen-modal__staff-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 2px;

  &.is-ledger-scroll {
    max-height: min(42vh, 360px);
  }
}

.gen-staff-result-row {
  padding: 0.55rem 0.7rem;
  border-radius: 9px;
  border: 1px solid #e8e4f5;
  background: #faf9ff;

  &.is-created {
    border-color: #b8ecd0;
    background: #f4fbf7;
  }

  &.is-updated {
    border-color: #ddd4ff;
    background: #f8f6ff;
  }
}

.gen-staff-result-row__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
}

.gen-staff-result-row__name {
  font-size: 0.82rem;
  font-weight: 700;
  color: #2d1b69;
}

.gen-staff-result-row__id {
  font-size: 0.68rem;
  color: #a29ec4;
  white-space: nowrap;
}

.gen-staff-result-row__meta {
  margin: 0.35rem 0 0;
  font-size: 0.74rem;
  font-weight: 600;
  color: #5e5873;
  line-height: 1.4;
}

.gen-staff-result-row__sub {
  margin: 0.25rem 0 0;
  font-size: 0.7rem;
  font-weight: 500;
  color: #8a86b7;
  line-height: 1.35;
}

.gen-modal__compact-summary {
  margin: 0.85rem 0 0;
  padding: 0.75rem 0.9rem;
  border-radius: 10px;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1.45;

  &.is-updated {
    background: #f8f6ff;
    border: 1px solid #ddd4ff;
    color: #5e50a3;
  }
}

.gen-modal__skipped {
  margin-top: 0.9rem;
}

.gen-modal__skipped-title {
  display: flex;
  align-items: center;
  margin: 0 0 0.5rem;
  font-size: 0.78rem;
  font-weight: 800;
  color: #b76e00;
}

.gen-modal__skipped-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  max-height: 260px;
  overflow-y: auto;
  padding-right: 2px;
}

.gen-skip-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.65rem;
  border: 1px solid #ffe6bd;
  border-radius: 9px;
  background: #fffdf7;
}

.gen-skip-row__staff {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.gen-skip-row__name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #2d1b69;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gen-skip-row__id {
  font-size: 0.68rem;
  color: #a29ec4;
}

.gen-skip-row__reason {
  font-size: 0.72rem;
  font-weight: 600;
  color: #8a6a35;
  text-align: right;
  word-break: break-word;
}

.gen-modal__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 1rem 0 0;
  padding: 0.85rem 0 0.25rem;
  border-top: 1px solid #f0edff;
}

.gen-modal__done-btn {
  border: none !important;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%) !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  height: 44px !important;
  min-height: 44px !important;
  width: auto !important;
  min-width: 112px;
  padding: 0 1.35rem !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.28);
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  line-height: 1;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: linear-gradient(135deg, #6558e8 0%, #8d83f2 100%) !important;
    color: #fff !important;
    box-shadow: 0 6px 16px rgba(115, 103, 240, 0.34);
    transform: none;
  }
}

::v-deep .salary-gen-result-modal__content {
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(45, 27, 105, 0.14);
}

::v-deep .salary-gen-result-modal__body {
  padding: 1rem 1.35rem 1.35rem !important;
}

::v-deep .salary-gen-result-modal .modal-header {
  padding: 1rem 1.35rem 0.85rem;
  border-bottom: 1px solid #f0edff;
}

::v-deep .salary-gen-result-modal .modal-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2d1b69;
}

@media (max-width: 576px) {
  .gen-modal__stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .gen-skip-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .gen-skip-row__reason {
    text-align: left;
  }
}

/* Salary sheet skeleton */
.sheet-skeleton {
  padding: 0.5rem;
}

.sheet-skeleton__row {
  display: grid;
  /* 4 lead columns + 16 metric columns = 20, matching salarySheetFields. */
  grid-template-columns:
    40px minmax(150px, 1.4fr) 110px 120px
    repeat(5, minmax(64px, 1fr))
    repeat(5, minmax(70px, 1fr))
    repeat(4, minmax(84px, 1fr))
    minmax(110px, 1fr);
  gap: 0.6rem;
  align-items: center;
  padding: 0.65rem 0.4rem;
  border-bottom: 1px solid #f1f5f9;
}

.sheet-skeleton__bar {
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.sheet-skeleton__bar--name {
  height: 14px;
  width: 70%;
}

.sheet-skeleton__bar--id {
  height: 9px;
  width: 45%;
  margin-top: 4px;
}

/* ===== Responsive: tablets / phones ===== */
@media (max-width: 768px) {
  .settings-header {
    padding: 0.85rem 1rem;
  }

  .settings-header__title {
    font-size: 1rem;
  }

  .settings-header__subtitle {
    font-size: 0.72rem;
  }

  .settings-scroll,
  .settings-body {
    padding: 0.85rem 1rem 0.65rem;
  }

  .settings-footer {
    padding: 0.85rem 1rem 1rem;
  }

  .settings-save {
    height: 42px;
    font-size: 0.9rem;
  }

  .policy-head {
    padding: 0.75rem 0.85rem;
    gap: 0.6rem;
  }

  .policy-icon {
    width: 30px;
    height: 30px;

    ::v-deep .feather-icon,
    ::v-deep svg {
      width: 16px;
      height: 16px;
    }
  }

  .policy-title {
    font-size: 0.88rem;
  }

  .policy-desc {
    font-size: 0.72rem;
    line-height: 1.05rem;
  }

  .policy-body {
    padding: 0 0.85rem 0.85rem;
  }

  .policy-grid {
    grid-template-columns: 1fr;
    gap: 0.65rem;
  }

  /* Stack each leave row instead of squeezing 5 columns into a phone width. */
  .leave-policy-row {
    flex-wrap: wrap;
    align-items: stretch;
    gap: 0.6rem;
    padding: 0.65rem;
  }

  .leave-policy-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.6rem;
  }

  .leave-policy-grid--stjacob {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .leave-policy-grid--stjacob .leave-policy-months {
    grid-column: 1 / -1;
  }

  .leave-policy-dept,
  .leave-policy-cat {
    grid-column: 1 / -1;
  }

  .leave-policy-actions {
    padding-bottom: 0;
    justify-content: flex-end;
  }

  .leave-policy-label {
    font-size: 0.66rem;
    margin-bottom: 0.3rem;
  }
}

@media (max-width: 480px) {
  .settings-header {
    padding: 0.7rem 0.75rem;
  }

  .settings-scroll,
  .settings-body {
    padding: 0.7rem 0.75rem 0.5rem;
  }

  .settings-footer {
    padding: 0.7rem 0.75rem 0.85rem;
  }

  .policy-head {
    padding: 0.65rem 0.7rem;
  }

  .policy-body {
    padding: 0 0.7rem 0.75rem;
  }

  .leave-policy-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .leave-policy-dept,
  .leave-policy-cat {
    grid-column: auto;
  }
}

/* ===== Skeleton loading (matches TabulationSheetView shimmer) ===== */
@mixin settingsShimmerBg {
  background: linear-gradient(
    90deg,
    #e9e6f4 0%,
    #f6f4fd 25%,
    #e9e6f4 50%,
    #f6f4fd 75%,
    #e9e6f4 100%
  );
  background-size: 300% 100%;
  animation: settingsShimmer 1.3s ease-in-out infinite;
}

.settings-skeleton {
  pointer-events: none;
}

.skeleton-card {
  pointer-events: none;
}

.skeleton-icon {
  @include settingsShimmerBg;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  flex-shrink: 0;
}

.skeleton-title-line {
  @include settingsShimmerBg;
  height: 13px;
  width: 42%;
  border-radius: 7px;
  margin-bottom: 7px;
}

.skeleton-desc-line {
  @include settingsShimmerBg;
  height: 10px;
  width: 64%;
  border-radius: 7px;
}

.skeleton-switch {
  @include settingsShimmerBg;
  width: 36px;
  height: 20px;
  border-radius: 10px;
  flex-shrink: 0;
}

@keyframes settingsShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.staff-salary-filter-col {
  display: flex;
  align-items: flex-start;
}

/* ===== Staff salary list revamp (matches planner list styling) ===== */
.staff-salary-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  margin-bottom: 1.25rem;
  position: relative;
  overflow: visible;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  .gradient-line-wrapper {
    position: absolute;
    top: 0;
    left: 1.25rem;
    right: 1.25rem;
    height: 4px;
    background: linear-gradient(90deg, #7367f0 0%, #9e95f5 100%);
    border-radius: 999px;
    z-index: 1;
  }
}

.staff-salary-card--history {
  margin-bottom: 0.5rem;
  padding-bottom: 0.75rem;

  ::v-deep .card-body {
    padding-bottom: 0.35rem;
  }
}

.staff-salary-card--attendance {
  background: #fff !important;
  border-color: #e2e8f0 !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06) !important;

  .gradient-line-wrapper {
    background: linear-gradient(90deg, #64748b 0%, #94a3b8 100%);
  }

  ::v-deep .card-body {
    background: #fff;
  }

  /* FullCalendar uses nested tables — keep day cells white on hover (no list-table tint). */
  ::v-deep table.fc-scrollgrid tbody tr:hover td,
  ::v-deep table.fc-scrollgrid-sync-table tbody tr:hover td,
  ::v-deep table.fc-scrollgrid tbody tr:nth-child(even):hover td,
  ::v-deep table.fc-scrollgrid-sync-table tbody tr:nth-child(even):hover td {
    background: #fff !important;
  }
}

.salary-history-table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  margin-bottom: 0;
  -webkit-overflow-scrolling: touch;
}

.salary-history-table-wrap ::v-deep .table-responsive {
  overflow-x: visible;
  overflow-y: visible;
  margin-bottom: 0;
}

.salary-history-table-wrap ::v-deep table {
  margin-bottom: 0 !important;
}

.staff-salary-card--history ::v-deep .b-table-busy-slot > td {
  height: auto !important;
  min-height: 0 !important;
  padding-top: 0.35rem !important;
  padding-bottom: 0.35rem !important;
  border: none !important;
}

.salary-list-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.salary-list-title {
  color: #2d1b69;
  font-weight: 800;
  letter-spacing: -0.5px;
  font-size: 1.4rem;
  margin: 0;
}

.salary-list-subtitle {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
}

.staff-salary-main-table {
  margin-top: 0.35rem !important;
}

.filter-row {
  padding: 0.75rem 0 0.5rem;
  margin-bottom: 1.25rem;
  border-radius: 15px;
  overflow: visible;
  position: relative;
  z-index: 10;

  ::v-deep .v-select.vs--open {
    z-index: 15;
  }
}

/* Filters on top row; action buttons stack in rows aligned right (printResultMe). */
.filter-toolbar {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.filter-toolbar--salary {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
}

.filter-toolbar--salary .filter-fields-group,
.filter-toolbar--salary .filter-actions-row {
  align-self: center;
}

/* Main staff list: grid keeps filters and buttons from overlapping. */
.filter-toolbar--salary.filter-toolbar--one-line {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(max-content, auto);
  align-items: center;
  gap: 0.75rem;
  width: 100%;

  .filter-fields-group {
    grid-column: 1;
    flex: none;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    gap: 0.65rem;
    overflow: visible;
  }

  .filter-search-input {
    flex: 1.2 1 0;
    min-width: 0;
    max-width: 300px;
    width: auto;

    ::v-deep .form-control,
    ::v-deep .input-group-text {
      height: 42px;
    }
  }

  .filter-control {
    flex: 1 1 0;
    min-width: 0;
    max-width: 280px;
    width: auto;

    ::v-deep .vs__dropdown-toggle {
      height: 42px;
      min-height: 42px;
    }

    ::v-deep .vs__selected {
      max-width: calc(100% - 2rem);
    }
  }

  .filter-control--dept {
    flex: 1.4 1 0;
    max-width: 360px;
  }

  .filter-actions-row,
  .staff-salary-toolbar-actions {
    grid-column: 2;
    flex: none;
    flex-shrink: 0;
    flex-wrap: nowrap !important;
    align-items: center;
    justify-content: flex-end;
    width: max-content;
    max-width: 100%;
    min-width: 0;
    gap: 0.45rem;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    padding: 1px 0;
    position: relative;
    z-index: 2;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #d4ccf5;
      border-radius: 999px;
    }
  }

  .salary-filter-action-btn {
    flex: 0 0 auto;
    height: 42px !important;
    min-height: 42px;
    padding: 0 0.85rem !important;
    font-size: 0.78rem !important;
    border-radius: 10px !important;
    line-height: 1.2;
  }

  .salary-filter-action-btn--icon {
    flex: 0 0 42px;
    width: 42px !important;
    min-width: 42px !important;
    padding: 0 !important;
  }
}

@media (min-width: 1400px) {
  .filter-toolbar--salary.filter-toolbar--one-line {
    .filter-search-input {
      max-width: 340px;
    }

    .filter-control--dept {
      max-width: 400px;
    }

    .filter-control:not(.filter-control--dept) {
      max-width: 200px;
    }

    .salary-filter-action-btn:not(.salary-filter-action-btn--icon) {
      padding: 0 1rem !important;
      font-size: 0.8rem !important;
    }
  }
}

@media (max-width: 1199px) {
  .filter-toolbar--salary.filter-toolbar--one-line {
    .filter-search-input {
      max-width: 240px;
    }

    .filter-control--dept {
      max-width: 280px;
    }

    .filter-control:not(.filter-control--dept) {
      max-width: 160px;
    }
  }
}

.filter-fields-group {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 640px;
  flex-wrap: nowrap;
}

.filter-search-input {
  flex: 0 1 240px;
  min-width: 180px;
  max-width: 280px;
  margin-bottom: 0 !important;

  ::v-deep .form-group,
  ::v-deep .input-group {
    margin-bottom: 0;
  }

  ::v-deep .form-control,
  ::v-deep .input-group-text {
    height: 42px;
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    font-weight: 500;
    color: #2d1b69;
    background: #fff;
    transition: all 0.2s ease;

    &::placeholder {
      color: #8a86b7;
      font-weight: 500;
    }

    &:focus {
      border-color: #7367f0;
      box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.1);
    }
  }

  ::v-deep .input-group-prepend .input-group-text {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    color: #7367f0;
    cursor: pointer;
  }

  ::v-deep .form-control {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.filter-control {
  flex: 0 1 210px;
  min-width: 175px;
  max-width: 240px;

  ::v-deep .vs__dropdown-toggle {
    height: 42px;
    min-height: 42px;
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    background: #fff;
    transition: all 0.2s ease;

    &:hover {
      border-color: #b8a9ff;
    }
  }

  ::v-deep .vs__selected {
    font-weight: 500;
    color: #2d1b69;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 1.5rem);
  }

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
    min-width: 0;
  }

  ::v-deep .vs__search,
  ::v-deep .vs__search::placeholder,
  ::v-deep .vs__placeholder {
    color: #5e5873;
    font-weight: 500;
    opacity: 0.9;
    white-space: nowrap;
  }

  ::v-deep .vs__actions {
    padding-right: 4px;
  }

  ::v-deep .vs__dropdown-menu {
    z-index: 990;
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    box-shadow: 0 6px 20px rgba(115, 103, 240, 0.18);
    margin-top: 4px;
    padding: 6px;

    .vs__dropdown-option {
      border-radius: 6px;
      padding: 7px 10px;
      font-size: 0.86rem;
      color: #2d1b69;
    }

    .vs__dropdown-option--highlight {
      background: #f3f0ff;
      color: #2d1b69;
    }
  }
}

.filter-actions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  flex: 1 1 420px;
  min-width: 0;
}

.salary-filter-action-btn {
  border-radius: 10px !important;
  height: 42px !important;
  min-height: 42px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 0.72rem !important;
  font-weight: 600 !important;
  font-size: 0.78rem !important;
  white-space: nowrap;
  margin: 0 !important;
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.22);
  }
}

.salary-filter-action-btn--icon {
  width: 42px !important;
  min-width: 42px !important;
  padding: 0 !important;
}

.staff-salary-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

.salary-toolbar-tip-wrap {
  display: inline-flex;
  flex-shrink: 0;
  vertical-align: middle;
}

.staff-salary-card ::v-deep .salary-ui-tooltip {
  pointer-events: none;
  z-index: 1200;

  &.bs-tooltip-top {
    padding: 0 0 12px;
    margin-top: -2px;
  }

  .tooltip-inner {
    max-width: 220px;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.35rem 0.6rem;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18);
  }
}

/* Table */
.staff-salary-card ::v-deep .table-responsive {
  border-radius: 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Staff/history/deposit tables only — exclude FullCalendar (.fc-scrollgrid). */
.staff-salary-card ::v-deep table:not(.fc-scrollgrid):not(.fc-scrollgrid-sync-table) {
  margin-bottom: 0;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  th {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: none;
    border-bottom: 1px solid #e2e8f0;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.5px;
    padding: 0.75rem 0.875rem;
    white-space: nowrap;
  }

  td {
    vertical-align: middle;
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f8fafc;
    padding: 0.75rem 0.875rem;
    background: #fff;
    font-size: 0.875rem;
    color: #475569;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  tbody tr {
    /* Light tint on hover only - no shadow/transform, so skeleton rows are
       never affected. */
    background: transparent;
    transition: background-color 0.15s ease;

    &:nth-child(even) td {
      background: #fafbfd;
    }

    &:hover td {
      background: #f7f5ff !important;
    }
  }
}

/* Table action cluster. Kept on ONE line: inside a table cell vertical wrapping
   makes the whole row as tall as the stack. The table's responsive wrapper
   scrolls horizontally instead, which keeps rows compact on phones. */
.staff-salary-card ::v-deep .staff-actions {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem;
  width: auto;
  max-width: 100%;
  min-width: max-content;
  margin-left: auto;
}

.staff-salary-card ::v-deep .staff-actions > .btn {
  margin: 0 !important;
  flex: 0 0 auto;
}

.staff-salary-card ::v-deep td .btn-icon {
  flex: 0 0 auto;
  width: 44px !important;
  min-width: 44px;
  height: 44px;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;

  ::v-deep .feather-icon,
  ::v-deep svg {
    width: 16px;
    height: 16px;
  }
}

/* Text action buttons (Leave Encashment / Security Deposit / Advance Loan) */
.staff-salary-card ::v-deep td .staff-action-text {
  flex: 0 0 auto;
  width: auto !important;
  min-width: max-content;
  height: 44px;
  padding: 0 1.1rem !important;
  margin: 0 !important;
  border-radius: 10px;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.staff-salary-main-table ::v-deep th[aria-label="actions"],
.staff-salary-main-table ::v-deep td:last-child {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

.salary-history-table ::v-deep th:last-child,
.salary-history-table ::v-deep td:last-child {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

.staff-salary-main-table ::v-deep th[aria-label="actions"] {
  text-align: center;
}

/* Wide tables (history) keep their columns but scroll instead of squashing. */
.staff-salary-card ::v-deep table.table-sm {
  font-size: 0.8125rem;
}

.staff-salary-card ::v-deep td .badge {
  font-weight: 600;
  font-size: 0.72rem;
  padding: 0.3rem 0.5rem;
  border-radius: 6px;
  white-space: nowrap;
}

/* Name cell: keep the avatar + stacked badges readable. */
.staff-salary-card ::v-deep td .media {
  align-items: center;
  min-width: 190px;
}

.staff-salary-card ::v-deep .media-aside {
  margin-right: 0.75rem;
}

.staff-salary-card ::v-deep .media-body {
  min-width: 0;
}

/* Skeleton loading */
.list-skeleton {
  width: 100%;
  padding: 0.35rem 0.25rem 0.75rem;
}

.list-skeleton__row {
  display: grid;
  gap: 0.75rem;
  align-items: center;
  padding: 0.9rem 0.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.staff-skeleton-row {
  grid-template-columns:
    52px
    minmax(200px, 1.35fr)
    minmax(110px, 0.75fr)
    minmax(100px, 0.65fr)
    minmax(340px, 1.4fr);
}

.staff-skel-date {
  width: 88px;
  height: 22px;
  border-radius: 8px;
}

.skeleton-text-btn {
  width: 108px;
  height: 44px;
  border-radius: 10px;
  flex: 0 0 auto;
}

.staff-skel-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem;
}

.skeleton-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 9px;
  flex: 0 0 auto;
}

.history-skeleton-row {
  grid-template-columns: 60px minmax(200px, 1fr) repeat(8, minmax(80px, 1fr));
}

.list-skeleton__cell {
  min-width: 0;
}

.list-skeleton__bar {
  height: 14px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.skeleton-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex: 0 0 44px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.staff-skel-person {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.staff-skel-lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.staff-skel-sno {
  width: 32px;
  height: 20px;
}

.staff-skel-name {
  width: 60%;
}

.staff-skel-sub {
  width: 78%;
  height: 11px;
}

.staff-skel-id {
  width: 40%;
  height: 11px;
}

.staff-skel-chip {
  width: 100px;
  height: 22px;
  border-radius: 999px;
}

@keyframes listSkeletonShine {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* History pagination bar (server-side paging) */
.history-pagination,
.pagination-controls-top.history-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  margin-top: 0;
  padding: 0.75rem 1.25rem;
  border: 1px solid #e0d8ff;
  border-radius: 10px;
  background: linear-gradient(180deg, #faf9ff 0%, #ffffff 100%);
}

.history-pagination__size {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex: 0 0 auto;
}

.history-pagination__label {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

.history-pagination__select {
  width: 82px;
  min-width: 82px;

  ::v-deep .vs__dropdown-toggle {
    height: 32px;
    min-height: 32px;
    padding: 0 0.4rem;
    border-radius: 7px;
    border-color: #e0d8ff;
    background: #fff;
  }

  ::v-deep .vs__selected {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 600;
    color: #2d1b69;
  }

  ::v-deep .vs__search {
    display: none;
  }

  ::v-deep .vs__dropdown-menu {
    min-width: 82px;
    padding: 4px;
    border-radius: 8px;
    border-color: #e0d8ff;
    box-shadow: 0 8px 22px rgba(115, 103, 240, 0.16);
  }

  ::v-deep .vs__dropdown-option {
    padding: 5px 8px;
    border-radius: 5px;
    font-size: 0.78rem;
    color: #2d1b69;
  }

  ::v-deep .vs__dropdown-option--highlight {
    background: #f3f0ff;
    color: #2d1b69;
  }
}

.history-pagination__count {
  flex: 1 1 auto;
  text-align: center;
  font-size: 0.78rem;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;

  strong {
    color: #2d1b69;
    font-weight: 700;
  }
}

.history-pagination__control {
  flex: 0 0 auto;

  ::v-deep .pagination {
    margin-bottom: 0;

    .page-link {
      min-width: 30px;
      height: 30px;
      padding: 0.25rem 0.5rem;
      font-size: 0.78rem;
      border-radius: 6px;
      margin: 0 0.1rem;
      border: 1px solid #e0d8ff;
      color: #64748b;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #f3f0ff;
        border-color: #b8a9ff;
        color: #7367f0;
      }
    }

    .page-item.active .page-link {
      background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
      border-color: #7367f0;
      color: #fff;
      font-weight: 700;
      box-shadow: 0 2px 8px rgba(115, 103, 240, 0.28);
    }

    .page-item.disabled .page-link {
      background: #f8fafc;
      border-color: #ece9f8;
      color: #cbd5e1;
    }
  }
}

@media (max-width: 768px) {
  .history-pagination {
    flex-direction: column;
    align-items: stretch;
    gap: 0.55rem;
  }

  .history-pagination__size {
    justify-content: space-between;
  }

  .history-pagination__count {
    order: 3;
    text-align: center;
  }

  .history-pagination__control {
    overflow-x: auto;

    ::v-deep .pagination {
      flex-wrap: nowrap;
      justify-content: center;
    }
  }
}

/* ===== Security deposit / Advance-Loan detail view ===== */
.deposit-back-btn {
  display: inline-flex;
  align-items: center;
  height: 34px;
  padding: 0 0.85rem;
  margin-bottom: 0.85rem;
  border: 1.5px solid #e0d8ff;
  border-radius: 9px;
  background: #fff;
  color: #6d5bd0;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f3ff;
    border-color: #b8a9ff;
    color: #7367f0;
  }
}

.deposit-staff {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.deposit-staff__avatar {
  flex: 0 0 auto;
}

.deposit-staff__text {
  min-width: 0;
}

.deposit-staff__name {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: #2d1b69;
  letter-spacing: -0.2px;
}

.deposit-staff__dept {
  font-weight: 600;
  color: #8a86b7;
}

.deposit-staff__role {
  display: block;
  margin-top: 0.1rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #7c5dfa;
}

/* Empty states (history / staff list) */
.salary-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2.75rem 1.5rem;
  margin: 0.5rem 0 1rem;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
}

.salary-empty-state--history {
  min-height: 220px;
}

.salary-empty-state__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  margin-bottom: 1rem;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.salary-empty-state__title {
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e293b;
}

.salary-empty-state__hint {
  margin: 0;
  max-width: 420px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.45;
}

/* ===== Staff attendance calendar (event-calendar styling) ===== */
.attendance-view {
  margin-top: 0.35rem;
}

.attendance-view__top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 0.85rem;
}

.attendance-back-btn {
  margin-bottom: 0 !important;
}

.attendance-period-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #334155;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.attendance-profile {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.attendance-profile__avatar {
  flex: 0 0 auto;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.attendance-profile__name {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.25px;
  line-height: 1.25;
}

.attendance-profile__meta {
  margin: 0.2rem 0 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
  line-height: 1.4;
}

.attendance-profile__dot {
  margin: 0 0.35rem;
  color: #cbd5e1;
}

.attendance-panel {
  margin-bottom: 1rem;
  padding: 0.25rem 0 0;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  background: #fafbfc;
  overflow: hidden;
}

.attendance-panel__section {
  padding: 0.85rem 1rem 1rem;
  background: #fff;
  border-bottom: 1px solid #eef2f6;

  &:last-child {
    border-bottom: none;
  }
}

.attendance-panel__section--legend {
  background: #f8fafc;
  padding-top: 0.65rem;
  padding-bottom: 0.75rem;
}

.attendance-panel__head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.65rem;
}

.attendance-panel__title {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.45px;
  color: #334155;
}

.attendance-panel__hint {
  font-size: 0.75rem;
  font-weight: 600;
  color: #94a3b8;
}

.attendance-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0;
}

.attendance-toolbar__months {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  flex: 1 1 auto;
}

.attendance-month-chip {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.38rem 0.68rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
    color: #334155;
  }

  &.is-active {
    background: #0f172a;
    border-color: #0f172a;
    color: #fff;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
  }
}

.attendance-toolbar__year {
  width: 110px;
  flex: 0 0 auto;

  ::v-deep .vs__dropdown-toggle {
    height: 36px;
    min-height: 36px;
    border-radius: 8px;
    border-color: #e2e8f0;
    background: #fff;
  }
}

.attendance-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.55rem;
  padding: 0;
  margin-bottom: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}

.attendance-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.attendance-legend__chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.65rem;
  padding: 0.12rem 0.4rem;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.attendance-legend__label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
}

.attendance-legend__item.is-success .attendance-legend__chip {
  background: #e8f9ef;
  color: #1a9e5c;
}
.attendance-legend__item.is-danger .attendance-legend__chip {
  background: #ffecee;
  color: #ea5455;
}
.attendance-legend__item.is-info .attendance-legend__chip {
  background: #e8f7ff;
  color: #00cfe8;
}
.attendance-legend__item.is-warning .attendance-legend__chip {
  background: #fff4e5;
  color: #ff9f43;
}
.attendance-legend__item.is-secondary .attendance-legend__chip {
  background: #f1f5f9;
  color: #64748b;
}
.attendance-legend__item.is-primary .attendance-legend__chip {
  background: #f0edff;
  color: #7367f0;
}

.attendance-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(122px, 1fr));
  gap: 0.65rem;
  margin-bottom: 0;
}

.attendance-stat {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 92px;
  padding: 0.6rem 0.75rem 0.65rem;
  border-radius: 12px;
  border: 1px solid transparent;
  color: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.attendance-stat__code {
  position: absolute;
  top: 0.5rem;
  right: 0.55rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.2px;
  padding: 0.15rem 0.4rem;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
  line-height: 1.2;
}

.attendance-stat__label {
  display: block;
  padding-right: 2.25rem;
  min-height: 2.35em;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.35px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.25;
}

.attendance-stat__value {
  display: block;
  margin-top: 0.25rem;
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
  color: #fff;
  letter-spacing: -0.02em;
}

.attendance-stat.is-present {
  background: linear-gradient(145deg, #32d583 0%, #28c76f 100%);
}
.attendance-stat.is-absent {
  background: linear-gradient(145deg, #f08182 0%, #ea5455 100%);
}
.attendance-stat.is-leave {
  background: linear-gradient(145deg, #22d3ee 0%, #00cfe8 100%);
}
.attendance-stat.is-short {
  background: linear-gradient(145deg, #42b9f5 0%, #1e9ff2 100%);
}
.attendance-stat.is-late {
  background: linear-gradient(145deg, #ffb366 0%, #ff9f43 100%);
}
.attendance-stat.is-holiday {
  background: linear-gradient(145deg, #38bdf8 0%, #0ea5e9 100%);
}
.attendance-stat.is-off {
  background: linear-gradient(145deg, #94a3b8 0%, #64748b 100%);
}

.attendance-stats--skeleton {
  pointer-events: none;
}

.attendance-stat-skeleton {
  min-height: 92px;
  padding: 0.65rem 0.75rem;
  border-radius: 12px;
  border: none;
  background: #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 0.45rem;
  opacity: 0.65;
}

.attendance-stat-skeleton__value {
  width: 42%;
  height: 1.65rem;
  border-radius: 8px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-stat-skeleton__label {
  width: 72%;
  height: 0.75rem;
  border-radius: 6px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-calendar {
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);
  background: #fff;
  overflow: hidden;
}

.attendance-calendar__card {
  position: relative;
}

.attendance-calendar__loading {
  position: absolute;
  inset: 0;
  z-index: 5;
  background: rgba(255, 255, 255, 0.92);
  padding: 1rem;
}

.attendance-calendar__body.is-loading {
  pointer-events: none;
  opacity: 0.35;
}

.attendance-skeleton__toolbar {
  margin-bottom: 0.85rem;
}

.attendance-skeleton__title-bar {
  width: 160px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 40%, #f1f5f9 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-skeleton__dow {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.35rem;
  margin-bottom: 0.45rem;
}

.attendance-skeleton__dow-cell {
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 40%, #f1f5f9 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-skeleton__week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.35rem;
  margin-bottom: 0.35rem;
}

.attendance-skeleton__day {
  min-height: 108px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.35rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.attendance-skeleton__day-num {
  width: 22px;
  height: 18px;
  margin-left: auto;
  border-radius: 6px;
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 40%, #f1f5f9 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-skeleton__event-card {
  flex: 1;
  min-height: 72px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  background: #f8fafc;
}

.attendance-skeleton__event-code {
  width: 40%;
  height: 18px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-skeleton__event-line {
  width: 70%;
  height: 10px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-skeleton__event-badge {
  width: 55%;
  height: 16px;
  border-radius: 999px;
  margin-top: auto;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.attendance-full-calendar.full-calendar {
  padding: 1rem 1.1rem 0.85rem !important;
  background: #fff !important;

  .fc-scrollgrid,
  .fc-scrollgrid table,
  .fc-scrollgrid td,
  .fc-scrollgrid th {
    background: #fff !important;
  }

  .fc-scrollgrid tbody tr:hover td,
  .fc-scrollgrid tbody tr:nth-child(even) td {
    background: #fff !important;
  }

  .fc-header-toolbar {
    margin-bottom: 1rem !important;
    align-items: center;
  }

  .fc-toolbar-title {
    font-size: 1.5rem !important;
    font-weight: 800 !important;
    color: #1e293b !important;
    letter-spacing: -0.35px;
  }

  .fc-theme-standard td,
  .fc-theme-standard th {
    border-color: #e2e8f0 !important;
  }

  .fc-col-header-cell {
    padding: 0.65rem 0;
    background: #f8fafc !important;

    .fc-col-header-cell-cushion {
      color: #64748b;
      font-weight: 800;
      text-transform: uppercase;
      font-size: 0.72rem;
      letter-spacing: 1px;
    }
  }

  .fc-daygrid-day {
    min-height: 132px !important;
    background: #fff !important;
  }

  .fc-daygrid-day-frame {
    min-height: 132px !important;
    background: #fff !important;
  }

  .fc-daygrid-day:hover,
  .fc-daygrid-day:hover .fc-daygrid-day-frame,
  .fc-daygrid-day:hover .fc-daygrid-day-bg,
  .fc-daygrid-day:hover .fc-daygrid-day-top,
  .fc-scrollgrid-section-body tr:hover td,
  .fc-scrollgrid-section-body tr:hover th {
    background: #fff !important;
    background-color: #fff !important;
  }

  .fc-highlight,
  .fc-daygrid-day-bg .fc-highlight {
    background: transparent !important;
    opacity: 0 !important;
  }

  .fc-day-today {
    background: #fff !important;

    .fc-daygrid-day-frame {
      background: #f8fafc !important;
    }

    .fc-daygrid-day-number {
      background: #334155;
      color: #fff !important;
      border-radius: 8px;
      box-shadow: none;
    }
  }

  .fc-day-today:hover,
  .fc-day-today:hover .fc-daygrid-day-frame {
    background: #f8fafc !important;
  }

  .fc-daygrid-day-number {
    font-weight: 700;
    color: #475569;
    padding: 0.35rem;
    font-size: 0.9rem;
  }

  .fc-daygrid-day-events {
    margin-top: 0.15rem;
    min-height: 5.75rem;
  }

  .fc-event,
  .fc-h-event,
  .fc-daygrid-block-event,
  .fc-daygrid-event {
    background: transparent !important;
    border: none !important;
    margin: 0 4px 4px !important;
    padding: 0 !important;
    box-shadow: none !important;
    transform: none !important;
    min-height: 5.5rem;
    filter: none !important;
  }

  .fc-event-main,
  .fc-event-main-frame,
  .fc-h-event .fc-event-main {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .fc-event:hover,
  .fc-event:focus,
  .fc-event-selected,
  .fc-daygrid-block-event:hover,
  .fc-daygrid-dot-event:hover,
  .fc-h-event:hover,
  .fc-daygrid-block-event:hover .fc-event-main,
  .fc-h-event:hover .fc-event-main {
    background: transparent !important;
    box-shadow: none !important;
    transform: none !important;
    filter: none !important;
  }

  .fc-daygrid-day:hover .fc-daygrid-day-bg,
  .fc-daygrid-day.fc-day:hover {
    background: transparent !important;
  }

  .fc-daygrid-event-harness {
    margin-bottom: 0 !important;
    min-height: 5.5rem;
  }

  .fc-daygrid-event-harness-abs {
    min-height: 5.5rem;
  }

  .fc-h-event .fc-event-main {
    color: inherit !important;
  }
}

.att-event-content {
  padding: 0.45rem 0.5rem 0.5rem;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  min-height: 5.5rem;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  box-shadow: none;
  transition: border-color 0.12s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;

  &:hover,
  &:active,
  &:focus {
    box-shadow: none;
    filter: none;
    outline: none;
  }
}

.att-event-content--empty {
  border-style: dashed;
  border-color: #cbd5e1;
  background: #f8fafc;

  .att-event-content__status {
    color: #94a3b8;
  }

  .att-event-content__title {
    color: #64748b;
    text-transform: none;
    letter-spacing: 0;
    font-size: 0.62rem;
    line-height: 1.25;
  }

  &:hover {
    border-color: #7367f0;
    background: #f5f3ff;
  }
}

.att-event-content__times {
  min-height: 2.35rem;
  margin-top: auto;
}

.att-event-content__times--empty {
  visibility: hidden;
}

.att-event-content__status {
  display: block;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.05;
  margin-bottom: 0.1rem;
}

.att-event-content__title {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  margin-bottom: 0.2rem;
}

.att-event-content__time {
  font-size: 0.72rem;
  line-height: 1.3;
}

.att-event-content__time-label {
  display: block;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 0.1rem;
}

.att-event-content--success {
  border-color: #b9ebd0;
  background: #f3fcf7;

  .att-event-content__status {
    color: #28c76f;
  }

  &:hover {
    border-color: #28c76f;
    background: #f3fcf7;
  }
}
.att-event-content--danger {
  border-color: #f5c2c7;
  background: #fff5f5;

  .att-event-content__status {
    color: #ea5455;
  }

  &:hover {
    border-color: #ea5455;
    background: #fff5f5;
  }
}
.att-event-content--info {
  border-color: #b8ecf5;
  background: #f0fcff;

  .att-event-content__status {
    color: #00a1b7;
  }

  &:hover {
    border-color: #00cfe8;
    background: #f0fcff;
  }
}
.att-event-content--warning {
  border-color: #ffd8a8;
  background: #fff8ef;

  .att-event-content__status {
    color: #ff9f43;
  }

  &:hover {
    border-color: #ff9f43;
    background: #fff8ef;
  }
}
.att-event-content--secondary {
  border-color: #cbd5e1;
  background: #f8fafc;

  .att-event-content__status {
    color: #64748b;
  }

  &:hover {
    border-color: #94a3b8;
    background: #f8fafc;
  }
}
.att-event-content--primary {
  border-color: #cbd5e1;
  background: #f8fafc;

  .att-event-content__status {
    color: #475569;
  }

  &:hover {
    border-color: #64748b;
    background: #f8fafc;
  }
}

@media (max-width: 992px) {
  .attendance-full-calendar.full-calendar {
    padding: 0.75rem 0.5rem 0.65rem !important;

    .fc-toolbar-title {
      font-size: 1.2rem !important;
    }

    .fc-daygrid-day,
    .fc-daygrid-day-frame {
      min-height: 102px !important;
    }

    .fc-daygrid-day-events {
      min-height: 3.5rem;
    }

    .att-event-content__status {
      font-size: 1.15rem;
    }
  }
}

@media (max-width: 768px) {
  .attendance-view {
    margin-top: 0.15rem;
  }

  .attendance-profile {
    flex-direction: row;
    align-items: center;
  }

  .attendance-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .attendance-stat,
  .attendance-stat-skeleton {
    min-height: 84px;
  }

  .attendance-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .attendance-toolbar__months {
    justify-content: flex-start;
  }

  .attendance-toolbar__year {
    width: 100%;
  }

  .attendance-legend {
    padding: 0.5rem 0.65rem;
    gap: 0.35rem 0.5rem;
  }

  .attendance-legend__label {
    display: none;
  }

  .attendance-stat__value {
    font-size: 1.35rem;
  }

  .attendance-calendar {
    border-radius: 12px;
    margin-left: -0.15rem;
    margin-right: -0.15rem;
  }

  .attendance-full-calendar.full-calendar {
    padding: 0.5rem 0.35rem 0.45rem !important;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .fc-scrollgrid {
      min-width: 640px;
    }

    .fc-daygrid-day,
    .fc-daygrid-day-frame {
      min-height: 92px !important;
    }

    .fc-event,
    .fc-daygrid-event-harness,
    .fc-daygrid-event-harness-abs {
      min-height: 5.5rem;
    }

    .att-event-content {
      min-height: 5.5rem;
      padding: 0.35rem 0.4rem;
    }

    .att-event-content__status {
      font-size: 1rem;
    }

    .att-event-content__title {
      font-size: 0.6rem;
    }
  }
}

@media (max-width: 480px) {
  .attendance-month-chip {
    padding: 0.25rem 0.45rem;
    font-size: 0.7rem;
  }

  .attendance-full-calendar.full-calendar .fc-scrollgrid {
    min-width: 580px;
  }
}

/* Staff header skeleton */
.deposit-staff-skeleton {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.deposit-staff-skeleton__avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex: 0 0 auto;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.deposit-staff-skeleton__lines {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex: 1 1 auto;
}

.deposit-staff-skeleton__bar,
.deposit-skel-bar {
  border-radius: 6px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.deposit-staff-skeleton__bar.is-name {
  height: 14px;
  width: 42%;
}

.deposit-staff-skeleton__bar.is-sub {
  height: 10px;
  width: 26%;
}

/* Deposit stat cards */
.deposit-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.deposit-stat {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
  padding: 0.9rem 1rem;
  border: 1px solid #ece9f8;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.07);

  &.is-deposited {
    border-color: #d8f0e3;
    .deposit-stat__value {
      color: #1a9e5c;
    }
  }

  &.is-remaining {
    border-color: #ffe0dc;
    .deposit-stat__value {
      color: #e5534b;
    }
  }

  &.is-returned {
    border-color: #ddd4ff;
    .deposit-stat__value {
      color: #6d5bd0;
    }
  }

  &.is-skeleton {
    gap: 0.55rem;
  }
}

.deposit-stat__label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  color: #8a86b7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.deposit-stat__value {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.15rem;
  font-weight: 800;
  color: #2d1b69;
  letter-spacing: -0.3px;
  white-space: nowrap;
}

.deposit-stat__currency {
  font-size: 0.76rem;
  font-weight: 700;
  color: #a29ec4;
}

.deposit-stat__badge {
  margin-left: auto;
  font-size: 0.68rem;
  font-weight: 800;
  border-radius: 999px;
}

.deposit-skel-bar.is-label {
  height: 9px;
  width: 55%;
}

.deposit-skel-bar.is-value {
  height: 16px;
  width: 72%;
}

.deposit-loan-view {
  margin-top: 0.25rem;
}

/* Deposit / Loan action toolbar */
.deposit-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 0.65rem;
}

.deposit-toolbar__btn {
  flex: 0 0 auto;
  height: 42px;
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem !important;
  border-radius: 10px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  margin: 0 !important;
  transition: all 0.22s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
}

/* Deposit / Loan tables */
.deposit-table {
  width: 100%;
  margin-top: 0.35rem !important;

  ::v-deep .table-responsive {
    border: 1px solid #e8e4f5;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
  }

  ::v-deep table {
    margin-bottom: 0;
    table-layout: auto;
  }

  ::v-deep th {
    background: #f8f7fc !important;
    color: #5e5873 !important;
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border: none;
    border-bottom: 1px solid #e8e4f5;
    padding: 0.65rem 0.75rem;
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
  }

  ::v-deep td {
    vertical-align: middle;
    text-align: center;
    border-top: 1px solid #f0edf8;
    padding: 0.6rem 0.75rem;
    background: #fff;
    font-size: 0.84rem;
    color: #5e5873;
    white-space: nowrap;
  }

  ::v-deep th.deposit-th-sno,
  ::v-deep td.deposit-td-sno {
    width: 52px;
    min-width: 52px;
    max-width: 64px;
    padding-left: 0.85rem;
    padding-right: 0.35rem;
    text-align: center;
  }

  ::v-deep th.deposit-th-date,
  ::v-deep td.deposit-td-date {
    min-width: 108px;
  }

  ::v-deep th.deposit-th-amount,
  ::v-deep td.deposit-td-amount {
    min-width: 100px;
    font-variant-numeric: tabular-nums;
  }

  ::v-deep th.deposit-th-actions,
  ::v-deep td.deposit-td-actions {
    width: 1%;
    min-width: 268px;
    white-space: nowrap !important;
    text-align: center;
    vertical-align: middle;
    padding-left: 0.5rem;
    padding-right: 0.65rem;
  }

  ::v-deep tbody tr {
    transition: background-color 0.12s ease;

    &:hover td {
      background: #faf9ff !important;
    }
  }
}

.deposit-index {
  display: inline;
  font-size: 0.84rem;
  font-weight: 600;
  color: #64748b;
  line-height: 1.2;
}

.deposit-date {
  font-size: 0.82rem;
  font-weight: 500;
  color: #5e5873;
}

.deposit-amount {
  font-size: 0.84rem;
  font-weight: 700;
  color: #2d1b69;
}

.deposit-months {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 24px;
  padding: 0 7px;
  border-radius: 7px;
  background: #f3f0ff;
  color: #6d5bd0;
  font-size: 0.76rem;
  font-weight: 700;
}

.deposit-type {
  display: inline-flex;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  border: 1px solid #ddd4ff;
  background: #f3f0ff;
  color: #6d5bd0;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.3px;
  text-transform: capitalize;

  &.is-loan {
    border-color: #ffe6bd;
    background: #fff4e5;
    color: #b76e00;
  }
}

.deposit-inline-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 0.4rem;
  padding: 0;
  border: 1px solid #e0d8ff;
  border-radius: 6px;
  background: #fff;
  color: #8a86b7;
  cursor: pointer;
  vertical-align: middle;
  transition: all 0.18s ease;

  &:hover {
    background: #f3f0ff;
    border-color: #b8a9ff;
    color: #7367f0;
  }
}

.deposit-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 0.35rem;
  max-width: 100%;
  margin: 0 auto;
}

.deposit-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  height: 28px;
  padding: 0 0.55rem;
  border-radius: 6px;
  border: 1px solid #e2ddf2;
  background: #fff;
  color: #7c7899;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.18s ease;

  &.is-off:hover {
    background: #f5f3ff;
    border-color: #b8a9ff;
    color: #7367f0;
  }

  &.is-on.is-deposited {
    background: #e8f9ef;
    border-color: #b8ecd0;
    color: #1a9e5c;

    &:hover {
      background: #fdeceb;
      border-color: #f2c1bd;
      color: #e5534b;
    }
  }

  &.is-on.is-returned {
    background: #f3f0ff;
    border-color: #ddd4ff;
    color: #6d5bd0;

    &:hover {
      background: #fff4e5;
      border-color: #ffdca8;
      color: #b76e00;
    }
  }
}

.deposit-row-btn,
.deposit-row-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  flex-shrink: 0;
  padding: 0;
  border-radius: 6px;
  border: 1px solid transparent;
  background: #fff;
  cursor: pointer;
  transition: all 0.18s ease;
}

.deposit-row-btn.is-view {
  border-color: #ddd4ff;
  color: #6d5bd0;

  &:hover {
    background: #7367f0;
    border-color: #7367f0;
    color: #fff;
  }
}

.deposit-row-btn.is-delete,
.deposit-row-delete {
  border-color: #f6d9d7;
  color: #e5534b;

  &:hover {
    background: #fdeceb;
    border-color: #f2c1bd;
  }
}

.deposit-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  padding: 1.6rem 1rem;
  color: #a29ec4;

  p {
    margin: 0;
    font-size: 0.84rem;
    font-weight: 600;
  }
}

/* Deposit / loan shimmer skeletons (table-busy) */
.deposit-skeleton {
  padding: 0.4rem 0;
}

.deposit-skeleton__row {
  display: grid;
  grid-template-columns: 90px minmax(120px, 1fr) 110px 90px 140px;
  gap: 0.75rem;
  align-items: center;
  padding: 0.72rem 0.9rem;
  border-bottom: 1px solid #f3f1fb;
}

.deposit-skel-bar {
  height: 13px;
  border-radius: 6px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;

  &.is-actions {
    width: 76px;
    justify-self: end;
  }
}

@media (max-width: 992px) {
  .deposit-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .deposit-stats {
    grid-template-columns: minmax(0, 1fr);
  }

  .deposit-toolbar__btn {
    width: 100%;
    justify-content: center;
  }
}

/* Pagination */
.staff-salary-card ::v-deep .pagination {
  margin-bottom: 1rem;

  .page-link {
    padding: 0.375rem 0.625rem;
    font-size: 0.8125rem;
    line-height: 1.5;
    border-radius: 6px;
    margin: 0 0.125rem;
    border: 1px solid #e0d8ff;
    color: #64748b;
    font-weight: 500;
    min-width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      background: #f3f0ff;
      border-color: #b8a9ff;
      color: #7c5dfa;
    }
  }

  .page-item.active .page-link {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    border-color: #7c5dfa;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(124, 93, 250, 0.3);
  }

  .page-item.disabled .page-link {
    background: #f8fafc;
    border-color: #e0d8ff;
    color: #cbd5e1;
    cursor: not-allowed;
  }
}

@media (max-width: 992px) {
  .staff-skeleton-row {
    grid-template-columns: 40px minmax(180px, 1fr) 120px 120px;
  }

  .staff-skel-actions {
    display: none;
  }

  .history-skeleton-row {
    grid-template-columns: 40px minmax(170px, 1fr) repeat(4, minmax(70px, 1fr));
  }

  .history-skeleton-row .list-skeleton__cell:nth-child(n + 7) {
    display: none;
  }

  .staff-salary-toolbar-actions {
    /* Keep the wrapped buttons right-aligned against the card edge. */
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .staff-salary-card {
    padding: 1rem;
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: visible;
  }

  .salary-list-title {
    font-size: 1.15rem;
  }

  .salary-list-subtitle {
    font-size: 0.78rem;
  }

  /* Stack the toolbar: filters then actions, all full width. */
  .filter-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 0.6rem;
  }

  .filter-fields-group {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .filter-search-input,
  .filter-control {
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  .filter-toolbar--salary {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-toolbar--salary.filter-toolbar--one-line {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .filter-fields-group {
      overflow: visible;
      max-width: none;
    }

    .filter-actions-row,
    .staff-salary-toolbar-actions {
      grid-column: auto;
      width: 100%;
      max-width: none;
      flex-wrap: wrap !important;
      overflow-x: visible;
      justify-content: flex-end;
    }
  }

  .filter-fields-group {
    max-width: none;
    flex-wrap: wrap;
  }

  .filter-actions-row {
    flex: 1 1 100%;
    justify-content: flex-end;
  }

  .staff-salary-toolbar-col {
    margin-top: 0.35rem;
    padding-top: 0.6rem;
  }

  .staff-salary-toolbar-actions {
    justify-content: stretch;
    gap: 0.45rem;
  }

  .salary-filter-action-btn:not(.salary-filter-action-btn--icon) {
    flex: 1 1 calc(50% - 0.45rem);
    min-width: 0;
  }

  .salary-filter-action-btn--icon {
    flex: 0 0 44px;
  }

  .staff-skeleton-row {
    grid-template-columns: 32px minmax(150px, 1fr) 110px;
  }

  .history-skeleton-row {
    grid-template-columns: 32px minmax(140px, 1fr) repeat(2, minmax(60px, 1fr));
  }

  .history-skeleton-row .list-skeleton__cell:nth-child(n + 5) {
    display: none;
  }

  .list-skeleton__row:nth-child(n + 4) {
    display: none;
  }

  /* Table rows stay compact on phones: the action cluster keeps one line and
     the table's responsive wrapper scrolls sideways. */
  .staff-salary-card ::v-deep .staff-actions {
    gap: 0.3rem;
  }

  .staff-salary-card ::v-deep td .staff-action-text {
    height: 40px;
    font-size: 0.8rem;
    padding: 0 0.85rem !important;
  }

  .staff-salary-card ::v-deep td .btn-icon {
    width: 40px !important;
    min-width: 40px;
    height: 40px;
  }
}

@media (max-width: 992px) {
  /* Salary sheet toolbar: let the action row wrap instead of overflowing. */
  .salary-sheet-toolbar {
    padding: 1rem;
  }

  .salary-sheet-toolbar-title {
    margin-bottom: 0.7rem !important;
  }

  .salary-sheet-toolbar-title small {
    white-space: normal;
  }

  /* Keep the stat beside the buttons while there is room; only the button
     group wraps internally when it runs out. */
  .salary-sheet-actions {
    align-items: flex-start !important;
  }

  .salary-sheet-action-group {
    flex: 1 1 auto;
    min-width: 0;
  }
}

@media (max-width: 768px) {
  /* Create/Update sidebar: tighter padding so the fields get the width. */
  .salary-create-body {
    padding: 0.75rem 0.85rem 1rem;
  }

  .salary-top-fields {
    ::v-deep .col-form-label,
    ::v-deep label {
      font-size: 0.76rem;
    }
  }

  .salary-sheet-toolbar {
    border-radius: 14px;
  }
}

@media (max-width: 576px) {
  .staff-skeleton-row {
    grid-template-columns: 28px minmax(120px, 1fr);
  }

  .staff-skel-chip {
    display: none;
  }

  .staff-salary-toolbar-actions .btn {
    flex: 1 1 100%;
  }

  /* Create/Update salary header stacks on phones. */
  .salary-create-header__bar {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .salary-create-header__bar-actions {
    width: 100%;
    justify-content: space-between;
  }

  .salary-create-header__context {
    flex-direction: column;
    align-items: stretch;
  }

  .salary-create-header__chips {
    justify-content: flex-start;
  }

  .salary-create-actions .btn {
    font-size: 0.78rem;
    padding: 0 0.6rem;
  }

  /* Salary sheet skeleton drops columns on small screens. */
  .sheet-skeleton__row {
    grid-template-columns: 28px minmax(120px, 1fr) 80px 90px;
  }

  .sheet-skeleton__row > .sheet-skeleton__bar:nth-child(n + 5) {
    display: none;
  }

  .staff-salary-toolbar-actions .btn-icon {
    flex: 0 0 38px;
  }

  .salary-list-title {
    font-size: 1.05rem;
  }
}

/* ===== Salary preparation sheet (purple theme) ===== */
.salary-sheet-toolbar {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 16px;
  padding: 1.15rem 1.25rem 1rem;
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.1);
  position: relative;
  overflow: visible;
}

.salary-sheet-toolbar-title {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.85rem !important;
}

.salary-sheet-toolbar-title h5 {
  color: #2d1b69;
  font-weight: 800;
  font-size: 1.05rem;
  letter-spacing: -0.2px;
  margin: 0;
}

.salary-sheet-toolbar-title small {
  color: #8a86b7 !important;
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
}

::v-deep .salary-sheet-label {
  color: #5e5873 !important;
  font-weight: 700;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 0.35rem;
}

.salary-sheet-form-group ::v-deep .vs__selected,
.salary-sheet-form-group ::v-deep .vs__dropdown-toggle,
.salary-sheet-input {
  color: #2d1b69;
}

.salary-sheet-form-group ::v-deep .vs__dropdown-toggle {
  border: 1.5px solid #e0d8ff;
  border-radius: 10px;
  min-height: 42px;
  background: #fff;

  &:hover {
    border-color: #b8a9ff;
  }
}

.salary-sheet-form-group ::v-deep .vs__selected {
  font-weight: 500;
  white-space: nowrap;
}

.salary-sheet-input {
  height: 42px;
  border: 1.5px solid #e0d8ff;
  border-radius: 10px;
}

.salary-sheet-actions {
  gap: 0.75rem;
  padding-top: 0.85rem;
  margin-top: 0.5rem;
  border-top: 1px solid #f0edff;
}

.salary-sheet-action-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;

  .btn {
    height: 42px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 0.84rem;
    padding: 0 1.15rem;
    margin: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
    }
  }

  /* Primary = purple gradient, matching the rest of the page. */
  .sheet-btn-primary {
    border: none !important;
    background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%) !important;
    color: #fff !important;
    box-shadow: 0 3px 10px rgba(115, 103, 240, 0.28);

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #6558e8 0%, #8d83f2 100%) !important;
      box-shadow: 0 5px 14px rgba(115, 103, 240, 0.38);
    }
  }

  .sheet-btn-outline {
    border: 1.5px solid #7367f0 !important;
    background: #fff !important;
    color: #7367f0 !important;

    &:hover:not(:disabled) {
      background: #f5f3ff !important;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.2);
    }
  }
}

.salary-sheet-recalc-switch {
  margin: 0;
  display: inline-flex;
  align-items: center;
}

.salary-sheet-switch-label {
  color: #5e5873;
  font-weight: 600;
  font-size: 0.82rem;
}

.sheet-stat-text {
  font-size: 0.82rem;
  font-weight: 700;
  color: #5e5873;
  white-space: nowrap;
}

.salary-sheet-wrap {
  border: 1px solid #e0d8ff;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.1);
}

.salary-sheet-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.7rem 0.95rem;
  background: linear-gradient(180deg, #faf9ff 0%, #ffffff 100%);
  border-bottom: 1px solid #f0edff;
}

.sheet-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.sheet-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #5e5873;
}

.sheet-head-hint {
  font-size: 0.76rem;
  color: #8a86b7 !important;
}

.sheet-empty {
  font-size: 0.88rem;
}

/* Salary sheet totals strip */
.sheet-totals {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.6rem;
  padding: 0.7rem 0.95rem;
  border-bottom: 1px solid #f0edff;
  background: #fdfcff;
}

.sheet-total {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  padding: 0.5rem 0.65rem;
  border: 1px solid #ece9f8;
  border-radius: 9px;
  background: #fff;

  &.is-allow .sheet-total__value {
    color: #1a9e5c;
  }

  &.is-deduct .sheet-total__value {
    color: #e5534b;
  }

  &.is-net {
    border-color: #ddd4ff;
    background: #f5f3ff;

    .sheet-total__value {
      color: #5e50a3;
    }
  }
}

.sheet-total__label {
  font-size: 0.64rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #8a86b7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sheet-total__value {
  font-size: 0.88rem;
  font-weight: 800;
  color: #2d1b69;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Totals strip skeleton (loads with the table) */
.sheet-totals-skeleton {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.6rem;
  padding: 0.7rem 0.95rem;
  border-bottom: 1px solid #f0edff;
  background: #fdfcff;
}

.sheet-totals-skeleton__tile {
  padding: 0.5rem 0.65rem;
  border: 1px solid #f0edff;
  border-radius: 9px;
  background: #fff;
}

.sheet-totals-skeleton__label,
.sheet-totals-skeleton__value {
  border-radius: 6px;
  background: linear-gradient(90deg, #ecebf8 0%, #f7f6ff 40%, #ecebf8 80%);
  background-size: 200% 100%;
  animation: listSkeletonShine 1.2s ease-in-out infinite;
}

.sheet-totals-skeleton__label {
  height: 8px;
  width: 52%;
  margin-bottom: 0.4rem;
}

.sheet-totals-skeleton__value {
  height: 14px;
  width: 74%;
}

@media (max-width: 992px) {
  .sheet-totals,
  .sheet-totals-skeleton {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .sheet-totals,
  .sheet-totals-skeleton {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* Sheet table header + rows in the page theme */
::v-deep .salary-sheet-table {
  margin-bottom: 0;

  thead th {
    background: linear-gradient(180deg, #ffffff 0%, #f8f7ff 100%) !important;
    color: #5e50a3 !important;
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    white-space: nowrap;
    border: none !important;
    border-bottom: 1px solid #e8e4f7 !important;
    vertical-align: middle;
    padding: 0.7rem 0.75rem !important;
    /* Keep long labels from colliding with the next header. */
    min-width: 62px;
  }

  tbody td {
    border: none !important;
    border-bottom: 1px solid #f4f2fb !important;
    vertical-align: middle;
    padding: 0.55rem 0.55rem !important;
    background: #fff;
    font-size: 0.82rem;
    color: #475569;
    transition: background-color 0.15s ease;
  }

  tbody tr:nth-child(even) td,
  tbody tr:nth-child(even) .sheet-sticky-col {
    background: #fafbfd !important;
  }

  tbody tr:hover td,
  tbody tr:hover .sheet-sticky-col {
    background: #f7f5ff !important;
  }
}

/* Sticky columns keep the theme background */
.sheet-sticky-col {
  position: sticky;
  background: inherit;
}

.sheet-col-sno.sheet-sticky-col {
  left: 0;
  z-index: 5;
  background: #fff;
}

.sheet-col-name.sheet-sticky-col {
  left: 36px;
  z-index: 3;
  background: #fff;
  box-shadow: 4px 0 8px -4px rgba(115, 103, 240, 0.12);
}

::v-deep .salary-sheet-table tbody tr:nth-child(even) .sheet-sticky-col {
  background: #fafbfd;
}

::v-deep .salary-sheet-table thead .sheet-sticky-col {
  background: #ffffff;
}

.sheet-col-sno {
  min-width: 40px;
  text-align: center;
}

.sheet-col-name {
  min-width: 170px;
}

.sheet-col-text {
  min-width: 110px;
}

.sheet-col-policy {
  min-width: 76px;
  text-align: center;
}

.sheet-text-cell {
  display: block;
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.3;
}

.sheet-policy-val {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #64748b;
  text-align: center;
}

.sheet-policy-val.sheet-policy-applied {
  color: #7367f0;
}

.sheet-col-att {
  min-width: 82px;
  text-align: center;
}

.sheet-col-pay {
  min-width: 96px;
}

.sheet-col-readonly {
  background: #fbfaff !important;
}

.sheet-col-net {
  min-width: 88px;
}

.sheet-col-note {
  min-width: 120px;
}

.sheet-staff-block {
  line-height: 1.25;
}

.sheet-staff-name {
  font-weight: 700;
  color: #2d1b69;
  font-size: 0.85rem;
  line-height: 1.25;
}

.sheet-staff-id {
  font-size: 0.72rem;
  color: #8a86b7;
  margin-top: 0.12rem;
}

.sheet-index {
  font-weight: 700;
  color: #8a86b7;
  font-size: 0.8rem;
}

.sheet-cell-edit {
  width: 100%;
  min-width: 52px;
  height: 32px;
  padding: 0.2rem 0.4rem;
  font-size: 0.82rem;
  text-align: center;
  color: #2d1b69;
  border: 1px solid transparent;
  border-radius: 6px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #ddd4ff;
  }

  &:focus {
    outline: none;
    border-color: #7367f0;
    box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.15);
  }
}

.sheet-cell-money {
  text-align: right;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.sheet-cell-net {
  background: #f7f5ff;
  color: #2d1b69;
  font-weight: 800;
}

.sheet-cell-net.is-negative {
  color: #dc2626;
  background: #fef2f2;
}

.sheet-cell-note {
  min-width: 100px;
  text-align: left;
  font-size: 0.75rem;
}

.sheet-money {
  display: block;
  text-align: right;
  font-size: 0.82rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #475569;
}

.sheet-money-allow {
  color: #7367f0;
}

.sheet-money-deduct {
  color: #b45309;
}

.salary-sheet-skipped {
  background: #fff7ed;
  border-top: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 0.8rem;
  padding: 0.6rem 0.85rem;
  border-radius: 0 0 12px 12px;
}

</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/apps/calendar.scss";

/* Attendance FC: rendered DOM has no Vue scope id — overrides must live here. */
.staff-salary-card--attendance .attendance-full-calendar.full-calendar {
  .fc-h-event,
  .fc-daygrid-block-event,
  .fc-daygrid-event,
  a.fc-event,
  .fc-event {
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    --fc-event-bg-color: transparent;
    --fc-event-border-color: transparent;
    --fc-event-selected-overlay-color: transparent;
  }

  .fc-event-main,
  .fc-event-main-frame,
  .fc-h-event .fc-event-main {
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .fc-event:hover,
  .fc-event:focus,
  .fc-event:active,
  .fc-event-selected,
  .fc-h-event:hover,
  .fc-h-event:focus,
  .fc-h-event:active,
  .fc-daygrid-block-event:hover,
  .fc-daygrid-dot-event:hover {
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .fc-event-selected::before,
  .fc-event-selected::after,
  .fc-event:focus::before,
  .fc-event:focus::after,
  .fc-event:active::before,
  .fc-event:active::after {
    display: none !important;
    content: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .fc-daygrid-event-harness,
  .fc-daygrid-event-harness-abs {
    background: transparent !important;
  }

  .att-fc-event-shell::before,
  .att-fc-event-shell::after,
  .att-fc-event-shell.fc-event-selected::before,
  .att-fc-event-shell.fc-event-selected::after,
  .att-fc-event-shell:focus::before,
  .att-fc-event-shell:focus::after {
    display: none !important;
    content: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .att-fc-event-shell.fc-event-selected,
  .att-fc-event-shell:focus,
  .att-fc-event-shell:active {
    box-shadow: none !important;
    outline: none !important;
  }

  .fc-scrollgrid tbody tr:hover td,
  .fc-scrollgrid-section-body tr:hover td {
    background: #fff !important;
  }
}
</style>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.card .card {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  margin-bottom: 0.5rem;
}
::v-deep.vs__clear {
  margin-right: 1px !important;
}
::v-deep.fc-daygrid-dot-event:hover {
  background: none !important;
}

/* Red Toggle Switch Styling */
::v-deep .leave-deduction-toggle .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}

::v-deep .leave-deduction-toggle .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #dc3545 !important;
}

::v-deep .leave-deduction-toggle .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

::v-deep .leave-deduction-toggle .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545 !important;
}

::v-deep .leave-deduction-toggle .custom-control-input:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545 !important;
}

::v-deep .leave-deduction-toggle .custom-control-label::before {
  border-color: #dc3545 !important;
}

::v-deep .leave-deduction-toggle .custom-control-label::after {
  background-color: #dc3545 !important;
}

.status-buttons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.status-btn {
  margin: 0 !important;
  padding: 0.25rem 0.5rem !important;
  min-width: 32px;
  height: 28px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 14px !important;
  transition: all 0.2s ease;
}

</style>
